function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "prefix__a"
}, React.createElement("path", {
  d: "M148.461 190.594h.068l.499.032.332.033.665.136.699.229.132.071.102.033.597.299.034.033.068.033.03.033.136.065.03.032.069.033.034.033.131.071.099.098.068.033.068.065.064.033.102.103.064.033.068.065.064.033.767.763v.071h.034l.167.163v.066h.034l.132.136v.066h.034l.064.065v.065h.034l.034.038v.066h.034l.064.065v.066h.034l.034.032v.066h.034l.034.038v.065h.03l.034.033v.065h.035l.034.033v.065h.034v.071h.029l.035.033v.065h.034v.066h.034l.034.032v.066h.03v.071h.034v.065h.034l.034.033v.065h.034v.066h.03v.07h.034v.066h.034v.065h.034v.065h.034v.104h.03v.065h.034v.066h.034v.065h.034v.065h.034v.072h.03v.065h.034v.098h.034v.098h.034v.071h.035v.098h.03v.098h.034v.066h.034v.103h.034v.098h.034v.066h.034v.136h.03v.098h.034v.131h.034v.103h.034v.131h.034v.098h.03v.136h.034v.131h.034v.169h.034v.164h.034v.169h.03v.13h.034v.169h.034v.267h.035v.3h.034v.261h.029v.502h.034l-.034 1.33-.029.501-.034.262-.035.299-.034.235-.166.833-.034.131-.03.098-.034.137-.034.097-.034.137-.034.098-.03.131-.102.3-.034.065-.064.201-.035.066-.068.202-.034.065-.03.098-.268.534-.034.098-.064.136-.034.033-.068.131-.03.033-.102.201-.035.033-.063.136-.034.033-.069.131-.03.032-.034.066-.068.07-.034.066-.034.033-.03.065-.068.066-.034.07-.034.033-.03.065-.068.066-.034.065-.167.169-.034.066-.166.169-.03.065-.532.529-.069.032-.166.169-.068.033-.098.098-.068.038-.064.065-.068.033-.098.098-.069.033-.034.033-.132.071-.034.032-.132.066-.034.032-.064.033-.034.033-.132.065-.034.038-.068.033-.098.033-.465.228-.801.268-.2.032-.499.104-.43.033v.032l-.768-.032-.43-.033-.665-.136-.2-.066-.132-.033-.401-.13-.264-.136-.102-.033-.396-.202-.035-.033-.132-.065-.034-.033-.136-.065-.03-.033-.068-.032-.035-.039-.131-.065-.069-.065-.064-.033-.102-.098-.064-.033-.068-.071-.064-.033-.102-.097-.064-.033-.469-.469-.064-.032-.068-.066h-.034v-.066l-.166-.169h-.034v-.065l-.167-.163h-.03v-.071l-.102-.098h-.034v-.066l-.064-.065h-.034v-.071l-.034-.032h-.034v-.066l-.064-.065h-.034v-.066l-.034-.033h-.034v-.07l-.064-.066h-.034v-.065h-.034v-.065l-.035-.033h-.034v-.071h-.029v-.065l-.034-.033h-.035v-.066h-.034v-.065h-.034v-.065l-.029-.038h-.035v-.066h-.034v-.065l-.034-.033h-.034v-.065h-.03v-.066h-.034v-.071h-.034v-.097h-.034v-.066h-.034v-.065h-.03v-.071h-.034v-.066h-.034v-.065h-.034v-.065h-.034v-.066h-.03v-.071h-.034v-.098h-.034v-.098h-.034v-.071h-.035v-.098h-.029v-.098h-.035v-.065h-.034v-.104h-.034v-.098h-.034V204h-.034v-.098h-.03v-.136h-.034v-.099h-.034v-.136h-.034v-.098h-.034v-.131h-.03v-.103h-.034v-.131h-.034v-.131h-.034v-.169h-.034v-.169h-.03v-.163h-.034v-.169h-.034v-.197h-.035v-.266h-.034v-.3h-.029v-.267h-.034v-.731h-.034v-.632l.034-.697.034-.3.029-.267.034-.3.201-.997.034-.098.034-.136.03-.098.034-.131.034-.104.034-.131.098-.299.034-.066.068-.201.035-.066.064-.201.034-.066.034-.098.132-.267.034-.098.264-.534.034-.033.069-.136.029-.033.103-.196.034-.033.063-.136.035-.033.034-.065.034-.032.03-.071.068-.066.034-.065.034-.033.034-.065.03-.033.034-.071.068-.065.034-.065.064-.066.034-.065.167-.169.034-.066.166-.169.034-.065.464-.463.068-.033.231-.234.068-.033.064-.065.068-.039.098-.097.068-.033.068-.066.065-.033.068-.065.132-.071.034-.033.132-.065.034-.032.068-.033.03-.033.137-.071.029-.032.2-.099.103-.032.396-.202.401-.131.132-.032.2-.066.132-.033.201-.038.332-.065.298-.033.533-.032z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#AD1519",
  fillRule: "nonzero",
  d: "M28.138 0h455.724C499.34 0 512 12.66 512 28.138v299.904c0 15.476-12.66 28.138-28.138 28.138H28.138C12.66 356.18 0 343.518 0 328.042V28.138C0 12.66 12.66 0 28.138 0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FABD00",
  fillRule: "nonzero",
  d: "M0 271.268h512V84.912H0z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M148.264 159.85c-7.26-.01-13.823-.925-18.82-2.33 4.997-1.41 11.56-2.271 18.82-2.285 7.26.014 13.858.875 18.854 2.285-4.996 1.405-11.594 2.32-18.854 2.33z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.895 142.601c0-.823.644-1.489 1.44-1.489.793 0 1.439.666 1.439 1.489 0 .819-.645 1.484-1.439 1.484s-1.44-.665-1.44-1.484zm.035 0c0 .8.63 1.449 1.405 1.449.774 0 1.404-.649 1.404-1.449 0-.803-.633-1.453-1.404-1.453-.775 0-1.405.65-1.405 1.453z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M147.952 129.924c4.36 0 8.242.702 10.767 1.796 1.447.711 3.387 1.235 5.514 1.547 1.617.237 3.154.282 4.492.172 1.79-.038 4.379.532 6.965 1.776 2.143 1.035 3.931 2.294 5.118 3.513l-1.027.998-.297 2.833-2.819 3.52-1.412 1.304-3.336 2.91-1.705.154-.52 1.607-21.596-2.759-21.663 2.759-.519-1.607-1.707-.152-3.337-2.912-1.41-1.304-2.819-3.52-.295-2.833-1.031-.998c1.193-1.219 2.981-2.478 5.118-3.513 2.591-1.244 5.177-1.814 6.965-1.776 1.337.11 2.875.065 4.494-.172 2.125-.312 4.071-.836 5.514-1.549 2.53-1.092 6.191-1.794 10.546-1.794z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M147.952 129.836c4.377 0 8.266.707 10.803 1.803l.004.002c1.439.706 3.372 1.228 5.486 1.536 1.609.235 3.142.283 4.472.173h.006c1.799-.038 4.401.534 7.004 1.783 2.154 1.042 3.952 2.308 5.146 3.535l.062.06-1.068 1.039-.298 2.828-2.842 3.544-1.413 1.31-3.362 2.932-1.674.149-.524 1.622-21.658-2.765-21.725 2.765-.524-1.622-1.678-.149-3.359-2.932-1.414-1.31-2.84-3.546-.293-2.826-1.073-1.039.063-.06c1.199-1.227 2.993-2.493 5.143-3.535 2.603-1.249 5.206-1.821 7.004-1.783h.004c1.332.11 2.865.062 4.476-.173 2.116-.308 4.05-.83 5.486-1.536l.002-.002h.002c2.537-1.096 6.212-1.803 10.582-1.803zm0 .177s-.087-.11-.087-.089c0 .08.087.089.087.089-4.341 0-7.989.698-10.511 1.788-1.449.713-3.401 1.241-5.536 1.553-1.626.237-3.169.284-4.511.172h-.002c-1.778-.037-4.35.532-6.919 1.768-2.089 1.012-3.844 2.24-5.033 3.432l.993.958.294 2.84 2.798 3.495 1.405 1.297 3.314 2.894 1.736.152.516 1.594 21.6-2.748 21.536 2.748.513-1.594 1.734-.152 3.318-2.894 1.401-1.297 2.801-3.495.295-2.84.99-.958c-1.181-1.192-2.938-2.418-5.032-3.432-2.571-1.236-5.143-1.805-6.92-1.768-1.345.115-2.888.065-4.514-.172-2.135-.31-4.083-.84-5.538-1.553-2.518-1.09-6.382-1.788-10.728-1.788z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M163.478 136.938l-1.364-2.431a5.61 5.61 0 002.46-5.309c-.14-3.1-3.611-5.663-8.009-5.663-2.286 0-4.346.68-5.798 1.773-.039-.48-.075-.892-.141-1.328 1.599-1.015 3.674-1.628 5.939-1.628 5.059 0 9.017 3.133 9.21 6.844.019.216.027.434.029.65 0 1.98-.829 3.763-2.139 5.003l.724 1.295-.911.794zm-30.567 0l1.366-2.431a5.612 5.612 0 01-2.461-5.309c.143-3.1 3.613-5.663 8.01-5.663 2.287 0 4.347.68 5.8 1.773.04-.48.075-.892.141-1.328-1.6-1.015-3.673-1.628-5.941-1.628-5.058 0-9.016 3.133-9.212 6.844a8.306 8.306 0 00-.025.65c0 1.98.827 3.763 2.139 5.003l-.725 1.295.908.794z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.938 134.466l.101-.069a5.484 5.484 0 002.402-5.184V129.204c-.057-1.206-.633-2.33-1.574-3.241-1.431-1.389-3.701-2.293-6.302-2.293-2.255 0-4.286.667-5.719 1.744l-.195.148-.019-.243a17.553 17.553 0 00-.139-1.318l-.015-.088.075-.045c1.62-1.029 3.717-1.651 6.012-1.651 5.14 0 9.146 3.199 9.346 6.967.018.222.026.442.026.662 0 1.98-.814 3.768-2.105 5.028l.725 1.299-1.114.975-1.505-2.682zm2.769-5.282v.001a5.749 5.749 0 01-2.418 5.364l1.224 2.179.705-.613-.721-1.294.075-.07a6.733 6.733 0 002.097-4.902c0-.215-.008-.431-.027-.645v-.002c-.191-3.651-4.099-6.717-9.077-6.717-2.203 0-4.224.586-5.794 1.561.046.335.078.659.109 1.015 1.459-1.025 3.465-1.659 5.685-1.659 4.476 0 7.992 2.628 8.142 5.782zm-32.875 6.989l.73-1.299a7 7 0 01-2.106-5.028c0-.22.008-.44.025-.661.2-3.769 4.208-6.968 9.345-6.968 2.293 0 4.392.622 6.012 1.651l.073.045-.013.088c-.066.434-.099.841-.139 1.318l-.021.243-.193-.148c-1.432-1.077-3.463-1.744-5.719-1.744-2.599 0-4.871.904-6.302 2.293-.943.911-1.517 2.035-1.571 3.241V129.213a5.48 5.48 0 002.401 5.184l.102.069-1.507 2.682-1.117-.975zm-.149-6.983v-.005c.147-3.153 3.665-5.783 8.143-5.783 2.218 0 4.226.634 5.686 1.659.029-.356.06-.68.108-1.015-1.57-.975-3.588-1.561-5.794-1.561-4.979 0-8.886 3.066-9.077 6.719l-.002.002c-.015.212-.023.428-.025.643 0 1.939.813 3.688 2.1 4.902l.075.07-.724 1.294.703.613 1.224-2.179a5.752 5.752 0 01-2.417-5.359z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M167.131 130.753c0-2.42-1.455-4.582-3.661-6.015 1.359 1.194 2.185 2.736 2.305 4.458.019.216.029.434.029.65 0 1.98-.829 3.763-2.139 5.003l.665 1.322c1.726-1.404 2.801-3.314 2.801-5.418z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M167.264 130.753v.135c-.046 2.089-1.127 3.986-2.85 5.387l-.129.104-.786-1.559.073-.069a6.735 6.735 0 002.097-4.905c0-.212-.008-.428-.027-.64v-.002c-.118-1.686-.929-3.195-2.262-4.363l.162-.213c2.246 1.456 3.722 3.659 3.722 6.125zm-.268 0c0-1.879-.896-3.599-2.343-4.931a6.385 6.385 0 011.258 3.363c.018.221.026.441.026.661 0 1.984-.814 3.77-2.108 5.03l.545 1.083c1.618-1.366 2.622-3.194 2.622-5.206z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M116.828 138.624a6.898 6.898 0 01-1.559-4.376 6.878 6.878 0 01.599-2.825c1.397-3.136 5.779-5.414 10.991-5.414 1.42 0 2.778.168 4.034.478-.281.331-.497.694-.712 1.06a15.956 15.956 0 00-3.322-.341c-4.769 0-8.759 2.023-9.916 4.753a5.651 5.651 0 00-.478 2.289c0 1.661.711 3.151 1.829 4.166l-1.728 3.073-.925-.801 1.187-2.06v-.002zm31.38-16.892c1.158 0 2.152.834 2.389 1.95.154.99.249 2.115.272 3.31.002.125-.008.247-.008.37.004.142.027.293.031.441.04 2.511.368 4.731.838 6.089l-3.522 3.674-3.561-3.674c.472-1.358.8-3.578.844-6.089.004-.148.027-.299.027-.441 0-.123-.008-.245-.004-.37.016-1.195.116-2.32.27-3.31.233-1.116 1.268-1.95 2.424-1.95z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.666 138.638a7.033 7.033 0 01-1.532-4.39c0-.998.208-1.981.611-2.88 1.416-3.17 5.844-5.492 11.114-5.492 1.433 0 2.801.168 4.067.482l.208.052-.14.164c-.272.324-.488.68-.696 1.04l-.05.085-.093-.021a15.871 15.871 0 00-3.296-.337c-4.704 0-8.652 1.976-9.791 4.672l-.003.002a5.541 5.541 0 00-.467 2.233c0 1.621.696 3.074 1.787 4.066l.078.071-1.859 3.314-1.133-.984 1.195-2.077zm.162.119s.133-.254.133-.133c0 .031-.133.135-.133.135l.115-.067-1.131 1.965.719.622 1.594-2.838a5.763 5.763 0 01-1.796-4.193c0-.809.169-1.61.493-2.341 1.171-2.767 5.206-4.834 10.037-4.834 1.14 0 2.233.112 3.256.325.166-.285.339-.564.54-.828a16.552 16.552 0 00-3.796-.428c-5.149 0-9.488 2.239-10.869 5.336a6.752 6.752 0 00-.588 2.77c0 1.636.582 3.133 1.53 4.291l-.104-.127v.345zm31.38-17.158c1.221 0 2.27.878 2.52 2.054v.005l.002.006c.154.991.252 2.123.272 3.326.002.125-.006.247-.006.372.004.142.025.293.029.439.04 2.497.366 4.7.83 6.048l.027.076-3.674 3.832-3.713-3.832.027-.076c.47-1.348.79-3.554.836-6.05.002-.144.027-.295.027-.437 0-.123-.008-.245-.006-.372.018-1.203.118-2.335.272-3.326v-.006l.002-.003c.247-1.178 1.339-2.056 2.555-2.056zm0 .269c-1.091 0-2.068.783-2.293 1.841-.152.98-.249 2.098-.268 3.287-.002.123.004.246.004.366 0 .144-.023.295-.025.443-.046 2.482-.364 4.68-.825 6.052l3.405 3.515 3.37-3.513c-.46-1.374-.78-3.572-.819-6.056 0-.146-.025-.295-.029-.439v-.002c0-.12.01-.243.008-.366a24.605 24.605 0 00-.272-3.291 2.325 2.325 0 00-2.256-1.837zM151.464 160.272h-.087v-5.482h.087v5.482zm-1.314 0h-.083v-5.482h.083v5.482zM148.977 160.272h-.214v-5.482h.214v5.482zm-1.228 0h-.212v-5.482h.212v5.482zm-1.094 0h-.212v-5.482h.212v5.482zm-2.085-.293h-.214l-.029-4.992h.214l.029 4.992zm.988.067h-.212v-5.223h.212v5.223zM142.751 159.755h-.428v-4.599h.428v4.599zm.977.128l-.428.005-.029-4.896.428-.003.029 4.894zm-3.559-.393h-.428v-4.039h.428v4.039zm.846.067h-.428v-4.237h.428v4.237zm.873.131h-.426v-4.401h.426v4.401zM139.368 159.457h-.64v-3.906h.64v3.906zm-.841.081h-.645v-4.276h.645v4.276zm-.909-.122h-.643v-3.99h.643v3.99zm-1.852-.35l-.645.004-.027-3.374.642-.004.03 3.374zm.95.208h-.643v-3.725h.643v3.725zM134.922 158.991h-.857v-3.049h.857v3.049zm-.872.034h-.854v-2.927h.854v2.927zm-.947-.566h-.859v-2.197h.859v2.197zm-.978.021h-.856v-2.008h.856v2.008zm-1.033-.262h-.857v-1.493h.857v1.493zM156.68 159.979h-.083v-5.025h.083v5.025zm-2.222.162h-.084l.03-5.318h.083l-.029 5.318zm-1.618.067h-.087v-5.418h.087v5.418z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M148.285 153.792c-8.046.014-15.253 1.054-20.397 2.738-.363.12-.557.464-.553.842-.02.389.175.765.553.888 5.144 1.69 12.351 2.727 20.397 2.74 8.046-.013 15.249-1.05 20.393-2.74.372-.123.567-.499.546-.888.008-.378-.183-.722-.546-.842-5.144-1.684-12.347-2.724-20.393-2.738zm-.019 1.443c7.26.014 13.856.875 18.852 2.285-4.996 1.405-11.592 2.32-18.852 2.33-7.262-.01-13.825-.925-18.822-2.33 4.997-1.41 11.56-2.271 18.822-2.285z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.202 157.374v-.004c-.006-.439.225-.828.643-.965 5.155-1.69 12.378-2.732 20.44-2.746 8.062.014 15.28 1.056 20.434 2.746.42.137.647.526.643.965.018.447-.213.875-.643 1.019-5.154 1.692-12.372 2.733-20.434 2.744-8.062-.011-15.285-1.052-20.44-2.744-.433-.144-.665-.57-.643-1.015zm21.083-3.447c-8.029.015-15.222 1.05-20.355 2.732-.305.1-.466.393-.459.711v.01c-.017.329.141.647.459.753 5.133 1.686 12.326 2.721 20.355 2.734 8.029-.013 15.216-1.048 20.351-2.734.314-.106.472-.426.455-.755v-.008c.007-.318-.15-.611-.455-.711-5.133-1.682-12.322-2.717-20.351-2.732zm-.019 1.17c7.275.017 13.884.882 18.89 2.293l.457.13-.457.129c-5.006 1.409-11.615 2.326-18.89 2.334-7.274-.008-13.852-.925-18.858-2.334l-.455-.129.455-.13c5.006-1.411 11.584-2.276 18.858-2.293zm0 .269c-7.025.016-13.392.823-18.317 2.154 4.925 1.33 11.292 2.187 18.317 2.195 7.021-.008 13.422-.865 18.349-2.195-4.927-1.331-11.328-2.138-18.349-2.154z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M148.229 153.786c-8.141.018-15.451 1.131-20.594 2.856.428-.22.389-.794-.144-2.286-.64-1.807-1.644-1.728-1.644-1.728 5.688-1.832 13.605-2.975 22.417-2.988 8.813.013 16.794 1.156 22.482 2.988 0 0-1.002-.079-1.642 1.728-.533 1.492-.572 2.066-.146 2.286-5.143-1.725-12.586-2.838-20.729-2.856z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.231 153.921h-.002c-8.125.017-15.42 1.127-20.553 2.85l-.104-.247c.171-.087.235-.252.217-.539-.021-.349-.163-.856-.425-1.584-.598-1.686-1.505-1.64-1.505-1.64l-.052-.26c5.699-1.834 13.63-2.983 22.457-2.996 8.832.013 16.823 1.162 22.521 2.996l-.049.26s-.907-.046-1.505 1.64c-.262.728-.402 1.235-.424 1.584-.021.287.043.452.213.539l-.104.247c-5.132-1.723-12.563-2.833-20.685-2.85zm-.002-.135l.002-.133c7.933.016 15.207 1.073 20.343 2.723a.907.907 0 01-.036-.193c-.031-.366.111-.948.439-1.873.385-1.082.896-1.52 1.272-1.697-5.642-1.744-13.419-2.827-21.985-2.84-8.563.013-16.278 1.096-21.92 2.84.378.177.89.615 1.274 1.697.329.925.47 1.507.439 1.873a1.144 1.144 0 01-.036.193c5.127-1.65 12.272-2.707 20.208-2.723v.133z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M148.264 149.642c-8.812.015-16.729 1.159-22.417 2.992-.378.123-.778-.039-.903-.428-.12-.393.084-.844.462-.969 5.713-1.911 13.831-3.11 22.86-3.129 9.029.017 17.181 1.218 22.892 3.129.38.125.584.576.461.969-.123.389-.524.551-.904.428-5.686-1.833-13.638-2.977-22.451-2.992z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.264 149.776c-8.796.014-16.698 1.153-22.374 2.985-.451.147-.927-.05-1.072-.516-.146-.461.102-.987.547-1.135 5.721-1.915 13.858-3.116 22.901-3.135 9.046.017 17.212 1.22 22.935 3.135.445.148.691.674.545 1.135-.145.466-.622.663-1.071.516-5.677-1.832-13.613-2.971-22.411-2.985zm0-.134v-.135c8.832.015 16.794 1.162 22.492 3 .308.1.635-.027.734-.343.102-.322-.06-.694-.374-.8-5.702-1.907-13.837-3.104-22.85-3.121-9.01.019-17.118 1.214-22.818 3.121-.312.106-.476.478-.375.8.1.316.427.443.734.343 5.699-1.838 13.63-2.985 22.457-3v.135z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M141.978 151.823c0-.407.322-.742.719-.742.399 0 .719.335.719.742 0 .408-.32.744-.719.744a.734.734 0 01-.719-.744z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M141.845 151.823c0-.482.384-.875.852-.875.472 0 .854.393.854.875 0 .485-.382.88-.854.88-.468 0-.852-.395-.852-.88zm.268 0c0 .333.26.611.584.611a.6.6 0 00.586-.611.595.595 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M150.466 152.408h-4.339a.738.738 0 01-.73-.741c0-.411.323-.746.72-.746h4.357c.397 0 .721.335.721.746 0 .41-.33.741-.729.741z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146.127 152.542a.87.87 0 01-.863-.875c0-.484.383-.879.853-.879h4.357a.87.87 0 01.855.879.87.87 0 01-.863.875h-4.339zm4.339-.268a.603.603 0 00.595-.607.6.6 0 00-.587-.611h-4.357a.599.599 0 00-.584.611c0 .335.268.607.594.607h4.339z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M137.449 153.054l-1.55.198a.735.735 0 01-.811-.643.736.736 0 01.628-.83l1.559-.197 1.588-.198a.72.72 0 01.8.643.742.742 0 01-.633.827l-1.581.2z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.468 153.187l-1.553.198a.865.865 0 01-.96-.761.872.872 0 01.744-.978l1.559-.197 1.586-.198a.855.855 0 01.953.759v.003a.881.881 0 01-.751.974l-1.578.2zm-.035-.266l1.58-.2a.61.61 0 00.518-.677.588.588 0 00-.653-.527l-1.584.198-1.562.198a.6.6 0 00-.511.677.6.6 0 00.661.528l1.551-.197z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M131.146 153.204c0-.408.322-.742.72-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.013 153.204c0-.483.385-.876.853-.876.471 0 .854.393.854.876a.868.868 0 01-.854.879c-.468 0-.853-.395-.853-.879zm.268 0c0 .332.26.611.585.611.326 0 .586-.279.586-.611a.595.595 0 00-.586-.607.595.595 0 00-.585.607z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M126.497 154.326l.658-.912 2.207.303-1.767 1.405-.977-.409-.28-.139z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.092 153.27l2.599.356-2.073 1.65-1.056-.44-.42-.21.245-.374.705-.982zm-.484 1.135l-.075.115.139.07.903.379 1.459-1.16-1.821-.252-.605.848z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M159.114 153.054l1.551.198a.736.736 0 00.811-.643c.044-.412-.233-.782-.628-.83l-1.559-.197-1.586-.198a.718.718 0 00-.801.643.738.738 0 00.634.827l1.578.2z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159.098 153.187l-1.58-.2a.877.877 0 01-.749-.977.85.85 0 01.95-.759l1.589.198 1.557.197a.875.875 0 01.744.975v.003a.869.869 0 01-.962.761l-1.549-.198zm.035-.266l1.549.197a.6.6 0 00.661-.526c.035-.334-.189-.64-.509-.679l-1.562-.198-1.586-.198a.585.585 0 00-.651.527.607.607 0 00.516.677l1.582.2z"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M153.146 151.823c0-.407.324-.742.719-.742.399 0 .721.335.721.742a.734.734 0 01-.721.744c-.395 0-.719-.336-.719-.744zm10.831 1.381c0-.412.324-.745.722-.745.396 0 .719.333.719.745a.732.732 0 01-.719.742.733.733 0 01-.722-.742z"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M153.013 151.823c0-.482.384-.875.852-.875.472 0 .854.393.854.875 0 .485-.382.88-.854.88-.468 0-.852-.395-.852-.88zm.268 0c0 .333.26.611.584.611a.6.6 0 00.586-.611.595.595 0 00-.586-.607.596.596 0 00-.584.607zm10.563 1.381c0-.485.385-.878.855-.878.469 0 .852.393.852.878a.866.866 0 01-.852.877.868.868 0 01-.855-.877zm.268 0a.6.6 0 00.587.609.598.598 0 00.583-.609.597.597 0 00-.583-.609.599.599 0 00-.587.609z"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M170.212 154.553l-.8-1.139-2.208.303 1.767 1.405 1.187-.415.124-.046z"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.32 154.476l.004.006.069.102c.085.129-.111.21-.111.21l.044-.006-.118.041-.005.002-1.189.418-.07.025-2.069-1.648 2.601-.356.844 1.206zm-.162.364l-.025-.162-.002-.005.027.167zm-.083-.247l-.726-1.036-1.817.252 1.463 1.164 1.08-.38z"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M148.208 122.93c.601 0 1.108.416 1.231.992.145.935.239 2.002.26 3.128 0 .119-.007.235-.007.35 0 .139.021.278.025.422.036 2.374.35 4.465.797 5.754l-2.321 2.397-2.326-2.397c.443-1.287.757-3.38.796-5.754.003-.144.024-.283.028-.422 0-.115-.009-.231-.009-.35.021-1.126.114-2.193.26-3.128.121-.576.669-.992 1.266-.992z"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.208 122.795c.665 0 1.227.459 1.362 1.101l.002.003v.004c.145.939.239 2.012.26 3.147 0 .119-.004.235-.004.35 0 .139.02.278.022.42.04 2.357.348 4.434.791 5.713l.026.076-2.474 2.558-2.48-2.558.027-.076c.441-1.277.751-3.356.789-5.713.001-.144.022-.281.024-.42 0-.115-.006-.231-.006-.35v-.002c.021-1.133.116-2.206.262-3.145l.002-.002v-.005c.133-.64.738-1.101 1.397-1.101zm0 .268c-.532 0-1.025.37-1.135.886a23.53 23.53 0 00-.258 3.103c0 .119.009.233.009.35-.004.139-.025.278-.028.422-.037 2.345-.345 4.418-.777 5.717l2.174 2.239 2.169-2.239c-.436-1.302-.742-3.372-.78-5.717-.002-.144-.023-.283-.023-.424 0-.115.004-.229.004-.348a23.386 23.386 0 00-.255-3.103v-.005a1.12 1.12 0 00-1.1-.881z"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M146.957 134.366c0-.713.561-1.285 1.251-1.285.686 0 1.247.572 1.247 1.285s-.561 1.289-1.247 1.289c-.69 0-1.251-.576-1.251-1.289z"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146.826 134.366c0-.786.619-1.42 1.382-1.42.761 0 1.385.634 1.385 1.42 0 .788-.624 1.422-1.385 1.422-.763 0-1.382-.634-1.382-1.422zm.266 0c0 .638.501 1.156 1.116 1.156.618 0 1.117-.518 1.117-1.156 0-.636-.499-1.152-1.117-1.152-.615 0-1.116.516-1.116 1.152z"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M146.959 131.838c0-.709.559-1.291 1.249-1.291.688 0 1.25.582 1.25 1.291 0 .711-.562 1.287-1.25 1.287-.69 0-1.249-.576-1.249-1.287zm.249-2.717c0-.57.449-1.029 1-1.029.549 0 .996.459.996 1.029 0 .567-.447 1.029-.996 1.029-.551 0-1-.462-1-1.029zm.283-2.449a.73.73 0 01.717-.742.73.73 0 01.717.742.73.73 0 01-.717.742.73.73 0 01-.717-.742zm.141-2.143c0-.331.258-.595.576-.595.318 0 .574.264.574.595a.583.583 0 01-.574.592.585.585 0 01-.576-.592z"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146.824 131.838c0-.785.621-1.424 1.384-1.424.761 0 1.385.639 1.385 1.424 0 .786-.624 1.422-1.385 1.422-.763 0-1.384-.636-1.384-1.422zm.268 0c0 .636.501 1.154 1.116 1.154.618 0 1.117-.518 1.117-1.154 0-.634-.499-1.156-1.117-1.156-.615 0-1.116.522-1.116 1.156zm-.017-2.717c0-.645.507-1.162 1.133-1.162.622 0 1.129.517 1.129 1.162 0 .645-.507 1.162-1.129 1.162a1.146 1.146 0 01-1.133-1.162zm.268 0c0 .493.387.894.865.894.474 0 .861-.401.861-.894s-.387-.892-.861-.892a.878.878 0 00-.865.892zm.011-2.449c0-.484.384-.875.854-.875s.852.391.852.875a.864.864 0 01-.852.877.867.867 0 01-.854-.877zm.27 0c0 .335.26.609.584.609a.597.597 0 00.584-.609.595.595 0 00-.584-.607.595.595 0 00-.584.607zm-.127-2.143c0-.408.318-.728.711-.728.389 0 .709.32.709.728 0 .403-.32.727-.709.727a.718.718 0 01-.711-.727zm.268 0c0 .251.198.459.443.459a.452.452 0 00.441-.459.45.45 0 00-.441-.46.45.45 0 00-.443.46z"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M148.312 142.121l.815.162c-.133.358-.16.75-.16 1.16 0 1.836 1.447 3.33 3.229 3.33 1.43 0 2.646-.964 3.064-2.297.048.034.308-1.204.443-1.191.112.015.102 1.289.141 1.266.208 1.678 1.616 2.813 3.2 2.813 1.777 0 3.22-1.484 3.22-3.324 0-.136-.009-.273-.025-.406l1.01-1.091.545 1.391c-.216.436-.303.927-.303 1.453 0 1.755 1.378 3.172 3.078 3.172a3.052 3.052 0 002.562-1.411l.646-.897-.006 1.1c0 1.104.428 2.096 1.416 2.271 0 0 1.137.075 2.642-1.211 1.505-1.288 2.335-2.355 2.335-2.355l.127 1.291s-1.248 2.104-2.609 2.963c-.743.472-1.872.966-2.77.806-.947-.166-1.625-.998-1.975-1.954a4.319 4.319 0 01-2.332.688c-1.838 0-3.493-1.099-4.148-2.756-.846.995-2.022 1.609-3.407 1.609-1.468 0-2.813-.722-3.657-1.828a4.535 4.535 0 01-3.197 1.331c-1.628 0-3.079-.869-3.901-2.181-.821 1.312-2.27 2.181-3.894 2.181a4.55 4.55 0 01-3.201-1.331 4.624 4.624 0 01-3.657 1.828c-1.382 0-2.561-.614-3.407-1.609-.655 1.657-2.306 2.756-4.146 2.756a4.307 4.307 0 01-2.33-.688c-.354.956-1.03 1.788-1.975 1.954-.899.16-2.027-.334-2.774-.806-1.359-.859-2.609-2.963-2.609-2.963l.131-1.291s.83 1.067 2.333 2.355c1.505 1.29 2.64 1.211 2.64 1.211.99-.175 1.416-1.167 1.416-2.271l-.004-1.1.646.897a3.052 3.052 0 002.562 1.411c1.7 0 3.077-1.417 3.077-3.172 0-.526-.088-1.017-.302-1.453l.543-1.391 1.012 1.091c-.016.133-.025.27-.025.406 0 1.84 1.441 3.324 3.218 3.324 1.589 0 2.992-1.135 3.198-2.813.045.023.033-1.251.147-1.266.133-.013.395 1.225.439 1.191.422 1.333 1.636 2.297 3.071 2.297 1.779 0 3.224-1.494 3.224-3.33 0-.41-.023-.802-.156-1.16l.84-.162z"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M140.641 144.343c.016-.266.029-.748.07-.967a.457.457 0 01.056-.156.154.154 0 01.111-.068.165.165 0 01.12.035.392.392 0 01.1.14c.098.207.216.679.293.931l.013-.01.058.187c.403 1.278 1.567 2.203 2.942 2.203 1.707 0 3.089-1.434 3.089-3.195 0-.395-.021-.769-.148-1.114l-.054-.148.996-.193.025.133.027-.133.967.195-.056.146c-.123.345-.148.719-.148 1.114 0 1.761 1.385 3.195 3.094 3.195 1.37 0 2.536-.925 2.937-2.203l.054-.181.017.008c.075-.247.195-.728.295-.935a.392.392 0 01.1-.14.159.159 0 01.118-.035.161.161 0 01.113.068c.018.03.041.082.054.156.043.217.056.693.068.961l.025.197c.2 1.609 1.549 2.695 3.067 2.695 1.705 0 3.087-1.424 3.087-3.189 0-.131-.009-.262-.025-.389l-.006-.063 1.197-1.295.643 1.647-.028.052c-.205.42-.288.89-.288 1.395 0 1.68 1.318 3.039 2.945 3.039 1.021 0 1.919-.536 2.45-1.353l.893-1.237-.006 1.515c0 1.031.376 1.969 1.299 2.138.096.002 1.152.004 2.537-1.179 1.493-1.277 2.314-2.335 2.314-2.335l.208-.264.166 1.665-.023.04s-1.27 2.135-2.653 3.006c-.769.491-1.937.992-2.865.828-.943-.167-1.638-.953-2.018-1.89a4.433 4.433 0 01-2.266.623c-1.821 0-3.464-1.045-4.189-2.64-.859.929-2.017 1.495-3.366 1.495a4.76 4.76 0 01-3.671-1.765 4.65 4.65 0 01-3.183 1.266 4.748 4.748 0 01-3.901-2.069 4.734 4.734 0 01-3.894 2.069 4.667 4.667 0 01-3.186-1.264c-.872 1.07-2.213 1.763-3.672 1.763-1.347 0-2.507-.566-3.368-1.495-.721 1.595-2.366 2.64-4.185 2.64a4.423 4.423 0 01-2.264-.623c-.384.937-1.079 1.723-2.02 1.89-.928.164-2.096-.337-2.867-.828-1.381-.871-2.651-3.008-2.651-3.008l-.023-.038.168-1.665.206.264s.824 1.058 2.316 2.335c1.387 1.191 2.445 1.181 2.538 1.179.917-.171 1.296-1.107 1.296-2.138l-.009-1.515.895 1.237.002.002a2.918 2.918 0 002.449 1.351c1.627 0 2.943-1.359 2.943-3.039 0-.505-.081-.975-.291-1.395l-.023-.052.641-1.647 1.199 1.295-.006.061c-.016.129-.025.26-.025.391 0 1.765 1.379 3.189 3.085 3.189 1.522 0 2.867-1.086 3.065-2.695l.025-.193.002.002zm7.671-2.087l-.667.129c.098.332.116.688.116 1.058 0 1.91-1.503 3.463-3.357 3.463-1.481 0-2.74-.989-3.189-2.359-.009-.013-.015-.027-.024-.044-.043-.096-.128-.436-.218-.729a.58.58 0 00-.029-.086c-.023.323-.033.74-.052.855a.145.145 0 01-.014.047c-.227 1.736-1.682 2.907-3.329 2.907-1.85 0-3.353-1.543-3.353-3.457 0-.121.008-.244.019-.36l-.824-.89-.446 1.137c.205.443.292.934.292 1.46 0 1.829-1.438 3.307-3.211 3.307a3.188 3.188 0 01-2.672-1.469l-.399-.556.002.682c0 1.175-.476 2.217-1.528 2.401l-.006.003h-.008s-1.179.091-2.736-1.241a20.003 20.003 0 01-2.144-2.125l-.095.927c.172.285 1.311 2.104 2.544 2.879.72.458 1.809.946 2.676.79.902-.16 1.538-.958 1.873-1.869l.058-.158.142.092a4.142 4.142 0 002.257.665c1.784 0 3.387-1.064 4.021-2.669l.081-.208.146.17c.821.967 1.964 1.562 3.305 1.562a4.485 4.485 0 003.551-1.778l.091-.121.11.108a4.398 4.398 0 003.106 1.292c1.576 0 2.982-.844 3.78-2.117l.114-.181.113.181c.8 1.273 2.208 2.117 3.788 2.117a4.39 4.39 0 003.103-1.292l.108-.108.092.121a4.491 4.491 0 003.551 1.778c1.343 0 2.484-.595 3.305-1.562l.146-.17.081.208c.634 1.605 2.239 2.669 4.023 2.669.829 0 1.605-.243 2.262-.665l.139-.092.058.158c.333.911.969 1.709 1.873 1.869.867.156 1.954-.332 2.674-.79 1.233-.775 2.37-2.594 2.543-2.879l-.094-.927a19.943 19.943 0 01-2.145 2.125c-1.558 1.33-2.736 1.241-2.736 1.241h-.007l-.006-.003c-1.054-.184-1.528-1.226-1.528-2.401l.002-.682s-.397.552-.399.553a3.18 3.18 0 01-2.672 1.472c-1.773 0-3.214-1.478-3.214-3.307 0-.526.086-1.017.291-1.46l-.442-1.137-.823.89c.01.116.018.239.018.36 0 1.914-1.503 3.457-3.355 3.457-1.643 0-3.102-1.171-3.329-2.907a.162.162 0 01-.012-.047c-.019-.117-.027-.539-.052-.861-.079.245-.158.559-.212.724a.583.583 0 01-.06.141s0 .002-.003.004c-.444 1.368-1.704 2.355-3.18 2.355-1.855 0-3.362-1.553-3.362-3.463 0-.37.023-.728.116-1.058l-.638-.129z"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M170.463 146.509c.185-.596.019-1.187-.376-1.316-.391-.135-.865.242-1.05.834-.189.594-.021 1.183.372 1.318.395.129.867-.243 1.054-.836zm-14.024-2.962c.072-.622-.2-1.164-.609-1.214-.414-.054-.805.405-.88 1.023-.075.621.198 1.166.612 1.22.409.05.804-.407.877-1.029zm-16.283 0c-.075-.622.202-1.164.61-1.214.411-.054.804.405.879 1.023.068.621-.2 1.166-.612 1.22-.409.05-.804-.407-.877-1.029zm-14.022 2.962c-.187-.596-.021-1.187.374-1.316.393-.135.863.242 1.052.834.183.594.015 1.183-.374 1.318-.395.129-.863-.243-1.052-.836z"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.59 146.549c-.122.391-.362.694-.625.842a.717.717 0 01-.597.081.757.757 0 01-.435-.422c-.126-.281-.15-.67-.025-1.062.125-.393.364-.697.628-.847a.72.72 0 01.597-.074.742.742 0 01.434.418c.125.278.146.671.023 1.064zm-.255-.079v-.002c.101-.322.089-.642-.013-.873a.475.475 0 00-.277-.275.466.466 0 00-.376.054c-.216.125-.403.374-.503.697-.102.318-.093.638.011.869.06.133.153.235.276.276.123.04.254.013.379-.058.212-.12.403-.372.503-.688zm-13.763-2.909c-.05.412-.229.755-.46.955a.735.735 0 01-.569.193.736.736 0 01-.506-.328c-.176-.254-.268-.63-.22-1.04.05-.408.227-.755.457-.952a.726.726 0 01.57-.189c.202.023.376.141.507.324.177.251.268.628.221 1.037zm-.266-.029c.039-.339-.029-.648-.173-.852-.085-.118-.193-.2-.322-.214-.129-.019-.252.033-.362.127-.187.162-.324.447-.366.781-.039.335.029.645.173.851a.47.47 0 00.32.218.476.476 0 00.362-.129c.189-.164.328-.447.368-.782zm-16.283.029c-.05-.409.044-.786.221-1.037.131-.183.305-.301.505-.324a.723.723 0 01.569.189c.231.197.412.544.46.954.048.408-.046.784-.22 1.038a.744.744 0 01-.508.328.735.735 0 01-.569-.193c-.231-.2-.41-.543-.458-.955zm.266-.029c.04.335.179.618.368.782a.476.476 0 00.36.129c.129-.017.235-.098.32-.218.144-.206.212-.516.173-.851-.04-.334-.177-.619-.366-.781-.108-.094-.233-.146-.362-.127a.458.458 0 00-.318.214c-.146.204-.216.513-.175.852zm-14.284 3.017c-.121-.393-.102-.786.025-1.064a.734.734 0 01.436-.418.716.716 0 01.595.074c.262.15.501.454.626.847.12.392.1.781-.025 1.062a.76.76 0 01-.435.422.708.708 0 01-.594-.081c-.264-.148-.503-.451-.628-.842zm.258-.081v.002c.1.316.288.568.503.688a.46.46 0 00.376.058.472.472 0 00.272-.276c.107-.231.117-.551.017-.871-.102-.321-.291-.574-.503-.695-.125-.068-.256-.095-.377-.054a.476.476 0 00-.276.275c-.104.231-.114.551-.012.873z"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M132.52 143.609a1.321 1.321 0 01-.442-.771 1.32 1.32 0 01.153-.879s-.584-.319-1.203-.497c-.472-.136-1.304-.14-1.555-.144a89.694 89.694 0 00-.753-.018s.042.122.183.392c.172.329.326.535.326.535-.831.21-1.54.806-1.989 1.497.651.488 1.515.786 2.362.692 0 0-.073.245-.127.622-.044.305-.042.432-.042.432s.468-.187.701-.283c.234-.094 1.012-.386 1.413-.682.524-.39.973-.894.973-.894v-.002zm1.863-.341a1.306 1.306 0 00-.272-1.65s.438-.506.962-.894c.399-.296 1.181-.591 1.416-.682.233-.094.701-.287.701-.287s.002.131-.044.439a4.213 4.213 0 01-.129.617c.853-.098 1.717.212 2.366.705-.447.69-1.16 1.274-1.99 1.484 0 0 .15.206.325.532.143.275.185.395.185.395s-.501-.012-.755-.016c-.249-.004-1.081-.007-1.553-.144-.622-.183-1.212-.495-1.212-.495v-.004z"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M128.72 141.433l-.092-.273.096.002.751.021c.257.006 1.106.013 1.588.152a6.887 6.887 0 011.233.507l.118.067-.068.116a1.187 1.187 0 00-.137.788c.05.283.199.524.399.695l-.088.101.102.092s-.459.513-.993.912c-.41.302-1.207.603-1.443.699l-.701.281-.052.02v-.008s-.133-.01-.133-.137c0-.025 0-.162.042-.451.027-.187.058-.341.085-.452-.821.038-1.638-.261-2.266-.735l-.1-.075.066-.104c.435-.668 1.1-1.247 1.886-1.501a6.018 6.018 0 01-.227-.395 2.895 2.895 0 01-.191-.408l-.002-.006.127.092zm.861 3.833c.155-.062.368-.147.505-.204.226-.089.99-.376 1.382-.663.377-.283.711-.621.865-.783-.193-.2-.337-.46-.389-.757a1.449 1.449 0 01.109-.842 6.654 6.654 0 00-1.063-.426c-.461-.132-1.276-.136-1.521-.14-.146-.004-.377-.01-.543-.012.023.05.056.114.098.193.166.316.311.516.311.516l.121.16-.195.048c-.757.191-1.404.717-1.836 1.334.609.426 1.391.678 2.164.593l.202-.023-.061.193s-.07.239-.122.601a4.592 4.592 0 00-.027.212zm7.609-5.376s.135-.254.135-.131c0 .027-.002.164-.046.453a4.501 4.501 0 01-.083.449c.819-.037 1.64.275 2.268.749l.1.075-.069.104c-.43.665-1.102 1.236-1.888 1.488.061.096.142.229.229.393v.002c.133.254.181.383.192.407.05.14-.125.183-.125.183h-.002c-.002 0-.005 0-.006-.002-.061 0-.514-.01-.749-.014-.256-.006-1.106-.01-1.588-.152-.634-.183-1.235-.505-1.235-.505l.064-.119-.118-.068c.131-.227.193-.507.143-.79a1.16 1.16 0 00-.387-.693l-.102-.087.086-.104s.449-.515.985-.913c.408-.301 1.204-.604 1.445-.7l.699-.283.045-.018.007.276zm-2.626 3.322c.2.098.626.297 1.069.426.461.133 1.274.136 1.521.14.144.002.375.008.543.01l-.098-.193c-.168-.316-.316-.516-.316-.516l-.114-.162.193-.046c.753-.191 1.406-.709 1.838-1.322-.609-.43-1.395-.694-2.166-.605l-.202.023.058-.195s.073-.237.123-.597c.015-.083.023-.154.027-.214l-.503.205c-.229.088-.994.379-1.383.668a6.45 6.45 0 00-.856.777 1.453 1.453 0 01.266 1.601z"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M133.736 138.476s.086-.183.468-.424c.385-.235.713-.228.713-.228s-.11.692-.168.943c-.054.244-.056.986-.206 1.657a5.792 5.792 0 01-.414 1.208 1.223 1.223 0 00-1.033-.297c-.384.07-.694.316-.873.64 0 0-.428-.407-.792-.985-.358-.576-.605-1.273-.738-1.483-.135-.214-.47-.827-.47-.827s.308-.125.746-.035c.441.089.578.233.578.233a3.863 3.863 0 01.678-2.57c.695.478 1.302 1.276 1.511 2.168z"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.797 138.194c.077-.073.185-.16.337-.254.424-.262.788-.252.788-.252l.153.004-.024.152s-.113.701-.171.955c-.054.241-.056.985-.206 1.654-.15.689-.426 1.237-.426 1.237l-.077.156-.131-.114a1.1 1.1 0 00-.919-.266 1.123 1.123 0 00-.782.576l-.083.15-.127-.119s-.438-.42-.812-1.013c-.358-.575-.605-1.272-.738-1.482a22.412 22.412 0 01-.474-.833l-.073-.133.139-.057s.339-.141.826-.043c.172.035.303.079.401.122a4 4 0 01.717-2.403l.077-.108.108.075a3.988 3.988 0 011.497 1.996zm.083.307l.027.111h-.379l.069-.15c-.202-.792-.727-1.505-1.338-1.963a3.735 3.735 0 00-.579 2.366l.044.391-.274-.285s-.123-.118-.507-.195a1.391 1.391 0 00-.521-.009c.107.192.29.524.383.67.133.21.383.906.74 1.482.237.381.508.684.655.842.204-.283.508-.491.871-.559a1.36 1.36 0 011.007.218c.087-.199.237-.582.334-1.025.15-.672.152-1.416.208-1.659.04-.166.102-.538.139-.761-.12.025-.295.075-.484.192-.243.154-.352.276-.395.334z"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M131.911 142.601c0-.813.639-1.472 1.424-1.472.78 0 1.422.659 1.422 1.472 0 .811-.64 1.468-1.422 1.468-.785 0-1.424-.657-1.424-1.468z"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.778 142.601c0-.888.699-1.603 1.557-1.603.855 0 1.555.715 1.555 1.603 0 .883-.698 1.603-1.555 1.603-.858 0-1.557-.72-1.557-1.603zm.268 0c0 .736.578 1.335 1.289 1.335s1.287-.599 1.287-1.335-.578-1.335-1.287-1.335c-.711 0-1.289.599-1.289 1.335z"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M149.537 136.684s.122-.187.596-.376.84-.115.84-.115-.256.755-.366 1.019c-.108.264-.253 1.092-.547 1.805-.289.719-.69 1.26-.69 1.26a1.408 1.408 0 00-1.098-.535c-.438 0-.833.211-1.093.535 0 0-.401-.541-.692-1.26-.291-.713-.437-1.541-.545-1.805a27.27 27.27 0 01-.368-1.019s.368-.074.84.115c.476.189.601.376.601.376.064-1.039.563-2.05 1.245-2.725.682.675 1.21 1.686 1.277 2.725z"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.642 136.41c.103-.069.244-.15.442-.227.517-.203.914-.123.914-.123l.15.032-.048.145s-.256.761-.368 1.027c-.112.262-.254 1.09-.549 1.805-.293.736-.705 1.287-.705 1.287l-.104.139-.108-.135a1.28 1.28 0 00-.994-.485 1.28 1.28 0 00-.989.485l-.108.135-.104-.139s-.409-.551-.707-1.287c-.293-.715-.436-1.543-.547-1.805-.112-.266-.37-1.027-.37-1.027l-.047-.145.147-.032s.401-.08.917.123c.199.081.341.16.443.229a4.499 4.499 0 011.257-2.547l.096-.093.092.093c.648.639 1.157 1.57 1.29 2.545zm-.238.283c-.063-.957-.528-1.89-1.144-2.543-.611.653-1.052 1.586-1.112 2.543l-.023.392-.222-.328s-.117-.156-.539-.324a1.6 1.6 0 00-.605-.119c.079.235.231.661.308.846.108.264.251 1.092.545 1.807v.002c.197.487.449.892.582 1.092a1.519 1.519 0 011.078-.454c.425 0 .805.175 1.086.454a6.4 6.4 0 00.578-1.094c.295-.715.439-1.543.549-1.809.079-.183.224-.609.305-.844a1.602 1.602 0 00-.607.119c-.42.168-.536.324-.536.324l-.218.337-.025-.401z"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M147.2 142.158a1.482 1.482 0 01-.01-1.896s-.587-.476-1.246-.8c-.499-.25-1.428-.42-1.705-.479l-.835-.172s.023.146.128.478c.132.404.262.664.262.664-.964.062-1.87.586-2.5 1.263.63.672 1.534 1.185 2.5 1.254 0 0-.13.254-.262.663a3.523 3.523 0 00-.128.474s.557-.114.835-.168c.277-.061 1.206-.231 1.705-.483.659-.324 1.256-.796 1.256-.796v-.002zm2.141 0a1.49 1.49 0 00.009-1.896s.588-.476 1.247-.8c.501-.25 1.428-.42 1.707-.479.274-.058.831-.172.831-.172s-.021.146-.131.478c-.131.404-.26.664-.26.664.967.062 1.873.586 2.502 1.263-.629.672-1.535 1.185-2.499 1.254 0 0 .126.254.257.663.108.325.131.474.131.474s-.555-.114-.831-.168c-.279-.061-1.206-.231-1.707-.483-.659-.324-1.256-.796-1.256-.796v-.002zm13.515-3.682s-.085-.183-.467-.424c-.383-.235-.713-.228-.713-.228s.11.692.168.943c.056.244.058.986.204 1.657.149.67.418 1.208.418 1.208a1.221 1.221 0 011.033-.297c.382.07.692.316.873.64 0 0 .428-.407.79-.985.357-.576.607-1.273.74-1.483.135-.214.47-.827.47-.827s-.308-.125-.749-.035c-.44.089-.577.233-.577.233a3.862 3.862 0 00-.676-2.57c-.695.478-1.302 1.276-1.515 2.168h.001z"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M162.796 138.194a4.018 4.018 0 011.495-1.996l.112-.075.075.108c.466.655.746 1.534.719 2.403.098-.043.227-.087.401-.122.485-.098.824.043.824.043l.141.057-.074.133s-.337.617-.474.833c-.134.21-.381.907-.739 1.482-.372.593-.81 1.013-.81 1.013l-.127.119-.085-.15a1.118 1.118 0 00-.78-.576 1.1 1.1 0 00-.921.266l-.131.114-.077-.156s-.274-.548-.428-1.237c-.146-.669-.148-1.413-.204-1.659-.058-.249-.17-.95-.17-.95l-.025-.152.154-.004s.365-.01.789.252c.15.096.256.181.335.254zm.202.268l.069.15h-.381l.027-.111c-.041-.058-.149-.18-.395-.334a1.479 1.479 0 00-.482-.192c.037.223.099.595.137.761.058.243.06.987.206 1.659.1.443.251.826.337 1.025a1.358 1.358 0 011.006-.218c.364.068.667.276.873.559.147-.158.416-.461.653-.842.359-.576.607-1.272.74-1.482.091-.146.278-.478.385-.67a1.397 1.397 0 00-.522.009c-.383.077-.508.195-.508.195l-.272.285.041-.391a3.72 3.72 0 00-.575-2.366c-.614.458-1.137 1.171-1.339 1.963zm-15.8 3.696l.083.11s-.605.476-1.277.809c-.509.256-1.453.431-1.738.493l-.835.168-.19.038.03-.192s.023-.151.135-.494c.068-.215.137-.387.189-.508-.93-.12-1.79-.623-2.399-1.274l-.088-.092.086-.091c.611-.657 1.474-1.172 2.401-1.287a5.49 5.49 0 01-.189-.507 3.766 3.766 0 01-.135-.497l-.03-.191.19.037.835.173c.283.058 1.229.234 1.738.488a7.777 7.777 0 011.269.819l.106.085-.086.104a1.342 1.342 0 00-.307.859c0 .33.125.632.316.865l-.104.085zm-.185-.023a1.623 1.623 0 01-.296-.927c0-.339.107-.661.285-.921a7.328 7.328 0 00-1.118-.705c-.489-.243-1.399-.411-1.672-.467-.17-.036-.443-.092-.632-.129.021.066.046.155.081.262.125.392.252.644.252.644l.092.181-.202.013c-.888.058-1.724.521-2.325 1.13.601.603 1.437 1.056 2.325 1.119l.202.015-.092.178s-.127.25-.252.645c-.035.106-.06.193-.081.262.189-.04.46-.094.632-.127.273-.06 1.183-.225 1.672-.472a7.984 7.984 0 001.129-.701zm2.33.023l-.104-.085c.191-.233.314-.535.314-.865a1.34 1.34 0 00-.305-.859l-.086-.104.104-.087s.599-.484 1.271-.817c.511-.254 1.455-.43 1.74-.488.274-.059.831-.173.831-.173l.185-.037-.025.185s-.021.154-.137.505a5.735 5.735 0 01-.187.505c.927.115 1.792.63 2.399 1.287l.086.091-.086.092c-.609.651-1.47 1.154-2.399 1.276.052.119.119.291.187.506.114.343.137.497.137.497l.027.189-.187-.038s-.555-.114-.833-.168c-.283-.062-1.229-.237-1.738-.493-.672-.333-1.277-.809-1.277-.809l.083-.11zm.185-.023c.196.144.645.464 1.129.703.491.245 1.397.41 1.674.47.17.033.441.087.623.127a3.592 3.592 0 00-.077-.262h-.002c-.127-.395-.249-.645-.249-.645l-.09-.178.2-.015c.89-.063 1.723-.516 2.324-1.119-.601-.609-1.438-1.072-2.322-1.13l-.202-.013.09-.181s.122-.252.251-.644c.036-.108.061-.196.082-.262-.187.037-.46.093-.628.129v.002c-.273.054-1.183.222-1.674.465-.484.237-.925.56-1.118.705.178.26.285.582.285.921 0 .343-.115.665-.296.927z"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M164.077 143.609c.22-.191.389-.457.439-.771.054-.304 0-.617-.148-.879-.15-.258.578-.319 1.199-.497.472-.136 1.306-.14 1.553-.144.254-.008.755-.018.755-.018s-.039.122-.185.392c-.173.329-.324.535-.324.535.831.21 1.538.806 1.987 1.497-.646.488-1.511.786-2.361.692 0 0 .076.245.126.622.044.305.04.432.04.432s-.468-.187-.697-.283c-.232-.094-1.014-.386-1.415-.682-.522-.39-.969-.894-.969-.894v-.002zm-1.867-.341a1.342 1.342 0 01-.162-.879c.056-.314.216-.58.436-.771 0 0-.441-.506-.964-.894-.4-.296-1.181-.591-1.414-.682-.233-.094-.698-.287-.698-.287s-.003.131.041.439c.052.372.127.617.127.617-.848-.098-1.715.212-2.364.705.449.69 1.16 1.274 1.99 1.484 0 0-.152.206-.325.532-.143.275-.183.395-.183.395s.499-.012.751-.016c.249-.004 1.085-.007 1.555-.144a7.618 7.618 0 001.208-.495l.002-.004z"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.077 143.609l-.09-.101a1.17 1.17 0 00.397-.693v-.002c.048-.27 0-.553-.134-.788a.258.258 0 01-.032-.179.313.313 0 01.158-.191c.206-.12.707-.193 1.154-.32.482-.139 1.335-.146 1.588-.152.252-.006.753-.021.753-.021l.087-.002.044.179-.002.006a2.759 2.759 0 01-.192.412 5.909 5.909 0 01-.228.393c.786.254 1.453.833 1.888 1.501l.066.104-.1.075c-.626.474-1.445.773-2.264.735.025.111.059.265.081.452v.002c.04.287.044.424.044.447 0 .129-.137.139-.137.139v.008l-.048-.02s-.468-.185-.7-.281c-.237-.096-1.034-.397-1.443-.699a7.726 7.726 0 01-.99-.912l.1-.092zm2.935 1.657a7.395 7.395 0 00-.025-.212c-.049-.362-.122-.599-.122-.599l-.06-.195.201.023c.774.085 1.557-.167 2.164-.593-.432-.617-1.083-1.143-1.836-1.334l-.195-.048.119-.16s.147-.2.313-.516a7.52 7.52 0 00.098-.193 40.78 40.78 0 00-.544.012h-.003c-.241.004-1.056.008-1.517.14-.37.108-.776.168-1.01.257a.677.677 0 00-.107.057c.161.284.219.623.161.954a1.434 1.434 0 01-.385.757c.152.162.486.5.861.783.393.287 1.158.574 1.386.663.133.057.343.142.501.204zm-7.604-5.376l.004-.276.047.018.695.283c.241.096 1.041.401 1.447.7.536.398.983.913.983.913l.089.104-.101.087c-.198.171-.341.41-.391.693a1.21 1.21 0 00.146.79l-.121.068.064.119s-.601.322-1.233.505c-.482.142-1.336.146-1.59.152-.229.004-.661.014-.74.014a.043.043 0 01-.013.002l-.127-.174s0-.004.003-.006c.006-.025.051-.154.191-.412.085-.164.166-.297.224-.393-.781-.252-1.451-.823-1.885-1.489l-.067-.103.1-.075c.622-.474 1.445-.786 2.266-.749a6.064 6.064 0 01-.083-.449c-.041-.289-.041-.426-.041-.453v-.004l.133.135zm-.508 3.898c.167-.002.397-.008.541-.01.243-.004 1.062-.007 1.522-.14a6.718 6.718 0 001.068-.428 1.461 1.461 0 01-.114-.842c.052-.297.189-.557.38-.757a6.857 6.857 0 00-.856-.779c-.391-.287-1.156-.578-1.385-.666-.135-.054-.345-.141-.501-.205.008.06.015.131.027.214.05.36.123.597.123.597l.058.195-.202-.023c-.773-.089-1.557.175-2.164.603.433.615 1.083 1.133 1.838 1.324l.193.046-.118.162s-.146.2-.312.516a2.75 2.75 0 00-.098.193z"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M161.838 142.601c0-.813.636-1.472 1.424-1.472.786 0 1.422.659 1.422 1.472 0 .811-.636 1.468-1.422 1.468-.788 0-1.424-.657-1.424-1.468zm15.904 3.26c-.335-.385-1.029-.306-1.549.178-.518.479-.67 1.186-.335 1.57.335.385 1.03.302 1.549-.179.518-.484.67-1.189.335-1.569z"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.705 142.601c0-.888.696-1.603 1.557-1.603.858 0 1.555.715 1.555 1.603 0 .883-.697 1.603-1.555 1.603-.861 0-1.557-.72-1.557-1.603zm.268 0c0 .736.573 1.335 1.289 1.335.713 0 1.287-.599 1.287-1.335s-.574-1.335-1.287-1.335c-.716 0-1.289.599-1.289 1.335zm15.871 3.172a.917.917 0 01.208.674c-.021.362-.215.765-.553 1.081-.341.316-.753.472-1.107.455a.856.856 0 01-.633-.288c-.157-.177-.225-.416-.211-.676.025-.362.217-.765.556-1.077.341-.318.75-.472 1.104-.457a.863.863 0 01.636.288zm-.092.077l-.112.098a.602.602 0 00-.443-.197c-.291-.011-.628.124-.913.386-.282.262-.446.597-.467.901a.666.666 0 00.143.482.6.6 0 00.445.195c.293.013.63-.123.911-.382.284-.264.451-.603.467-.905a.652.652 0 00-.141-.478l.11-.1z"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M175.721 146.794c.071-.264.235-.532.472-.755.52-.484 1.214-.563 1.549-.178.041.052.089.12.114.181 0 0 .721-1.491 1.576-1.986.853-.501 2.299-.374 2.299-.374 0-1.141-.86-2.066-1.967-2.066-.65 0-1.263.295-1.625.792l-.152-.768s-.887.194-1.299 1.304c-.406 1.11.037 2.717.037 2.717s-.22-.688-.555-1.15c-.332-.455-1.187-.956-1.63-1.184a6.866 6.866 0 01-.9-.568s-.021.125-.037.432c-.019.368.008.595.008.595-.815-.116-1.769.029-2.51.343a3.33 3.33 0 001.714 1.649s-.285.257-.547.538c-.216.237-.285.351-.285.351s.559.086.838.127c.279.042 1.206.2 1.759.16.409-.027.867-.1 1.141-.16zm-54.849 0a1.637 1.637 0 00-.472-.755c-.52-.484-1.21-.563-1.547-.178a.774.774 0 00-.116.181s-.724-1.491-1.576-1.986c-.852-.501-2.295-.374-2.295-.374 0-1.141.858-2.066 1.965-2.066.652 0 1.262.295 1.627.792l.148-.768s.892.194 1.299 1.304c.408 1.11-.037 2.717-.037 2.717s.222-.688.557-1.15c.335-.455 1.187-.956 1.632-1.184.445-.225.902-.568.902-.568s.015.125.033.432c.017.368-.008.595-.008.595.813-.116 1.769.029 2.512.343a3.35 3.35 0 01-1.718 1.649s.287.257.547.538c.216.237.287.351.287.351s-.559.086-.838.127c-.281.042-1.206.2-1.756.16-.41-.027-.867-.1-1.146-.16z"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M173.64 142.894l.042-.27.037.029s.447.333.882.555c.457.235 1.336.755 1.677 1.227.048.064.094.135.135.205-.05-.54-.047-1.199.148-1.744.441-1.187 1.397-1.387 1.397-1.387l.135-.028.123.627a2.183 2.183 0 011.548-.627c1.182 0 2.098.981 2.098 2.201v.146l-.145-.013s-1.393-.127-2.216.358c-.828.478-1.522 1.927-1.522 1.927l-.127.258-.116-.262a.805.805 0 00-.098-.15.606.606 0 00-.441-.195c-.291-.011-.628.124-.91.386-.219.204-.37.451-.435.692l-.131-.035.029.131c-.278.06-.744.135-1.16.164-.563.04-1.505-.118-1.788-.162-.249-.037-.719-.11-.819-.124l-.112-.208.002-.007a3.63 3.63 0 01.297-.363 8.76 8.76 0 01.405-.408 3.488 3.488 0 01-1.596-1.632l-.06-.127.128-.052a5.167 5.167 0 012.42-.372c-.004-.108-.01-.26 0-.449.017-.285.036-.416.038-.441l.002-.004.133.154zm1.977 3.786c.088-.26.252-.522.487-.738.145-.137.305-.245.467-.32-.068-.19-.255-.68-.511-1.032-.32-.442-1.15-.923-1.582-1.143a7.131 7.131 0 01-.73-.443 9.494 9.494 0 00-.012.196c-.017.353.008.571.008.571l.023.173-.175-.025c-.746-.106-1.609.01-2.307.281.318.605.869 1.16 1.581 1.453l.198.083-.16.141s-.281.252-.536.528l-.144.162c.189.03.451.071.618.094.274.042 1.185.2 1.729.16a8.608 8.608 0 001.046-.141zm1.214-1.152c.127-.035.256-.05.377-.043a.85.85 0 01.636.291h.002c.237-.437.838-1.441 1.519-1.836.714-.418 1.824-.416 2.225-.399-.067-1-.84-1.792-1.826-1.792-.607 0-1.18.272-1.519.738l-.179.249-.181-.921c-.247.1-.784.397-1.07 1.175-.335.917-.071 2.179.016 2.538zm-53.872-2.634s.115-.278.133-.148c.002.025.017.156.036.439.008.189.006.341.002.449a5.144 5.144 0 012.415.372l.129.052-.056.127a3.498 3.498 0 01-1.598 1.632c.108.102.259.252.405.408.203.224.282.342.299.363.087.133-.112.213-.112.213l.023-.005-.84.131c-.287.044-1.227.202-1.788.162a9.317 9.317 0 01-1.162-.164l.027-.131-.129.035a1.5 1.5 0 00-.435-.692c-.28-.262-.617-.397-.91-.386a.605.605 0 00-.443.197.587.587 0 00-.096.148l-.118.262-.125-.258s-.696-1.449-1.524-1.927c-.821-.485-2.216-.358-2.216-.358l-.145.013v-.146c0-1.22.921-2.201 2.1-2.201.594 0 1.155.23 1.548.629l.121-.629.135.028s.96.2 1.397 1.387c.197.545.202 1.2.148 1.744a2.92 2.92 0 01.137-.205c.345-.472 1.22-.992 1.679-1.227.435-.222.882-.555.882-.555l.044-.033.037.274zm-1.981 3.786c.277.056.682.116 1.048.141.542.04 1.451-.118 1.729-.16.165-.023.424-.064.614-.091a3.245 3.245 0 00-.142-.165 9.967 9.967 0 00-.536-.528l-.16-.141.198-.083a3.198 3.198 0 001.582-1.453c-.703-.271-1.566-.387-2.308-.281l-.173.025.021-.173s.023-.218.008-.571a3.743 3.743 0 00-.014-.196 6.922 6.922 0 01-.726.443c-.432.22-1.262.703-1.586 1.143-.256.352-.441.842-.509 1.032.162.075.32.183.467.32.236.216.402.478.487.738zm-1.214-1.154c.089-.357.349-1.619.014-2.536-.284-.778-.821-1.075-1.07-1.175l-.175.919-.181-.247c-.343-.464-.914-.738-1.521-.738-.988 0-1.759.792-1.828 1.792.401-.017 1.514-.019 2.224.399.68.395 1.283 1.401 1.522 1.836.002 0 .002-.003.002-.003a.855.855 0 01.636-.288c.121-.007.248.008.377.041z"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M118.853 145.861c.337-.385 1.027-.306 1.547.178.522.479.669 1.186.335 1.57-.335.385-1.029.302-1.547-.179-.52-.484-.669-1.189-.335-1.569zm27.998-4.653c0-.813.64-1.466 1.421-1.466.787 0 1.427.653 1.427 1.466s-.636 1.472-1.427 1.472c-.781 0-1.421-.659-1.421-1.472z"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.751 145.773a.855.855 0 01.636-.288c.352-.015.764.139 1.104.455.341.314.533.717.553 1.079.017.26-.051.499-.209.676a.855.855 0 01-.635.288c-.353.017-.765-.139-1.104-.455-.338-.316-.532-.719-.554-1.081a.922.922 0 01.209-.674zm.202.175a.652.652 0 00-.143.48c.018.302.185.641.467.905.283.259.62.395.913.382a.593.593 0 00.443-.195.657.657 0 00.143-.482c-.016-.304-.183-.639-.468-.901-.28-.262-.617-.397-.91-.386a.61.61 0 00-.445.197zm27.764-4.74c0-.888.699-1.601 1.555-1.601.859 0 1.56.713 1.56 1.601s-.699 1.605-1.56 1.605c-.856 0-1.555-.717-1.555-1.605zm.269 0c0 .738.575 1.337 1.286 1.337.718 0 1.291-.599 1.291-1.337 0-.736-.577-1.333-1.291-1.333-.711 0-1.286.597-1.286 1.333z"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M145.314 118.897c0-1.661 1.302-3.002 2.904-3.002 1.606 0 2.907 1.341 2.907 3.002 0 1.655-1.301 2.993-2.907 2.993-1.602 0-2.904-1.338-2.904-2.993z"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M145.227 118.897c0-1.713 1.341-3.092 2.991-3.092 1.653 0 2.994 1.379 2.994 3.092 0 1.704-1.341 3.083-2.994 3.083-1.65 0-2.991-1.379-2.991-3.083zm.177 0c0 1.605 1.262 2.906 2.814 2.906 1.558 0 2.818-1.301 2.818-2.906 0-1.614-1.26-2.915-2.818-2.915-1.552 0-2.814 1.301-2.814 2.915z"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M147.46 110.483v1.62h-1.591v1.642h1.591v4.726h-2.002c-.025.155-.148.268-.148.428 0 .414.083.81.229 1.17.004.009.014.013.02.021h5.325c.004-.008.019-.012.023-.021.151-.368.226-.767.226-1.17 0-.16-.122-.273-.145-.428h-1.94v-4.726h1.59v-1.642h-1.59v-1.62h-1.588z"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M150.963 120.138l-.019.042h-5.443l-.018-.042a.091.091 0 01-.025-.035 3.17 3.17 0 01-.235-1.204.58.58 0 01.073-.256c.029-.06.062-.117.072-.187l.011-.075h1.991v-4.546h-1.59v-1.822h1.59v-1.617h1.768v1.617h1.59v1.822h-1.59v4.546h1.927l.012.075c.008.07.042.127.071.187a.574.574 0 01.072.256 3.08 3.08 0 01-.232 1.204v.001a.176.176 0 01-.025.034zm-5.356-.135h5.231c.137-.349.206-.724.206-1.104 0-.065-.027-.123-.052-.179a1.057 1.057 0 01-.073-.16h-1.958v-4.904h1.588v-1.464h-1.588v-1.62h-1.414v1.62h-1.588v1.464h1.588v4.904h-2.021c-.018.056-.046.11-.07.16-.027.056-.055.112-.055.179 0 .389.071.765.206 1.104z"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M180.991 141.333c0-.408.322-.742.72-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M180.856 141.333c0-.482.385-.876.853-.876.471 0 .854.394.854.876a.868.868 0 01-.854.879c-.468 0-.853-.395-.853-.879zm.268 0c0 .332.26.611.585.611.326 0 .586-.279.586-.611a.595.595 0 00-.586-.607.595.595 0 00-.585.607z"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M181.972 139.432c0-.407.323-.741.72-.741a.73.73 0 01.719.741c0 .408-.32.745-.719.745a.735.735 0 01-.72-.745z"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M181.837 139.432c0-.482.385-.874.853-.874.472 0 .854.392.854.874 0 .485-.382.88-.854.88-.468 0-.853-.395-.853-.88zm.269 0c0 .333.26.612.584.612.326 0 .586-.279.586-.612a.596.596 0 00-.586-.607.596.596 0 00-.584.607z"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M182.627 137.233c0-.407.322-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.744-.719.744a.734.734 0 01-.72-.744z"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.503 137.368a.87.87 0 01.848-1.012c.468 0 .85.393.85.877a.863.863 0 01-.85.877.864.864 0 01-.848-.742zm.259-.135c0 .337.262.609.589.609.32 0 .582-.274.582-.609 0-.332-.262-.609-.582-.609a.6.6 0 00-.589.609z"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M182.712 134.874c0-.408.323-.743.72-.743.399 0 .719.335.719.743 0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.579 134.874c0-.483.385-.876.853-.876.472 0 .854.393.854.876a.867.867 0 01-.854.879c-.468 0-.853-.395-.853-.879zm.269 0c0 .332.259.611.584.611.326 0 .586-.279.586-.611a.596.596 0 00-.586-.608.595.595 0 00-.584.608z"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M182.18 132.549c0-.407.323-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.045 132.549c0-.482.385-.875.853-.875.471 0 .854.393.854.875 0 .484-.383.88-.854.88-.468 0-.853-.396-.853-.88zm.268 0c0 .333.26.611.585.611a.6.6 0 00.586-.611.595.595 0 00-.586-.607.595.595 0 00-.585.607z"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M181.07 130.441c0-.407.322-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.745-.719.745a.735.735 0 01-.72-.745z"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  d: "M180.935 130.441c0 .125.135.135.135.135s-.135-.166-.135-.135c0-.486.387-.875.855-.875.472 0 .856.389.856.875a.866.866 0 01-.856.879.868.868 0 01-.855-.879zm.27 0c0 .337.26.609.585.609a.596.596 0 00.586-.609.594.594 0 00-.586-.605.595.595 0 00-.585.605z"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M179.596 128.709c0-.407.322-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.745-.719.745a.735.735 0 01-.72-.745z"
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  d: "M179.461 128.709c0-.482.385-.875.853-.875.471 0 .854.393.854.875 0 .485-.383.88-.854.88-.468 0-.853-.395-.853-.88zm.268 0c0 .333.26.612.585.612.326 0 .586-.279.586-.612a.596.596 0 00-.586-.607.596.596 0 00-.585.607z"
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M177.881 127.271c0-.408.322-.743.719-.743.399 0 .72.335.72.743a.734.734 0 01-.72.744c-.397 0-.719-.337-.719-.744z"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M177.746 127.271c0 .124.135.135.135.135s-.135-.167-.135-.135c0-.487.386-.876.854-.876.472 0 .857.389.857.876a.867.867 0 01-.857.879.868.868 0 01-.854-.879zm.27 0c0 .336.26.609.584.609a.597.597 0 00.587-.609.594.594 0 00-.587-.605.595.595 0 00-.584.605z"
});

var _ref84 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M175.831 126.092c0-.408.323-.742.719-.742.399 0 .72.334.72.742a.734.734 0 01-.72.744c-.396 0-.719-.337-.719-.744z"
});

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  d: "M175.696 126.092c0-.482.385-.875.852-.875.473 0 .855.393.855.875a.868.868 0 01-.855.879c-.467 0-.852-.395-.852-.879zm.268 0c0 .333.26.611.584.611a.6.6 0 00.587-.611.596.596 0 00-.587-.607.595.595 0 00-.584.607z"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M173.707 125.252c0-.407.322-.742.719-.742.399 0 .719.335.719.742 0 .408-.32.744-.719.744a.734.734 0 01-.719-.744z"
});

var _ref87 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M179.563 138.624a6.892 6.892 0 001.559-4.376 6.878 6.878 0 00-.599-2.825c-1.397-3.136-5.781-5.414-10.991-5.414-1.42 0-2.777.168-4.033.478.278.331.497.694.711 1.06a15.963 15.963 0 013.322-.341c4.769 0 8.758 2.023 9.917 4.753.314.715.478 1.497.478 2.289a5.612 5.612 0 01-1.83 4.166l1.728 3.073.925-.801-1.187-2.06v-.002z"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M179.725 138.638l1.196 2.077-1.133.984-1.861-3.314.081-.071a5.49 5.49 0 001.786-4.066 5.56 5.56 0 00-.47-2.235c-1.142-2.696-5.087-4.672-9.792-4.672-1.154 0-2.26.121-3.293.337l-.096.021-.052-.085c-.208-.358-.42-.713-.696-1.04l-.137-.164.207-.054a17.033 17.033 0 014.067-.482c5.27 0 9.7 2.324 11.114 5.494.404.896.611 1.882.611 2.88 0 1.669-.58 3.197-1.532 4.39zm-.162.123l-.002-.004h.002l-.104-.218c.035-.044.068-.088.104-.131v-.052l.019.029a6.761 6.761 0 001.407-4.137c0-.961-.201-1.907-.59-2.77-1.379-3.097-5.717-5.334-10.867-5.334-1.332 0-2.609.147-3.794.426.201.264.374.543.539.828a15.989 15.989 0 013.255-.325c4.832 0 8.867 2.067 10.037 4.834.325.731.493 1.532.493 2.341a5.755 5.755 0 01-1.796 4.193l1.594 2.838.717-.622-1.014-1.759v-.137zM173.574 125.252c0-.482.384-.875.852-.875.472 0 .854.393.854.875 0 .485-.382.88-.854.88-.468 0-.852-.395-.852-.88zm.268 0c0 .333.26.611.584.611a.6.6 0 00.586-.611.595.595 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M171.33 124.788c0-.407.322-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.745-.719.745a.735.735 0 01-.72-.745z"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.195 124.788c0-.482.385-.875.852-.875.473 0 .855.393.855.875 0 .485-.382.88-.855.88-.467 0-.852-.395-.852-.88zm.269 0c0 .333.259.612.583.612a.601.601 0 00.587-.612.596.596 0 00-.587-.607.595.595 0 00-.583.607z"
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M169.074 124.662c0-.408.323-.743.72-.743.399 0 .719.335.719.743 0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.94 124.662c0-.487.382-.876.854-.876.47 0 .854.389.854.876a.866.866 0 01-.854.877.862.862 0 01-.844-.744h-.01v-.133zm.27 0c0 .334.262.609.584.609a.6.6 0 00.586-.609.595.595 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M166.86 124.745c0-.408.323-.742.72-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref94 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.726 124.745c0-.482.384-.875.852-.875.471 0 .854.393.854.875a.868.868 0 01-.854.879c-.468 0-.852-.395-.852-.879zm.267 0c0 .332.261.611.585.611.326 0 .586-.279.586-.611a.595.595 0 00-.586-.607.596.596 0 00-.585.607z"
});

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M164.649 124.745c0-.408.322-.742.719-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744-.397 0-.719-.337-.719-.744z"
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.516 124.745c0-.482.384-.875.852-.875.472 0 .854.393.854.875a.867.867 0 01-.854.879c-.468 0-.852-.395-.852-.879zm.268 0c0 .332.26.611.584.611.326 0 .586-.279.586-.611a.595.595 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref97 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M165.756 126.813c0-.409.323-.742.72-.742.397 0 .719.333.719.742a.733.733 0 01-.719.743.734.734 0 01-.72-.743zm.452 2.287c0-.413.322-.746.717-.746.399 0 .721.333.721.746a.73.73 0 01-.721.738.73.73 0 01-.717-.738zm.079 2.277c0-.414.324-.745.721-.745a.73.73 0 01.718.745.73.73 0 01-.718.74.733.733 0 01-.721-.74zm-.653 2.072c0-.409.32-.744.717-.744.399 0 .72.335.72.744a.73.73 0 01-.72.741.728.728 0 01-.717-.741zm-1.223 1.905c0-.41.323-.745.72-.745.397 0 .717.335.717.745 0 .409-.32.74-.717.74a.73.73 0 01-.72-.74z"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M165.622 126.813c0-.484.384-.877.854-.877s.852.393.852.877a.866.866 0 01-.852.878.867.867 0 01-.854-.878zm.267 0a.6.6 0 00.587.609.595.595 0 00.582-.609.596.596 0 00-.582-.609.6.6 0 00-.587.609zm.184 2.287c0-.488.382-.879.852-.879.472 0 .855.391.855.879 0 .48-.381.871-.855.871a.863.863 0 01-.852-.871zm.268 0c0 .331.262.603.584.603a.594.594 0 00.586-.603.6.6 0 00-.586-.613c-.322 0-.584.276-.584.613zm-.187 2.277c0-.491.384-.878.854-.878s.85.387.85.878c0 .482-.38.875-.85.875a.867.867 0 01-.854-.875zm.268 0c0 .334.262.607.586.607a.593.593 0 00.582-.607.592.592 0 00-.582-.609.596.596 0 00-.586.609zm-.921 2.072c0-.484.382-.877.85-.877.472 0 .855.393.855.877a.863.863 0 01-.855.875.861.861 0 01-.85-.875zm.268 0c0 .335.26.607.582.607a.596.596 0 00.587-.607.598.598 0 00-.587-.609c-.322 0-.582.275-.582.609zm-1.493 1.905a.87.87 0 01.855-.878c.47 0 .85.393.85.878 0 .484-.38.877-.85.877a.87.87 0 01-.855-.877zm.269 0c0 .332.262.607.586.607a.597.597 0 00.582-.607.596.596 0 00-.582-.609.598.598 0 00-.586.609z"
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M162.975 123.306c0-.407.322-.742.719-.742.399 0 .72.335.72.742a.734.734 0 01-.72.745c-.397 0-.719-.337-.719-.745z"
});

var _ref100 =
/*#__PURE__*/
React.createElement("path", {
  d: "M162.84 123.306c0-.482.385-.875.852-.875.472 0 .855.393.855.875 0 .485-.383.88-.855.88-.467 0-.852-.395-.852-.88zm.268 0c0 .333.26.612.584.612a.601.601 0 00.587-.612.596.596 0 00-.587-.607.596.596 0 00-.584.607z"
});

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M161.008 122.123c0-.407.323-.742.719-.742.4 0 .72.335.72.742 0 .408-.32.745-.72.745-.396 0-.719-.337-.719-.745z"
});

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160.873 122.123c0-.482.385-.875.853-.875.471 0 .854.393.854.875 0 .485-.383.88-.854.88-.468 0-.853-.395-.853-.88zm.268 0c0 .333.26.612.585.612.326 0 .586-.279.586-.612a.596.596 0 00-.586-.607.596.596 0 00-.585.607z"
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M158.842 121.41c0-.407.322-.742.719-.742.4 0 .72.335.72.742 0 .408-.32.744-.72.744a.734.734 0 01-.719-.744z"
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158.707 121.41c0-.486.382-.875.854-.875.47 0 .855.389.855.875a.866.866 0 01-.855.877.862.862 0 01-.844-.744h-.01v-.133zm.27 0c0 .335.262.609.584.609a.599.599 0 00.587-.609.596.596 0 00-.587-.607.595.595 0 00-.584.607z"
});

var _ref105 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M156.588 120.988c0-.407.323-.742.72-.742.399 0 .719.335.719.742s-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref106 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.453 120.988c0-.482.385-.875.853-.875.472 0 .854.393.854.875 0 .485-.382.88-.854.88-.468 0-.853-.395-.853-.88zm.269 0c0 .333.259.611.584.611a.6.6 0 00.586-.611.596.596 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref107 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M154.38 121.03c0-.408.323-.743.72-.743.399 0 .719.335.719.743 0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref108 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.256 121.165a.87.87 0 01.848-1.013c.468 0 .85.393.85.878a.864.864 0 01-.85.877.864.864 0 01-.848-.742zm.26-.135c0 .336.262.609.588.609.32 0 .582-.275.582-.609 0-.333-.262-.609-.582-.609a.6.6 0 00-.588.609z"
});

var _ref109 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M152.086 121.45c0-.408.322-.742.719-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744-.397 0-.719-.337-.719-.744z"
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M151.95 121.45c0-.483.385-.875.853-.875.472 0 .854.392.854.875a.867.867 0 01-.854.879c-.468 0-.853-.395-.853-.879zm.269 0c0 .332.259.611.584.611.326 0 .586-.279.586-.611a.595.595 0 00-.586-.607.594.594 0 00-.584.607z"
});

var _ref111 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M149.961 122.25c0-.407.322-.742.719-.742.399 0 .719.335.719.742s-.32.744-.719.744c-.397 0-.719-.337-.719-.744z"
});

var _ref112 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.826 122.25c0-.482.384-.875.852-.875.472 0 .854.393.854.875 0 .485-.382.88-.854.88-.468 0-.852-.395-.852-.88zm.268 0c0 .333.26.611.584.611a.6.6 0 00.586-.611.595.595 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref113 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M113.963 141.333c0-.408.323-.742.72-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref114 =
/*#__PURE__*/
React.createElement("path", {
  d: "M113.83 141.333c0-.482.385-.876.853-.876.472 0 .854.394.854.876a.867.867 0 01-.854.879c-.468 0-.853-.395-.853-.879zm.269 0c0 .332.259.611.584.611.326 0 .586-.279.586-.611a.595.595 0 00-.586-.607.594.594 0 00-.584.607z"
});

var _ref115 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M112.978 139.432c0-.407.323-.741.719-.741.399 0 .72.334.72.741a.734.734 0 01-.72.745c-.396 0-.719-.337-.719-.745z"
});

var _ref116 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.853 139.568a.87.87 0 01.849-1.013c.467 0 .85.393.85.877a.865.865 0 01-.85.878.865.865 0 01-.849-.742zm.26-.136c0 .338.262.61.589.61.32 0 .582-.275.582-.61 0-.332-.262-.608-.582-.608a.6.6 0 00-.589.608z"
});

var _ref117 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M112.321 137.233c0-.407.322-.742.719-.742.4 0 .72.335.72.742 0 .408-.32.744-.72.744a.734.734 0 01-.719-.744z"
});

var _ref118 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.188 137.233c0-.482.385-.875.852-.875.473 0 .855.393.855.875a.868.868 0 01-.855.879c-.467 0-.852-.395-.852-.879zm.268 0c0 .333.26.611.584.611a.6.6 0 00.587-.611.596.596 0 00-.587-.607.595.595 0 00-.584.607z"
});

var _ref119 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M112.242 134.874c0-.408.322-.743.719-.743.4 0 .72.335.72.743 0 .407-.32.744-.72.744-.397 0-.719-.337-.719-.744z"
});

var _ref120 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.107 134.874c0-.483.385-.876.853-.876.471 0 .854.393.854.876a.868.868 0 01-.854.879c-.468 0-.853-.395-.853-.879zm.268 0c0 .332.26.611.585.611.326 0 .586-.279.586-.611a.596.596 0 00-.586-.608.596.596 0 00-.585.608z"
});

var _ref121 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M112.774 132.549c0-.407.323-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref122 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.65 132.684a.87.87 0 01.848-1.012c.468 0 .85.393.85.877a.863.863 0 01-.85.877.864.864 0 01-.848-.742zm.26-.135c0 .337.262.609.588.609.32 0 .582-.274.582-.609 0-.332-.262-.609-.582-.609a.6.6 0 00-.588.609z"
});

var _ref123 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M113.878 130.441c0-.407.322-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.745-.719.745a.735.735 0 01-.72-.745z"
});

var _ref124 =
/*#__PURE__*/
React.createElement("path", {
  d: "M113.745 130.441c0-.486.385-.875.857-.875.468 0 .85.389.85.875a.864.864 0 01-.85.879.856.856 0 01-.823-.634l-.034.036v-.281zm.009.011l.126.124s-.07-.256-.099-.226a.098.098 0 00-.027.102zm.259-.021v.01c0 .337.262.609.589.609.32 0 .582-.272.582-.609a.595.595 0 00-.582-.605.596.596 0 00-.589.595z"
});

var _ref125 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M115.354 128.709c0-.407.323-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.745-.719.745a.735.735 0 01-.72-.745z"
});

var _ref126 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.221 128.709c0-.482.385-.875.853-.875.472 0 .854.393.854.875 0 .485-.382.88-.854.88-.468 0-.853-.395-.853-.88zm.269 0c0 .333.259.612.584.612.326 0 .586-.279.586-.612a.596.596 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref127 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M117.072 127.271c0-.408.322-.743.719-.743.399 0 .719.335.719.743 0 .407-.32.744-.719.744-.397 0-.719-.337-.719-.744z"
});

var _ref128 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.936 127.271c0 .124.136.135.136.135s-.136-.167-.136-.135c0-.487.387-.876.855-.876.472 0 .856.389.856.876a.867.867 0 01-.856.879.868.868 0 01-.855-.879zm.271 0c0 .336.26.609.584.609a.597.597 0 00.586-.609.594.594 0 00-.586-.605.595.595 0 00-.584.605z"
});

var _ref129 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M119.119 126.092c0-.408.322-.742.72-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref130 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.984 126.092c0-.482.385-.875.852-.875.472 0 .855.393.855.875a.868.868 0 01-.855.879c-.467 0-.852-.395-.852-.879zm.268 0c0 .333.26.611.584.611a.6.6 0 00.587-.611.596.596 0 00-.587-.607.595.595 0 00-.584.607z"
});

var _ref131 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M121.246 125.252c0-.407.322-.742.719-.742.4 0 .72.335.72.742 0 .408-.32.744-.72.744a.734.734 0 01-.719-.744z"
});

var _ref132 =
/*#__PURE__*/
React.createElement("path", {
  d: "M121.111 125.252c0-.482.385-.875.853-.875.471 0 .854.393.854.875 0 .485-.383.88-.854.88-.468 0-.853-.395-.853-.88zm.268 0c0 .333.26.611.585.611a.6.6 0 00.586-.611.595.595 0 00-.586-.607.595.595 0 00-.585.607z"
});

var _ref133 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M123.622 124.788c0-.407.323-.742.72-.742.399 0 .719.335.719.742 0 .408-.32.745-.719.745a.735.735 0 01-.72-.745z"
});

var _ref134 =
/*#__PURE__*/
React.createElement("path", {
  d: "M123.489 124.788c0-.482.385-.875.853-.875.472 0 .854.393.854.875 0 .485-.382.88-.854.88-.468 0-.853-.395-.853-.88zm.269 0c0 .333.259.612.584.612.326 0 .586-.279.586-.612a.596.596 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref135 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M125.878 124.662c0-.408.322-.743.719-.743.4 0 .72.335.72.743 0 .407-.32.744-.72.744-.397 0-.719-.337-.719-.744z"
});

var _ref136 =
/*#__PURE__*/
React.createElement("path", {
  d: "M125.743 124.662c0-.483.384-.876.852-.876.472 0 .855.393.855.876a.868.868 0 01-.855.879c-.468 0-.852-.395-.852-.879zm.268 0c0 .332.26.611.584.611a.601.601 0 00.587-.611.596.596 0 00-.587-.607.595.595 0 00-.584.607z"
});

var _ref137 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M128.09 124.745c0-.408.322-.742.719-.742.4 0 .72.334.72.742 0 .407-.32.744-.72.744-.397 0-.719-.337-.719-.744z"
});

var _ref138 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.955 124.745c0-.482.385-.875.852-.875.472 0 .855.393.855.875a.868.868 0 01-.855.879c-.467 0-.852-.395-.852-.879zm.268 0c0 .332.26.611.584.611a.601.601 0 00.587-.611.596.596 0 00-.587-.607.595.595 0 00-.584.607z"
});

var _ref139 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M130.306 124.745c0-.408.322-.742.72-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref140 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.181 124.878a.87.87 0 01.849-1.013c.467 0 .85.393.85.878a.864.864 0 01-.85.877.865.865 0 01-.849-.742zm.26-.135c0 .336.262.609.589.609.32 0 .582-.275.582-.609 0-.333-.262-.609-.582-.609a.6.6 0 00-.589.609z"
});

var _ref141 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M132.061 136.171c-1.728-1.404-2.8-3.314-2.8-5.418 0-2.42 1.453-4.582 3.663-6.015-1.364 1.194-2.189 2.736-2.31 4.458a7.435 7.435 0 00-.027.65c0 1.98.827 3.763 2.139 5.003l-.665 1.322z"
});

var _ref142 =
/*#__PURE__*/
React.createElement("path", {
  d: "M132.061 136.171l-.086.104c-1.76-1.43-2.847-3.377-2.847-5.522 0-2.466 1.473-4.669 3.721-6.125l.162.213c-1.335 1.168-2.146 2.677-2.262 4.365v.002a7.584 7.584 0 00-.029.638 6.73 6.73 0 002.1 4.905l.072.069-.713 1.411-.118-.06zm-.046-.212l.547-1.083a7.007 7.007 0 01-2.108-5.03c0-.22.008-.44.027-.662a6.35 6.35 0 011.258-3.362c-1.447 1.332-2.343 3.052-2.343 4.931 0 2.012 1.002 3.84 2.619 5.206z"
});

var _ref143 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M129.2 126.813c0-.409.323-.742.719-.742.395 0 .72.333.72.742a.735.735 0 01-.72.743.734.734 0 01-.719-.743zm-.453 2.287c0-.413.322-.746.722-.746.394 0 .717.333.717.746a.73.73 0 01-.717.738.73.73 0 01-.722-.738zm-.081 2.277c0-.414.322-.745.721-.745.393 0 .718.331.718.745 0 .407-.325.74-.718.74a.731.731 0 01-.721-.74zm.657 2.072c0-.409.32-.744.717-.744.399 0 .722.335.722.744 0 .41-.323.741-.722.741a.728.728 0 01-.717-.741zm1.22 1.905c0-.41.325-.745.72-.745.399 0 .719.335.719.745 0 .409-.32.74-.719.74a.732.732 0 01-.72-.74z"
});

var _ref144 =
/*#__PURE__*/
React.createElement("path", {
  d: "M129.065 126.813c0-.484.383-.877.854-.877s.853.393.853.877a.866.866 0 01-.853.878.867.867 0 01-.854-.878zm.268 0c0 .335.262.609.586.609a.598.598 0 00.585-.609.599.599 0 00-.585-.609.6.6 0 00-.586.609zm-.719 2.287c0-.488.382-.879.855-.879.467 0 .852.391.852.879 0 .48-.385.871-.852.871a.863.863 0 01-.855-.871zm.268 0c0 .331.26.603.587.603a.595.595 0 00.583-.603c0-.337-.261-.613-.583-.613a.6.6 0 00-.587.613zm-.351 2.277c0-.491.382-.878.856-.878.468 0 .851.387.851.878a.865.865 0 01-.851.875.866.866 0 01-.856-.875zm.268 0c0 .334.262.607.588.607a.595.595 0 00.582-.607.593.593 0 00-.582-.609.596.596 0 00-.588.609zm.391 2.072c0-.484.382-.877.85-.877.472 0 .855.393.855.877a.863.863 0 01-.855.875.861.861 0 01-.85-.875zm.268 0c0 .335.258.607.582.607a.596.596 0 00.588-.607.599.599 0 00-.588-.609.596.596 0 00-.582.609zm.952 1.905c0-.485.385-.878.853-.878.471 0 .856.393.856.878a.868.868 0 01-.856.877.867.867 0 01-.853-.877zm.268 0c0 .332.262.607.585.607a.597.597 0 00.586-.607.597.597 0 00-.586-.609.598.598 0 00-.585.609z"
});

var _ref145 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M131.978 123.306c0-.407.322-.742.719-.742.399 0 .719.335.719.742 0 .408-.32.745-.719.745-.397 0-.719-.337-.719-.745z"
});

var _ref146 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.845 123.306c0-.482.384-.875.852-.875.472 0 .855.393.855.875 0 .485-.383.88-.855.88-.468 0-.852-.395-.852-.88zm.268 0c0 .333.26.612.584.612.327 0 .586-.279.586-.612a.595.595 0 00-.586-.607.596.596 0 00-.584.607z"
});

var _ref147 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M133.947 122.123c0-.407.322-.742.719-.742.399 0 .719.335.719.742 0 .408-.32.745-.719.745-.397 0-.719-.337-.719-.745z"
});

var _ref148 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.811 122.123c0-.482.385-.875.853-.875.472 0 .854.393.854.875 0 .485-.382.88-.854.88-.468 0-.853-.395-.853-.88zm.269 0c0 .333.26.612.584.612.326 0 .586-.279.586-.612a.596.596 0 00-.586-.607.596.596 0 00-.584.607z"
});

var _ref149 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M136.111 121.41c0-.407.322-.742.719-.742.399 0 .719.335.719.742 0 .408-.32.744-.719.744a.734.734 0 01-.719-.744z"
});

var _ref150 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.975 121.41c0-.482.385-.875.853-.875.472 0 .855.393.855.875 0 .485-.383.88-.855.88-.468 0-.853-.395-.853-.88zm.269 0c0 .333.26.611.584.611a.6.6 0 00.586-.611.595.595 0 00-.586-.607.595.595 0 00-.584.607z"
});

var _ref151 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M138.366 120.988c0-.407.323-.742.72-.742.399 0 .719.335.719.742s-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref152 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.231 120.988c0-.482.385-.875.853-.875.471 0 .854.393.854.875 0 .485-.383.88-.854.88-.468 0-.853-.395-.853-.88zm.268 0c0 .333.26.611.585.611a.6.6 0 00.586-.611.596.596 0 00-.586-.607.596.596 0 00-.585.607z"
});

var _ref153 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M140.574 121.03c0-.408.322-.743.72-.743.399 0 .719.335.719.743 0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref154 =
/*#__PURE__*/
React.createElement("path", {
  d: "M140.439 121.03c0-.483.385-.876.852-.876.472 0 .855.393.855.876a.868.868 0 01-.855.879c-.467 0-.852-.395-.852-.879zm.268 0c0 .332.26.611.584.611a.601.601 0 00.587-.611.596.596 0 00-.587-.607.595.595 0 00-.584.607z"
});

var _ref155 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M142.869 121.45c0-.408.323-.742.72-.742a.73.73 0 01.719.742c0 .407-.32.744-.719.744a.735.735 0 01-.72-.744z"
});

var _ref156 =
/*#__PURE__*/
React.createElement("path", {
  d: "M142.734 121.45c0-.483.385-.875.853-.875.472 0 .854.392.854.875a.867.867 0 01-.854.879c-.468 0-.853-.395-.853-.879zm.268 0c0 .332.26.611.585.611.326 0 .586-.279.586-.611a.595.595 0 00-.586-.607.595.595 0 00-.585.607z"
});

var _ref157 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M144.99 122.25c0-.407.322-.742.719-.742.399 0 .72.335.72.742a.734.734 0 01-.72.744c-.397 0-.719-.337-.719-.744z"
});

var _ref158 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.859 122.25c0-.482.384-.875.852-.875.472 0 .855.393.855.875 0 .485-.383.88-.855.88-.468 0-.852-.395-.852-.88zm.268 0c0 .333.26.611.584.611a.6.6 0 00.587-.611.596.596 0 00-.587-.607.595.595 0 00-.584.607z"
});

var _ref159 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M118.598 128.321c-1.256.86-2.206 1.92-2.73 3.102a6.878 6.878 0 00-.599 2.825c0 1.669.593 3.195 1.559 4.376l-1.05 1.854c-1.002-1.405-1.584-3.045-1.584-4.79 0-3.004 1.755-5.629 4.404-7.367zm59.2 0c1.251.86 2.203 1.92 2.728 3.102.392.881.596 1.848.596 2.825a6.9 6.9 0 01-1.555 4.376l1.046 1.854c1.004-1.405 1.582-3.045 1.582-4.79 0-3.004-1.749-5.629-4.397-7.367z"
});

var _ref160 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.598 128.456s-.044-.268 0-.268c.17 0 0 .268 0 .268zm-.435 0h.017c.112-.084.224-.167.341-.246l.077.246.074-.023c-.002 0-.002.002-.002.002-1.232.844-2.166 1.881-2.68 3.042a6.76 6.76 0 00-.588 2.771c0 1.636.582 3.133 1.53 4.291l.058.07-1.197 2.117-.123-.171c-1.018-1.428-1.611-3.095-1.611-4.867 0-2.91 1.618-5.473 4.104-7.232zm0 0h-.016l.374-.246a9.85 9.85 0 00-.358.246zm-2.227 2.519c-1.014 1.375-1.609 2.979-1.609 4.713 0 1.647.528 3.196 1.441 4.539l.898-1.589a7.041 7.041 0 01-1.532-4.39 7.033 7.033 0 01.802-3.273zm61.935-2.765c2.686 1.763 4.461 4.431 4.461 7.478 0 1.772-.59 3.439-1.611 4.867l-.12.171-1.196-2.117.06-.07a6.78 6.78 0 001.524-4.291c0-.961-.201-1.907-.584-2.771-.518-1.161-1.453-2.2-2.686-3.044l.152-.223zm2.594 2.78a7.09 7.09 0 01.792 3.258 7.04 7.04 0 01-1.53 4.39l.896 1.587c.915-1.341 1.439-2.89 1.439-4.537 0-1.725-.588-3.324-1.597-4.698z"
});

var _ref161 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M197.346 156.854s-.482.555-.833.632c-.354.075-.797-.343-.797-.343s-.318.36-.708.453c-.387.098-.928-.476-.928-.476s-.372.574-.702.709c-.333.133-.742-.172-.742-.172s-.146.285-.423.441c-.12.062-.316-.04-.316-.04l-.393-.268-.444-.516-.408-.175s-.185-.648-.204-.762c-.014-.115-.054-.406-.054-.406-.083-.461.572-1.002 1.51-1.233.54-.137 1.008-.126 1.353-.01.374-.347 1.166-.591 2.098-.591.844 0 1.584.196 1.993.5.404-.304 1.144-.5 1.99-.5.927 0 1.719.244 2.094.591.345-.116.815-.125 1.355.01.935.231 1.595.772 1.509 1.233 0 0-.037.291-.056.406-.019.114-.203.762-.203.762l-.408.175-.445.516-.387.268s-.197.102-.313.04a1.178 1.178 0 01-.429-.441s-.411.305-.74.172c-.335-.135-.709-.709-.709-.709s-.536.574-.925.476c-.389-.093-.707-.453-.707-.453s-.445.418-.794.343c-.355-.077-.832-.632-.832-.632h-.002z"
});

var _ref162 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.887 158.085l-.057.038h-.004a.719.719 0 01-.168.06.348.348 0 01-.21-.021 1.311 1.311 0 01-.418-.403c-.06.039-.168.097-.289.137a.665.665 0 01-.453 0c-.143-.056-.293-.187-.418-.324a3.5 3.5 0 01-.272-.339c-.079.077-.22.203-.385.299-.174.108-.376.179-.55.137-.315-.079-.583-.32-.691-.428a1.871 1.871 0 01-.326.221c-.152.078-.324.128-.482.095-.151-.033-.323-.145-.475-.272a3.538 3.538 0 01-.341-.325 3.848 3.848 0 01-.343.327c-.153.125-.326.237-.478.27-.153.033-.33-.017-.48-.095a1.927 1.927 0 01-.327-.221c-.108.108-.378.349-.694.428-.172.042-.372-.029-.549-.137-.164-.096-.305-.225-.386-.299a3.248 3.248 0 01-.269.339c-.126.137-.276.268-.417.324a.665.665 0 01-.453 0 1.444 1.444 0 01-.292-.137 1.254 1.254 0 01-.413.403.35.35 0 01-.21.021.734.734 0 01-.169-.06h-.004l.033.006-.039-.011-.401-.272-.441-.514-.424-.178-.009-.034s-.187-.657-.205-.773v-.002a64.63 64.63 0 01-.054-.399c-.038-.206.051-.426.245-.63.268-.287.74-.545 1.318-.688.534-.135 1.002-.129 1.353-.021.395-.339 1.187-.58 2.117-.58.831 0 1.565.189 1.991.482.422-.293 1.156-.482 1.992-.482.923 0 1.715.241 2.11.58.354-.108.817-.112 1.356.021.576.143 1.049.401 1.318.688.193.204.283.424.243.628-.002.014-.038.293-.054.405-.021.114-.206.771-.206.771l-.01.034-.424.178-.441.514-.345.239zm-10.952-.089a.595.595 0 00.129.045c.039.007.081.011.116-.008.258-.146.395-.409.395-.409l.038-.076.068.051s.138.106.312.158a.518.518 0 00.358.004c.124-.048.255-.167.366-.287.174-.192.303-.393.303-.393l.052-.075.062.067s.187.199.418.339c.142.082.302.149.439.116.37-.09.669-.435.669-.435l.052-.054.052.05s.154.144.35.243c.118.063.26.111.382.084.131-.03.283-.131.416-.242.21-.172.38-.366.38-.366l.054.117c-.004-.015-.052-.143 0-.143h.002c.042 0 .046.031.038.062l.019-.036s.168.196.376.366c.133.111.282.212.414.242.127.029.264-.021.384-.084.196-.099.347-.243.347-.243l.054-.05.05.054s.3.345.668.435c.141.033.299-.034.443-.116.23-.14.415-.339.415-.339l.063-.069.051.077s.129.201.304.393c.112.12.241.239.368.287.117.05.244.031.354-.004a1.12 1.12 0 00.315-.158l.069-.051.04.076s.137.266.399.413c.031.015.073.011.112.004.058-.012.119-.041.129-.045l.374-.258.451-.524.393-.166c.038-.133.175-.624.193-.724.017-.114.055-.401.055-.403v-.002c.031-.167-.05-.339-.206-.506-.256-.27-.705-.509-1.248-.644-.525-.131-.981-.125-1.318-.012l-.039.014-.031-.029c-.366-.339-1.139-.569-2.044-.569-.827 0-1.553.184-1.948.482l-.041.031-.044-.031c-.399-.295-1.125-.482-1.95-.482-.911 0-1.684.23-2.05.569l-.031.029-.04-.014c-.334-.113-.79-.121-1.314.012-.546.135-.995.374-1.249.644-.156.167-.237.342-.206.508v.002s.04.287.052.403c.021.104.156.591.194.722l.392.166.449.524.381.258z"
});

var _ref163 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M196.428 153.832c0-.774.407-1.402.902-1.402.501 0 .908.628.908 1.402 0 .779-.407 1.407-.908 1.407-.495 0-.902-.628-.902-1.407z"
});

var _ref164 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196.357 153.832c0-.485.154-.913.388-1.179.165-.185.369-.295.585-.295.22 0 .426.11.59.295.235.266.389.694.389 1.179 0 .486-.154.916-.389 1.185-.164.187-.37.295-.59.295-.216 0-.42-.108-.585-.295-.234-.269-.388-.699-.388-1.185zm.145 0c0 .446.138.844.35 1.089.135.154.299.247.478.247.183 0 .347-.093.482-.247.214-.245.352-.643.352-1.089 0-.446-.138-.841-.352-1.084-.135-.153-.299-.245-.482-.245-.179 0-.343.092-.478.245-.212.243-.35.638-.35 1.084z"
});

var _ref165 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M196.933 153.832c0-.712.187-1.29.415-1.29.231 0 .416.578.416 1.29 0 .715-.183 1.293-.416 1.293-.228 0-.415-.578-.415-1.293z"
});

var _ref166 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196.86 153.832c0-.514.097-.961.237-1.183.075-.119.162-.177.251-.177.092 0 .179.058.254.177.139.222.235.669.235 1.183 0 .517-.096.964-.235 1.186-.075.121-.162.179-.254.179-.089 0-.176-.058-.251-.179-.14-.222-.237-.669-.237-1.186zm.145 0c0 .417.065.785.167 1.014a.43.43 0 00.1.164c.022.027.049.044.076.044.029 0 .057-.017.082-.044a.58.58 0 00.099-.164c.1-.229.162-.597.162-1.014 0-.414-.062-.782-.162-1.011a.544.544 0 00-.102-.162c-.022-.025-.05-.044-.079-.044-.027 0-.054.019-.076.044a.444.444 0 00-.1.162c-.102.229-.167.597-.167 1.011z"
});

var _ref167 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M192.69 159.592c-.134-.409-.385-.775-.385-.775 1.28-.408 3.058-.665 5.035-.669 1.979.004 3.769.261 5.046.669l-.343.657c-.111.21-.254.578-.245.578-1.154-.387-2.639-.587-4.466-.588-1.828.001-3.582.249-4.499.613.014 0-.064-.231-.154-.485h.011z"
});

var _ref168 =
/*#__PURE__*/
React.createElement("path", {
  d: "M192.87 160.141a.108.108 0 01-.037.009l-.027-.14c-.009.002-.015.008-.021.013-.006.006-.023.054-.023.054s-.062-.206-.135-.414h.052s-.01-.031-.017-.065l-.041.017a3.563 3.563 0 00-.372-.759l-.056-.079.093-.029c1.281-.409 3.069-.667 5.054-.673 1.988.006 3.786.264 5.066.673l.084.027-.04.075-.343.657-.002.002c-.079.142-.098.208-.239.57l-.027.062-.065-.021c-1.147-.384-2.625-.58-4.442-.582-1.809.002-3.547.242-4.462.603zm-.147-.559c-.004.012-.008.027-.015.04l.033-.046-.018.006zm.027-.008c.056.162.108.314.135.405.942-.351 2.661-.584 4.449-.586 1.8.002 3.27.195 4.422.567.125-.314.145-.384.226-.521l.302-.579c-1.266-.39-3.017-.636-4.944-.642-1.923.006-3.657.247-4.921.638.081.133.239.414.339.716l-.008.002z"
});

var _ref169 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M197.34 161.362c1.597-.003 3.354-.266 4.002-.449.432-.138.688-.352.64-.597-.02-.119-.116-.219-.243-.277-.95-.332-2.667-.567-4.399-.574-1.728.007-3.453.242-4.409.574-.123.058-.216.158-.237.277-.048.245.204.459.638.597.648.183 2.416.446 4.008.449z"
});

var _ref170 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M197.342 161.362c1.597-.003 3.353-.266 4.002-.449.433-.138.688-.352.641-.597-.021-.119-.117-.219-.244-.277-.95-.332-2.667-.567-4.399-.574-1.727.007-3.453.242-4.409.574-.123.058-.216.158-.237.277-.048.245.203.459.638.597.649.183 2.416.446 4.008.449z"
});

var _ref171 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.342 161.432c-1.603-.002-3.378-.268-4.029-.451-.278-.087-.486-.206-.596-.343a.383.383 0 01-.094-.335.477.477 0 01.279-.328l.004-.002h.004c.96-.335 2.694-.576 4.432-.578 1.74.002 3.468.243 4.422.578h.006l.003.002a.48.48 0 01.282.328.392.392 0 01-.095.335c-.113.137-.316.256-.597.343v.002c-.651.181-2.418.447-4.021.449zm0-.143c1.587-.002 3.335-.265 3.981-.445.204-.065.366-.148.472-.241.09-.083.136-.175.119-.275-.019-.095-.098-.174-.2-.222-.95-.331-2.652-.563-4.372-.566-1.719.003-3.43.235-4.384.568-.098.046-.177.125-.193.22-.019.1.026.192.116.275.106.093.268.176.474.241.646.18 2.401.443 3.987.445z"
});

var _ref172 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M201.211 154.459c0-.17.133-.307.295-.307.167 0 .3.137.3.307a.3.3 0 01-.3.306.3.3 0 01-.295-.306zm-.166-1.07a.3.3 0 01.295-.308c.164 0 .297.137.297.308a.3.3 0 01-.297.303.3.3 0 01-.295-.303zm-.742-.672c0-.168.129-.305.295-.305.162 0 .295.137.295.305a.302.302 0 01-.295.308.3.3 0 01-.295-.308zm-.93-.322c0-.173.133-.31.298-.31a.3.3 0 01.295.31.3.3 0 01-.295.304.303.303 0 01-.298-.304zm-.946.035c0-.17.133-.307.298-.307.164 0 .297.137.297.307a.3.3 0 01-.297.306.3.3 0 01-.298-.306z"
});

var _ref173 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201.14 154.459c0-.21.167-.378.366-.378.204 0 .371.168.371.378a.374.374 0 01-.371.379.373.373 0 01-.366-.379zm.144 0c0 .129.1.233.222.233a.228.228 0 00.225-.233c0-.131-.1-.235-.225-.235-.122 0-.222.107-.222.235zm-.312-1.07c0-.21.166-.379.368-.379.204 0 .37.169.37.379a.375.375 0 01-.37.376.373.373 0 01-.362-.306h-.006v-.07zm.143 0c0 .126.1.233.225.233a.232.232 0 00.225-.233.23.23 0 00-.225-.235.229.229 0 00-.225.235zm-.887-.672c0-.21.164-.378.37-.378.199 0 .368.168.368.378a.374.374 0 01-.368.378.371.371 0 01-.37-.378zm.145 0c0 .131.1.235.225.235a.23.23 0 00.224-.235.231.231 0 00-.224-.235.23.23 0 00-.225.235zm-1.07-.322c0-.212.166-.381.368-.381.205 0 .368.169.368.381a.374.374 0 01-.368.378.376.376 0 01-.368-.378zm.143 0c0 .127.1.233.225.233a.228.228 0 00.222-.233c0-.131-.097-.237-.222-.237a.23.23 0 00-.225.237zm-1.089.035c0-.21.164-.378.368-.378s.368.168.368.378a.371.371 0 01-.368.379.371.371 0 01-.368-.379zm.145 0c0 .129.1.233.223.233a.228.228 0 00.224-.233.228.228 0 00-.224-.234.229.229 0 00-.223.234z"
});

var _ref174 =
/*#__PURE__*/
React.createElement("path", {
  d: "M204.211 156.565a.071.071 0 01-.094.044c-.035-.014-.056-.056-.041-.092.085-.228.139-.48.139-.744 0-1.095-.794-1.989-1.781-1.989-.304 0-.603.087-.863.253a.077.077 0 01-.1-.022.072.072 0 01.021-.101c.287-.182.613-.274.942-.274 1.062 0 1.925.953 1.925 2.133 0 .281-.054.549-.148.792zM200.907 155.127l-.128-.067c.091-.175.158-.387.158-.588 0-.786-.751-1.416-1.663-1.416a1.84 1.84 0 00-1.038.312l-.081-.121a1.992 1.992 0 011.119-.334c1 0 1.806.7 1.806 1.559a1.5 1.5 0 01-.173.655z"
});

var _ref175 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M204.398 155.609c0-.168.135-.308.3-.308.164 0 .297.14.297.308a.3.3 0 01-.297.303.302.302 0 01-.3-.303zm-.11-1.129c0-.17.133-.303.297-.303a.3.3 0 01.298.303.303.303 0 01-.298.306.302.302 0 01-.297-.306zm-.667-.863c0-.168.133-.305.297-.305.164 0 .297.137.297.305a.302.302 0 01-.297.306.302.302 0 01-.297-.306zm-.89-.461c0-.166.133-.304.297-.304.162 0 .295.138.295.304 0 .17-.133.312-.295.312a.306.306 0 01-.297-.312zm-.946.041c0-.17.133-.307.297-.307.165 0 .298.137.298.307a.3.3 0 01-.298.306.3.3 0 01-.297-.306z"
});

var _ref176 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.658 153.156c0 .066.073.072.073.072s-.073-.087-.073-.072c0-.206.166-.377.37-.377.202 0 .368.171.368.377a.376.376 0 01-.368.384.376.376 0 01-.37-.384zm.146 0c0 .131.099.239.224.239s.225-.108.225-.239a.23.23 0 00-.225-.233.229.229 0 00-.224.233zm1.524 2.453c0-.21.168-.38.37-.38.201 0 .368.17.368.38s-.167.376-.368.376a.373.373 0 01-.37-.376zm.145 0a.23.23 0 00.225.233.228.228 0 00.224-.233.23.23 0 00-.224-.235.231.231 0 00-.225.235zm-.258-1.129c0-.21.168-.376.37-.376.202 0 .368.166.368.376a.373.373 0 01-.368.376.374.374 0 01-.37-.376zm.144 0a.23.23 0 00.226.233.228.228 0 00.225-.233c0-.129-.1-.233-.225-.233a.23.23 0 00-.226.233zm-.809-.863c0-.207.166-.376.368-.376.204 0 .368.169.368.376a.372.372 0 01-.368.379.373.373 0 01-.368-.379zm.143 0c0 .129.1.235.225.235a.23.23 0 00.224-.235.227.227 0 00-.224-.232.228.228 0 00-.225.232zm-1.981-.42c0-.21.166-.378.37-.378s.37.168.37.378-.166.379-.37.379a.374.374 0 01-.37-.379zm.144 0a.23.23 0 00.226.233.231.231 0 00.227-.233.232.232 0 00-.227-.235.231.231 0 00-.226.235z"
});

var _ref177 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M202.465 158.041l-.389-.384s-.372.249-.836.172c-.463-.075-.611-.686-.611-.686s-.522.472-.944.439c-.426-.042-.702-.439-.702-.439s-.466.36-.876.323c-.407-.04-.798-.593-.798-.593s-.406.574-.815.613c-.407.036-.74-.387-.74-.387s-.187.423-.705.518c-.519.096-.965-.44-.965-.44s-.293.517-.648.652c-.351.133-.813-.191-.813-.191s-.073.191-.131.306c-.056.114-.204.135-.204.135l.114.343c1.271-.401 2.996-.651 4.944-.653 1.95.002 3.719.252 4.99.655l.131-.383h-.002z"
});

var _ref178 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.521 158.112l-.137.403-.069-.022c-1.264-.404-3.027-.649-4.969-.651-1.937.002-3.654.247-4.921.648l-.066.021-.169-.492.09-.011s.108-.014.148-.096c.056-.114.128-.301.128-.301l.034-.087.075.054s.158.11.355.172a.59.59 0 00.393.011c.335-.125.609-.62.609-.62l.052-.091.067.081s.152.183.378.309c.15.082.327.14.518.107a.908.908 0 00.65-.474l.05-.113.075.096s.11.141.283.249a.668.668 0 00.393.111c.152-.017.299-.111.426-.219.197-.168.339-.368.339-.368l.06-.081.058.081s.135.194.327.356c.122.102.268.195.418.21.386.031.823-.31.823-.31l.058-.046.046.06s.253.373.648.41c.159.013.327-.052.475-.131.237-.125.415-.291.415-.291l.092-.079.027.116s.052.206.185.387a.59.59 0 00.368.248c.434.07.786-.163.786-.163l.047-.033.556.549h-.121zm-.135-.05l-.32-.314a1.369 1.369 0 01-.838.154.711.711 0 01-.458-.306 1.236 1.236 0 01-.176-.33 2.581 2.581 0 01-.358.239c-.174.091-.374.164-.557.148-.353-.033-.609-.296-.709-.412-.145.095-.524.329-.867.297-.179-.018-.353-.122-.497-.243a2.118 2.118 0 01-.295-.306 2.282 2.282 0 01-.304.321c-.149.122-.328.232-.505.247a.76.76 0 01-.482-.131 1.352 1.352 0 01-.252-.204 1.066 1.066 0 01-.706.466.915.915 0 01-.611-.123 1.675 1.675 0 01-.356-.27c-.102.158-.349.495-.632.601a.733.733 0 01-.485-.009 1.446 1.446 0 01-.32-.143 2.617 2.617 0 01-.102.233.303.303 0 01-.174.147l.068.206c1.268-.388 2.973-.631 4.896-.634 1.925.003 3.676.246 4.946.636l.094-.27z"
});

var _ref179 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M192.841 154.459a.3.3 0 01.298-.307.3.3 0 01.293.307.298.298 0 01-.293.306.3.3 0 01-.298-.306zm.167-1.07c0-.171.133-.308.297-.308.16 0 .293.137.293.308a.3.3 0 01-.293.303.3.3 0 01-.297-.303zm.74-.672c0-.168.133-.305.297-.305a.3.3 0 01.297.305.3.3 0 01-.297.308.302.302 0 01-.297-.308zm.927-.322c0-.173.133-.31.299-.31.164 0 .297.137.297.31a.303.303 0 01-.297.304.303.303 0 01-.299-.304zm.946.035c0-.17.133-.307.297-.307.165 0 .298.137.298.307a.3.3 0 01-.298.306.3.3 0 01-.297-.306z"
});

var _ref180 =
/*#__PURE__*/
React.createElement("path", {
  d: "M192.769 154.459c0 .067.072.073.072.073s-.072-.089-.072-.073c0-.21.166-.378.37-.378.199 0 .367.168.367.378a.374.374 0 01-.367.379.37.37 0 01-.37-.379zm.143 0c0 .129.1.233.227.233.12 0 .22-.104.22-.233 0-.128-.1-.235-.22-.235a.23.23 0 00-.227.235zm.025-1.07c0-.21.164-.379.368-.379.201 0 .368.169.368.379a.375.375 0 01-.368.376.373.373 0 01-.368-.376zm.143 0c0 .126.1.233.225.233.122 0 .222-.107.222-.233 0-.131-.1-.235-.222-.235a.229.229 0 00-.225.235zm.597-.672c0-.21.164-.378.368-.378s.37.168.37.378a.372.372 0 01-.37.378.37.37 0 01-.368-.378zm.143 0c0 .131.1.235.225.235a.228.228 0 00.226-.235.23.23 0 00-.226-.235.23.23 0 00-.225.235zm.784-.322c0-.212.167-.381.37-.381.204 0 .368.169.368.381a.374.374 0 01-.368.378.377.377 0 01-.37-.378zm.144 0a.23.23 0 00.226.233.23.23 0 00.223-.233c0-.131-.1-.237-.223-.237a.23.23 0 00-.226.237zm.802.035c0-.21.166-.378.368-.378.204 0 .368.168.368.378a.371.371 0 01-.368.379.373.373 0 01-.368-.379zm.144 0c0 .129.099.233.224.233a.228.228 0 00.225-.233.23.23 0 00-.225-.234.228.228 0 00-.224.234z"
});

var _ref181 =
/*#__PURE__*/
React.createElement("path", {
  d: "M190.567 156.517a.073.073 0 01-.044.092.07.07 0 01-.093-.044 2.34 2.34 0 01-.146-.792c0-1.18.863-2.133 1.925-2.133.341 0 .664.1.942.274a.072.072 0 01.023.098.072.072 0 01-.098.025 1.625 1.625 0 00-.867-.253c-.987 0-1.781.894-1.781 1.989 0 .264.054.516.139.744zM193.887 155.037l-.127.067c-.102-.194-.197-.41-.197-.632 0-.859.81-1.559 1.808-1.559.42 0 .811.126 1.117.334l-.079.121a1.854 1.854 0 00-1.038-.312c-.914 0-1.663.63-1.663 1.416 0 .199.088.391.179.565z"
});

var _ref182 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M189.65 155.609c0-.168.131-.308.297-.308.162 0 .295.14.295.308a.3.3 0 01-.295.303.298.298 0 01-.297-.303zm.108-1.129a.298.298 0 11.597 0 .302.302 0 01-.297.306.304.304 0 01-.3-.306zm.67-.863c0-.168.133-.305.299-.305.162 0 .295.137.295.305a.301.301 0 01-.295.306.302.302 0 01-.299-.306zm.892-.461c0-.166.133-.304.295-.304a.3.3 0 01.297.304c0 .17-.131.312-.297.312-.162 0-.295-.142-.295-.312zm.943.041c0-.17.133-.307.297-.307a.3.3 0 01.296.307.299.299 0 01-.296.306.3.3 0 01-.297-.306z"
});

var _ref183 =
/*#__PURE__*/
React.createElement("path", {
  d: "M190.357 153.617c0-.207.164-.376.37-.376.201 0 .366.169.366.376a.373.373 0 01-.366.379.372.372 0 01-.364-.308h-.006v-.071zm.145 0c0 .129.1.235.225.235a.23.23 0 00.223-.235c0-.128-.1-.232-.223-.232a.228.228 0 00-.225.232zm.745-.461c0 .066.073.072.073.072s-.073-.087-.073-.072c0-.206.166-.377.368-.377.203 0 .37.171.37.377a.377.377 0 01-.37.384.376.376 0 01-.368-.384zm.143 0c0 .131.1.239.225.239a.233.233 0 00.226-.239.23.23 0 00-.226-.233.23.23 0 00-.225.233zm.8.041c0-.21.167-.378.37-.378.205 0 .369.168.369.378s-.164.379-.369.379a.373.373 0 01-.363-.306h-.007v-.073zm.146 0a.23.23 0 00.224.233.228.228 0 00.225-.233.23.23 0 00-.225-.235.232.232 0 00-.224.235zm-2.759 2.412c0-.21.165-.38.37-.38.2 0 .366.17.366.38s-.166.376-.366.376a.371.371 0 01-.37-.376zm.144 0c0 .129.1.233.226.233a.228.228 0 00.223-.233.23.23 0 00-.223-.235.23.23 0 00-.226.235zm-.033-1.129c0-.21.168-.376.37-.376.203 0 .37.166.37.376a.374.374 0 01-.37.376.374.374 0 01-.37-.376zm.143 0c0 .129.104.233.227.233a.23.23 0 00.226-.233.23.23 0 00-.226-.233.231.231 0 00-.227.233z"
});

var _ref184 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M197.351 156.189l.184.035a.816.816 0 00-.033.267c0 .417.327.754.73.754a.732.732 0 00.694-.522c.013.009.071-.272.1-.268.027 0 .023.293.029.289.05.376.366.636.726.636a.743.743 0 00.725-.844l.231-.251.121.32a.71.71 0 00-.069.324c0 .399.314.724.697.724a.687.687 0 00.58-.325l.149-.201-.004.251c0 .248.1.472.322.512 0 0 .258.021.597-.275.345-.291.53-.534.53-.534l.021.299s-.335.599-.636.79c-.169.106-.424.219-.624.179-.214-.033-.364-.222-.443-.434a.937.937 0 01-.524.151 1 1 0 01-.931-.615.976.976 0 01-.765.357 1.03 1.03 0 01-.821-.411 1.006 1.006 0 01-.718.306c-.363 0-.692-.2-.875-.493a1.04 1.04 0 01-.873.493 1.02 1.02 0 01-.719-.306c-.19.252-.491.414-.823.414a.973.973 0 01-.759-.36 1.006 1.006 0 01-1.453.464c-.079.212-.231.401-.443.434-.202.04-.456-.073-.622-.179-.306-.191-.667-.79-.667-.79l.045-.299s.188.243.527.534c.345.296.6.275.6.275.225-.04.321-.264.321-.512v-.251l.145.201a.697.697 0 00.58.325.713.713 0 00.701-.724.71.71 0 00-.069-.324l.12-.32.229.251c-.004.027-.004.059-.004.09a.74.74 0 00.726.754c.359 0 .677-.26.725-.636.01.004.009-.289.031-.289.032-.004.092.277.1.268a.74.74 0 00.697.522.742.742 0 00.731-.754.767.767 0 00-.035-.267l.191-.035h.005z"
});

var _ref185 =
/*#__PURE__*/
React.createElement("path", {
  d: "M195.562 156.703l.013-.179a.327.327 0 01.015-.092c.016-.035.039-.045.062-.048h.01c.025 0 .061.013.086.061a2 2 0 01.054.158l.029.101c.087.273.335.47.628.47a.67.67 0 00.659-.683.741.741 0 00-.029-.242l-.029-.079.272-.052v.007c.006-.004.01-.009.019-.009l.014.002h.006l.26.052-.027.079a.716.716 0 00-.031.242.67.67 0 00.659.683.66.66 0 00.626-.47l.029-.095c.018-.056.039-.129.056-.162a.106.106 0 01.048-.056c.014-.007.027-.009.039-.007h.007c.02.003.045.013.06.046.01.017.016.052.019.094.006.062.008.166.01.197v.011a.657.657 0 00.655.575.669.669 0 00.651-.76l-.005-.036.335-.359.177.455-.017.029a.638.638 0 00-.06.293c0 .36.281.651.624.651.22 0 .409-.117.521-.289v-.002l.281-.387-.004.476c0 .208.073.403.26.441.031 0 .251-.006.54-.258.337-.285.52-.524.52-.524l.117-.154.033.512-.011.021s-.349.617-.661.815c-.179.116-.457.23-.673.189-.212-.034-.37-.2-.466-.401a1.077 1.077 0 01-1.439-.439 1.045 1.045 0 01-.746.301c-.322 0-.622-.143-.829-.376-.19.169-.439.268-.71.268-.353 0-.671-.174-.875-.437-.204.263-.52.437-.873.437a1.074 1.074 0 01-.713-.268 1.095 1.095 0 01-.829.376c-.291 0-.545-.11-.741-.301a1.069 1.069 0 01-1.438.439c-.094.201-.256.367-.464.401-.216.041-.495-.073-.673-.189-.316-.198-.691-.813-.691-.813l-.012-.023.077-.491.102.133s.183.239.517.524c.291.254.516.258.545.258.187-.038.254-.233.254-.441v-.474l.278.385a.618.618 0 00.52.291.638.638 0 00.626-.651.679.679 0 00-.058-.293l-.017-.029.176-.455.331.359-.006.036c-.004.027-.002.052-.002.079 0 .376.291.681.653.681a.65.65 0 00.652-.571l.004-.033zm3.425.068a.804.804 0 01-.755.547.817.817 0 01-.805-.827.98.98 0 01.019-.211l-.098-.018-.101.018c.012.069.016.138.016.211 0 .457-.36.827-.804.827a.804.804 0 01-.757-.555.797.797 0 01-.796.69c-.441 0-.799-.37-.799-.827 0-.021.003-.044.003-.067l-.13-.139-.068.179a.83.83 0 01.062.33.78.78 0 01-.771.794.77.77 0 01-.64-.351l-.015-.021v.027c0 .285-.12.537-.376.582l-.004.002h-.004s-.283.028-.653-.291a4.68 4.68 0 01-.433-.424l-.018.117c.066.11.368.582.63.746.153.098.386.204.569.168h.002c.187-.031.318-.201.387-.391l.031-.083.075.048a.888.888 0 00.484.144.934.934 0 00.863-.572l.046-.11.077.091c.174.208.42.333.705.333.311 0 .59-.15.765-.383l.051-.066.059.058a.932.932 0 00.667.281c.341 0 .64-.185.811-.456l.062-.095.061.095a.972.972 0 00.814.456.933.933 0 00.666-.281l.06-.058.048.064a.966.966 0 00.765.385.929.929 0 00.713-.333l.077-.091.044.11c.135.341.48.572.862.572a.884.884 0 00.485-.144l.075-.048.031.083c.07.19.199.36.389.391.184.036.417-.07.571-.168.26-.164.545-.647.603-.749l-.008-.099c-.09.102-.233.249-.42.409-.37.319-.653.291-.653.291h-.004l-.002-.002c-.258-.045-.381-.297-.381-.582v-.027l-.012.019s-.002 0-.002.002a.762.762 0 01-.64.351.782.782 0 01-.77-.794c0-.118.021-.231.065-.33l-.071-.179-.129.139c.002.023.002.046.002.067a.815.815 0 01-.802.827.798.798 0 01-.794-.682zm-3.268-.102z"
});

var _ref186 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M197.34 158.149c-1.977.003-3.752.26-5.029.672-.087.029-.191-.042-.22-.127-.027-.087.035-.197.116-.229 1.287-.424 3.108-.694 5.133-.696 2.025.002 3.855.272 5.137.696.086.032.148.142.121.229-.027.085-.135.156-.221.127-1.276-.412-3.058-.669-5.037-.672z"
});

var _ref187 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.34 158.222c-1.969.002-3.738.258-5.006.666a.228.228 0 01-.16-.009.29.29 0 01-.152-.162c-.037-.123.046-.274.162-.318h.002c1.289-.428 3.119-.7 5.154-.703 2.033.003 3.873.275 5.16.703.121.044.204.195.166.318a.279.279 0 01-.156.162.209.209 0 01-.153.009c-1.271-.408-3.048-.664-5.017-.666zm0-.143c1.988.002 3.78.26 5.062.673.023.009.048 0 .069-.012a.137.137 0 00.058-.067c.015-.054-.025-.12-.075-.137-1.278-.426-3.097-.692-5.114-.694-2.016.002-3.827.268-5.108.694-.05.019-.087.083-.073.137a.15.15 0 00.059.067c.02.012.045.021.07.012 1.281-.413 3.067-.671 5.052-.673z"
});

var _ref188 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M195.428 158.914a.29.29 0 01.288-.295c.154 0 .283.133.283.295a.29.29 0 01-.283.296.29.29 0 01-.288-.296z"
});

var _ref189 =
/*#__PURE__*/
React.createElement("path", {
  d: "M195.355 158.914c0-.201.162-.367.361-.367.196 0 .356.164.356.367a.36.36 0 01-.356.367.362.362 0 01-.361-.367zm.143 0c0 .125.096.223.218.223a.217.217 0 00.213-.223.22.22 0 00-.213-.224.221.221 0 00-.218.224z"
});

var _ref190 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M198.009 159.041h-1.28a.22.22 0 01-.216-.224c0-.121.093-.219.212-.219h1.288c.117 0 .211.098.211.219a.22.22 0 01-.215.224z"
});

var _ref191 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196.729 159.114a.297.297 0 01-.291-.297.29.29 0 01.287-.291h1.288c.157 0 .281.131.281.291a.29.29 0 01-.285.297h-1.28zm1.28-.143c.08 0 .142-.073.142-.154 0-.079-.06-.146-.138-.146h-1.288a.146.146 0 00-.142.146c0 .081.067.154.146.154h1.28z"
});

var _ref192 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M194.178 159.281l-.455.072a.219.219 0 01-.248-.187.217.217 0 01.179-.247l.458-.073.463-.081a.222.222 0 01.247.185c.015.116-.064.233-.18.249l-.464.082z"
});

var _ref193 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.733 159.424a.29.29 0 01-.328-.245.29.29 0 01.237-.331l.457-.073.468-.081a.293.293 0 01.326.245.296.296 0 01-.239.333l-.463.079-.458.073zm.433-.214l.463-.081h.002c.077-.011.131-.088.121-.169a.145.145 0 00-.164-.12l-.466.077-.458.072c-.076.011-.128.088-.116.167a.147.147 0 00.164.127l.454-.073z"
});

var _ref194 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M192.338 159.628l.202-.356.434.087-.251.4z"
});

var _ref195 =
/*#__PURE__*/
React.createElement("path", {
  d: "M192.504 159.191l.587.121-.337.534-.522-.181.272-.474zm-.058.397l.246.085.166-.262-.279-.058-.133.235z"
});

var _ref196 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M198.685 158.914c0-.162.127-.295.289-.295.154 0 .283.133.283.295a.29.29 0 01-.283.296.29.29 0 01-.289-.296z"
});

var _ref197 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.613 158.914c0 .065.072.071.072.071s-.072-.089-.072-.071c0-.203.162-.367.357-.367a.368.368 0 010 .734.361.361 0 01-.357-.367zm.143 0c0 .125.098.223.214.223a.219.219 0 00.218-.223.222.222 0 00-.218-.224.222.222 0 00-.214.224z"
});

var _ref198 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M200.506 159.281l.458.072c.116.019.224-.064.243-.187a.215.215 0 00-.175-.247l-.457-.073-.468-.081a.218.218 0 00-.243.185.217.217 0 00.179.249l.463.082z"
});

var _ref199 =
/*#__PURE__*/
React.createElement("path", {
  d: "M200.494 159.351l-.461-.079a.295.295 0 01-.24-.333.291.291 0 01.327-.245l.467.081.456.073a.29.29 0 01.237.331v.001a.287.287 0 01-.327.244l-.459-.073zm.025-.141l.455.073c.079.01.15-.044.162-.125.013-.079-.037-.158-.114-.169l-.457-.072-.468-.077a.144.144 0 00-.162.12.146.146 0 00.122.169l.462.081z"
});

var _ref200 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M202.307 159.648l-.16-.378-.447.039.214.427z"
});

var _ref201 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.309 159.694c-.115.029-.243.077-.378.11l-.057.013-.284-.57.603-.054.199.48-.083.021zm-.115-.116l-.095-.231-.285.025.139.279c.083-.025.167-.053.241-.073z"
});

var _ref202 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M197.338 160.958c-1.597-.002-3.041-.154-4.141-.466 1.1-.305 2.544-.496 4.141-.5 1.597 0 3.048.193 4.145.5-1.097.312-2.548.464-4.145.466z"
});

var _ref203 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M197.338 161.029a21.072 21.072 0 01-2.296-.12 11.726 11.726 0 01-1.864-.348.071.071 0 010-.137 13.36 13.36 0 011.943-.372 19.167 19.167 0 012.217-.131c.783-.001 1.531.046 2.218.129.722.087 1.381.216 1.947.374a.071.071 0 010 .137c-.544.154-1.174.27-1.864.347-.709.08-1.485.12-2.301.121zm-2.28-.262c.706.079 1.476.12 2.28.121a21.005 21.005 0 002.285-.121 12.223 12.223 0 001.584-.274 13.488 13.488 0 00-1.668-.302 18.593 18.593 0 00-4.401.003c-.606.073-1.166.175-1.663.299.475.118 1.008.21 1.583.274z"
});

var _ref204 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M202.371 157.185c.044-.135.004-.268-.085-.299-.089-.03-.196.058-.235.187-.046.137-.008.272.081.303.09.027.198-.056.239-.191z"
});

var _ref205 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.44 157.208a.395.395 0 01-.16.214.232.232 0 01-.171.023v-.002a.216.216 0 01-.122-.119.398.398 0 01-.005-.274.382.382 0 01.156-.21.202.202 0 01.169-.023h.002a.218.218 0 01.122.12c.034.071.04.171.009.271zm-.138-.046a.254.254 0 00.007-.146c-.008-.029-.023-.054-.048-.064-.023-.004-.046.006-.067.025a.254.254 0 00-.076.116.299.299 0 00-.009.152c.011.029.023.052.046.062.025.007.048-.004.071-.022a.238.238 0 00.076-.123z"
});

var _ref206 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M199.192 156.516c.017-.14-.045-.267-.139-.277-.091-.015-.183.091-.197.233-.017.139.043.264.139.276.093.009.179-.098.197-.232z"
});

var _ref207 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.263 156.524a.38.38 0 01-.114.239.208.208 0 01-.162.056h-.003a.208.208 0 01-.145-.094.383.383 0 01-.054-.264.368.368 0 01.116-.241.213.213 0 01.161-.056.232.232 0 01.143.094c.048.064.07.162.058.266zm-.141-.017a.261.261 0 00-.023-.148c-.012-.026-.031-.047-.056-.049-.023-.005-.044.012-.06.035a.221.221 0 00-.054.135.23.23 0 00.02.144c.013.026.031.05.054.054.023 0 .046-.017.063-.038a.248.248 0 00.056-.133z"
});

var _ref208 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M195.502 156.516c-.016-.14.046-.267.138-.277.093-.015.183.091.199.233.015.139-.046.264-.137.276-.094.009-.181-.098-.2-.232z"
});

var _ref209 =
/*#__PURE__*/
React.createElement("path", {
  d: "M195.446 156.586h-.008l-.006-.062a.384.384 0 01.056-.266.23.23 0 01.143-.094.214.214 0 01.162.056.387.387 0 01.119.241l.002.002a.423.423 0 01-.06.262.205.205 0 01-.142.094h-.004a.197.197 0 01-.158-.056.336.336 0 01-.104-.177zm.127-.079c.008.052.027.1.056.133.019.021.04.038.065.038.025-.004.039-.028.054-.054a.318.318 0 00.02-.146.248.248 0 00-.054-.133c-.018-.023-.041-.04-.064-.035-.025.002-.044.023-.054.049a.261.261 0 00-.023.148z"
});

var _ref210 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M192.323 157.185c-.041-.135-.004-.268.084-.299.089-.03.197.058.241.187.042.137.004.272-.085.303-.092.027-.198-.056-.237-.191h-.003z"
});

var _ref211 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M192.326 157.185c-.042-.135-.004-.268.083-.299.089-.03.197.058.241.187.042.137.004.272-.085.303-.092.027-.198-.056-.237-.191h-.002z"
});

var _ref212 =
/*#__PURE__*/
React.createElement("path", {
  d: "M192.276 157.257h-.002l-.015-.039-.002-.01a.39.39 0 01.004-.271.225.225 0 01.123-.12h.002l.002-.002a.204.204 0 01.166.025.373.373 0 01.163.21v.002a.41.41 0 01-.007.272.226.226 0 01-.122.121h-.002a.225.225 0 01-.169-.023.358.358 0 01-.141-.165zm.05 0l.068-.095a.26.26 0 00.077.123c.023.018.048.029.073.022.021-.01.033-.033.042-.062a.32.32 0 00-.007-.152.247.247 0 00-.077-.116c-.022-.019-.047-.029-.072-.023-.021.008-.036.033-.044.062a.293.293 0 00.006.146l-.066.095z"
});

var _ref213 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M197.34 154.514l-.563.37.416.989.147.104.141-.104.423-.989c-.19-.125-.377-.252-.564-.37z"
});

var _ref214 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.377 154.453c.192.121.377.245.566.37l.048.033-.449 1.063-.202.145-.204-.145-.451-1.063.653-.43.039.027zm-.037.146l-.476.311.389.915.087.063.083-.063.389-.915-.472-.311z"
});

var _ref215 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M196.105 156.006l.254.407.879-.295.092-.135-.092-.137-.879-.281c-.087.146-.175.291-.254.441zm2.474 0l-.26.407-.877-.295-.094-.135.094-.137.877-.281c.092.146.175.293.26.441zm-4.904-1.054l-.441.455.563.813.152.065.111-.125.199-.981c-.195-.077-.389-.154-.584-.227z"
});

var _ref216 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.34 155.869l.056-.083.957-.304.029.046c.091.145.174.293.26.443l.02.037-.311.491-.955-.32-.056-.081-.056.081-.954.32-.31-.489.021-.037c.081-.152.168-.3.258-.445l.029-.046.956.304.056.083zm1.154.135a11.114 11.114 0 00-.206-.351l-.8.255-.05.075.05.073.802.27.204-.322zm-2.308 0l.204.322.803-.27.051-.073-.051-.075-.801-.255a6.85 6.85 0 00-.206.351zm-2.484-1.119c.193.073.389.15.584.227l.056.023-.216 1.058-.156.181-.218-.095-.611-.88.515-.53.046.016zm-.008.152l-.368.379.521.746.082.035.064-.07.183-.905c-.16-.062-.32-.125-.482-.185z"
});

var _ref217 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M192.75 156.582l.33.341.803-.472.062-.154-.116-.112-.917-.087c-.062.157-.11.322-.162.486v-.002zm2.42-.53l-.169.451-.919-.094-.12-.114.062-.154.805-.462c.118.119.229.246.341.373zm-3.306.659l-.075.474-.917.104-.141-.086.033-.162.693-.625c.133.104.27.197.407.295z"
});

var _ref218 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.929 156.183l.039-.094.875-.501.04.04c.118.123.229.249.341.378l.029.031-.206.543-.998-.1-.073-.071-.035.09-.871.515-.335-.343-.137.148.083-.258c.05-.164.102-.33.164-.488l.017-.052.998.093.069.069zm-1.179.472s-.04-.138-.054-.123c-.056.064.054.123.054.123zm.079-.092l.264.268.732-.432.033-.083-.062-.062-.836-.079c-.048.128-.087.257-.131.388zm2.258-.495c-.09-.099-.177-.203-.271-.299l-.734.422-.035.088.067.062.837.083.136-.356zm-3.235 1.181l-.998.112-.204-.124.052-.233.751-.684.05.038c.128.103.267.197.405.292l.037.028-.093.571zm-.065-.505c-.11-.079-.218-.154-.326-.235l-.63.57-.019.087.075.048.84-.096.06-.374z"
});

var _ref219 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M193.633 156.299c0-.183.146-.335.322-.335.179 0 .325.152.325.335a.329.329 0 01-.325.333.328.328 0 01-.322-.333z"
});

var _ref220 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M193.635 156.299c0-.183.146-.335.323-.335.178 0 .324.152.324.335a.329.329 0 01-.324.333.328.328 0 01-.323-.333z"
});

var _ref221 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.563 156.299a.4.4 0 01.392-.405c.221 0 .396.181.396.405a.4.4 0 01-.396.408.403.403 0 01-.392-.408zm.145 0c0 .144.11.262.247.262.14 0 .252-.118.252-.262a.256.256 0 00-.252-.26.254.254 0 00-.247.26z"
});

var _ref222 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M201.014 154.952l.442.455-.565.813-.15.065-.112-.125-.2-.981c.198-.069.393-.144.585-.227z"
});

var _ref223 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201.55 155.399l-.611.88-.219.095-.158-.181-.214-1.062.059-.019a9.37 9.37 0 00.579-.227l.044-.016.52.53zm-.553-.36c-.158.067-.32.129-.482.185l.183.903.062.07.083-.035.52-.746-.366-.377z"
});

var _ref224 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M201.943 156.582l-.333.341-.802-.472-.065-.154.119-.112.917-.087c.064.16.11.32.164.484zm-2.422-.53l.168.451.921-.094.117-.114-.063-.154-.804-.462c-.11.127-.227.248-.339.373z"
});

var _ref225 =
/*#__PURE__*/
React.createElement("path", {
  d: "M200.758 156.183l.07-.069.999-.093.02.052c.065.16.11.32.164.488l.013.042-.403.411-.872-.515-.037-.09-.071.071-.997.1-.206-.543.031-.033c.112-.123.226-.247.339-.374l.037-.044.878.505.035.092zm-1.154-.115l.135.356.838-.083.064-.062-.033-.088-.732-.42c-.089.1-.181.2-.272.297zm2.256.495c-.042-.133-.079-.26-.129-.388l-.838.079-.065.062.036.083.732.432.264-.268z"
});

var _ref226 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M202.7 156.711l.075.474.916.104.138-.086-.034-.162-.688-.625z"
});

var _ref227 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M202.7 156.711l.075.474.916.104.138-.086-.034-.162-.688-.625c-.137.095-.272.193-.407.295z"
});

var _ref228 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.658 156.653c.133-.102.27-.2.408-.298l.048-.033.748.682.048.233-.202.124-.998-.112-.087-.571.035-.025zm.118.089l.061.376.838.096.075-.048-.021-.087-.628-.572a20.19 20.19 0 00-.325.235z"
});

var _ref229 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M197.022 155.985a.33.33 0 01.322-.334.33.33 0 01.324.334.328.328 0 01-.324.333.328.328 0 01-.322-.333z"
});

var _ref230 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196.949 155.985a.4.4 0 01.393-.405c.221 0 .395.181.395.405a.4.4 0 01-.395.408.403.403 0 01-.393-.408zm.146 0c0 .144.11.262.247.262a.258.258 0 00.252-.262.257.257 0 00-.252-.26.254.254 0 00-.247.26z"
});

var _ref231 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M200.417 156.299a.33.33 0 01.322-.335c.179 0 .325.152.325.335a.329.329 0 01-.325.333.327.327 0 01-.322-.333z"
});

var _ref232 =
/*#__PURE__*/
React.createElement("path", {
  d: "M200.342 156.299a.4.4 0 01.393-.405c.22 0 .395.181.395.405a.4.4 0 01-.395.408.403.403 0 01-.393-.408zm.146 0c0 .144.11.262.247.262a.257.257 0 00.251-.262.256.256 0 00-.251-.26.254.254 0 00-.247.26z"
});

var _ref233 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M197.77 152.008v.412h-.935v-.412h.305v-.935h-.405v-.418h.405v-.408h.402v.408h.399v.418h-.399v.935h.226z"
});

var _ref234 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.772 151.936c.092 0 0 .143 0 .143l.073-.071v.485h-1.081v-.557h.308v-.79h-.41v-.562h.41v-.409h.545v.409h.396v.562h-.396v.79h.155zm-.07.143h-.229v-1.077h.397v-.274h-.397v-.408h-.258v.408h-.405v.274h.405v1.077h-.305v.27h.792v-.27z"
});

var _ref235 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M197.588 151.428a.821.821 0 01.576.796.815.815 0 01-.807.828.816.816 0 01-.803-.828c0-.384.252-.704.595-.802l.439.006z"
});

var _ref236 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.569 151.497l.041-.139a.9.9 0 01.626.866.89.89 0 01-.879.901.889.889 0 01-.875-.901c0-.417.274-.765.646-.873l.042.14a.757.757 0 00-.545.733c0 .418.328.757.732.757a.745.745 0 00.734-.757.749.749 0 00-.522-.727z"
});

var _ref237 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M190.592 157.22a3.215 3.215 0 00-.399-.476c-.129-.127-.443-.233-.443-.233 0-.062.185-.206.384-.206a.36.36 0 01.291.144l.023-.137s.163.033.235.228c.073.204.027.51.027.51-.027.066-.081.112-.118.17z"
});

var _ref238 =
/*#__PURE__*/
React.createElement("path", {
  d: "M190.592 157.347l-.056-.087c-.003 0-.003-.003-.007-.003a3.192 3.192 0 00-.386-.463c-.121-.116-.416-.214-.416-.214l-.048-.017v-.052c0-.031.021-.079.067-.124a.604.604 0 01.388-.154c.088 0 .173.025.244.072l.012-.081.073.017s.2.038.287.275c.079.216.031.544.031.544l-.002.01-.002.007c-.027.068-.083.12-.123.183l-.062.093v-.006zm0-.243l.002-.005a.738.738 0 01.058.08l-.056-.081a.34.34 0 00.044-.069c.006-.05.037-.297-.025-.466a.315.315 0 00-.111-.147l-.035.212-.102-.137a.29.29 0 00-.233-.113.446.446 0 00-.262.092c-.004.002-.008.004-.01.008.11.042.289.125.383.212.124.127.241.262.347.405v.009zm.002-.005l-.002-.004v-.002l.004.005-.002.001z"
});

var _ref239 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M190.637 157.089c.076-.085.234-.066.348.042.118.11.154.268.075.357-.075.09-.231.069-.347-.039-.121-.108-.155-.272-.076-.36z"
});

var _ref240 =
/*#__PURE__*/
React.createElement("path", {
  d: "M190.581 157.044c.1-.113.304-.104.454.035.149.139.178.343.081.457-.098.115-.299.106-.453-.033a.433.433 0 01-.14-.277.253.253 0 01.058-.182zm.109.095c-.017.019-.023.048-.021.079a.275.275 0 00.091.177c.048.043.1.071.152.077.035.004.07-.002.094-.029a.122.122 0 00.022-.084.276.276 0 00-.091-.174.261.261 0 00-.15-.075c-.037-.004-.074.002-.097.029z"
});

var _ref241 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M203.939 157.264c.012.01.249-.343.432-.52.125-.127.443-.233.443-.233 0-.062-.185-.206-.385-.206a.366.366 0 00-.293.144l-.025-.137s-.16.033-.231.228c-.074.204-.029.51-.029.51s.032.141.088.214z"
});

var _ref242 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M203.939 157.264c.012.01.249-.343.432-.52.125-.127.443-.233.443-.233 0-.062-.185-.206-.385-.206a.366.366 0 00-.293.144l-.025-.137s-.16.033-.231.228c-.074.204-.029.51-.029.51-.002.089.036.116.088.214z"
});

var _ref243 =
/*#__PURE__*/
React.createElement("path", {
  d: "M203.876 157.299c-.06-.112-.099-.147-.095-.243-.009-.044-.042-.341.029-.54.087-.237.289-.275.289-.275l.071-.017.016.084a.436.436 0 01.243-.075c.162 0 .312.081.389.154.048.045.069.093.069.124v.052l-.05.017s-.297.098-.414.214c-.164.158-.372.459-.42.511a.081.081 0 01-.108.017l-.01-.008-.009-.015zm.073-.16c.083-.114.252-.331.372-.447.09-.089.273-.172.381-.214l-.009-.008a.45.45 0 00-.264-.092.296.296 0 00-.234.113l-.098.135-.038-.21a.288.288 0 00-.112.147c-.067.189-.023.476-.023.476V157.052c-.002.037.009.058.023.085.002 0 .002.002.002.002z"
});

var _ref244 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M203.949 157.089c-.079-.085-.233-.066-.353.042-.119.11-.148.268-.075.357.075.09.233.069.349-.039.121-.108.154-.272.079-.36z"
});

var _ref245 =
/*#__PURE__*/
React.createElement("path", {
  d: "M203.949 156.998a.197.197 0 01.054.046h.002a.243.243 0 01.056.182.426.426 0 01-.141.277c-.15.139-.356.148-.455.033-.092-.114-.067-.32.083-.457.129-.121.293-.142.401-.081zm.054.046l-.054-.061v-.002l.054.063zm-.054.153l-.054-.058c-.023-.027-.058-.033-.098-.029a.274.274 0 00-.151.075.264.264 0 00-.092.174.117.117 0 00.023.084c.021.027.056.033.096.029a.276.276 0 00.149-.077.265.265 0 00.096-.177c.002-.031-.004-.06-.023-.079l.054.06v-.002zm0-.035s-.07-.087-.07-.073c0 .067.07.073.07.073z"
});

var _ref246 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M198.19 152.008v.412h-1.663v-.412h.616v-.935h-.406v-.418h.406v-.408h.401v.408h.401v.418h-.401v.935z"
});

var _ref247 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.261 152.493h-1.807v-.557h.618v-.79h-.41v-.562h.41v-.409h.545v.409h.399v.562h-.399v.79h.644v.557zm-.143-.414H197.473v-1.077h.399v-.274h-.399v-.408h-.258v.408h-.405v.274h.405v1.077h-.617v.27h1.52v-.27z"
});

var _ref248 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M197.377 160.964a.052.052 0 01-.052.053.053.053 0 01-.052-.053v-.906c0-.028.024-.052.052-.052.029 0 .052.024.052.052v.906zm-.226 0a.053.053 0 01-.053.053.053.053 0 01-.052-.053v-.906c0-.028.024-.052.052-.052.029 0 .053.024.053.052v.906z"
});

var _ref249 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196.906 160.964h-.036v-.906h.036v.906zm-.212 0h-.036v-.906h.036v.906zm-.187 0h-.036v-.906h.036v.906zm-.36-.047h-.035l-.005-.826h.036l.004.826zm.17.01h-.035v-.863h.035v.863zM195.835 160.879h-.075v-.761h.075v.761zm.166.021h-.072l-.004-.809h.07l.006.809zm-.613-.063h-.073v-.671h.073v.671zm.148.011h-.075v-.701h.075v.701zm.149.019h-.073v-.726h.073v.726zM195.251 160.829h-.108v-.644h.108v.644zm-.146.015h-.11v-.707h.11v.707zm-.156-.021h-.108v-.659h.108v.659zm-.32-.058h-.108l-.004-.555.108-.002.004.557zm.164.035h-.108v-.615h.108v.615zM194.484 160.752h-.144v-.503h.144v.503zm-.148.006h-.148v-.482h.148v.482zm-.164-.093h-.146v-.362h.146v.362zm-.169.002h-.145v-.328h.145v.328zm-.178-.042h-.144v-.245h.144v.245z"
});

var _ref250 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M198.276 160.917a.052.052 0 01-.052.052.052.052 0 01-.052-.052v-.832c0-.028.023-.052.052-.052.029 0 .052.024.052.052v.832zm-.381.027a.052.052 0 01-.052.052.052.052 0 01-.051-.052l.004-.88c0-.029.024-.052.052-.052.028 0 .051.024.051.052l-.004.88zm-.28.01a.052.052 0 01-.105 0v-.896c0-.028.024-.052.053-.052.028 0 .052.024.052.052v.896z"
});

var _ref251 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M189.985 165.426h14.623v-4.177h-14.623z"
});

var _ref252 =
/*#__PURE__*/
React.createElement("path", {
  d: "M189.852 161.116h14.889v4.445h-14.889v-4.445zm.268 4.177h14.353v-3.911H190.12v3.911z"
});

var _ref253 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M203.074 168.207a.592.592 0 00-.27-.045h-10.952a.808.808 0 00-.302.058.996.996 0 00.645-.944 1.04 1.04 0 00-.674-.958c.094.031.216.06.324.06h10.959a.89.89 0 00.305-.04l-.062.011c-.391.131-.616.509-.616.927 0 .401.25.803.643.931z"
});

var _ref254 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M202.964 168.308l-.039-.008-.121-.005h-10.952a.668.668 0 00-.257.049.133.133 0 01-.168-.074.133.133 0 01.073-.173l.036-.014a.84.84 0 00.373-.304.892.892 0 00.153-.503.871.871 0 00-.162-.502.929.929 0 00-.418-.329l-.007-.003a.133.133 0 01-.079-.17.133.133 0 01.166-.08c.048.015.103.03.155.04a.794.794 0 00.129.013h10.958c.148-.007.156-.016.283-.038a.133.133 0 01.066.256l-.115.031a.723.723 0 00-.327.273.913.913 0 00.012 1.013c.082.12.195.219.329.277l.07.027a.133.133 0 01-.089.25l-.069-.026zm-10.913-.279h10.529l-.076-.098a1.165 1.165 0 01-.206-.655c0-.239.067-.469.191-.656l.084-.109h-10.544l.088.11a1.144 1.144 0 01.011 1.308l-.077.1z"
});

var _ref255 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M191.852 168.162h10.952c.367 0 .667.251.667.559 0 .308-.3.561-.667.561h-10.952c-.37 0-.672-.253-.672-.561 0-.308.302-.559.672-.559z"
});

var _ref256 =
/*#__PURE__*/
React.createElement("path", {
  d: "M191.852 168.026h10.952c.447 0 .802.321.802.695 0 .374-.355.694-.802.694h-10.952c-.449 0-.805-.32-.805-.694 0-.374.356-.695.805-.695zm0 .269c-.291 0-.537.185-.537.426s.246.426.537.426h10.952c.287 0 .534-.185.534-.426s-.247-.426-.534-.426h-10.952z"
});

var _ref257 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DEAD00",
  fillRule: "nonzero",
  d: "M191.845 165.426h10.959c.368 0 .667.214.667.472 0 .264-.299.48-.667.48h-10.961c-.37 0-.669-.216-.669-.48 0-.258.299-.472.669-.472h.002z"
});

var _ref258 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M191.843 165.426h10.958c.369 0 .668.214.668.472 0 .264-.299.48-.668.48h-10.96c-.37 0-.669-.216-.669-.48 0-.258.299-.472.669-.472h.002z"
});

var _ref259 =
/*#__PURE__*/
React.createElement("path", {
  d: "M191.845 165.293h10.959c.257 0 .486.093.63.231a.52.52 0 01.172.374.524.524 0 01-.172.38.915.915 0 01-.63.233h-10.961a.92.92 0 01-.634-.233.53.53 0 01-.17-.38.52.52 0 01.17-.374.925.925 0 01.636-.231zm0 .268a.665.665 0 00-.451.156c-.052.054-.087.112-.087.181 0 .07.035.133.087.187a.654.654 0 00.449.158h10.961c.18 0 .345-.06.445-.158a.275.275 0 00.089-.187.257.257 0 00-.089-.181.652.652 0 00-.445-.156h-10.959z"
});

var _ref260 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DEAD00",
  fillRule: "nonzero",
  d: "M203.072 228.653c-.036.146-.084.287-.084.443 0 1.046.828 1.877 1.841 1.877h-15.046c1.01 0 1.838-.831 1.838-1.877a2.1 2.1 0 00-.058-.443.78.78 0 00.286.04h10.948c.09 0 .194-.013.269-.04h.006z"
});

var _ref261 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M203.072 228.653c-.036.146-.084.287-.084.443 0 1.046.828 1.877 1.841 1.877h-15.046c1.01 0 1.838-.831 1.838-1.877a2.1 2.1 0 00-.058-.443.78.78 0 00.286.04h10.948c.09 0 .194-.013.269-.04h.006z"
});

var _ref262 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M203.2 228.689l-.026.098a1.265 1.265 0 00-.052.309c0 .485.191.921.498 1.235.31.315.738.51 1.209.51a.133.133 0 110 .266h-15.046a.133.133 0 110-.266c.47 0 .897-.195 1.207-.51a1.76 1.76 0 00.498-1.235c0-.07-.006-.138-.016-.205l-.039-.21a.132.132 0 01.102-.157.134.134 0 01.077.006.473.473 0 00.103.024l.135.006h10.947c.099-.008.196-.035.275-.039.073 0 .133.059.133.133l-.005.035zm-.345.407c0-.098.016-.188.037-.275l-.095.005H191.85l-.119-.005.004.031c.012.08.019.161.019.244a2.023 2.023 0 01-.99 1.745h13.082a2.023 2.023 0 01-.991-1.745z"
});

var _ref263 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M191.852 227.568h10.952c.367 0 .667.252.667.559 0 .308-.3.561-.667.561h-10.952c-.37 0-.672-.253-.672-.561 0-.307.302-.559.672-.559z"
});

var _ref264 =
/*#__PURE__*/
React.createElement("path", {
  d: "M191.852 227.435h10.952c.447 0 .802.322.802.696 0 .375-.355.695-.802.695h-10.952c-.449 0-.805-.32-.805-.695 0-.374.356-.696.805-.696zm0 .268s-.133-.166-.133-.135c0 .123.133.135.133.135-.291 0-.537.187-.537.428s.246.427.537.427h10.952c.287 0 .534-.186.534-.427s-.247-.428-.534-.428h-10.952z"
});

var _ref265 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M189.802 235.146h15.008v-4.173h-15.008z"
});

var _ref266 =
/*#__PURE__*/
React.createElement("path", {
  d: "M189.667 230.84h15.276v4.439h-15.276v-4.439zm.268 4.173h14.742v-3.907h-14.742v3.907z"
});

var _ref267 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M205.982 212.803c1.485.934 2.495 1.892 2.333 2.368-.083.439-.555.767-1.229 1.256-1.06.804-1.707 2.241-1.201 2.904a4.264 4.264 0 01-1.431-3.206c0-1.341.584-2.55 1.528-3.322z"
});

var _ref268 =
/*#__PURE__*/
React.createElement("path", {
  d: "M206.053 212.691c1.062.665 1.879 1.347 2.223 1.863.17.253.222.48.17.65-.04.196-.146.373-.306.549-.222.241-.561.483-.975.78-.609.465-1.079 1.148-1.251 1.759-.106.374-.102.721.077.96l-.196.179a4.395 4.395 0 01-1.474-3.306c0-1.384.601-2.629 1.576-3.426l.075-.062.081.054zm-.06.277c-.871.75-1.406 1.893-1.406 3.157a4.15 4.15 0 00.992 2.707 1.789 1.789 0 01.077-.613c.185-.659.69-1.397 1.351-1.9h.003c.33-.241.613-.443.82-.634.19-.177.316-.344.354-.539v-.008l.004-.009c.023-.068.006-.151-.035-.243a1.685 1.685 0 00-.264-.399c-.379-.447-1.056-.983-1.896-1.519z"
});

var _ref269 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "nonzero",
  d: "M191.993 226.894h10.665v-56.949h-10.665z"
});

var _ref270 =
/*#__PURE__*/
React.createElement("path", {
  d: "M191.86 169.81h10.933v57.217H191.86V169.81zm9.204.269v56.67h-.269v-56.67h-.931v56.67h-.268v-56.67h-7.468v56.68h10.397v-56.68h-1.461z"
});

var _ref271 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M181.104 191.246c2.328-1.049 6.282-1.825 10.823-1.987 1.563.01 3.305.172 5.109.499 6.377 1.16 11.235 3.936 10.848 6.197-.008.046-.02.146-.033.187 0 0 2.395-5.873 2.429-6.093.428-2.511-4.961-5.592-12.037-6.881a33.804 33.804 0 00-6.273-.541c-4.53 0-8.468.632-10.837 1.593l-.029 7.026z"
});

var _ref272 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M181.237 191.043c1.175-.504 2.725-.942 4.531-1.273 1.829-.336 3.922-.564 6.154-.644h.009c.794.005 1.637.05 2.51.135.848.083 1.727.205 2.619.367 3.203.582 6.028 1.572 8.002 2.7 1.689.965 2.766 2.041 2.949 3.065.635-1.572 2.121-5.256 2.137-5.363.204-1.198-1.011-2.549-3.139-3.765-2.167-1.239-5.268-2.326-8.79-2.967a33.899 33.899 0 00-6.248-.538c-2.212 0-4.282.151-6.094.417-1.844.271-3.421.662-4.612 1.133l-.028 6.733zm4.578-1.013c-1.881.346-3.48.807-4.657 1.337a.133.133 0 01-.187-.121l.029-7.02a.132.132 0 01.083-.129c1.219-.494 2.848-.902 4.756-1.183 1.825-.268 3.908-.42 6.131-.42a33.904 33.904 0 016.296.544c3.553.646 6.686 1.745 8.875 2.996 2.228 1.274 3.494 2.721 3.269 4.037-.057.333-2.429 6.105-2.435 6.121a.133.133 0 01-.251-.086l.03-.174c.183-1.069-.91-2.28-2.823-3.373-1.951-1.115-4.745-2.094-7.918-2.671a32.216 32.216 0 00-2.597-.363 27.582 27.582 0 00-2.486-.134c-2.22.08-4.3.306-6.115.639z"
});

var _ref273 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M202.679 198.394c2.958-.231 4.977-1.091 5.205-2.439.183-1.075-.819-2.264-2.6-3.341-.801.092-1.699.212-2.626.212l.021 5.568z"
});

var _ref274 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.679 198.394l-.135.002-.019-5.705h.133c.923 0 1.817-.118 2.609-.21l.046-.008.04.025c1.093.661 1.895 1.364 2.324 2.056.299.482.418.965.339 1.424-.098.572-.493 1.069-1.142 1.464-.927.571-2.384.946-4.185 1.087l-.01-.135zm.133-.144c1.682-.145 3.046-.497 3.921-1.035.574-.351.931-.779 1.018-1.283.069-.401-.041-.814-.303-1.237-.405-.656-1.166-1.316-2.195-1.943-.755.087-1.593.197-2.46.208l.019 5.29z"
});

var _ref275 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M191.978 194.04c-1.852.308-3.236.807-3.929 1.423l-.062.122c-.333.738 1.295 2.304 4.004 4.054l-.013-5.599z"
});

var _ref276 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187.987 195.72l-.117-.195.057-.123.122.194-.089-.235c.707-.626 2.114-1.142 3.996-1.449l.155-.027.015 6.002-.206-.136c-1.919-1.236-3.299-2.39-3.839-3.222-.262-.403-.329-.746-.215-.998l.121.189zm.168-.174l-.045.093v.002c-.054.119-.036.262.031.431.079.197.228.422.434.667.622.74 1.771 1.663 3.283 2.653l-.013-5.191c-1.723.297-3.02.765-3.69 1.345z"
});

var _ref277 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M209.3 209.381c.281-.921-2.602-2.761-6.677-4.391-1.863-.727-3.402-1.484-5.308-2.401-5.661-2.727-9.841-5.858-9.326-7l.056-.118c-.299.266-.765 5.892-.765 5.892-.518 1.045 3.31 4.131 8.515 6.854 1.67.869 5.196 2.287 6.859 2.921 2.973 1.127 5.929 3.247 5.661 4.033l.985-5.788v-.002z"
});

var _ref278 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M209.175 209.337c.111-.391-.499-1.016-1.607-1.744-1.188-.782-2.939-1.657-4.995-2.479-1.702-.665-3.132-1.354-4.815-2.164l-.5-.241c-2.841-1.369-5.313-2.841-7.007-4.112-1.177-.884-1.984-1.684-2.294-2.306-.247 1.557-.545 5.071-.545 5.084l-.013.046c-.227.46.586 1.437 2.079 2.639 1.537 1.237 3.787 2.684 6.379 4.039.694.361 1.711.819 2.78 1.274 1.492.635 3.094 1.271 4.064 1.641l.006.002c1.489.565 2.976 1.378 4.058 2.15.71.505 1.249 1.003 1.515 1.417l.895-5.246zm-1.461-1.966c1.206.793 1.858 1.516 1.717 2.034l-.969 5.696a.39.39 0 01-.022.113.132.132 0 01-.168.083.134.134 0 01-.089-.148l.018-.105c-.004-.355-.636-.982-1.59-1.662-1.066-.76-2.531-1.561-3.999-2.118l-.005-.001a124.8 124.8 0 01-4.074-1.646c-1.076-.458-2.1-.919-2.799-1.282-2.609-1.365-4.874-2.822-6.422-4.068-1.574-1.267-2.418-2.347-2.162-2.939.027-.331.362-4.343.669-5.597a.565.565 0 01.049-.196l.057-.121.03-.041a.136.136 0 01.147-.022.133.133 0 01.063.177l-.056.118c-.225.506.671 1.515 2.3 2.738 1.682 1.262 4.138 2.725 6.964 4.086l.5.241c1.678.808 3.103 1.494 4.795 2.155l.004.002c2.071.827 3.838 1.712 5.042 2.503z"
});

var _ref279 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M187.748 188.752c.403-1.67.925-3.283 1.437-4.917-.113.033-.236.06-.348.081a3.92 3.92 0 01-.357.035c-.244 1.173-.572 2.35-.927 3.53-.63-1.031-1.316-2.031-1.863-3.072-.219.048-.445.106-.67.141-.218.036-.451.052-.677.077.949 1.391 1.87 2.784 2.756 4.226.104-.029.206-.068.322-.087.107-.012.219-.01.327-.014zm4.056-4.884c-.196.013-.389.027-.584.023-.196-.002-.389-.027-.58-.041l-.079 4.584 2.944.056c-.017-.096-.04-.198-.036-.293 0-.096.025-.194.042-.287-.528.039-1.102.075-1.776.06l.069-4.102zm4.617.755c.47.044.925.133 1.377.222-.009-.095-.021-.193-.015-.293.006-.093.039-.187.065-.28l-3.984-.358c.011.096.025.189.017.283-.009.102-.04.193-.065.287.406-.009.898-.015 1.445.035l-.347 4.127c.195.006.391.004.58.02.195.017.389.054.58.086l.345-4.129h.002zm1.63 4.521c.193.034.387.057.576.105.189.041.372.108.559.168l.472-2.11.052.014c.11.289.252.641.327.845l.59 1.592c.231.04.462.073.69.127.233.056.456.131.68.199l-.206-.48c-.316-.717-.648-1.432-.927-2.16.734.036 1.301-.256 1.447-.898.1-.447-.063-.796-.451-1.096-.283-.222-.836-.339-1.194-.426l-1.607-.38-1.008 4.5zm2.062-3.879c.462.112 1.04.194 1.04.767a1.392 1.392 0 01-.038.337c-.149.676-.617.909-1.397.655l.395-1.759zm5.524 5.254c-.037.497-.116.979-.205 1.503.201.104.401.197.594.314.195.116.372.247.561.372l.395-5.17a2.282 2.282 0 01-.515-.304l-4.179 2.894c.108.06.225.112.33.175.109.066.2.137.308.203.352-.322.722-.582 1.146-.925l1.565.936v.002zm-1.185-1.183l1.393-.981-.162 1.713-1.231-.732z"
});

var _ref280 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.685 187.354l-.472 2.109-.037-.013c-.185-.058-.368-.124-.557-.166-.189-.048-.381-.071-.574-.104l.006-.036-.035-.01 1.016-4.536 1.643.393c.361.087.919.206 1.208.43.399.308.567.672.461 1.133-.141.643-.698.946-1.426.927.273.71.596 1.41.906 2.111l.235.546-.072-.02c-.225-.067-.445-.144-.678-.198-.227-.054-.457-.087-.688-.127l-.021-.002-.597-1.611c-.073-.2-.21-.541-.318-.826zm-1.59 1.761c.181.029.361.054.542.098.175.04.35.102.522.156l.456-2.035.043.01s-.035-.081.009-.073l.05.015c.026.004.02.029.008.046l.018-.025c.111.289.254.644.329.848l.582 1.572c.224.037.449.071.669.125.208.047.41.112.609.174l-.174-.405c-.316-.72-.651-1.435-.927-2.164l-.019-.055.054.005c.715.033 1.27-.244 1.41-.869.097-.433-.063-.772-.437-1.061-.283-.218-.828-.33-1.181-.417l-1.571-.375-.992 4.43zm2.018-3.85l.007-.035c.235.058.499.106.702.214.217.112.366.285.366.588-.002.15-.014.254-.037.348-.077.349-.239.582-.481.698-.241.112-.561.11-.962-.021l-.031-.008.401-1.79.035.006zm.028.046c-.057.245-.381 1.688-.381 1.688.366.114.659.119.88.015.222-.109.37-.327.442-.651.021-.091.033-.187.036-.331 0-.27-.138-.426-.329-.526-.189-.097-.43-.145-.648-.195zm5.459 5.224c-.25-.147-1.526-.91-1.526-.91-.414.335-.777.592-1.123.908l-.021.019-.021-.014c-.109-.067-.199-.138-.309-.204-.106-.062-.22-.115-.328-.173l-.055-.029 4.254-2.944.018.017a2.208 2.208 0 00.506.299l.025.013-.402 5.255-.051-.033c-.186-.127-.366-.256-.558-.374-.195-.115-.393-.208-.594-.312l-.023-.012.004-.025c.087-.516.166-.992.204-1.481zm.004-.018l.029.033-.027-.017.031.021-.004-.004v.002c-.006-.008-.023-.033-.029-.035zm.033.035s.008-.089.029-.056l-.004.019c.004-.009.013-.011.013.004l-.002.002h.002c-.036.491-.117.967-.202 1.48.191.1.385.191.574.304.174.108.339.222.509.34l.389-5.083a2.208 2.208 0 01-.478-.282l-4.11 2.844c.093.048.191.095.282.149.1.061.185.127.283.19.345-.314.709-.574 1.127-.911l.017-.016 1.494.891.077.125zm.25-2.272l-.175 1.848-1.326-.79 1.501-1.058zm-1.368 1.054l1.133.673.147-1.578-1.28.905zm-16.771-.582l.002.035c-.108.004-.216.002-.322.015-.115.018-.216.058-.321.087l-.027.006-.012-.023a97.781 97.781 0 00-2.757-4.224l-.033-.052.06-.004c.225-.025.458-.042.678-.077.222-.036.447-.094.665-.144l.029-.006.011.025c.534 1.019 1.202 1.998 1.821 3.002.343-1.149.665-2.301.902-3.449l.007-.027h.026c.117-.006.24-.019.352-.035a3.61 3.61 0 00.347-.079l.064-.019-.02.064c-.512 1.632-1.034 3.244-1.437 4.911l-.035-.006zm-.029-.036c.399-1.638.908-3.224 1.411-4.827a3.898 3.898 0 01-.289.062c-.106.015-.222.03-.332.034-.241 1.166-.57 2.337-.923 3.505l-.023.077-.042-.069c-.626-1.021-1.305-2.014-1.85-3.048-.212.046-.428.102-.645.136-.201.033-.413.05-.619.07a100.006 100.006 0 012.707 4.156c.098-.029.195-.062.303-.081.098-.012.2-.012.302-.015zm4.085-4.848l.035.002-.069 4.065c.658.012 1.221-.023 1.739-.063l.043-.002-.006.046c-.015.089-.041.187-.041.281-.003.095.018.195.035.286l.006.042-3.023-.056.081-4.659.038.004c.193.015.384.04.578.042.193.002.388-.01.582-.023l.002.035zm-.035.042c-.186.008-.366.021-.549.018-.181-.002-.364-.025-.545-.039l-.079 4.509 2.863.054c-.013-.085-.029-.17-.027-.255 0-.081.02-.167.033-.248-.513.038-1.075.071-1.734.056h-.035l.073-4.095zm4.684.752l-.346 4.129-.041-.004c-.189-.031-.381-.068-.574-.085-.189-.017-.385-.015-.578-.019l-.038-.002.346-4.129a11.906 11.906 0 00-1.404-.031h-.047l.01-.043c.025-.094.056-.183.062-.283.008-.094-.004-.183-.016-.277l-.005-.046 4.071.37-.01.04c-.025.089-.058.181-.065.275-.006.095.007.191.015.286l.006.046-.048-.008a13.28 13.28 0 00-1.338-.219zm-.032-.037l.004-.037c.456.041.894.127 1.333.212-.008-.081-.017-.167-.01-.25.006-.083.031-.164.054-.245l-3.896-.352c.008.084.016.165.01.248-.006.087-.031.166-.054.247a11.5 11.5 0 011.401.036l.036.004-.345 4.124c.183.004.363.003.544.017.183.017.362.05.543.081l.343-4.089.037.004z"
});

var _ref281 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#005BBF",
  fillRule: "nonzero",
  d: "M187.087 235.728c1.014 0 1.914-.231 2.58-.618.657-.366 1.551-.588 2.534-.588.988 0 1.904.225 2.563.593.659.38 1.576.613 2.574.613 1.008 0 1.913-.256 2.578-.645.655-.349 1.528-.561 2.49-.561.99 0 1.869.206 2.529.578.663.383 1.586.628 2.594.628v1.727c-1.008 0-1.931-.251-2.594-.632-.66-.374-1.539-.582-2.529-.582-.962 0-1.835.217-2.49.568-.661.384-1.57.646-2.578.646-.996 0-1.913-.241-2.574-.615-.659-.372-1.574-.599-2.563-.599-.983 0-1.877.227-2.534.595-.666.387-1.553.619-2.564.619l-.016-1.727z"
});

var _ref282 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0045AF",
  fillRule: "nonzero",
  d: "M187.087 235.728c1.014 0 1.914-.231 2.58-.618.657-.366 1.551-.588 2.534-.588.988 0 1.904.225 2.563.593.659.38 1.576.613 2.574.613 1.008 0 1.913-.256 2.578-.645.655-.349 1.528-.561 2.49-.561.99 0 1.869.206 2.529.578.663.383 1.586.628 2.594.628v1.727c-1.008 0-1.931-.251-2.594-.632-.66-.374-1.539-.582-2.529-.582-.962 0-1.835.217-2.49.568-.661.384-1.57.646-2.578.646-.996 0-1.913-.241-2.574-.615-.659-.372-1.574-.599-2.563-.599-.983 0-1.877.227-2.534.595-.666.387-1.553.619-2.564.619l-.016-1.727z"
});

var _ref283 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187.087 235.595c.987 0 1.862-.225 2.513-.601.678-.376 1.591-.605 2.601-.605 1.013 0 1.952.233 2.63.611.642.368 1.534.595 2.507.595.981 0 1.865-.25 2.513-.626l.003-.002c.669-.36 1.565-.578 2.552-.578 1.017 0 1.917.212 2.595.595h.004c.643.376 1.543.611 2.524.611h.133v1.993h-.133c-1.035 0-1.979-.259-2.657-.65-.646-.36-1.501-.564-2.466-.564-.939 0-1.787.208-2.426.553-.677.391-1.607.661-2.642.661-1.023 0-1.96-.247-2.64-.631-.643-.362-1.534-.583-2.497-.583-.959 0-1.827.221-2.472.576-.68.397-1.588.638-2.626.638h-.133l-.018-1.993h.135zm.135.266l.014 1.457c.928-.019 1.745-.241 2.364-.601.678-.376 1.591-.611 2.601-.611 1.014 0 1.954.235 2.63.618.644.366 1.538.594 2.507.594.981 0 1.867-.251 2.513-.623v-.003c.672-.361 1.568-.586 2.555-.586 1.017 0 1.917.219 2.595.599h.004c.614.355 1.459.592 2.389.613v-1.457c-.979-.021-1.875-.266-2.522-.645-.646-.361-1.501-.559-2.466-.559-.939 0-1.787.204-2.423.545-.68.395-1.61.661-2.645.661-1.025 0-1.963-.241-2.64-.63-.643-.36-1.537-.576-2.497-.576-.959 0-1.827.214-2.472.57-.651.378-1.522.613-2.507.634z"
});

var _ref284 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "nonzero",
  d: "M187.087 237.455c1.014 0 1.914-.23 2.58-.617.657-.366 1.551-.588 2.534-.588.988 0 1.904.224 2.563.592.659.381 1.576.613 2.574.613 1.008 0 1.913-.255 2.578-.644.655-.349 1.528-.561 2.49-.561.99 0 1.869.205 2.529.578.663.382 1.586.627 2.594.627v1.728c-1.008 0-1.931-.252-2.594-.632-.66-.374-1.539-.582-2.529-.582-.962 0-1.835.216-2.49.567-.661.385-1.57.647-2.578.647-.996 0-1.913-.241-2.574-.615-.659-.373-1.574-.599-2.563-.599-.983 0-1.877.226-2.534.595-.666.386-1.553.619-2.564.619l-.016-1.728z"
});

var _ref285 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187.087 237.455v-.137c.987 0 1.862-.222 2.513-.601.678-.376 1.591-.611 2.601-.611 1.013 0 1.954.235 2.63.618.642.366 1.532.594 2.507.594.981 0 1.865-.251 2.513-.623v-.003c.672-.361 1.568-.586 2.555-.586 1.017 0 1.917.219 2.595.599h.004c.643.372 1.543.613 2.524.613h.133v1.992h-.133c-1.035 0-1.979-.254-2.657-.645-.646-.366-1.501-.565-2.466-.565-.939 0-1.787.208-2.426.549-.677.395-1.607.661-2.642.661-1.023 0-1.96-.246-2.64-.632-.643-.362-1.534-.578-2.497-.578-.959 0-1.827.216-2.472.576-.68.393-1.588.634-2.626.634h-.133l-.017-1.855h.134zm.135.133l.014 1.452c.928-.017 1.745-.239 2.364-.597v-.002c.678-.376 1.591-.609 2.601-.609 1.014 0 1.952.233 2.63.613.644.366 1.538.597 2.507.597.981 0 1.867-.25 2.513-.626.672-.364 1.568-.584 2.555-.584 1.017 0 1.917.214 2.595.6h.004c.614.354 1.459.587 2.389.608v-1.452c-.979-.022-1.875-.276-2.522-.65-.646-.36-1.501-.564-2.466-.564-.939 0-1.787.208-2.426.553-.681.391-1.607.661-2.642.661-1.025 0-1.963-.247-2.64-.631-.643-.362-1.537-.583-2.497-.583-.959 0-1.827.221-2.472.576-.651.381-1.522.618-2.507.638z"
});

var _ref286 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0045AF",
  fillRule: "nonzero",
  d: "M187.087 239.175c1.014 0 1.914-.231 2.58-.618.657-.366 1.551-.588 2.534-.588.988 0 1.904.225 2.563.592.659.381 1.576.614 2.574.614 1.008 0 1.913-.256 2.578-.645.655-.349 1.528-.561 2.49-.561.99 0 1.869.206 2.529.578.663.382 1.586.628 2.594.628v1.727c-1.008 0-1.931-.251-2.594-.632-.66-.374-1.539-.582-2.529-.582-.962 0-1.835.217-2.49.568-.661.384-1.57.646-2.578.646-.996 0-1.913-.241-2.574-.615-.659-.372-1.574-.599-2.563-.599-.983 0-1.877.227-2.534.595-.666.387-1.553.619-2.564.619l-.016-1.727z"
});

var _ref287 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187.087 239.175v-.133c.987 0 1.864-.227 2.513-.599v-.002c.678-.376 1.591-.609 2.601-.609 1.013 0 1.952.233 2.63.613.642.366 1.532.597 2.507.597.981 0 1.865-.25 2.513-.626.672-.364 1.568-.584 2.555-.584 1.017 0 1.917.214 2.599.6.643.371 1.543.61 2.524.61h.133v1.989h-.133c-1.035 0-1.979-.253-2.657-.646-.646-.36-1.501-.562-2.466-.562-.939 0-1.787.208-2.423.547-.678.397-1.61.661-2.645.661-1.023 0-1.96-.241-2.64-.628-.643-.361-1.534-.58-2.497-.58-.959 0-1.827.216-2.472.574-.68.399-1.588.634-2.626.634h-.133l-.017-1.854.134-.002zm.135.133l.014 1.455c.928-.021 1.745-.237 2.364-.599.678-.378 1.591-.607 2.601-.607 1.014 0 1.952.233 2.63.614.644.365 1.538.592 2.507.592.981 0 1.867-.247 2.513-.626h.003c.669-.359 1.565-.58 2.552-.58 1.017 0 1.917.215 2.595.595h.004c.614.355 1.459.59 2.389.611v-1.455c-.979-.019-1.875-.268-2.522-.643-.646-.366-1.501-.565-2.466-.565-.939 0-1.787.208-2.426.551-.681.393-1.607.659-2.642.659-1.025 0-1.963-.246-2.64-.632-.643-.362-1.537-.578-2.497-.578-.959 0-1.827.216-2.472.576-.651.374-1.522.613-2.507.632z"
});

var _ref288 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "nonzero",
  d: "M187.103 242.624c1.011 0 1.899-.237 2.564-.622.657-.366 1.551-.59 2.534-.59.988 0 1.904.224 2.563.596.659.374 1.576.616 2.574.616 1.008 0 1.913-.26 2.578-.647.655-.349 1.528-.565 2.49-.565.99 0 1.869.212 2.529.58.663.384 1.586.632 2.594.632v-1.715c-1.008 0-1.931-.258-2.594-.641-.66-.37-1.539-.578-2.529-.578-.962 0-1.835.215-2.49.566-.661.384-1.57.642-2.578.642-.996 0-1.913-.235-2.574-.613-.659-.37-1.574-.595-2.563-.595-.983 0-1.877.223-2.534.591-.665.389-1.566.617-2.58.617l.016 1.726z"
});

var _ref289 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187.103 242.624h-.135l-.016-1.861h.135c.987 0 1.862-.22 2.513-.599.678-.378 1.591-.607 2.601-.607 1.014 0 1.952.233 2.63.614.644.365 1.538.592 2.507.592.981 0 1.867-.247 2.513-.626h.003c.669-.359 1.565-.58 2.552-.58 1.017 0 1.917.215 2.595.595h.004c.643.374 1.543.621 2.524.621h.133v1.984h-.133c-1.035 0-1.979-.256-2.657-.649-.646-.359-1.501-.561-2.466-.561-.939 0-1.787.206-2.423.547-.68.397-1.61.663-2.645.663-1.025 0-1.963-.248-2.64-.632-.643-.362-1.537-.578-2.497-.578-.959 0-1.827.216-2.472.572-.68.395-1.588.638-2.626.638v-.133zm.133-.137c.928-.019 1.745-.241 2.364-.601v-.003c.678-.374 1.591-.604 2.601-.604 1.013 0 1.952.233 2.63.613.642.366 1.532.595 2.507.595.981 0 1.865-.25 2.513-.626l.003-.002c.669-.358 1.565-.58 2.552-.58 1.017 0 1.917.218 2.595.596h.004c.614.358 1.46.591 2.389.612v-1.447c-.979-.021-1.875-.279-2.522-.655-.646-.36-1.501-.562-2.466-.562-.939 0-1.787.208-2.423.547-.678.397-1.61.661-2.645.661-1.023 0-1.96-.241-2.64-.628-.643-.361-1.534-.58-2.497-.58-.959 0-1.827.216-2.472.574-.651.381-1.522.613-2.507.634l.014 1.456z"
});

var _ref290 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#005BBF",
  fillRule: "nonzero",
  d: "M187.103 244.345c1.011 0 1.899-.237 2.564-.622.657-.365 1.551-.59 2.534-.59.988 0 1.904.225 2.563.597.659.374 1.576.615 2.574.615 1.008 0 1.913-.26 2.578-.647.655-.349 1.528-.565 2.49-.565.99 0 1.869.212 2.529.58.663.385 1.586.632 2.594.632v-1.715c-1.008 0-1.931-.258-2.594-.64-.66-.37-1.539-.578-2.529-.578-.962 0-1.835.214-2.49.565-.661.385-1.57.643-2.578.643-.996 0-1.913-.235-2.574-.614-.659-.37-1.574-.594-2.563-.594-.983 0-1.877.222-2.534.59-.665.389-1.566.618-2.58.618l.016 1.725z"
});

var _ref291 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0045AF",
  fillRule: "nonzero",
  d: "M187.103 244.345c1.011 0 1.899-.233 2.564-.615.657-.37 1.551-.597 2.534-.597.988 0 1.904.229 2.563.599.659.376 1.576.613 2.574.613 1.008 0 1.913-.262 2.578-.644.655-.354 1.528-.568 2.49-.568.99 0 1.869.21 2.529.582.663.383 1.586.63 2.594.63v-1.709c-1.008 0-1.931-.26-2.594-.644-.66-.368-1.539-.576-2.529-.576-.962 0-1.835.214-2.49.563-.661.385-1.57.645-2.578.645-.996 0-1.913-.242-2.574-.616-.659-.372-1.574-.592-2.563-.592-.983 0-1.877.22-2.534.588-.665.383-1.564.62-2.576.62l.012 1.721z"
});

var _ref292 =
/*#__PURE__*/
React.createElement("path", {
  d: "M186.956 242.487h.135c.985 0 1.86-.223 2.509-.597.678-.381 1.591-.609 2.601-.609 1.014 0 1.952.228 2.63.611.644.366 1.538.595 2.507.595.981 0 1.867-.25 2.513-.624h.003c.669-.36 1.565-.582 2.552-.582 1.017 0 1.917.216 2.595.594h.004c.643.374 1.543.628 2.524.628h.133v1.977h-.133c-1.035 0-1.979-.255-2.657-.646-.646-.364-1.501-.568-2.466-.568-.939 0-1.787.208-2.426.551-.681.393-1.607.663-2.642.663-1.025 0-1.963-.247-2.64-.632-.643-.362-1.537-.582-2.497-.582-.959 0-1.827.219-2.472.58-.68.393-1.588.634-2.626.634h-.133l-.014-1.993zm.28 1.723c.928-.017 1.745-.241 2.364-.597v-.002c.676-.378 1.591-.611 2.601-.611 1.013 0 1.952.235 2.63.615.642.366 1.532.597 2.507.597.981 0 1.865-.254 2.513-.628v-.002c.672-.362 1.568-.584 2.555-.584 1.017 0 1.917.218 2.595.603h.004c.614.355 1.459.59 2.389.609v-1.441c-.979-.023-1.875-.285-2.522-.661-.646-.359-1.501-.559-2.466-.559-.939 0-1.787.208-2.423.547-.678.395-1.61.661-2.645.661-1.023 0-1.96-.248-2.64-.632-.641-.362-1.534-.576-2.497-.576-.959 0-1.827.214-2.472.574-.651.376-1.52.611-2.503.629l.01 1.458z"
});

var _ref293 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M94.494 158.154s-.334 0-.517-.113c-.186-.118-.743-.692-.743-.692l-.445-.345-.405-.613s-.482-.836-.262-1.489c.223-.65.594-.881.929-1.073.333-.189 1.036-.419 1.036-.419s.559-.269.742-.308c.185-.04.854-.229.854-.229s.183-.114.368-.191c.187-.075.445-.075.597-.115.145-.041.518-.17.74-.182.343-.015.89.066 1.077.066.185 0 .815.04 1.073.04s1.185-.077 1.447-.077c.255 0 .444-.036.742 0 .295.037.813.228.964.307.146.075 1.038.42 1.37.535.335.112 1.152.266 1.524.457.368.193.595.516.778.784.189.268.222.559.295.752.071.192.075.603.004.794-.075.188-.337.583-.337.583l-.409.725-.52.46s-.37.384-.665.343c-.3-.034-3.302-.612-5.231-.612-1.929 0-5.008.612-5.008.612h.002z"
});

var _ref294 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M94.493 158.226c-.028-.001-.361-.005-.554-.123l-.004-.003c-.197-.128-.736-.683-.751-.699l-.439-.34-.421-.63c-.001-.002-.5-.869-.27-1.552.115-.337.271-.567.44-.736.168-.169.35-.278.522-.376.36-.204 1.009-.413 1.042-.424.05-.023.575-.273.756-.311.173-.037.763-.204.846-.227.06-.037.214-.128.364-.19l.004-.001c.122-.048.267-.067.396-.083h.007c.074-.009.144-.019.198-.033l.113-.034c.18-.056.457-.141.642-.151.219-.009.512.019.748.041.142.013.261.025.333.025l.459.018c.226.01.469.022.613.022.13 0 .422-.02.715-.038.301-.02.603-.04.733-.04l.238-.007c.156-.008.309-.016.513.008l.007.001a4.11 4.11 0 01.982.314 24.045 24.045 0 001.36.531l.005.002c.11.036.285.08.476.128.366.092.801.203 1.052.331.193.101.348.236.479.38.127.139.231.29.324.426.141.2.2.409.248.585l.058.189c.038.104.057.263.058.419.001.158-.017.317-.055.42l-.004.008c-.081.198-.34.589-.34.59-.138.206-.28.56-.423.739l-.516.456c-.001.001-.392.408-.724.364l-.434-.069c-.957-.161-3.227-.541-4.789-.541-1.861 0-4.785.568-4.983.607l-.024.004zm-.479-.246c.151.093.427.101.473.101.193-.037 3.14-.611 5.013-.611 1.572 0 3.851.383 4.813.544l.425.068c.26.037.606-.322.607-.323l.514-.454.406-.72c.001 0 .255-.383.329-.563.033-.09.048-.231.047-.373 0-.141-.017-.283-.049-.372a2.048 2.048 0 01-.061-.199c-.045-.164-.1-.36-.228-.54a3.541 3.541 0 00-.313-.413 1.59 1.59 0 00-.439-.348c-.233-.12-.66-.228-1.02-.319a8.346 8.346 0 01-.487-.132l-.006-.002a25.285 25.285 0 01-1.378-.539 4.019 4.019 0 00-.936-.3h-.005c-.192-.023-.339-.015-.488-.008l-.246.009c-.132 0-.429.019-.724.038-.298.019-.597.039-.724.039-.133 0-.387-.012-.619-.023l-.453-.017c-.069 0-.196-.012-.345-.026a6.188 6.188 0 00-.726-.041c-.169.009-.436.092-.61.145l-.118.036c-.06.015-.136.025-.217.036l-.007.001a1.647 1.647 0 00-.362.073 2.956 2.956 0 00-.383.197c-.001 0-.669.189-.853.228-.175.038-.724.301-.725.302l-.006.002c-.001 0-.734.249-1.026.416a2.176 2.176 0 00-.491.352 1.723 1.723 0 00-.406.681c-.21.622.253 1.424.254 1.426l.399.604.442.343c.001.001.554.57.729.682z"
});

var _ref295 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M98.621 153.464c0-.988.405-1.784.904-1.784s.905.796.905 1.784c0 .983-.406 1.783-.905 1.783s-.904-.8-.904-1.783z"
});

var _ref296 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.548 153.538v-.074c0-.61.152-1.148.383-1.483.166-.237.372-.374.594-.374.221 0 .429.137.595.374.23.335.382.873.382 1.483 0 .609-.152 1.145-.382 1.48-.166.239-.374.376-.595.376-.222 0-.428-.137-.594-.376-.223-.322-.37-.83-.383-1.406zm.144-.074v.008c.002.569.141 1.077.359 1.388.133.196.296.316.474.316.179 0 .341-.12.474-.316.221-.313.358-.823.358-1.396 0-.576-.14-1.084-.358-1.402-.133-.191-.295-.312-.474-.312-.178 0-.341.121-.474.312-.22.318-.359.826-.359 1.402z"
});

var _ref297 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M99.126 153.464c0-.909.189-1.645.416-1.645.23 0 .416.736.416 1.645 0 .904-.186 1.64-.416 1.64-.227 0-.416-.736-.416-1.64z"
});

var _ref298 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.056 153.464c0-.649.095-1.213.23-1.493a.518.518 0 01.131-.179.2.2 0 01.125-.046c.043 0 .085.015.125.046a.47.47 0 01.13.179c.138.28.233.844.233 1.493 0 .646-.095 1.207-.233 1.486a.463.463 0 01-.13.179.202.202 0 01-.125.046.204.204 0 01-.125-.046.572.572 0 01-.131-.179c-.135-.279-.23-.84-.23-1.486zm.143 0c0 .617.087 1.155.218 1.424a.4.4 0 00.075.116c.017.014.033.025.05.025.018 0 .033-.011.05-.025a.402.402 0 00.077-.116c.131-.269.216-.807.216-1.424 0-.622-.085-1.16-.216-1.429a.402.402 0 00-.077-.116c-.017-.015-.032-.029-.05-.029-.017 0-.033.014-.05.029a.375.375 0 00-.075.116c-.131.269-.218.807-.218 1.429z"
});

var _ref299 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M102.712 158.041h-6.326l-.073-.846-.15-.877-.158-1.096c-.867-1.249-1.667-2.07-1.935-1.896.065-.231.141-.403.31-.509.771-.501 2.366.701 3.565 2.674.106.18.21.361.302.54h2.605c.097-.183.199-.362.305-.54 1.196-1.973 2.792-3.175 3.561-2.674.167.106.244.278.31.509-.27-.172-1.069.647-1.942 1.896l-.155 1.096-.146.877-.073.846z"
});

var _ref300 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.32 158.112l-.079-.904-.148-.88-.156-1.079c-.597-.858-1.158-1.511-1.534-1.767a.642.642 0 00-.196-.097c-.039-.011-.072-.013-.095.001l-.16.107.05-.183c.068-.254.155-.437.336-.553.329-.212.796-.148 1.32.154.749.432 1.622 1.347 2.348 2.542.099.168.197.337.284.507h2.516c.094-.172.189-.341.289-.507.725-1.195 1.596-2.11 2.345-2.542.522-.302.99-.366 1.318-.154.179.116.268.299.339.55l.054.183-.162-.101c-.025-.017-.059-.015-.098-.004a.663.663 0 00-.195.099c-.377.256-.938.907-1.539 1.765l-.154 1.079-.147.88-.077.904H96.32zm3.218-.143h3.11l.066-.782.146-.879.158-1.115.01-.012c.618-.886 1.2-1.555 1.586-1.817a.702.702 0 01.283-.127c.008-.002.019-.002.027-.002-.054-.156-.122-.279-.245-.358-.289-.189-.703-.108-1.166.16-.734.422-1.585 1.319-2.296 2.491-.104.177-.205.356-.301.536l-.023.042h-2.692l-.019-.042a9.587 9.587 0 00-.299-.536c-.713-1.172-1.563-2.069-2.297-2.491-.464-.268-.876-.349-1.169-.16-.124.079-.191.2-.243.354.01.004.017.004.025.006.079.01.174.052.285.125.384.264.968.933 1.582 1.819l.012.012.156 1.115.15.879.069.782h3.085z"
});

var _ref301 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.249 153.355l-.079-.12c.195-.127.468-.106.79.052.69.343 1.617 1.328 2.411 2.642l-.122.077c-.668-1.104-1.428-1.975-2.057-2.412a1.715 1.715 0 00-.559-.276c-.149-.037-.28-.029-.384.037zm10.677-.12l-.076.12c-.107-.066-.236-.074-.389-.037a1.702 1.702 0 00-.558.276c-.63.437-1.386 1.308-2.056 2.412l-.122-.077c.796-1.314 1.721-2.299 2.409-2.642.322-.158.597-.179.792-.052z"
});

var _ref302 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M94.86 159.592c-.133-.409-.385-.775-.385-.775 1.281-.408 3.058-.665 5.036-.669 1.979.004 3.769.261 5.045.669l-.343.657c-.11.21-.254.578-.245.578-1.154-.387-2.638-.587-4.466-.588-1.827.001-3.582.249-4.499.613.015 0-.064-.231-.153-.485h.01z"
});

var _ref303 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95.041 160.141a.113.113 0 01-.038.009l-.027-.14c-.008.002-.014.008-.021.013-.006.006-.022.054-.022.054s-.063-.206-.136-.414h.053s-.011-.031-.017-.065l-.042.017a3.563 3.563 0 00-.372-.759l-.056-.079.094-.029c1.28-.409 3.068-.667 5.054-.673 1.987.006 3.786.264 5.066.673l.083.027-.039.075-.343.657-.002.002c-.079.142-.098.208-.239.57l-.027.062-.065-.021c-1.147-.384-2.626-.58-4.443-.582-1.808.002-3.546.242-4.461.603zm-.148-.559c-.004.012-.008.027-.014.04l.033-.046-.019.006zm.027-.008c.056.162.108.314.135.405.942-.351 2.661-.584 4.45-.586 1.8.002 3.27.195 4.422.567.124-.314.145-.384.226-.521.135-.26.245-.472.302-.579-1.267-.39-3.017-.636-4.944-.642-1.923.006-3.657.247-4.921.638.081.133.239.414.339.716l-.009.002z"
});

var _ref304 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M99.513 161.362c1.596-.003 3.353-.266 4.002-.449.432-.138.688-.352.64-.597-.021-.119-.117-.219-.243-.277-.95-.332-2.667-.567-4.399-.574-1.728.007-3.454.242-4.41.574-.123.058-.216.158-.237.277-.048.245.204.459.639.597.648.183 2.415.446 4.008.449z"
});

var _ref305 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.513 161.432c-1.603-.002-3.379-.268-4.029-.451-.279-.087-.487-.206-.597-.343a.386.386 0 01-.094-.335c.025-.139.136-.26.279-.328l.004-.002h.004c.961-.335 2.695-.576 4.433-.578 1.74.002 3.468.243 4.421.578h.007l.002.002a.478.478 0 01.283.328.393.393 0 01-.096.335c-.112.137-.316.256-.597.343v.002c-.65.181-2.417.447-4.02.449zm0-.143c1.586-.002 3.334-.265 3.981-.445.204-.065.366-.148.472-.241.089-.083.135-.175.118-.275-.018-.095-.097-.174-.199-.222-.95-.331-2.653-.563-4.372-.566-1.719.003-3.43.235-4.385.568-.098.046-.177.125-.193.22-.019.1.027.192.116.275.106.093.268.176.474.241.647.18 2.402.443 3.988.445z"
});

var _ref306 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M104.635 158.041l-.388-.384s-.373.249-.836.172c-.464-.075-.612-.686-.612-.686s-.521.472-.943.439c-.427-.042-.703-.439-.703-.439s-.465.36-.875.323c-.408-.04-.798-.593-.798-.593s-.406.574-.815.613c-.408.036-.741-.387-.741-.387s-.187.423-.704.518c-.52.096-.965-.44-.965-.44s-.293.517-.649.652c-.351.133-.813-.191-.813-.191s-.072.191-.13.306c-.057.114-.204.135-.204.135l.114.343c1.27-.401 2.996-.651 4.944-.653 1.95.002 3.719.252 4.989.655l.131-.383h-.002z"
});

var _ref307 =
/*#__PURE__*/
React.createElement("path", {
  d: "M104.646 158.091l-.009.021.069-.05-.152.453-.066-.022c-1.266-.404-3.029-.649-4.971-.651-1.938.002-3.655.247-4.921.648l-.066.021-.167-.492.088-.011s.108-.014.147-.096c.056-.114.129-.301.129-.301l.033-.087.075.054s.158.11.356.172a.59.59 0 00.393.011c.334-.125.609-.62.609-.62l.052-.091.066.081s.152.183.381.309c.145.082.324.14.513.107.48-.088.655-.474.655-.474l.048-.113.074.096s.113.141.283.249a.67.67 0 00.393.111c.15-.017.3-.111.427-.219.197-.168.338-.368.338-.368l.061-.081.056.081s.135.194.328.356c.123.102.268.195.418.21.385.031.821-.31.821-.31l.06-.046.046.06s.256.373.649.41c.158.013.329-.052.476-.131.233-.125.416-.291.416-.291l.087-.081.029.118s.052.206.185.387a.587.587 0 00.368.248c.437.07.784-.163.784-.163l.05-.033.43.427-.041.101zm-.09-.029l-.32-.314c-.12.067-.449.214-.836.154a.713.713 0 01-.461-.306 1.355 1.355 0 01-.175-.33 2.54 2.54 0 01-.359.239c-.173.091-.373.164-.553.148h-.003c-.353-.033-.611-.296-.711-.412-.143.095-.521.329-.867.297-.176-.018-.351-.122-.496-.243a1.957 1.957 0 01-.291-.306 2.513 2.513 0 01-.306.321c-.15.122-.328.232-.507.247a.763.763 0 01-.481-.131 1.434 1.434 0 01-.253-.204 1.058 1.058 0 01-.705.466.913.913 0 01-.611-.123 1.702 1.702 0 01-.356-.27c-.102.158-.349.495-.631.601a.734.734 0 01-.485-.009 1.446 1.446 0 01-.32-.143 3.888 3.888 0 01-.1.233.305.305 0 01-.177.147l.069.206c1.27-.388 2.973-.631 4.896-.634 1.925.003 3.676.246 4.946.636l.093-.27z"
});

var _ref308 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M99.521 156.189l.185.035a.816.816 0 00-.033.267c0 .417.326.754.73.754a.733.733 0 00.694-.522c.012.009.07-.272.1-.268.027 0 .023.293.029.289.05.376.366.636.725.636a.742.742 0 00.726-.844l.231-.251.12.32a.723.723 0 00-.068.324c0 .399.313.724.696.724.243 0 .46-.131.58-.325l.15-.201-.004.251c0 .248.099.472.322.512 0 0 .258.021.596-.275.346-.291.531-.534.531-.534l.02.299s-.334.599-.636.79c-.168.106-.424.219-.623.179-.215-.033-.364-.222-.443-.434a.94.94 0 01-.524.151.999.999 0 01-.931-.615.977.977 0 01-.766.357c-.328 0-.632-.159-.821-.411-.185.189-.44.306-.717.306-.364 0-.692-.2-.875-.493a1.04 1.04 0 01-.873.493c-.266 0-.524-.111-.72-.306a1.03 1.03 0 01-.823.414.974.974 0 01-.759-.36 1.004 1.004 0 01-.931.615.929.929 0 01-.522-.151c-.079.212-.231.401-.443.434-.201.04-.455-.073-.621-.179-.306-.191-.668-.79-.668-.79l.046-.299s.187.243.526.534c.345.296.601.275.601.275.224-.04.32-.264.32-.512v-.251l.145.201a.698.698 0 00.58.325.713.713 0 00.701-.724.71.71 0 00-.069-.324l.121-.32.229.251c-.004.027-.004.059-.004.09 0 .418.326.754.725.754.36 0 .678-.26.726-.636.01.004.008-.289.031-.289.031-.004.091.277.1.268a.738.738 0 00.696.522.742.742 0 00.732-.754.767.767 0 00-.035-.267l.191-.035h.004z"
});

var _ref309 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.733 156.703a2.601 2.601 0 01.027-.271.076.076 0 01.063-.048h.01c.025 0 .06.013.085.061.015.033.038.102.052.158l.033.101c.088.273.333.47.626.47a.671.671 0 00.661-.683.716.716 0 00-.031-.242l-.029-.079.272-.052.017-.002h.004l.013.002.266.052-.03.079a.8.8 0 00-.031.242c0 .378.298.683.662.683a.657.657 0 00.625-.47l.03-.095h.001c.015-.058.038-.129.054-.162a.12.12 0 01.048-.056c.013-.007.027-.009.04-.007h.004a.072.072 0 01.062.046.292.292 0 01.021.094c.004.062.006.166.008.197v.011a.656.656 0 00.657.575.667.667 0 00.655-.681c0-.027 0-.052-.004-.079l-.006-.036.335-.359.174.455-.014.029a.639.639 0 00-.061.293c0 .36.281.651.624.651a.62.62 0 00.52-.289v-.002l.283-.387-.004.476c0 .208.072.403.259.441.029 0 .252-.006.543-.258.335-.285.515-.524.515-.524l.119-.154.033.512-.008.021s-.351.617-.663.815c-.181.116-.458.23-.674.189-.212-.034-.372-.2-.465-.401a1.067 1.067 0 01-.489.122c-.403 0-.771-.224-.952-.561-.194.191-.45.301-.745.301a1.1 1.1 0 01-.827-.376 1.073 1.073 0 01-.711.268c-.353 0-.672-.174-.875-.437a1.11 1.11 0 01-.876.437 1.061 1.061 0 01-.708-.268 1.101 1.101 0 01-.83.376 1.04 1.04 0 01-.742-.301 1.08 1.08 0 01-.952.561c-.169 0-.335-.043-.484-.122-.096.201-.256.367-.466.401-.218.041-.493-.073-.674-.189-.316-.198-.69-.813-.69-.813l-.013-.023.077-.491.102.133s.181.239.518.524c.291.254.516.258.545.258.184-.038.255-.233.255-.441v-.474l.277.385a.616.616 0 00.518.291.637.637 0 00.627-.651.614.614 0 00-.06-.293l-.014-.029.176-.455.331.359-.007.036c-.004.027-.002.052-.002.079 0 .376.291.681.651.681a.652.652 0 00.655-.571l.004-.033zm3.424.068a.802.802 0 01-.754.547.817.817 0 01-.805-.827.98.98 0 01.019-.211l-.098-.018c-.029.004-.102.018-.102.018.013.069.017.138.017.211a.817.817 0 01-.805.827.812.812 0 01-.759-.553.794.794 0 01-.796.688c-.439 0-.794-.37-.794-.827v-.067l-.127-.139-.07.179a.83.83 0 01.062.33.78.78 0 01-.772.794.776.776 0 01-.64-.351l-.012-.021v.027c0 .285-.123.537-.381.582l-.004.002h-.002s-.283.028-.653-.291a4.402 4.402 0 01-.432-.424l-.019.117c.067.11.368.582.63.746.154.098.387.204.572.168.189-.031.318-.201.386-.391l.032-.083.076.048a.866.866 0 00.481.144c.382 0 .73-.233.865-.572l.045-.11.077.091c.175.208.42.333.707.333.31 0 .589-.15.763-.383l.052-.066.056.058a.942.942 0 00.667.281.97.97 0 00.816-.456l.06-.095.06.095a.975.975 0 00.815.456c.26 0 .495-.106.668-.281l.058-.058.05.064a.954.954 0 00.762.385.924.924 0 00.712-.333l.079-.091.043.11a.925.925 0 00.863.572.87.87 0 00.482-.144l.079-.048.032.083c.068.19.197.36.386.391.185.036.418-.07.57-.168.262-.164.546-.647.603-.749l-.007-.099a4.191 4.191 0 01-.42.409c-.367.319-.652.291-.652.291h-.002l-.004-.002c-.258-.045-.383-.297-.383-.582v-.027l-.011.019-.001.002a.761.761 0 01-.641.351.779.779 0 01-.767-.794c0-.118.017-.231.062-.33l-.07-.179-.129.139c.002.023.002.046.002.067 0 .457-.36.827-.801.827a.8.8 0 01-.796-.682zm-3.268-.102zm1.628-.409h.002-.002z"
});

var _ref310 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M99.513 158.149c-1.977.003-3.753.26-5.029.672-.088.029-.191-.042-.221-.127-.027-.087.036-.197.117-.229 1.287-.424 3.108-.694 5.133-.696 2.025.002 3.854.272 5.137.696.085.032.147.142.121.229-.028.085-.136.156-.221.127-1.277-.412-3.058-.669-5.037-.672z"
});

var _ref311 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.513 158.222c-1.969.002-3.74.258-5.008.666a.219.219 0 01-.157-.009.283.283 0 01-.153-.162c-.04-.123.044-.274.162-.318v-.002c1.291-.426 3.121-.698 5.156-.701 2.033.003 3.871.275 5.158.703h.002c.118.044.201.195.164.318a.272.272 0 01-.152.162.222.222 0 01-.158.009c-1.27-.408-3.045-.664-5.014-.666zm0-.143c1.985.002 3.777.26 5.06.673h.002c.023.009.048 0 .071-.012a.158.158 0 00.054-.067c.016-.054-.021-.118-.075-.137-1.277-.426-3.098-.692-5.112-.694-2.019.002-3.83.268-5.11.694a.127.127 0 00-.059.056.105.105 0 00-.012.081c.008.025.031.05.056.067.023.012.046.019.071.012 1.28-.413 3.066-.671 5.054-.673z"
});

var _ref312 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M97.598 158.914c0-.162.127-.295.289-.295.154 0 .283.133.283.295a.29.29 0 01-.283.296.29.29 0 01-.289-.296z"
});

var _ref313 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.525 158.914c0 .065.073.071.073.071s-.073-.089-.073-.071c0-.203.162-.367.358-.367.197 0 .361.166.361.367a.365.365 0 01-.361.367.362.362 0 01-.358-.367zm.144 0c0 .125.097.223.214.223a.22.22 0 00.218-.223.222.222 0 00-.218-.224.221.221 0 00-.214.224z"
});

var _ref314 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M100.182 159.041h-1.28a.22.22 0 01-.217-.224c0-.121.094-.219.213-.219h1.288c.117 0 .21.098.21.219a.22.22 0 01-.214.224z"
});

var _ref315 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.899 159.114a.297.297 0 01-.291-.297.29.29 0 01.287-.291h1.289c.156 0 .281.131.281.291a.29.29 0 01-.285.297h-1.281zm1.281-.143c.079 0 .141-.073.141-.154 0-.079-.06-.146-.137-.146h-1.289a.145.145 0 00-.141.146c0 .081.066.154.145.154h1.281z"
});

var _ref316 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M96.351 159.281l-.456.072c-.118.019-.226-.064-.247-.187a.215.215 0 01.179-.247l.457-.073.464-.081a.222.222 0 01.247.185c.015.116-.064.233-.181.249l-.463.082z"
});

var _ref317 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95.904 159.424a.29.29 0 01-.329-.245.29.29 0 01.237-.331l.458-.073.468-.081a.294.294 0 01.326.245.297.297 0 01-.24.333l-.463.079-.457.073zm.432-.214l.464-.081h.002c.077-.011.131-.088.12-.169a.144.144 0 00-.164-.12l-.466.077-.457.072c-.077.011-.129.088-.116.167a.147.147 0 00.164.127l.453-.073z"
});

var _ref318 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M94.511 159.628l.203-.356.433.087-.254.4z"
});

var _ref319 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.677 159.191l.587.121-.34.534-.519-.177.272-.478zm-.06.397l.247.085.164-.262-.278-.058-.133.235z"
});

var _ref320 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M100.856 158.914c0-.162.127-.295.289-.295.154 0 .283.133.283.295a.29.29 0 01-.283.296.29.29 0 01-.289-.296z"
});

var _ref321 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.785 158.914c0 .065.073.071.073.071s-.073-.089-.073-.071c0-.203.162-.367.358-.367.197 0 .361.166.361.367a.365.365 0 01-.361.367.362.362 0 01-.358-.367zm.144 0c0 .125.097.223.214.223a.22.22 0 00.218-.223.222.222 0 00-.218-.224.221.221 0 00-.214.224z"
});

var _ref322 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M102.679 159.281l.457.072a.215.215 0 00.244-.187.216.216 0 00-.175-.247l-.457-.073-.468-.081a.22.22 0 00-.065.434l.464.082z"
});

var _ref323 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.666 159.351l-.461-.079a.294.294 0 01-.239-.333.29.29 0 01.326-.245l.468.081.455.073a.29.29 0 01.237.331v.001a.286.286 0 01-.326.244l-.46-.073zm.025-.141l.456.073c.079.01.15-.044.162-.125.012-.079-.037-.158-.115-.169l-.457-.072-.468-.077a.145.145 0 00-.162.12.147.147 0 00.123.169l.461.081z"
});

var _ref324 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#CE1126",
  fillRule: "nonzero",
  d: "M104.479 159.648l-.162-.378-.444.039.213.427z"
});

var _ref325 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M104.463 159.623l-.146-.353-.444.039.213.427c.133-.034.265-.083.377-.113z"
});

var _ref326 =
/*#__PURE__*/
React.createElement("path", {
  d: "M104.481 159.694c-.114.029-.243.077-.378.11l-.056.013-.285-.57.603-.054.2.48-.084.021zm-.114-.116l-.095-.231-.285.025.139.279c.083-.025.166-.053.241-.073z"
});

var _ref327 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M99.509 160.958c-1.597-.002-3.042-.154-4.142-.466 1.1-.305 2.545-.496 4.142-.5 1.596 0 3.047.193 4.145.5-1.098.312-2.549.464-4.145.466z"
});

var _ref328 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M99.508 161.03a21.121 21.121 0 01-2.295-.12 11.853 11.853 0 01-1.865-.348.072.072 0 01-.05-.089.069.069 0 01.05-.049 13.086 13.086 0 011.944-.372 18.759 18.759 0 014.434-.003 13.01 13.01 0 011.947.375c.038.01.06.05.05.088a.074.074 0 01-.05.05c-.544.154-1.174.27-1.864.347-.71.08-1.487.12-2.301.121zm-2.28-.263c.705.079 1.474.119 2.28.12a20.702 20.702 0 002.285-.121 12.18 12.18 0 001.581-.273 13.425 13.425 0 00-1.664-.301 18.547 18.547 0 00-2.202-.128 18.51 18.51 0 00-2.199.131 13.5 13.5 0 00-1.661.298 12.39 12.39 0 001.58.274z"
});

var _ref329 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M104.542 157.185c.043-.135.004-.268-.086-.299-.089-.03-.195.058-.234.187-.046.137-.009.272.081.303.089.027.197-.056.239-.191z"
});

var _ref330 =
/*#__PURE__*/
React.createElement("path", {
  d: "M104.613 157.208a.396.396 0 01-.161.214.23.23 0 01-.17.023v-.002a.217.217 0 01-.123-.119.399.399 0 01-.004-.274.373.373 0 01.156-.21.199.199 0 01.168-.023h.002a.22.22 0 01.123.12c.033.071.04.171.009.271zm-.138-.046a.245.245 0 00.006-.146c-.008-.029-.022-.054-.047-.064-.023-.004-.046.006-.067.025a.263.263 0 00-.077.116.31.31 0 00-.008.152c.01.029.023.052.046.062.024.007.048-.004.07-.022a.24.24 0 00.077-.123z"
});

var _ref331 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M101.363 156.516c.017-.14-.046-.267-.139-.277-.092-.015-.183.091-.198.233-.016.139.044.264.14.276.093.009.178-.098.197-.232z"
});

var _ref332 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.436 156.524a.382.382 0 01-.115.239.208.208 0 01-.162.056h-.002a.206.206 0 01-.145-.094.378.378 0 01-.054-.264.368.368 0 01.116-.241.212.212 0 01.16-.056.234.234 0 01.144.094c.047.064.07.162.058.266zm-.142-.017a.253.253 0 00-.023-.148c-.012-.026-.031-.047-.056-.049-.023-.005-.043.012-.06.035a.227.227 0 00-.054.135.23.23 0 00.021.144c.012.026.031.05.054.054.023 0 .046-.017.062-.038a.248.248 0 00.056-.133z"
});

var _ref333 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M97.673 156.516c-.015-.14.046-.267.139-.277.094-.015.181.091.2.233.014.139-.048.264-.139.276-.092.009-.182-.098-.2-.232z"
});

var _ref334 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.602 156.524a.406.406 0 01.056-.266.24.24 0 01.144-.094.219.219 0 01.164.056.403.403 0 01.119.241v.002a.416.416 0 01-.061.262.195.195 0 01-.141.094.203.203 0 01-.162-.056.395.395 0 01-.119-.239zm.146-.017c.006.052.025.1.052.133.02.021.039.038.066.038.023-.007.038-.028.052-.054a.268.268 0 00.021-.144.24.24 0 00-.054-.135c-.019-.023-.037-.04-.062-.035-.025.002-.042.023-.057.049a.262.262 0 00-.018.148z"
});

var _ref335 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6E6E6",
  fillRule: "nonzero",
  d: "M94.496 157.185c-.041-.135-.004-.268.083-.299.09-.03.198.058.242.187.041.137.004.272-.086.303-.091.027-.197-.056-.237-.191h-.002z"
});

var _ref336 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.427 157.208a.378.378 0 01.007-.271.214.214 0 01.12-.12h.002l.003-.002a.203.203 0 01.166.025.376.376 0 01.162.21v.002c.031.1.025.199-.006.272a.221.221 0 01-.123.121h-.002a.223.223 0 01-.168-.023.387.387 0 01-.161-.214zm.138-.046a.249.249 0 00.079.123c.02.018.045.029.07.022.021-.01.034-.033.042-.062a.319.319 0 00-.006-.152.266.266 0 00-.079-.116c-.021-.019-.046-.029-.069-.023-.023.008-.037.033-.046.062a.275.275 0 00.009.146z"
});

var _ref337 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M99.509 154.514l-.564.37.416.989.148.104.141-.104.422-.989c-.189-.125-.376-.252-.563-.37z"
});

var _ref338 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.492 154.528c-.008-.039-.012-.085.017-.085.02 0 .031.008.037.021l.002-.011c.189.121.376.245.565.37l.05.033-.451 1.063-.203.145-.204-.145-.449-1.063.613-.403.023.075zm.017.071l-.472.311.386.915.086.063.085-.063.389-.915c-.158-.104-.314-.208-.474-.311z"
});

var _ref339 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M98.274 156.006l.253.407.88-.295.091-.135-.091-.137-.88-.281c-.087.146-.174.291-.253.441zm2.474 0l-.26.407-.878-.295-.093-.135.093-.137.878-.281c.091.146.175.293.26.441zm-4.905-1.054l-.44.455.563.813.152.065.11-.125.2-.981c-.196-.077-.389-.154-.585-.227z"
});

var _ref340 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.513 155.869l.054-.083.956-.304.029.046c.089.145.175.293.26.443l.021.037-.312.491-.954-.32-.054-.081-.058.081-.955.32-.31-.489.021-.037c.081-.152.169-.3.258-.445l.031-.046.955.304.058.083zm-1.156.135l.204.322.802-.27.052-.073-.052-.075-.8-.255a6.85 6.85 0 00-.206.351zm2.307 0a8.25 8.25 0 00-.206-.351l-.8.255-.052.075.052.073.803.27.203-.322zm-4.793-1.119c.195.073.39.15.586.227l.056.023-.217 1.058-.158.181-.216-.095-.611-.88.516-.53.044.016zm-.007.152l-.368.379.522.746.083.035.062-.07.186-.905c-.163-.062-.323-.125-.485-.185z"
});

var _ref341 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M94.92 156.582l.331.341.802-.472.063-.154-.117-.112-.917-.087c-.062.157-.11.322-.162.486v-.002zm2.42-.53l-.168.451-.919-.094-.121-.114.063-.154.804-.462c.119.119.229.246.341.373zm-3.305.659l-.075.474-.917.104-.141-.086.033-.162.692-.625c.133.104.271.197.408.295z"
});

var _ref342 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.099 156.183l.038-.094.877-.501.039.04c.117.123.229.249.341.378l.03.031-.206.543-.998-.1-.071-.071-.037.09-.874.515-.401-.411.015-.042a6.21 6.21 0 01.164-.488l.018-.052.999.093.066.069zm-1.098.38l.263.268.731-.432.033-.083-.062-.062-.836-.079a6.529 6.529 0 00-.129.388zm2.256-.495c-.089-.099-.177-.203-.27-.299l-.734.422-.036.088.067.062.838.083.135-.356zm-3.235 1.181l-.998.112-.204-.124.05-.233.753-.684.048.038c.133.103.268.197.407.292l.038.028-.094.571zm-.064-.505c-.11-.079-.221-.154-.326-.235l-.631.57-.018.087.074.048.841-.096.06-.374z"
});

var _ref343 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M95.804 156.299a.33.33 0 01.322-.335.33.33 0 01.324.335.328.328 0 01-.324.333.327.327 0 01-.322-.333z"
});

var _ref344 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95.733 156.299a.4.4 0 01.393-.405c.22 0 .395.181.395.405a.4.4 0 01-.395.408.403.403 0 01-.393-.408zm.146 0c0 .144.11.262.247.262a.258.258 0 00.252-.262.257.257 0 00-.252-.26.254.254 0 00-.247.26z"
});

var _ref345 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M103.186 154.952l.443.455-.565.813-.15.065-.112-.125-.2-.981a8.6 8.6 0 00.584-.227z"
});

var _ref346 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.721 155.399l-.614.88-.214.095-.16-.181-.214-1.062.06-.019a9.1 9.1 0 00.578-.227l.044-.016.52.53zm-.553-.36a8.39 8.39 0 01-.483.185l.183.903.063.07.083-.035.519-.746-.365-.377z"
});

var _ref347 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M104.114 156.582l-.333.341-.803-.472-.064-.154.118-.112.917-.087c.065.16.111.32.165.484zm-2.423-.53l.169.451.921-.094.116-.114-.062-.154-.805-.462c-.11.127-.226.248-.339.373z"
});

var _ref348 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.931 156.183l.068-.069.998-.093.021.052c.064.16.11.32.164.488l.013.042-.404.411-.869-.515-.039-.09-.071.071-.998.1-.208-.543.031-.033c.117-.123.229-.247.341-.374l.04-.044.875.505.038.092zm-1.157-.115l.134.356.84-.083.064-.062-.033-.088-.732-.42c-.089.1-.181.2-.273.297zm2.256.495c-.041-.133-.079-.26-.129-.388l-.837.079-.065.062.036.083.733.432.262-.268z"
});

var _ref349 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M104.872 156.711l.075.474.915.104.139-.086-.035-.162-.686-.625z"
});

var _ref350 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M104.872 156.711l.075.474.917.104.137-.086-.033-.162-.688-.625c-.138.095-.273.193-.408.295z"
});

var _ref351 =
/*#__PURE__*/
React.createElement("path", {
  d: "M104.829 156.653c.135-.102.27-.2.407-.298l.048-.033.748.682.05.233-.201.124-.996-.112-.092-.571.036-.025zm.122.089l.056.376.84.096.073-.048-.019-.087-.63-.572a11.92 11.92 0 00-.32.235z"
});

var _ref352 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M99.193 155.985a.33.33 0 01.322-.334.33.33 0 01.324.334.329.329 0 01-.324.333.327.327 0 01-.322-.333z"
});

var _ref353 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.12 155.985a.4.4 0 01.393-.405c.22 0 .395.181.395.405a.4.4 0 01-.395.408.403.403 0 01-.393-.408zm.145 0c0 .144.111.262.248.262a.257.257 0 00.251-.262.256.256 0 00-.251-.26.255.255 0 00-.248.26z"
});

var _ref354 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M102.587 156.299c0-.183.146-.335.323-.335a.33.33 0 01.324.335.328.328 0 01-.324.333.328.328 0 01-.323-.333z"
});

var _ref355 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.515 156.299a.4.4 0 01.393-.405c.22 0 .395.181.395.405a.4.4 0 01-.395.408.403.403 0 01-.393-.408zm.145 0c0 .144.11.262.248.262a.257.257 0 00.251-.262.256.256 0 00-.251-.26.254.254 0 00-.248.26z"
});

var _ref356 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M92.764 157.22a3.097 3.097 0 00-.399-.476c-.129-.127-.443-.233-.443-.233 0-.062.186-.206.385-.206a.36.36 0 01.291.144l.023-.137s.162.033.235.228c.073.204.027.51.027.51-.027.066-.081.112-.119.17z"
});

var _ref357 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.764 157.347l-.056-.087c-.002 0-.002-.003-.006-.003a3.136 3.136 0 00-.387-.463c-.12-.116-.415-.214-.415-.214l-.048-.017v-.052c0-.031.021-.079.066-.124a.607.607 0 01.389-.154c.087 0 .173.025.243.072l.013-.081.073.017s.199.038.286.275c.079.216.031.544.031.544l-.001.01-.003.007c-.027.068-.083.12-.122.183l-.063.093v-.006zm0-.243l.002-.005a.748.748 0 01.059.08l-.056-.081a.336.336 0 00.043-.069c.007-.05.038-.297-.025-.466a.314.314 0 00-.11-.147l-.035.212-.102-.137a.29.29 0 00-.233-.113.446.446 0 00-.262.092c-.004.002-.008.004-.01.008.11.042.289.125.382.212.125.127.241.262.347.405v.009zm.002-.005l-.002-.004v-.002l.005.005-.003.001z"
});

var _ref358 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M92.806 157.089c.075-.085.233-.066.347.042.119.11.154.268.075.357-.075.09-.231.069-.347-.039-.121-.108-.154-.272-.075-.36z"
});

var _ref359 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.806 157.162s-.073-.087-.073-.073c0 .067.073.073.073.073l-.054-.118c.1-.113.304-.104.451.035.152.139.181.343.083.459-.097.113-.299.104-.453-.035a.436.436 0 01-.139-.277.249.249 0 01.058-.182l.054.118zm.054-.023a.108.108 0 00-.023.079.29.29 0 00.094.177c.047.043.1.071.151.077.038.004.071-.002.096-.029.023-.029.025-.069.017-.111a.26.26 0 00-.09-.147.251.251 0 00-.147-.075c-.038-.004-.075.002-.098.029z"
});

var _ref360 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M106.113 157.264c.013.01.25-.343.433-.52.124-.127.443-.233.443-.233 0-.062-.185-.206-.385-.206a.366.366 0 00-.293.144l-.025-.137s-.16.033-.231.228c-.075.204-.029.51-.029.51s.031.141.087.214z"
});

var _ref361 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M106.113 157.264c.013.01.25-.343.433-.52.124-.127.443-.233.443-.233 0-.062-.185-.206-.385-.206a.366.366 0 00-.293.144l-.025-.137s-.16.033-.231.228c-.075.204-.029.51-.029.51-.002.089.036.116.087.214z"
});

var _ref362 =
/*#__PURE__*/
React.createElement("path", {
  d: "M106.113 157.336l-.004.003v-.003h-.004l.004.003h-.041l-.019-.04c-.062-.112-.1-.147-.098-.243-.004-.044-.041-.341.032-.54.085-.237.286-.275.286-.275l.073-.017.015.084a.44.44 0 01.245-.075c.16 0 .312.081.389.154.045.045.066.093.066.124v.052l-.05.017s-.297.098-.413.214c-.165.16-.373.459-.42.511a.082.082 0 01-.061.031zm.007-.197c.083-.114.251-.331.372-.447.091-.089.272-.172.38-.214-.002-.004-.006-.006-.008-.008a.449.449 0 00-.262-.092.294.294 0 00-.235.113l-.1.135-.037-.21a.292.292 0 00-.11.147c-.069.189-.025.476-.025.476V157.052a.14.14 0 00.025.085v.002z"
});

var _ref363 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M106.12 157.089c-.079-.085-.233-.066-.354.042-.118.11-.147.268-.074.357.074.09.232.069.349-.039.12-.108.154-.272.079-.36z"
});

var _ref364 =
/*#__PURE__*/
React.createElement("path", {
  d: "M106.12 156.998a.213.213 0 01.054.046h.002c.041.047.06.112.056.182a.426.426 0 01-.141.277c-.15.139-.356.148-.456.033-.091-.114-.066-.32.083-.457.129-.121.294-.142.402-.081zm.054.046l-.054-.061v-.002l.054.063zm-.054.153l-.054-.058c-.023-.027-.059-.033-.098-.029a.28.28 0 00-.152.075.273.273 0 00-.092.174.123.123 0 00.024.084c.02.027.055.033.095.029a.278.278 0 00.15-.077.264.264 0 00.095-.177.1.1 0 00-.022-.079l.054.06v-.002zm0-.035s-.071-.087-.071-.073c0 .067.071.073.071.073z"
});

var _ref365 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M99.76 150.526a.82.82 0 01.576.796.816.816 0 01-.807.828.815.815 0 01-.802-.828c0-.384.251-.704.595-.802l.438.006z"
});

var _ref366 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.737 150.595l.042-.14a.9.9 0 01.625.867c0 .497-.392.9-.879.9a.889.889 0 01-.875-.9c0-.418.274-.765.647-.873l.041.139a.759.759 0 00-.544.734c0 .418.328.757.731.757a.744.744 0 00.734-.757.748.748 0 00-.522-.727z"
});

var _ref367 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M100.361 151.106v.411h-1.663v-.411h.615v-.936h-.405v-.418h.405v-.407h.401v.407h.402v.418h-.402v.936z"
});

var _ref368 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.432 151.59h-1.807v-.559h.615v-.788h-.405v-.561h.405v-.408h.547v.408h.399v.561h-.399v.788h.645v.559zm-.144-.413H99.642v-1.079h.399v-.273h-.399v-.407h-.256v.407h-.405v.273h.405v1.079h-.615v.27h1.517v-.27z"
});

var _ref369 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M99.517 160.964a.052.052 0 01-.052.053.052.052 0 01-.052-.053v-.906c0-.028.023-.052.052-.052.029 0 .052.024.052.052v.906zm-.226 0a.053.053 0 01-.053.053.053.053 0 01-.052-.053v-.906c0-.028.024-.052.052-.052.029 0 .053.024.053.052v.906z"
});

var _ref370 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.045 160.964h-.035v-.906h.035v.906zm-.212 0h-.035v-.906h.035v.906zm-.187 0h-.035v-.906h.035v.906zm-.36-.047h-.035l-.004-.826h.035l.004.826zm.17.01h-.035v-.863h.035v.863zM97.972 160.879h-.075v-.761h.075v.761zm.167.021h-.073l-.005-.809h.071l.007.809zm-.614-.063h-.072v-.671h.072v.671zm.148.011h-.075v-.701h.075v.701zm.15.019h-.073v-.726h.073v.726zM97.39 160.829h-.108v-.644h.108v.644zm-.146.015h-.11v-.707h.11v.707zm-.155-.021h-.108v-.659h.108v.659zm-.32-.058h-.109l-.004-.555.108-.002.005.557zm.164.035h-.109v-.615h.109v.615zM96.623 160.752h-.144v-.503h.144v.503zm-.148.006h-.147v-.482h.147v.482zm-.164-.093h-.145v-.362h.145v.362zm-.168.002h-.146v-.328h.146v.328zm-.179-.042h-.143v-.245h.143v.245z"
});

var _ref371 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M100.417 160.917a.052.052 0 01-.052.052.052.052 0 01-.052-.052v-.832c0-.028.023-.052.052-.052.029 0 .052.024.052.052v.832zm-.383.027a.052.052 0 01-.052.052.052.052 0 01-.051-.052l.004-.88c0-.029.023-.052.052-.052.028 0 .051.024.051.052l-.004.88zm-.28.01a.052.052 0 01-.052.052.052.052 0 01-.052-.052v-.896c0-.028.023-.052.052-.052.029 0 .052.024.052.052v.896z"
});

var _ref372 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M92.143 165.426h14.621v-4.177H92.143z"
});

var _ref373 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.01 161.116h14.887v4.445H92.01v-4.445zm.268 4.177h14.351v-3.911H92.278v3.911z"
});

var _ref374 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M93.677 168.207a.572.572 0 01.272-.045h10.948c.108 0 .21.021.298.058a1 1 0 01-.645-.944c0-.436.291-.817.671-.958-.087.031-.214.06-.317.06H93.949a.888.888 0 01-.309-.04l.058.011c.393.131.617.509.617.927 0 .401-.249.803-.638.931z"
});

var _ref375 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M93.624 168.086l.08-.031a.791.791 0 00.321-.275.92.92 0 00.015-1.007l-.004-.006a.74.74 0 00-.33-.274l-.112-.03a.132.132 0 01-.079-.17.132.132 0 01.155-.084c.12.021.139.03.279.036h10.955a.73.73 0 00.122-.012l.006-.001c.053-.01.105-.025.146-.039a.132.132 0 01.09.249.916.916 0 00-.424.331.878.878 0 00.362 1.308l.041.016a.134.134 0 01.07.175.133.133 0 01-.171.071l-.119-.036a.673.673 0 00-.129-.012H93.949l-.158.011-.072.028a.134.134 0 01-.168-.085.134.134 0 01.073-.163zm.544-.057h10.527l-.078-.102a1.143 1.143 0 01.01-1.306l.087-.11h-10.54l.088.115c.121.186.187.413.187.65 0 .231-.074.463-.205.654l-.076.099z"
});

var _ref376 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M93.949 168.162h10.952c.368 0 .668.251.668.559 0 .308-.3.561-.668.561H93.949c-.37 0-.671-.253-.671-.561 0-.308.301-.559.671-.559z"
});

var _ref377 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.947 168.026h10.952c.447 0 .803.321.803.695 0 .374-.356.694-.803.694H93.947c-.449 0-.804-.32-.804-.694 0-.374.355-.695.804-.695zm0 .269c-.291 0-.536.185-.536.426s.245.426.536.426h10.952c.287 0 .534-.185.534-.426s-.247-.426-.534-.426H93.947z"
});

var _ref378 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M93.949 165.426h10.959c.367 0 .667.214.667.472 0 .264-.3.48-.667.48H93.947c-.37 0-.669-.216-.669-.48 0-.258.299-.472.669-.472h.002z"
});

var _ref379 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.947 165.293h10.958c.258 0 .487.093.63.231a.517.517 0 01.173.374.521.521 0 01-.173.38.912.912 0 01-.63.233h-10.96a.922.922 0 01-.634-.233.53.53 0 01-.17-.38.52.52 0 01.17-.374.927.927 0 01.636-.231zm0 .268a.663.663 0 00-.451.156c-.052.054-.087.112-.087.181 0 .07.035.133.087.187a.652.652 0 00.449.158h10.96a.64.64 0 00.445-.158c.052-.054.09-.117.09-.187a.258.258 0 00-.09-.181.649.649 0 00-.445-.156H93.947z"
});

var _ref380 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M93.677 228.653c.035.146.083.287.083.443 0 1.046-.829 1.877-1.842 1.877h15.048c-1.013 0-1.842-.831-1.842-1.877 0-.154.027-.297.062-.443a.813.813 0 01-.289.04H93.949a.9.9 0 01-.272-.04z"
});

var _ref381 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M93.572 228.778l-.024-.091a.133.133 0 01.172-.159l.101.023.128.009h10.949l.133-.006a.498.498 0 00.109-.025.14.14 0 01.076-.004.132.132 0 01.099.159 2.05 2.05 0 00-.058.412c0 .485.192.921.5 1.235.309.315.738.51 1.209.51a.133.133 0 110 .266H91.919a.133.133 0 110-.266c.471 0 .9-.195 1.209-.51.308-.314.499-.75.499-1.235a1.22 1.22 0 00-.053-.309l-.002-.009zm.285.044c.021.087.036.176.036.274 0 .557-.221 1.058-.576 1.421a2.048 2.048 0 01-.416.324h13.082a2.02 2.02 0 01-.992-1.745c0-.083.008-.165.02-.244l.004-.031-.117.005-11.041-.004z"
});

var _ref382 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M93.949 227.568h10.952c.368 0 .668.252.668.559 0 .308-.3.561-.668.561H93.949c-.37 0-.671-.253-.671-.561 0-.307.301-.559.671-.559z"
});

var _ref383 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.949 227.435h10.952c.447 0 .803.322.803.696 0 .375-.356.695-.803.695H93.949c-.449 0-.804-.32-.804-.695 0-.374.355-.696.804-.696zm0 .268s-.133-.166-.133-.135c0 .123.133.135.133.135-.291 0-.536.187-.536.428s.245.427.536.427h10.952c.287 0 .535-.186.535-.427s-.248-.428-.535-.428H93.949z"
});

var _ref384 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M91.937 235.146h15.01v-4.173h-15.01z"
});

var _ref385 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.804 230.84h15.276v4.439H91.804v-4.439zm.268 4.173h14.742v-3.907H92.072v3.907z"
});

var _ref386 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M90.764 212.803c-1.484.934-2.492 1.892-2.33 2.368.083.439.555.767 1.229 1.256 1.06.804 1.704 2.241 1.199 2.904a4.264 4.264 0 001.435-3.206c0-1.341-.584-2.55-1.533-3.322z"
});

var _ref387 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.85 212.699c.977.797 1.58 2.042 1.58 3.426 0 1.321-.572 2.51-1.479 3.308l-.195-.181c.179-.239.183-.586.077-.96-.17-.614-.64-1.294-1.249-1.759-.414-.297-.753-.539-.973-.78-.162-.176-.267-.353-.306-.549-.054-.17-.002-.397.17-.65.34-.516 1.156-1.198 2.219-1.863l.079-.054.077.062zm-.096.269c-.84.534-1.518 1.072-1.896 1.519-.122.144-.21.277-.264.397-.04.094-.056.177-.033.245l.004.009.002.008c.035.195.162.362.351.539.208.191.493.393.826.634v.002c.659.501 1.162 1.239 1.349 1.898.06.214.087.422.075.613a4.145 4.145 0 00.996-2.707c0-1.264-.537-2.407-1.41-3.157z"
});

var _ref388 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "nonzero",
  d: "M94.089 226.894h10.663v-56.949H94.089z"
});

var _ref389 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.954 169.81h10.933v57.217H93.954V169.81zm7.602 56.949v-56.68h-7.334v56.68h7.334zm.266-56.68v56.68h.932v-56.68h-.932zm1.2 0v56.68h1.597v-56.68h-1.597z"
});

var _ref390 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M115.643 191.246c-2.324-1.049-6.28-1.825-10.818-1.987-1.566.01-3.31.172-5.111.499-6.38 1.16-11.236 3.936-10.852 6.197.007.046.023.146.033.187 0 0-2.392-5.873-2.432-6.093-.426-2.511 4.965-5.592 12.044-6.881a33.78 33.78 0 016.274-.541c4.526 0 8.461.632 10.835 1.593l.027 7.026z"
});

var _ref391 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M115.589 191.367c-1.174-.53-2.772-.991-4.653-1.336-1.815-.334-3.895-.56-6.115-.64-.79.005-1.625.05-2.489.134-.841.082-1.711.203-2.594.363-3.174.577-5.968 1.556-7.92 2.67-1.913 1.092-3.007 2.305-2.825 3.375l.033.184a.133.133 0 01-.255.073c-.038-.093-2.373-5.757-2.438-6.118-.225-1.318 1.043-2.764 3.273-4.038 2.191-1.251 5.323-2.35 8.877-2.996a34.005 34.005 0 016.298-.544c2.221 0 4.302.152 6.127.42 1.906.28 3.536.689 4.758 1.183a.132.132 0 01.083.128l.027 7.021c0 .073-.06.133-.133.133a.125.125 0 01-.054-.012zm-4.605-1.597c1.804.331 3.353.769 4.526 1.273l-.026-6.733c-1.193-.471-2.772-.862-4.615-1.133-1.812-.266-3.88-.417-6.088-.417a33.854 33.854 0 00-6.251.538c-3.523.641-6.626 1.729-8.794 2.966-2.129 1.217-3.345 2.568-3.142 3.763.022.087 1.508 3.786 2.143 5.364.184-1.024 1.262-2.1 2.951-3.064 1.975-1.128 4.799-2.117 8.003-2.699.89-.162 1.768-.284 2.616-.367.873-.085 1.717-.13 2.513-.135h.009c2.232.08 4.326.308 6.155.644z"
});

var _ref392 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M94.07 198.394c-2.956-.231-4.975-1.091-5.208-2.439-.181-1.075.817-2.264 2.603-3.341.796.092 1.694.212 2.624.212l-.019 5.568z"
});

var _ref393 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.07 198.394l-.01.135c-1.801-.141-3.258-.516-4.188-1.087-.646-.395-1.043-.892-1.141-1.464-.077-.459.042-.942.341-1.424.429-.692 1.231-1.395 2.324-2.056l.04-.025.046.008c.79.092 1.684.21 2.607.21h.133l-.019 5.705-.133-.002zm-.133-.144l.017-5.29c-.867-.011-1.705-.121-2.458-.208-1.031.627-1.792 1.287-2.197 1.943-.26.423-.372.836-.304 1.237.087.504.449.932 1.021 1.283.875.538 2.239.89 3.921 1.035z"
});

var _ref394 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M104.771 194.04c1.848.308 3.234.807 3.926 1.423l.063.122c.329.738-1.295 2.304-4.004 4.054l.015-5.599z"
});

var _ref395 =
/*#__PURE__*/
React.createElement("path", {
  d: "M108.456 195.111l-.035-.077.366.329a2.731 2.731 0 00-.331-.252zm-3.685-1.071l.022-.128c1.622.266 2.894.686 3.663 1.199l.241.485s.059-.32.123-.192l.056.119.007.008c.112.254.043.595-.219.998-.54.832-1.916 1.986-3.838 3.222l-.205.136.016-5.847h.134zm3.818 1.506c-.665-.58-1.964-1.048-3.685-1.345l-.015 5.191c1.509-.99 2.659-1.913 3.28-2.653.208-.245.356-.47.435-.667.067-.167.085-.312.033-.431l-.048-.095z"
});

var _ref396 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M87.446 209.381c-.28-.921 2.603-2.761 6.678-4.391 1.863-.727 3.401-1.484 5.306-2.401 5.661-2.727 9.843-5.858 9.33-7l-.058-.118c.303.266.769 5.892.769 5.892.518 1.045-3.31 4.131-8.522 6.854-1.667.869-5.191 2.287-6.854 2.921-2.973 1.127-5.931 3.247-5.661 4.033l-.988-5.788v-.002z"
});

var _ref397 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M87.315 209.405c-.14-.518.513-1.242 1.718-2.034 1.203-.791 2.97-1.675 5.041-2.503l.005-.002c1.699-.664 3.129-1.353 4.815-2.166l.477-.23c2.827-1.361 5.283-2.824 6.966-4.086 1.63-1.223 2.527-2.233 2.303-2.738l-.057-.117a.132.132 0 01.062-.177.132.132 0 01.145.019l.032.042.057.119c.029.064.045.13.05.2.31 1.255.645 5.265.672 5.596.257.592-.588 1.673-2.164 2.941-1.549 1.245-3.815 2.701-6.426 4.065-.698.364-1.722.825-2.798 1.284-1.503.64-3.104 1.276-4.071 1.645l-.005.001c-1.469.557-2.934 1.359-4 2.119-.954.679-1.585 1.306-1.59 1.66l.018.106a.133.133 0 01-.257.065.419.419 0 01-.021-.114l-.972-5.695zm1.863-1.812c-1.107.728-1.717 1.353-1.606 1.744l.896 5.245c.266-.413.805-.91 1.514-1.416 1.084-.771 2.571-1.585 4.06-2.15l.006-.002c.97-.37 2.57-1.005 4.06-1.64 1.069-.456 2.087-.914 2.78-1.275 2.594-1.355 4.844-2.801 6.382-4.038 1.495-1.202 2.31-2.18 2.082-2.64l-.013-.046c-.001-.013-.298-3.532-.547-5.087-.309.622-1.117 1.424-2.297 2.308-1.695 1.272-4.167 2.744-7.008 4.113l-.477.23c-1.691.815-3.127 1.507-4.833 2.174-2.06.824-3.81 1.698-4.999 2.48z"
});

var _ref398 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M93.353 188.515c1.303-.52 2.158-1.131 1.74-2.252-.264-.709-.938-.846-1.944-.444l-1.784.704 1.605 4.314c.177-.085.349-.175.532-.248.181-.07.368-.124.554-.184l-.703-1.888v-.002zm-.776-2.083l.449-.177c.375-.152.799.067.986.567.141.383.104.811-.326 1.111a3.122 3.122 0 01-.462.233l-.647-1.734zm4.942-1.805c-.187.056-.372.117-.563.158-.19.039-.385.063-.574.092l.923 4.486 2.877-.632c-.035-.087-.081-.181-.095-.273-.021-.093-.019-.199-.023-.292-.505.158-1.056.328-1.718.471l-.823-4.01h-.004zm5.761 3.869c.543-1.628 1.199-3.185 1.846-4.767a3.64 3.64 0 01-.355.048c-.115.006-.24.008-.356.004-.345 1.146-.773 2.289-1.222 3.432-.541-1.083-1.14-2.141-1.595-3.228-.225.031-.451.066-.678.083-.225.016-.457.012-.684.016.83 1.472 1.63 2.94 2.389 4.46.104-.023.212-.05.328-.058.107-.007.217.004.327.008v.002zm6.01-3.453c.102-.219.202-.431.314-.634-.152-.161-.63-.393-1.185-.456-1.173-.126-1.848.441-1.925 1.215-.164 1.615 2.174 1.476 2.066 2.546-.045.464-.496.651-.975.599-.532-.058-.921-.378-.991-.852l-.144-.015a5.566 5.566 0 01-.312.824c.344.243.788.38 1.214.424 1.196.13 2.109-.393 2.196-1.25.154-1.534-2.208-1.624-2.117-2.528.038-.38.306-.63.917-.564.439.048.709.306.826.678l.116.013z"
});

var _ref399 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.399 188.533l.704 1.897-.037.01c-.181.058-.372.112-.549.183-.183.073-.356.162-.53.247l-.035.019-1.632-4.387 1.815-.717c1.031-.414 1.721-.262 1.991.468.258.686.044 1.191-.455 1.597-.32.259-.761.48-1.272.683zm-.046.017l-.015-.068c.007-.003.011-.005.015-.005v-.064l.018.054c.506-.202.94-.418 1.254-.674.474-.386.676-.863.433-1.515-.258-.693-.917-.819-1.897-.426l-1.75.692 1.58 4.243a7.29 7.29 0 01.499-.231c.168-.068.345-.12.52-.172l-.657-1.763-.03-.085c.011.014.03.014.03.014zm-.036-.035l.006.021a.035.035 0 01-.006-.021zm.036.035l-.036-.035c0-.011.036.035.036.035zm-.339-2.328c.391-.158.838.064 1.033.59.144.397.104.84-.343 1.15a2.832 2.832 0 01-.466.237l-.035.016-.671-1.802.482-.191zm-.391.23l.622 1.666c.145-.063.291-.129.42-.217.413-.286.449-.698.313-1.066-.178-.48-.582-.69-.939-.547l-.416.164zm16.684-1.401c-.007.015-.017.029-.017.029l-.141-.016-.009-.021a.888.888 0 00-.796-.655c-.293-.031-.505.011-.649.108a.553.553 0 00-.228.424c-.017.169.06.308.189.432.137.134.331.248.543.371.326.187.692.378.966.642.279.268.466.607.418 1.081-.087.875-1.016 1.416-2.235 1.283-.43-.044-.883-.183-1.228-.43l-.025-.015.01-.029c.121-.268.233-.538.31-.819l.008-.032.204.023.002.027c.069.46.445.768.96.824.458.047.892-.125.936-.566.025-.255-.096-.438-.289-.592-.2-.162-.474-.293-.748-.443-.562-.31-1.115-.688-1.03-1.513.079-.789.765-1.377 1.965-1.246.568.063 1.05.302 1.208.466l.019.016-.013.025a9.294 9.294 0 00-.314.632l-.016-.006zm-.104-.054l.066.006c.094-.201.187-.401.291-.588-.168-.156-.621-.368-1.143-.426-1.15-.125-1.811.428-1.888 1.181-.058.565.202.912.551 1.168.237.177.516.314.769.451.215.116.412.235.547.378a.67.67 0 01.2.551c-.048.483-.516.685-1.013.632-.543-.06-.939-.382-1.021-.856l-.087-.01a5.657 5.657 0 01-.291.773c.335.229.763.358 1.172.401 1.171.127 2.071-.376 2.154-1.22.046-.447-.128-.767-.393-1.021-.27-.26-.633-.449-.954-.632-.216-.124-.415-.245-.559-.38-.145-.142-.229-.302-.21-.491.023-.202.104-.368.262-.478.152-.104.38-.154.696-.119a.96.96 0 01.851.68zm-11.682-.37l.037-.008.815 3.977c.647-.144 1.186-.31 1.68-.464l.044-.014.002.045c.004.094.002.196.023.289.014.088.06.179.093.268l.015.038-2.952.647-.942-4.56.038-.006c.191-.027.386-.05.575-.089.188-.04.375-.102.562-.158l.01.035zm-.027.044c-.174.054-.353.11-.53.147-.177.04-.362.063-.541.085l.911 4.416 2.798-.613a1.22 1.22 0 01-.081-.241c-.018-.079-.018-.169-.023-.25-.492.152-1.031.318-1.673.458l-.036.01-.825-4.012zm5.786 3.825l-.004.033c-.106-.004-.215-.014-.32-.006-.115.006-.221.033-.325.056l-.027.004-.012-.025a99.489 99.489 0 00-2.387-4.457l-.027-.052.058-.002c.225-.002.458 0 .682-.014.223-.019.451-.052.676-.083l.027-.005.01.025c.445 1.065 1.027 2.096 1.557 3.154a44.08 44.08 0 001.194-3.354l.006-.026.029.001c.114.005.239.003.351-.006.117-.008.237-.025.352-.045l.064-.011-.025.062c-.646 1.576-1.304 3.136-1.846 4.761l-.033-.01zm-.025-.039c.534-1.597 1.176-3.129 1.813-4.68-.098.014-.2.027-.296.035-.105.006-.222.011-.332.006-.341 1.138-.767 2.275-1.214 3.408l-.029.074-.038-.072c-.536-1.075-1.129-2.125-1.584-3.204-.216.029-.437.063-.653.079-.204.015-.418.015-.623.017.814 1.445 1.6 2.889 2.347 4.38.095-.018.199-.042.305-.05.1-.006.202.002.304.007z"
});

var _ref400 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M109.66 235.728c-1.01 0-1.91-.231-2.576-.618-.659-.366-1.553-.588-2.536-.588-.99 0-1.902.225-2.563.593-.661.38-1.578.613-2.576.613-1.013 0-1.911-.256-2.576-.645-.653-.349-1.53-.561-2.489-.561-.991 0-1.873.206-2.53.578-.665.383-1.586.628-2.594.628v1.727c1.008 0 1.929-.251 2.594-.632.657-.374 1.539-.582 2.53-.582.957 0 1.834.217 2.489.568.661.384 1.563.646 2.576.646.998 0 1.915-.241 2.576-.615.661-.372 1.573-.599 2.563-.599.983 0 1.877.227 2.536.595.666.387 1.549.619 2.564.619l.012-1.727z"
});

var _ref401 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.66 235.595c.146 0 0 .266 0 .268l-.135-.002c-.983-.021-1.854-.256-2.507-.634-.643-.356-1.512-.57-2.47-.57-.963 0-1.854.216-2.497.576-.68.389-1.617.63-2.642.63-1.038 0-1.959-.264-2.643-.661-.636-.341-1.488-.545-2.422-.545-.964 0-1.823.198-2.465.559-.653.379-1.545.624-2.524.645v1.457c.929-.021 1.773-.258 2.393-.613.676-.38 1.578-.599 2.596-.599.981 0 1.88.225 2.553.589h.002c.647.372 1.524.623 2.51.623.973 0 1.865-.228 2.509-.594.678-.383 1.615-.618 2.63-.618 1.01 0 1.923.235 2.603.611.617.36 1.432.582 2.364.601l.01-1.455h.135l.133-.133-.012 1.858h-.133c-1.042 0-1.948-.241-2.63-.638-.643-.355-1.512-.576-2.47-.576-.963 0-1.854.221-2.497.583-.68.384-1.617.631-2.642.631-1.038 0-1.961-.27-2.643-.661-.64-.345-1.492-.553-2.422-.553-.964 0-1.823.202-2.465.564-.682.391-1.624.65-2.659.65h-.133v-1.993h.133c.981 0 1.877-.235 2.528-.611.676-.383 1.578-.595 2.596-.595.984 0 1.882.218 2.553.58h.002c.649.376 1.524.626 2.51.626.973 0 1.862-.227 2.511-.595v-.002c.676-.376 1.613-.609 2.628-.609 1.01 0 1.923.229 2.603.605v.002c.647.374 1.524.599 2.509.599z"
});

var _ref402 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "nonzero",
  d: "M109.66 237.455c-1.01 0-1.91-.23-2.576-.617-.659-.366-1.553-.588-2.536-.588-.99 0-1.902.224-2.563.592-.661.381-1.578.613-2.576.613-1.013 0-1.911-.255-2.576-.644-.653-.349-1.53-.561-2.489-.561-.991 0-1.873.205-2.53.578-.665.382-1.586.627-2.594.627v1.728c1.008 0 1.929-.252 2.594-.632.657-.374 1.539-.582 2.53-.582.957 0 1.834.216 2.489.567.661.385 1.563.647 2.576.647.998 0 1.915-.241 2.576-.615.661-.373 1.573-.599 2.563-.599.983 0 1.877.226 2.536.595.666.386 1.549.619 2.564.619l.012-1.728z"
});

var _ref403 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.66 237.455h.133l-.012 1.855h-.133c-1.042 0-1.948-.241-2.63-.634-.643-.36-1.512-.576-2.47-.576-.963 0-1.854.216-2.497.578-.68.386-1.617.632-2.642.632-1.038 0-1.961-.266-2.643-.661-.64-.341-1.492-.549-2.422-.549-.964 0-1.823.199-2.463.565-.684.391-1.626.645-2.661.645h-.133v-1.992h.133c.981 0 1.877-.241 2.528-.613.676-.38 1.578-.599 2.596-.599.984 0 1.882.225 2.553.589h.002c.649.372 1.524.623 2.51.623.973 0 1.865-.228 2.509-.594.678-.383 1.615-.618 2.63-.618 1.01 0 1.925.235 2.603.611.647.379 1.524.601 2.509.601v.137zm-.135.133c-.983-.02-1.856-.257-2.507-.638-.643-.355-1.512-.576-2.47-.576-.963 0-1.854.221-2.497.583-.68.384-1.617.631-2.642.631-1.038 0-1.959-.27-2.64-.661-.639-.345-1.491-.553-2.425-.553-.964 0-1.823.202-2.465.564-.653.374-1.545.628-2.524.65v1.452c.929-.021 1.773-.254 2.393-.608.676-.386 1.578-.6 2.596-.6.981 0 1.88.22 2.553.584h.002c.647.376 1.524.626 2.51.626.973 0 1.865-.231 2.511-.597.676-.38 1.613-.613 2.628-.613 1.01 0 1.923.233 2.603.611.617.358 1.432.58 2.364.597l.01-1.452z"
});

var _ref404 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M109.66 239.175c-1.01 0-1.91-.231-2.576-.618-.659-.366-1.553-.588-2.536-.588-.99 0-1.902.225-2.563.592-.661.381-1.578.614-2.576.614-1.013 0-1.911-.256-2.576-.645-.653-.349-1.53-.561-2.489-.561-.991 0-1.873.206-2.53.578-.665.382-1.586.628-2.594.628v1.727c1.008 0 1.929-.251 2.594-.632.657-.374 1.539-.582 2.53-.582.957 0 1.834.217 2.489.568.661.384 1.563.646 2.576.646.998 0 1.915-.241 2.576-.615.661-.372 1.573-.599 2.563-.599.983 0 1.877.227 2.536.595.666.387 1.549.619 2.564.619l.012-1.727z"
});

var _ref405 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.66 239.175l.133.002-.012 1.854h-.133c-1.042 0-1.948-.235-2.63-.634-.643-.358-1.512-.574-2.47-.574-.963 0-1.854.219-2.497.58-.68.387-1.617.628-2.642.628-1.038 0-1.961-.264-2.643-.659-.64-.341-1.492-.549-2.422-.549-.964 0-1.823.202-2.465.562-.682.393-1.624.646-2.659.646h-.133v-1.989h.133c.981 0 1.879-.239 2.528-.61.676-.386 1.578-.6 2.596-.6.984 0 1.882.22 2.553.584h.002c.649.376 1.524.626 2.51.626.973 0 1.865-.231 2.511-.597.676-.38 1.613-.613 2.628-.613 1.01 0 1.925.233 2.603.611.647.372 1.524.599 2.509.599v.133zm-.135.133c-.983-.019-1.854-.258-2.507-.632-.643-.36-1.512-.576-2.47-.576-.963 0-1.854.216-2.497.578-.68.386-1.617.632-2.642.632-1.038 0-1.959-.266-2.643-.661-.636-.343-1.488-.549-2.422-.549-.964 0-1.823.199-2.463.565-.655.375-1.547.624-2.526.643v1.455c.929-.021 1.773-.256 2.393-.611v-.002c.676-.378 1.578-.593 2.596-.593.981 0 1.88.221 2.553.58l.002.002c.647.377 1.524.624 2.51.624.973 0 1.865-.227 2.511-.592.676-.381 1.613-.614 2.628-.614 1.01 0 1.923.229 2.603.607l.002.002c.615.36 1.43.576 2.362.597l.01-1.455z"
});

var _ref406 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "nonzero",
  d: "M109.648 242.624c-1.015 0-1.898-.237-2.564-.622-.659-.366-1.553-.59-2.536-.59-.99 0-1.902.224-2.563.596-.661.374-1.578.616-2.576.616-1.013 0-1.911-.26-2.576-.647-.653-.349-1.53-.565-2.489-.565-.991 0-1.873.212-2.53.58-.665.384-1.586.632-2.594.632v-1.715c1.008 0 1.929-.258 2.594-.641.657-.37 1.539-.578 2.53-.578.957 0 1.834.215 2.489.566.661.384 1.563.642 2.576.642.998 0 1.915-.235 2.576-.613.661-.37 1.573-.595 2.563-.595.983 0 1.877.223 2.536.591.666.389 1.566.617 2.576.617l-.012 1.726z"
});

var _ref407 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.648 242.624v.133c-1.042 0-1.948-.243-2.63-.638-.643-.356-1.512-.572-2.47-.572-.963 0-1.854.216-2.497.578-.68.384-1.617.632-2.642.632-1.038 0-1.959-.266-2.643-.663-.636-.341-1.488-.547-2.422-.547-.964 0-1.823.202-2.465.561-.682.395-1.624.649-2.659.649h-.133v-1.984h.133c.981 0 1.877-.247 2.528-.621v-.002c.676-.378 1.578-.593 2.596-.593.981 0 1.88.221 2.553.58l.002.002c.647.377 1.524.624 2.51.624.973 0 1.865-.227 2.511-.592.676-.381 1.613-.614 2.628-.614 1.01 0 1.923.229 2.603.607l.002.002c.645.377 1.522.597 2.507.597h.135l-.012 1.861h-.135zm-.133-.137l.01-1.456c-.983-.021-1.856-.253-2.507-.634-.643-.358-1.512-.574-2.47-.574-.963 0-1.854.219-2.497.58-.68.387-1.617.628-2.642.628-1.038 0-1.961-.264-2.643-.659-.64-.341-1.492-.549-2.422-.549-.964 0-1.823.202-2.465.562-.653.376-1.545.634-2.524.655v1.447c.929-.021 1.773-.254 2.393-.612.676-.378 1.578-.596 2.596-.596.984 0 1.882.222 2.553.582h.002c.649.376 1.524.626 2.51.626.973 0 1.865-.229 2.511-.595.676-.383 1.613-.613 2.628-.613 1.01 0 1.923.23 2.603.607.617.36 1.432.582 2.364.601z"
});

var _ref408 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#005BBF",
  fillRule: "nonzero",
  d: "M109.648 244.345c-1.015 0-1.898-.237-2.564-.622-.659-.365-1.553-.59-2.536-.59-.99 0-1.902.225-2.563.597-.661.374-1.578.615-2.576.615-1.013 0-1.911-.26-2.576-.647-.653-.349-1.53-.565-2.489-.565-.991 0-1.873.212-2.53.58-.665.385-1.586.632-2.594.632v-1.715c1.008 0 1.929-.258 2.594-.64.657-.37 1.539-.578 2.53-.578.957 0 1.834.214 2.489.565.661.385 1.563.643 2.576.643.998 0 1.915-.235 2.576-.614.661-.37 1.573-.594 2.563-.594.983 0 1.877.222 2.536.59.666.389 1.566.618 2.576.618l-.012 1.725z"
});

var _ref409 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M109.648 244.345c-1.015 0-1.898-.233-2.564-.615-.659-.37-1.553-.597-2.536-.597-.99 0-1.902.229-2.563.599-.661.376-1.578.613-2.576.613-1.013 0-1.911-.262-2.576-.644-.653-.354-1.53-.568-2.489-.568-.991 0-1.873.21-2.53.582-.665.383-1.586.63-2.594.63v-1.709c1.008 0 1.929-.26 2.594-.644.657-.368 1.539-.576 2.53-.576.957 0 1.834.214 2.489.563.661.385 1.563.645 2.576.645.998 0 1.915-.242 2.576-.616.661-.372 1.573-.592 2.563-.592.983 0 1.877.22 2.536.588.666.383 1.559.62 2.574.62l-.01 1.721z"
});

var _ref410 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.648 244.48c-1.042 0-1.948-.241-2.63-.634-.643-.361-1.512-.58-2.47-.58-.963 0-1.854.22-2.497.582-.68.385-1.617.632-2.642.632-1.038 0-1.959-.27-2.64-.663-.639-.343-1.491-.551-2.425-.551-.964 0-1.823.204-2.465.568-.682.391-1.624.646-2.659.646h-.133v-1.977h.133c.981 0 1.877-.253 2.528-.628.676-.378 1.578-.594 2.596-.594.981 0 1.88.222 2.553.582l.002.002c.647.372 1.524.622 2.51.622.973 0 1.865-.229 2.511-.595.676-.383 1.613-.611 2.628-.611 1.01 0 1.923.228 2.603.609.647.374 1.52.597 2.507.597h.133l-.01 1.993h-.133zm-.133-.27l.008-1.458c-.985-.018-1.852-.253-2.505-.629-.643-.36-1.512-.574-2.47-.574-.963 0-1.854.214-2.497.576-.68.384-1.617.632-2.642.632-1.038 0-1.961-.266-2.643-.661-.64-.339-1.492-.547-2.422-.547-.964 0-1.823.2-2.465.559-.653.376-1.545.638-2.524.661v1.441c.929-.019 1.773-.254 2.393-.609.676-.385 1.578-.603 2.596-.603.984 0 1.882.222 2.553.586h.002c.649.374 1.524.628 2.51.628.973 0 1.865-.231 2.511-.599.676-.378 1.613-.613 2.628-.613 1.01 0 1.925.233 2.603.613.617.356 1.432.58 2.364.597z"
});

var _ref411 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "nonzero",
  d: "M148.507 245.495c-8.584 0-17.091-2.293-24.24-6.106-5.272-2.848-8.767-8.588-8.767-15.154v-23.814h65.884v23.814c0 6.566-3.495 12.306-8.767 15.15-7.152 3.817-15.525 6.11-24.11 6.11z"
});

var _ref412 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.507 245.671s-.035-.361-.083-.332c-.195.104.083.332.083.332-8.61 0-17.147-2.301-24.323-6.128-5.329-2.876-8.861-8.674-8.861-15.308v-23.993h66.238v23.993c0 6.634-3.53 12.432-8.859 15.308-7.178 3.827-15.581 6.128-24.195 6.128zm0-.355c8.555 0 16.9-2.285 24.027-6.085 5.216-2.819 8.673-8.497 8.673-14.996v-23.637h-65.53v23.637c0 6.499 3.457 12.177 8.675 14.996 7.125 3.8 15.605 6.085 24.155 6.085z"
});

var _ref413 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M148.393 224.206c0 9.412-7.318 17.04-16.43 17.04-9.118 0-16.507-7.628-16.507-17.04v-23.847h32.937v23.847z"
});

var _ref414 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M122.651 238.268c1.028.597 2.443 1.589 3.953 1.984l-.096-40.733h-3.857v38.749z"
});

var _ref415 =
/*#__PURE__*/
React.createElement("path", {
  d: "M122.473 199.338h4.214l.093 41.144-.22-.058c-1.528-.399-2.958-1.399-3.998-2l-.089-.054v-39.032zm.355 38.828c.959.564 2.231 1.437 3.599 1.851l-.096-40.322h-3.503v38.471z"
});

var _ref416 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M115.4 223.886c.102 5.025 1.931 8.761 3.763 11.21v-35.38h-3.717l-.046 24.17z"
});

var _ref417 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M115.572 223.883a19.767 19.767 0 001.007 5.909 18.565 18.565 0 002.412 4.774v-34.678h-3.375l-.044 23.995zm.682 6.018a20.086 20.086 0 01-1.025-6.012l.044-24.173c0-.095.078-.172.172-.172h3.718c.095 0 .172.077.172.172v35.379a.172.172 0 01-.309.103 18.881 18.881 0 01-2.772-5.297z"
});

var _ref418 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M129.994 241.146a16.83 16.83 0 003.859 0v-41.627h-3.859v41.627zm7.247-.894c1.51-.329 3.215-1.354 3.957-1.884v-38.849h-3.859l-.098 40.733zm7.539-5.553c1.607-1.555 3.118-5.094 3.665-9.127l.096-26.053h-3.857l.096 35.18z"
});

var _ref419 =
/*#__PURE__*/
React.createElement("path", {
  d: "M129.815 199.338h4.215v41.968l-.161.016a16.593 16.593 0 01-3.896 0l-.158-.018v-41.966zm.356 41.645a15.92 15.92 0 003.503 0v-41.288h-3.503v41.288zm6.991-41.645h4.213v39.122l-.075.051c-.755.539-2.485 1.581-4.019 1.915l-.216.048.097-41.136zm.261 40.689c1.378-.358 2.87-1.245 3.594-1.753v-38.579h-3.501l-.093 40.332zm7.082-40.689h4.215l-.096 26.244v.015c-.557 4.079-2.094 7.657-3.719 9.229l-.299.288-.101-35.776zm.454 34.918c1.47-1.665 2.8-4.967 3.309-8.696l.096-25.865h-3.501l.096 34.561z"
});

var _ref420 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.57 224.206c0 9.511-7.397 17.218-16.607 17.218-9.216 0-16.685-7.707-16.685-17.218V200.18h33.292v24.026zm-.356 0v-23.671h-32.581v23.671c0 9.312 7.308 16.863 16.33 16.863 9.015 0 16.251-7.553 16.251-16.863z"
});

var _ref421 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M115.458 200.381h32.921v-39.843h-32.921z"
});

var _ref422 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2B1100",
  fillRule: "nonzero",
  d: "M121.98 195.702v-5.803h2.867l-.015-5.12-.018-5.121-1.401-.037v-1.513c0-.834.02-1.99.043-2.568l.04-1.052h.316c.176 0 .634-.021 1.018-.042l.703-.045v-2.514h-1.31l.002-.852c0-.468.017-1.141.04-1.501l.039-.649h1.167v.293c0 .316.056.375.372.375.318 0 .376-.059.376-.375v-.293h1.667l.042.295c.043.314.11.373.432.373.262 0 .35-.104.35-.414v-.254h1.184v2.998l-1.34.037-.017 1.25-.017 1.251h1.871v-6.203h-1.247v-3.002h1.252l-.04.334-.044.333h.221c.12 0 .306-.018.411-.042.183-.037.196-.06.196-.332v-.293h1.619v.289c0 .355.082.445.41.445.305 0 .37-.069.43-.451l.044-.283h1.172v3.002h-1.307v6.203h1.559l-.033-2.501-1.214-.037.006-1.216c.002-.67.021-1.366.046-1.549l.039-.333.578-.02.576-.017v.32c0 .381.075.485.349.485.333 0 .393-.057.435-.408l.044-.326h.48c.264 0 .611-.021.771-.042l.289-.043v.819h.366c.409 0 .484-.059.515-.398.025-.262.081-.288.755-.361l.42-.046v3.054l-.289.044c-.16.02-.455.041-.655.041h-.366v2.514l.759.045c.418.023.936.042 1.154.042h.393v1.32c0 .722.019 1.877.041 2.566l.042 1.247-.68.021-.68.016v10.208l1.325.019 1.324.017v5.8H121.98z"
});

var _ref423 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M121.928 195.702v-5.803c0-.028.023-.052.052-.052h2.815l-.033-10.138-1.351-.037c-.028 0-.05-.024-.051-.052v-1.513l.013-1.328c.008-.485.02-.942.031-1.241l.04-1.052c0-.028.024-.05.051-.05h.316l.393-.011.623-.03.654-.042v-2.414h-1.258a.052.052 0 01-.052-.052l.002-.852.012-.805a21 21 0 01.028-.7l.039-.648a.053.053 0 01.052-.049h1.167c.028 0 .052.023.052.052v.293c0 .144.011.228.052.269.041.042.125.053.268.053.145 0 .229-.012.27-.053.042-.041.054-.125.054-.269v-.293c0-.029.023-.052.052-.052h1.667c.028 0 .051.022.053.049l.04.291c.02.145.044.229.094.272.05.043.138.055.287.055.115 0 .19-.021.234-.072.045-.054.064-.147.064-.289v-.254c0-.029.023-.052.052-.052h1.184c.029 0 .053.023.053.052v2.998a.052.052 0 01-.053.052l-1.289.036-.033 2.398h1.768v-6.099h-1.196a.052.052 0 01-.052-.052v-3.002c0-.029.023-.053.052-.053h1.252c.028 0 .052.024.052.053l-.076.615h.161l.204-.011.197-.029c.077-.016.117-.028.132-.054.019-.033.022-.101.022-.228v-.293c0-.029.023-.053.052-.053h1.619c.029 0 .053.024.053.053v.289c0 .164.017.265.067.321.049.053.141.072.29.072.138 0 .22-.015.27-.066.052-.056.081-.161.109-.341l.044-.283a.052.052 0 01.051-.044l1.172-.001c.029 0 .052.024.052.053v3.002a.052.052 0 01-.052.052h-1.255v6.099h1.455l-.032-2.398-1.165-.036a.052.052 0 01-.05-.053l.007-1.215c.001-.345.006-.696.014-.981.008-.272.019-.485.032-.575l.039-.332a.05.05 0 01.049-.045l1.154-.038a.052.052 0 01.054.05v.322c0 .179.016.291.062.355.041.057.116.077.235.077.153 0 .242-.011.291-.057.05-.048.073-.141.092-.304l.044-.327a.053.053 0 01.051-.045h.481a7.889 7.889 0 00.763-.042l.29-.043a.053.053 0 01.059.044v.774h.314c.193 0 .306-.012.368-.06.059-.047.082-.137.096-.289.014-.151.039-.235.163-.294.107-.052.294-.078.638-.115l.419-.045a.052.052 0 01.058.045v3.06c0 .027-.021.05-.048.052a9.25 9.25 0 01-.622.073l-.326.012h-.314v2.414l.71.042.648.029.503.012h.393c.029 0 .052.023.052.052v1.32l.012 1.296.029 1.268.042 1.247a.053.053 0 01-.051.053l-1.308.037v10.106l2.597.034a.053.053 0 01.051.052v5.801a.052.052 0 01-.052.052H121.98a.052.052 0 01-.052-.052zm.104-5.751v5.698h19.773v-5.697c-.797-.01-1.832-.085-2.596-.034a.052.052 0 01-.052-.052v-10.208c0-.028.023-.051.051-.052l1.306-.036-.04-1.195-.029-1.269-.012-1.298v-1.268h-.341l-.507-.012-.649-.03-.755-.045a.052.052 0 01-.054-.052v-2.514c0-.029.023-.052.052-.052h.366l.319-.011.326-.029.247-.038v-2.951l-.362.039c-.33.036-.509.06-.604.106-.078.037-.095.099-.105.209-.017.182-.047.292-.133.36l-.003.002c-.085.065-.215.083-.431.083h-.366a.052.052 0 01-.052-.052v-.759l-.229.034a7.622 7.622 0 01-.779.043h-.435l-.038.281c-.022.187-.052.298-.124.367-.074.069-.183.086-.362.086-.154 0-.255-.032-.319-.122-.06-.084-.082-.214-.082-.415v-.267l-1.056.035-.034.289a6.894 6.894 0 00-.03.564c-.008.285-.014.636-.015.978l-.006 1.166 1.163.036c.028.001.05.023.051.051l.033 2.501a.052.052 0 01-.052.053h-1.559a.052.052 0 01-.052-.053v-6.203c0-.029.023-.052.052-.052h1.255v-2.898h-1.075l-.038.239c-.032.201-.066.322-.137.396-.073.078-.177.099-.344.099-.179 0-.294-.027-.366-.106-.072-.078-.096-.2-.096-.391v-.237h-1.515v.241c0 .145-.004.224-.037.28-.035.062-.093.082-.197.102l-.211.031-.214.014-.227-.001a.053.053 0 01-.045-.058l.076-.609h-1.141v2.898h1.196c.029 0 .052.023.052.052v6.203a.052.052 0 01-.052.053h-1.872a.054.054 0 01-.052-.053l.034-2.5c0-.028.022-.051.05-.052l1.29-.036v-2.896h-1.08v.202c0 .167-.026.281-.089.357-.066.077-.166.109-.313.109-.173 0-.28-.018-.354-.082-.074-.063-.106-.165-.129-.333l-.036-.253h-1.57v.241c0 .172-.018.277-.084.342-.066.066-.172.085-.344.085s-.276-.018-.341-.085c-.066-.066-.084-.17-.084-.342v-.241h-1.065l-.036.599c-.012.179-.021.432-.028.697l-.012.802-.002.8h1.258c.029 0 .052.023.052.052v2.514c-.001.027-.021.051-.049.052l-.703.045-.626.03-.396.012h-.266l-.038 1.002a85.95 85.95 0 00-.043 2.565v1.463l1.351.036a.053.053 0 01.051.052c.012 3.279-.156 7.028.033 10.241a.052.052 0 01-.052.052h-2.815z"
});

var _ref424 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M125.005 179.413v10.677l-2.749.009v5.494l19.324-.031v-5.494l-2.657-.011v-10.644z"
});

var _ref425 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139.031 179.303v10.646l2.657.011v5.711l-19.537.031v-5.711l2.746-.009v-10.679h14.134zm-13.92.218v10.676l-2.746.008v5.28l19.107-.031v-5.276l-2.659-.013v-10.644h-13.702z"
});

var _ref426 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M122.256 195.593l19.115-.031-19.115.031zm-.006-1.355l19.312-.019-19.312.019zm.006-1.347l19.306.016-19.306-.016zm-.006-1.318l19.312-.017-19.312.017zm.011-1.472l19.322-.044-19.322.044zm2.79-1.461l13.879-.007-13.879.007zm-.046-1.387h13.918-13.918zm0-1.181h13.918-13.918zm0-1.333h13.918-13.918zm0-1.33h13.918-13.918z"
});

var _ref427 =
/*#__PURE__*/
React.createElement("path", {
  d: "M122.256 195.664v-.143l19.115-.031v.143l-19.115.031zm-.006-1.353v-.146l19.312-.016v.143l-19.312.019zm.006-1.347v-.146l19.306.019v.146l-19.306-.019zm-.006-1.316v-.146l19.312-.018v.143l-19.312.021zm.011-1.476v-.144l19.319-.043.003.145-19.322.042zm2.79-1.46v-.145l13.879-.006v.143l-13.879.008zm-.046-1.388v-.144h13.918v.144h-13.918zm0-1.179v-.146h13.918v.146h-13.918zm0-1.333v-.145h13.918v.145h-13.918zm0-1.33v-.146h13.918v.146h-13.918zM125.005 182.149v-.146h13.918v.146z"
});

var _ref428 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M136.048 180.777v1.26-1.26zm-11.043-.031h13.918-13.918z"
});

var _ref429 =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.123 180.816v1.221h-.145v-1.221h-10.973v-.145h13.918v.145zM125.076 195.562h-.144v-1.332h.144z"
});

var _ref430 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M125.005 192.897v-1.33 1.33zm-1.225 0v1.333-1.333z"
});

var _ref431 =
/*#__PURE__*/
React.createElement("path", {
  d: "M125.076 192.897h-.144v-1.33h.144v1.33zm-1.368 0h.145v1.333h-.145v-1.333zM126.448 194.23h-.144v-1.333h.144z"
});

var _ref432 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M127.816 190.068v-1.424 1.424zm.021-2.823l-.021-1.173.021 1.173zm-1.462 4.322v-1.499 1.499z"
});

var _ref433 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.888 190.068h-.145v-1.424h.145v1.424zm.021-2.823l-.143.001-.023-1.174.145-.002.021 1.175zm-1.461 4.322h-.144v-1.499h.144v1.499zM123.853 191.567h-.145v-1.499h.145z"
});

var _ref434 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M126.375 187.253v1.332-1.332zm2.771 0v1.332-1.332zm2.736.027l.013 1.368-.013-1.368zm-1.393.008v-1.216 1.216zm1.41-2.549v1.333-1.333zm-1.373-3.993v1.33-1.33zm1.379-1.333v1.333-1.333zm-2.759 0v1.333-1.333zm-2.615 0v1.333-1.333zm12.392 16.149v-1.332 1.332zm0-2.665v-1.33 1.33zm1.223 0v1.333-1.333zm-2.757 1.333v-1.333 1.333zm-1.326-4.162l-.008-1.443.008 1.443zm-.008-2.805v-1.191 1.191z"
});

var _ref435 =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.304 187.253h.144v1.332h-.144v-1.332zm2.77 0h.147v1.332h-.147v-1.332zm2.735.027l.146-.002.01 1.37-.143.002-.013-1.37zm-1.249.008h-.146v-1.216h.146v1.216zm1.266-2.549h.143v1.333h-.143v-1.333zm-1.372-3.993h.143v1.33h-.143v-1.33zm1.378-1.333h.143v1.333h-.143v-1.333zm-2.758 0h.147v1.333h-.147v-1.333zm-2.614 0h.144v1.333h-.144v-1.333zm12.534 16.149h-.145v-1.332h.145v1.332zm0-2.665h-.145v-1.33h.145v1.33zm1.079 0h.144v1.333h-.144v-1.333zm-2.613 1.333h-.146v-1.333h.146v1.333zm-1.326-4.162h-.144l-.008-1.441.145-.002.007 1.443zm-.007-2.805h-.145v-1.191h.145v1.191zM137.314 190.068h.146v1.499h-.146v-1.499zm2.759 0h.144v1.499h-.144v-1.499zM137.316 187.249l.146-.003.015 1.394-.144.004z"
});

var _ref436 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M134.632 187.249v1.391-1.391zm-1.32.016v-1.193 1.193zm0-3.846v1.331-1.331z"
});

var _ref437 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.56 187.249h.143v1.391h-.143v-1.391zm-1.173.016h-.145v-1.193h.145v1.193zm-.145-3.846h.145v1.331h-.145v-1.331zM131.795 182.076h.143v1.333h-.143z"
});

var _ref438 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M133.312 180.746v1.33-1.33zm1.32-1.271v1.244-1.244zm2.757-.004v1.25-1.25zm-6.9 5.268v-1.33 1.33z"
});

var _ref439 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.242 180.746h.145v1.33h-.145v-1.33zm1.318-1.271h.143v1.244h-.143v-1.244zm2.754-.004h.146v1.25h-.146v-1.25zm-6.754 5.268h-.146v-1.33h.146v1.33z"
});

var _ref440 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M134.649 195.564v-3.602c0-.686-.268-2.745-2.825-2.745-2.426 0-2.696 2.059-2.696 2.745v3.602h5.521z"
});

var _ref441 =
/*#__PURE__*/
React.createElement("path", {
  d: "M129.057 195.637v-3.675c0-.493.137-1.674 1.073-2.339.401-.287.946-.476 1.694-.476 1.048 0 1.721.339 2.152.79.646.675.748 1.603.748 2.025v3.675h-5.667zm5.521-.143v-3.532c0-.402-.093-1.283-.706-1.927-.41-.429-1.05-.745-2.048-.745-.711 0-1.231.179-1.611.449-.886.632-1.013 1.755-1.013 2.223v3.532h5.378z"
});

var _ref442 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M133.346 192.907l2.692.017-.004-1.372-.915-1.492-1.863 1.436c.192.505.09 1.079.09 1.411zm-.688-2.124l.598-2.129-2.769-.019.64 2.106a3.211 3.211 0 011.531.042zm2.045-4.709v-3.141c0-.857.487-1.572 1.339-1.572.853 0 1.339.715 1.339 1.572v3.141h-2.678z"
});

var _ref443 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.346 192.983s-.073-.092-.073-.076c0-.324.104-.889-.085-1.384l-.021-.052 1.971-1.515.968 1.573.003 1.466-2.763-.012zm0 0s-.073-.009-.073-.076l.073.076zm.073-.146l2.546.014-.002-1.28-.863-1.406-1.76 1.356c.162.468.091.981.079 1.316zm-.761-1.983s-.073-.09-.073-.071c0 .064.073.071.073.071v.004l-.019-.007a3.121 3.121 0 00-1.497-.037l-.066.012-.686-2.264 2.96.021-.622 2.218-.07.053zm-.05-.161l.553-1.968-2.578-.017.592 1.95a3.27 3.27 0 011.433.035zm2.023-7.76c0-.9.515-1.645 1.411-1.645.894 0 1.41.745 1.41 1.645v3.214h-2.821v-3.214zm.143 3.068h2.534v-3.068c0-.815-.457-1.499-1.266-1.499-.811 0-1.268.684-1.268 1.499v3.068z"
});

var _ref444 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M130.494 194.24v1.298c0 .006-.005.012-.011.012h-2.655a.013.013 0 01-.012-.012v-1.298c0-.006.006-.01.012-.01h2.655c.006 0 .011.004.011.01z"
});

var _ref445 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.566 194.24v1.298a.082.082 0 01-.083.083h-2.655a.081.081 0 01-.083-.083v-1.298a.08.08 0 01.083-.081h2.655c.046 0 .083.035.083.081zm-2.675.062v1.173h2.531v-1.173h-2.531z"
});

var _ref446 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M133.369 194.236h2.692v1.318h-2.692v-1.318zm-2.882-1.355l-2.671.026.025-1.355.792-1.437 1.9 1.36c-.117.555-.035.524-.046 1.406z"
});

var _ref447 =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.131 194.163v1.462h-2.835v-1.462h2.835zm-2.692.144v1.174h2.547v-1.174h-2.547zm-5.696-1.324l.027-1.449.838-1.527 2.004 1.439-.008.046c-.113.546-.034.517-.044 1.391l-.002.07-2.815.03zm2.671-.175c.008-.792-.06-.803.04-1.302l-1.797-1.284-.746 1.349-.02 1.264 2.523-.027zM127.722 180.779h.144v1.258h-.144z"
});

var _ref448 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M126.379 186.078v-3.164c0-.863.507-1.584 1.393-1.584.888 0 1.393.721 1.393 1.584v3.164h-2.786z"
});

var _ref449 =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.306 182.914c0-.904.537-1.655 1.466-1.655.929 0 1.466.751 1.466 1.655v3.237h-2.932v-3.237zm.146 3.092h2.642v-3.092c0-.823-.48-1.511-1.322-1.511-.844 0-1.32.688-1.32 1.511v3.092z"
});

var _ref450 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M125.751 171.738h2.763v7.829h-2.763v-7.829zm4.784-3.56h2.75v11.385h-2.75v-11.385zm4.582 3.56h2.763v7.829h-2.763v-7.829z"
});

var _ref451 =
/*#__PURE__*/
React.createElement("path", {
  d: "M128.622 171.629v8.046h-2.979v-8.046h2.979zm-2.763.219v7.613h2.545v-7.613h-2.545zm7.535-3.78v11.601h-2.967v-11.601h2.967zm-2.751.218v11.169h2.536v-11.169h-2.536zm7.345 3.343v8.046h-2.981v-8.046h2.981zm-2.763.219v7.613h2.545v-7.613h-2.545z"
});

var _ref452 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M130.579 175.147l2.725.004-2.725-.004zm-.03 1.123l2.726.008-2.726-.008zm4.574-3.801h2.728-2.728zm-.012 1.478h2.729-2.729zm0 1.152h2.729-2.729zm.043 1.241h2.73-2.73zm1.343-3.896v-.719.719zm.011 2.609v-1.085 1.085zm-.031 2.393v-1.085 1.085zm-10.732-2.293h2.73-2.73zm.044 1.239h2.731-2.731z"
});

var _ref453 =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.427 172.397v-.672h.143v.672h1.281v.145h-2.728v-.145h1.304zm.153 1.621v1.008h1.26v.144h-2.729v-.144h1.326v-1.008h-1.326v-.143h2.729v.143h-1.26zm-.033 2.393v1.035h-.143v-1.035h-1.25v-.146h2.73v.146h-1.337zm-5.968-1.193v-.144l2.725.005-.002.145-2.723-.006zm-.03 1.126v-.145l2.726.004v.146l-2.726-.005zm-4.804-1.12v-.143h2.73v.143h-2.73zm.044 1.239v-.144h2.731v.144h-2.731z"
});

var _ref454 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M123.668 179.579v-4.952l2.075-.012.617.438.027 2.4 1.749.004-.013-2.476.533-.385h1.788l.613.493-.004 2.376 1.808.008.027-2.353.462-.513h1.781l.539.478.071 2.303 1.652.009-.029-2.277.57-.524 2.28.011v4.937z"
});

var _ref455 =
/*#__PURE__*/
React.createElement("path", {
  d: "M123.56 174.521l2.216-.012.692.488.025 2.347 1.535.005-.015-2.422.607-.437 1.863-.002.682.549-.004 2.32 1.594.006.025-2.284.522-.581 1.869-.002.605.537.071 2.247 1.436.009-.027-2.215.636-.586 2.433.008v5.156l-16.765.035v-5.166zm.216 4.948l16.333-.035v-4.722l-2.134-.006-.503.46.031 2.339-1.866-.011-.073-2.361-.474-.421-1.69.003-.404.446-.027 2.42-2.026-.01.003-2.428-.54-.441-1.717.004-.458.329.013 2.53-1.965-.004-.027-2.451-.542-.387-1.934.012v4.734z"
});

var _ref456 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M123.651 178.147h16.539-16.539zm1.352.004v1.428-1.428zm2.794-.017v1.431-1.431z"
});

var _ref457 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.868 178.218v1.347h-.144v-1.347h-2.651v1.361h-.143v-1.361h-1.279v-.144h16.539v.144z"
});

var _ref458 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.489 178.151h.144v1.431h-.144z"
});

var _ref459 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M133.315 178.145v1.426-1.426zm2.742.006v1.431-1.431zm2.866-.004v1.43-1.43zm-12.546-1.397v1.428-1.428zm-.035-1.358h-2.666 2.666zm.016 1.454h-2.665 2.665zm4.678-1.462h-2.898 2.898zm4.64-.004l-2.813-.013 2.813.013zm4.541-.013h-2.855 2.855zm-9.189 1.479l-2.909-.013 2.909.013zm4.684 0h-2.845 2.845zm4.486-.005l-2.825-.012 2.825.012zm-15.201-1.421v1.427-1.427zm4.151 1.417l.006 1.325-.006-1.325zm1.412-1.453l.002 1.443-.002-1.443zm2.755.008l.001 1.441-.001-1.441zm5.611-.048l.002 1.491-.002-1.491zm-9.79-.729l.002.792-.002-.792z"
});

var _ref460 =
/*#__PURE__*/
React.createElement("path", {
  d: "M125.069 175.465v1.306h1.235v-.021h.144v1.428h-.144v-1.262h-2.611v-.145h1.233v-1.306h-1.25v-.143h2.666v.143h-1.273zm8.318-.023l.004 1.329h2.321v.145h-2.845v-.145h.377l-.002-1.329-.379-.002v-.145l2.815.012-.002.144-2.289-.009zm5.609-.002l.004 1.322 1.198.005v.145l-2.825-.012v-.144l1.484.006-.006-1.322h-1.489v-.145h2.855v.145h-1.221zm-8.505 1.328l-.002-1.313h-2.351v-.144h.927l-.002-.696.144-.002.002.698h1.827v.144h-.403l.002 1.313.395.003-.002.145-1.807-.006.006 1.252-.145.001-.007-1.253-.956-.006v-.143l2.372.007zm2.751 1.377h.145v1.426h-.145v-1.426zm2.74.006h.145v1.431h-.145v-1.431zm2.867-.004h.145v1.43h-.145v-1.43zM131.832 177.465h.143v.684h-.143z"
});

var _ref461 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M134.632 176.841l.007 1.283-.007-1.283zm-.012-2.266l.004.79-.004-.79z"
});

var _ref462 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.562 176.841h.143l.005 1.281-.144.002-.004-1.283zm-.015-2.266h.146l.002.79h-.146l-.002-.79zM137.316 176.829h.146l.006 1.316h-.143z"
});

var _ref463 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M133.356 195.567v-3.002c0-.502.102-2.011-1.522-1.88-1.648-.098-1.351 1.378-1.351 1.88v3.002h2.873z"
});

var _ref464 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.377 195.677v-3.112c0-.215-.054-.603.008-.976.046-.268.148-.526.36-.715.218-.197.561-.326 1.087-.295.522-.044.876.079 1.117.276.228.188.359.446.43.714.102.38.083.779.083.996v3.112h-3.085zm2.871-.218v-2.894c0-.171.013-.464-.04-.765-.05-.283-.155-.578-.396-.778-.211-.168-.518-.264-.967-.229h-.015c-.455-.027-.753.071-.942.242-.216.195-.289.486-.309.762-.023.302.012.595.012.768v2.894h2.657z"
});

var _ref465 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M136.791 185.546v-2.36c0-.619-.246-1.239-.74-1.239-.496 0-.743.62-.743 1.239v2.36h1.483zm-8.279-.027v-2.357c0-.62-.25-1.242-.74-1.242-.495 0-.744.622-.744 1.242v2.357h1.484z"
});

var _ref466 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.235 185.617v-2.431c0-.388.096-.775.283-1.025.133-.178.31-.286.533-.286.218 0 .399.11.532.286.183.25.278.637.278 1.025v2.431h-1.626zm1.483-.144v-2.287c0-.355-.084-.71-.252-.937-.106-.142-.243-.231-.415-.231a.508.508 0 00-.418.231c-.171.227-.252.582-.252.937v2.287h1.337zm-9.761.119v-2.43c0-.387.096-.776.283-1.028a.649.649 0 01.532-.284c.218 0 .399.108.532.284.183.252.279.641.279 1.028v2.43h-1.626zm1.482-.144v-2.286c0-.354-.083-.711-.253-.94-.104-.14-.241-.229-.414-.229a.51.51 0 00-.418.229c-.17.229-.253.586-.253.94v2.286h1.338z"
});

var _ref467 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M130.533 173.991l2.725.006-2.725-.006zm0-1.449l2.725.006-2.725-.006zm0-1.227l2.725.005-2.725-.005zm0-1.293l2.725.007-2.725-.007zm0-1.135l2.783.005-2.783-.005zm1.37 1.138v-1.148 1.148z"
});

var _ref468 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.83 169.954v-.992l-1.297-.002.002-.146 2.781.007v.143l-1.341-.002v.992l1.283.002v.143l-2.725-.004.002-.143 1.295.002zm-1.297 4.11l.002-.143 2.723.004v.143l-2.725-.004zm0-1.449l.002-.146 2.723.007v.143l-2.725-.004zm0-1.229l.002-.143 2.723.006v.143l-2.725-.006z"
});

var _ref469 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.975 172.494h-.145v-1.15h.145z"
});

var _ref470 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M131.903 175.153v-1.149 1.149zm0 2.277v-1.15 1.15zm-6.146-4.907h2.73-2.73zm-.012 1.477h2.73-2.73zm1.387-1.504v-.754.754zm.01 2.611v-1.085 1.085z"
});

var _ref471 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.061 172.451v-.709h.144v.709h1.282v.143h-2.73v-.143h1.304zm.154 1.619v1.037h-.144v-1.037h-1.326v-.143h2.73v.143h-1.26zm4.76 1.083h-.145v-1.149h.145v1.149zm0 2.277h-.145v-1.15h.145v1.15zM127.182 177.498h-.144v-1.083h.144z"
});

var _ref472 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M129.304 165.328l-.023 2.857 5.339-.023-.019-2.817-.923.018-.046.699-.989-.019v-.686h-1.383v.686h-1.02l.02-.715z"
});

var _ref473 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.373 165.22l-.023.715h.805v-.686h1.594v.688l.784.017.043-.695 1.134-.025.018 3.036-5.555.023.023-3.073h1.177zm-.961.216l-.022 2.64 5.122-.022-.017-2.601-.717.018-.044.703-1.201-.027v-.684h-1.165v.686h-1.241l.021-.713h-.736z"
});

var _ref474 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DEAD00",
  fillRule: "nonzero",
  d: "M129.306 166.979l5.333.006-5.333-.006zm2.599 1.187v-1.15 1.15z"
});

var _ref475 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.975 167.054v1.112h-.145v-1.112l-2.524-.002v-.144l5.333.004v.144z"
});

var _ref476 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M124.495 168.975l-.022 2.856 5.338-.023-.018-2.817-.923.019-.046.698-.99-.018v-.686h-1.382v.686h-1.021l.021-.715z"
});

var _ref477 =
/*#__PURE__*/
React.createElement("path", {
  d: "M125.564 168.867l-.023.715h.805v-.686h1.594v.688l.784.016.044-.694 1.133-.025.018 3.035-5.554.023.022-3.072h1.177zm-.96.216l-.023 2.64 5.122-.023-.016-2.601-.717.019-.044.703-1.202-.027v-.684h-1.164v.686h-1.241l.02-.713h-.735z"
});

var _ref478 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DEAD00",
  fillRule: "nonzero",
  d: "M124.498 170.625l5.332.007-5.332-.007zm2.599 1.187v-1.149 1.149z"
});

var _ref479 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.167 170.7v1.112h-.146V170.7l-2.523-.002v-.143l5.332.004v.143z"
});

var _ref480 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M133.926 168.939l-.023 2.857 5.339-.023-.019-2.817-.923.019-.046.698-.989-.019v-.686h-1.383v.686h-1.021l.021-.715z"
});

var _ref481 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.994 168.831l-.022.715h.804v-.686h1.594v.688l.784.017.044-.694 1.133-.025.019 3.035-5.555.023.023-3.073h1.176zm-.96.216l-.023 2.641 5.123-.023-.017-2.601-.717.019-.044.702-1.202-.027v-.684h-1.164v.686h-1.241l.021-.713h-.736z"
});

var _ref482 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DEAD00",
  fillRule: "nonzero",
  d: "M133.928 170.59l5.332.006-5.332-.006zm2.598 1.187v-1.15 1.15z"
});

var _ref483 =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.597 170.665v1.112h-.145v-1.112l-2.524-.002v-.144l5.332.005v.143z"
});

var _ref484 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.282 160.359h33.275v40.199h-33.275v-40.199zm.353 39.844h32.567v-39.486h-32.567v39.486zM168.553 213.595l-.799-1.233 2.194-2.698 1.32.597-2.715 3.334zm2.468-3.276l-1.03-.464-2.047 2.518.623.962 2.454-3.016zm1.844 1.871l-2.194 2.698-1.318-.6 2.713-3.335.799 1.237zm-.815-.977l-2.449 3.018 1.025.468 2.047-2.522-.623-.964z"
});

var _ref485 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B60028",
  fillRule: "nonzero",
  d: "M181.415 200.359v23.847c0 9.412-7.401 17.04-16.517 17.04-9.114 0-16.505-7.628-16.505-17.04v-23.847h33.022z"
});

var _ref486 =
/*#__PURE__*/
React.createElement("path", {
  d: "M181.592 224.206c0 9.511-7.48 17.218-16.694 17.218-9.212 0-16.684-7.707-16.684-17.218V200.18h33.378v24.026zm-.355-23.671H148.57v23.671c0 9.312 7.309 16.863 16.328 16.863 9.021 0 16.339-7.551 16.339-16.863v-23.671z"
});

var _ref487 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M153.208 202.782c-1.056 0-1.906.888-1.906 1.98 0 .867.536 1.613 1.284 1.879v3.083l-1.216.376v3.408l1.196.378v-1.104h.02v-1.981h1.175v-4.135c.05-.014.137-.031.183-.048l3.75 4.585-.692 1.128 2.139 2.58 1.173-.551 2.965 3.634c-.048.098-.079.196-.113.302h-1.931l-.347-1.277h-3.287l-.368 1.277h-2.254c-.181-.607-.634-1.102-1.218-1.304v-4.21h-1.175v1.104h-.02l.02 3.106a1.965 1.965 0 00-1.309 1.454c0 .008.002.018 0 .025-.019.12-.044.247-.044.376 0 .883.559 1.627 1.333 1.879v2.006l-1.221.449.185 3.41 1.218.301c.165.946.433 1.844.784 2.707l-.093.125a2.014 2.014 0 00.206 2.781 1.863 1.863 0 001.819.377 12.765 12.765 0 001.769 1.779l-.275 1.329a13.195 13.195 0 002.874 1.628l.918-.953c.77.281 1.564.483 2.368.603.19.884.948 1.551 1.863 1.551.919 0 1.68-.659 1.863-1.551a12.603 12.603 0 002.23-.576l-.024-.027c.322-.118.634-.23.946-.374l-.578-1.106c.588-.27 1.151-.582 1.679-.95l.576 1.077c-.534.362-1.093.703-1.677.979-.308.142-.606.283-.922.401l.897.926a13.235 13.235 0 002.873-1.628l-.254-1.329a12.786 12.786 0 001.749-1.779 1.857 1.857 0 001.816-.377c.803-.709.915-1.956.229-2.781l-.112-.125c.349-.863.617-1.761.78-2.707l1.22-.301.183-3.41-1.218-.449v-2.006a1.961 1.961 0 001.334-1.879c0-.129-.022-.256-.048-.376-.002-.007 0-.017 0-.025a1.953 1.953 0 00-1.309-1.454l.023-3.106 1.218-.378V210.1l-1.218-.376v-3.083a1.956 1.956 0 001.334-1.879c0-1.092-.854-1.98-1.91-1.98-.851 0-1.568.583-1.815 1.379h-3.243v1.229h-1.932v-1.229h-2.941c-.252-.796-.967-1.379-1.818-1.379-.85 0-1.567.583-1.814 1.379h-2.899v1.229h-1.931v-1.229h-3.241c-.249-.796-.964-1.379-1.819-1.379z"
});

var _ref488 =
/*#__PURE__*/
React.createElement("path", {
  d: "M151.202 218.462v-.031c.15-.707.661-1.26 1.309-1.495l-.02-2.975h.02v-.015l-1.218-.38v-3.524l1.218-.374v-2.973c-.752-.291-1.286-1.054-1.286-1.933 0-1.088.815-1.98 1.848-2.052l-.004-.006h.139c.869 0 1.601.582 1.873 1.38h3.262v1.227h1.777v-1.227h2.919c.275-.798 1.007-1.38 1.873-1.38.865 0 1.597.582 1.872 1.38h2.964v1.227h1.778v-1.227h3.263c.275-.798 1.009-1.38 1.872-1.38 1.097 0 1.985.923 1.985 2.058 0 .902-.555 1.657-1.333 1.935v2.971l1.219.374v3.524l-1.219.374-.022 2.996a2.047 2.047 0 011.309 1.495v.002a.048.048 0 010 .029c.025.125.046.252.046.385 0 .896-.557 1.657-1.333 1.933v1.898l1.223.451-.191 3.524-1.225.302c-.162.916-.42 1.787-.761 2.625l.086.092v.002c.709.858.596 2.151-.237 2.89a1.936 1.936 0 01-1.84.405 13.262 13.262 0 01-1.693 1.724l.256 1.33-.041.027a13.4 13.4 0 01-2.89 1.641l-.05.018-.896-.929c-.684.249-1.412.43-2.146.555-.21.9-.989 1.563-1.927 1.563-.935 0-1.711-.667-1.927-1.563a12.265 12.265 0 01-2.283-.578l-.921.952-.047-.018a13.437 13.437 0 01-2.892-1.641l-.04-.027.277-1.333c-.62-.517-1.2-1.095-1.711-1.721a1.935 1.935 0 01-1.842-.405 2.092 2.092 0 01-.216-2.888l.064-.087a13.258 13.258 0 01-.761-2.634l-1.225-.302-.191-3.524 1.221-.451v-1.898c-.776-.276-1.333-1.037-1.333-1.933 0-.133.025-.26.048-.385zm17.762 18.187l-.023-.023.082-.031c.295-.111.582-.214.864-.339l-.573-1.106.072-.033a10.958 10.958 0 001.666-.946l.072-.048.649 1.214-.058.039c-.514.35-1.052.68-1.616.95l-.074.034a13.573 13.573 0 01-.815.361l.78.807a13.13 13.13 0 002.769-1.572l-.252-1.326.035-.029a13.016 13.016 0 001.738-1.767l.034-.042.05.015a1.78 1.78 0 001.742-.36c.771-.682.877-1.877.22-2.673l-.146-.16.019-.044c.349-.858.616-1.75.778-2.692l.008-.048 1.214-.3.177-3.295-1.218-.449v-2.116l.054-.017a1.886 1.886 0 001.28-1.806c0-.123-.018-.246-.043-.36v-.002c-.002-.008-.002-.023-.002-.029a1.89 1.89 0 00-1.258-1.391l-.052-.019.023-3.218 1.218-.376v-3.295l-1.22-.374v-3.196l.054-.019c.746-.243 1.28-.952 1.28-1.806 0-1.048-.817-1.902-1.831-1.902-.815 0-1.503.561-1.742 1.324l-.017.054h-3.222v1.226h-2.084v-1.226h-2.923l-.018-.054c-.239-.763-.925-1.324-1.743-1.324-.816 0-1.503.561-1.742 1.324l-.018.054h-2.875v1.226h-2.088v-1.226h-3.22l-.019-.054c-.237-.763-.921-1.324-1.742-1.324-1.012 0-1.831.854-1.831 1.902 0 .831.517 1.553 1.237 1.806l.051.019v3.196l-1.22.374v3.297l1.042.324v-.919h.024v-2.133h1.173v-4.116l.054-.017c.048-.016.131-.029.177-.05l.054-.018 3.817 4.671-.688 1.129 2.064 2.493 1.175-.553 3.035 3.721-.025.044c-.048.095-.077.189-.108.289l-.019.054h-2.045l-.346-1.279h-3.17l-.37 1.279h-2.368l-.014-.054c-.175-.587-.607-1.061-1.171-1.254l-.052-.019v-4.187h-1.019v1.102h-.022l.022 3.085-.054.019a1.897 1.897 0 00-1.258 1.391l-.001.029c-.019.114-.044.237-.044.362 0 .848.538 1.563 1.281 1.806l.054.017v2.116l-1.217.449.179 3.295 1.21.3.011.048c.162.942.428 1.834.777 2.692l.015.04-.119.162a1.936 1.936 0 00.198 2.675 1.776 1.776 0 001.742.36l.05-.015.033.042a13.047 13.047 0 001.758 1.767l.036.031-.274 1.324c.858.624 1.779 1.169 2.769 1.572l.921-.952.045.019a12.2 12.2 0 002.354.596l.052.009.012.049c.181.853.907 1.495 1.786 1.495.884 0 1.609-.638 1.788-1.492l.011-.052.051-.009c.73-.12 1.452-.297 2.133-.542zm-17.762-18.191zm18.827 17.731c.536-.257 1.05-.572 1.543-.9l-.502-.941c-.49.332-1.008.621-1.547.877l.506.964zm-17.364-23.483l1.096-.003h.077v4.235a2.037 2.037 0 011.197 1.281h2.14l.368-1.279h3.405l.345 1.279h1.815c.025-.075.048-.146.081-.214l-2.896-3.549-1.175.551-2.209-2.67.69-1.128-3.682-4.503c-.023.008-.052.014-.079.02v4.152h-1.173v1.828z"
});

var _ref489 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M157.553 202.882l-.343 1.254h4l-.343-1.254h-3.314zm11.476 0l-.37 1.254h4.004l-.347-1.254h-3.287zm-15.821 1.028c.453 0 .83.386.83.852a.847.847 0 01-.83.852c-.449 0-.827-.385-.827-.852 0-.466.378-.852.827-.852z"
});

var _ref490 =
/*#__PURE__*/
React.createElement("path", {
  d: "M153.208 203.832c.493 0 .905.423.905.93 0 .509-.41.929-.905.929-.493 0-.904-.42-.904-.929 0-.507.411-.93.904-.93zm0 .157s-.075-.096-.075-.079c0 .07.075.079.075.079-.41 0-.748.349-.748.773 0 .426.338.775.748.775a.77.77 0 00.753-.775.769.769 0 00-.753-.773zm7.715-1.183l.389 1.405h-4.204l.389-1.405h3.426zm-3.31.153l-.303 1.1h3.8l-.303-1.1h-3.194zm14.761-.153l.389 1.405h-4.206l.414-1.405h3.403zm-3.289.153l-.322 1.1h3.796l-.301-1.1h-3.173z"
});

var _ref491 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M155.048 205.39h2.162l.343 1.276h3.314l.343-1.276h1.888a1.926 1.926 0 001.241 1.276v1.455l-1.221.375v3.409l1.221.374v4.74c-.067.023-.143.067-.208.1l-2.921-3.559.713-1.104-2.16-2.605-1.152.549-3.769-4.561c.087-.139.158-.289.206-.449z"
});

var _ref492 =
/*#__PURE__*/
React.createElement("path", {
  d: "M157.268 205.311l.345 1.278h3.194l.345-1.278h2l.018.054a1.858 1.858 0 001.191 1.228l.053.017v1.565l-1.217.379v3.295l1.217.376v4.844l-.048.021c-.062.023-.137.064-.2.095l-.056.032-2.996-3.653.716-1.102-2.09-2.517-1.148.55-3.846-4.648.029-.048c.086-.135.152-.278.2-.434l.017-.054h2.276zm-2.164.153c-.044.129-.1.254-.168.369l3.698 4.471 1.148-.549 2.236 2.697-.712 1.102 2.844 3.467c.035-.02.072-.037.112-.056v-4.628l-1.22-.376v-3.522l1.22-.376v-1.341a2.013 2.013 0 01-1.223-1.258h-1.769l-.347 1.279h-3.426l-.347-1.279h-2.046z"
});

var _ref493 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M166.707 205.39h1.952l.37 1.276h3.287l.347-1.276h2.183c.025.085.077.145.114.224l-3.817 4.686-1.172-.526-2.117 2.605.716 1.106.687-.827 1.219-1.53.921.802-1.911 2.355 1.152.527 2.137-2.608-.711-1.101 3.724-4.587c.085.046.162.094.253.125v3.083l-1.241.376v3.408l1.241.378v3.133c-.584.2-1.037.67-1.22 1.277h-2.183l-.368-1.277h-3.289l-.343 1.277h-1.84c-.05-.173-.093-.331-.185-.476l2.873-3.535.668-.852-.897-.775-3.54 4.384c-.052-.016-.154-.033-.208-.05v-5.814h-1.17v-1.98h1.195v3.081l1.216-.374v-3.409l-1.216-.375v-1.48c.564-.2.984-.665 1.173-1.251z"
});

var _ref494 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.707 205.311h2.01l.368 1.278h3.17l.348-1.278h2.301l.015.056c.024.085.074.139.112.216l.019.042-3.884 4.771-1.175-.528-2.041 2.519.626.967.623-.746 1.269-1.591 1.035.905-1.892 2.334 1.004.462 2.064-2.518-.711-1.101 3.801-4.68.056.031c.081.044.154.089.241.118l.052.019v3.196l-1.241.374v3.295l1.241.376v3.243l-.052.019a1.844 1.844 0 00-1.168 1.229l-.019.054h-2.299l-.368-1.279h-3.171l-.345 1.279h-1.956l-.017-.054c-.047-.167-.087-.318-.174-.458l-.029-.048 2.846-3.5.062-.075.62-.795-.78-.677-3.524 4.365-.05-.014c-.054-.019-.154-.033-.208-.052l-.052-.014v-5.797h-1.172v-2.132h1.347v3.053l1.067-.326v-3.295l-1.221-.379v-1.588l.052-.019c.543-.191.946-.638 1.127-1.203l.073-.231v.177zm3.451 8.024l1.131-1.397-.803-.7-1.12 1.407.792.69zm-1.676.158l-.724-1.118 2.19-2.696 1.172.528 3.749-4.603c-.025-.046-.054-.087-.077-.14h-2.073l-.343 1.279h-3.405l-.368-1.279h-1.84c-.198.57-.609 1.023-1.154 1.231v1.368l1.22.376v3.522l-1.243.383v4.588c.033.008.069.015.102.025l2.794-3.464zm-3.027-2.393v-1.825h-1.041v1.825h1.041zm1.252-5.636c-.002 0-.077-.095-.077-.074 0 .068.077.074.077.074zm2.802 8.915l-2.802 3.447c.068.125.108.251.147.393h1.724l.345-1.279h3.403l.37 1.279h2.071a1.995 1.995 0 011.197-1.256v-3.023l-1.243-.374v-3.524l1.243-.376v-2.971c-.054-.023-.106-.052-.158-.079l-3.648 4.491.713 1.104-2.212 2.694-1.15-.526z"
});

var _ref495 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M153.784 209.724v4.162l1.218-.378V210.1z"
});

var _ref496 =
/*#__PURE__*/
React.createElement("path", {
  d: "M155.079 210.042v3.524l-1.372.424v-4.37l1.372.422zm-1.218-.214v3.954l1.066-.33v-3.295l-1.066-.329z"
});

var _ref497 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M176.041 210.801h1.196v1.981h-1.196v-1.981zm-16.762.426l1.241 1.505-.894.801-1.266-1.528.919-.778z"
});

var _ref498 =
/*#__PURE__*/
React.createElement("path", {
  d: "M177.313 210.726v2.133h-1.349v-2.133h1.349zm-1.195.152v1.825h1.04v-1.825h-1.04zm-15.49 1.861l-1.013.904-1.364-1.646 1.036-.878 1.341 1.62zm-1.358-1.402l-.802.678 1.164 1.408.782-.699-1.144-1.387z"
});

var _ref499 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M153.164 218.022c.312 0 .574.176.712.424.001.008-.003.018 0 .025a.986.986 0 01.093.376c0 .467-.351.852-.805.852a.846.846 0 01-.829-.852c0-.129.042-.243.093-.352.003-.006-.004-.018 0-.024a.841.841 0 01.736-.449zm23.497 0c.322 0 .578.201.713.473h.025c.041.113.068.231.068.352 0 .467-.351.852-.806.852-.452 0-.826-.385-.826-.852 0-.14.034-.262.09-.376a.84.84 0 01.736-.449z"
});

var _ref500 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.352 218.475c0-.013.002-.032.008-.04a.924.924 0 01.804-.492c.341 0 .63.193.78.465v.004l.002.006a.094.094 0 01.004.036.999.999 0 01.094.393c0 .513-.383.929-.88.929-.495 0-.904-.418-.904-.929 0-.138.039-.256.092-.372zm1.449-.007a.743.743 0 00-.637-.372.766.766 0 00-.661.397c-.002.013-.002.027-.006.036v.002a.705.705 0 00-.085.316c0 .426.339.775.752.775.412 0 .728-.351.728-.775a.92.92 0 00-.087-.347.14.14 0 01-.004-.032zm23.631.011a.365.365 0 01-.033.093l.071-.104c.045.123.074.25.074.379 0 .513-.386.929-.883.929-.491 0-.905-.418-.905-.929 0-.15.038-.287.1-.412a.927.927 0 01.805-.492c.351 0 .632.22.781.519l-.01.017zm-.089.093h-.017l-.021-.041c-.122-.25-.353-.435-.644-.435a.767.767 0 00-.668.41.768.768 0 00.668 1.116c.414 0 .727-.351.727-.775a.9.9 0 00-.045-.275z"
});

var _ref501 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M158.175 218.296h2.002v1.176h3.01c.042.127.079.248.137.352l-2.804 3.382-1.173-.549-2.137 2.605.711 1.104-2.32 2.807a2.035 2.035 0 00-1.035-.127 11.108 11.108 0 01-.622-2.231 11.757 11.757 0 01-.137-1.025h-1.196a13.12 13.12 0 01-.045-1.103v-.905l1.218.027v.878c0 .374-.004.74.023 1.103.027.345.077.686.137 1.025l1.22-.424s-.147-2.278-.116-1.704c.027.488-.046-1.705-.046-1.705l-1.218-.325v-1.931c.557-.198.981-.671 1.17-1.254h3.221v-1.176zm11.521 0h1.93v1.176h3.22c.191.583.634 1.056 1.195 1.254v1.931l-1.241.325s-.05 2.193-.023 1.705c.034-.574-.139 1.704-.139 1.704l1.241.424a11.31 11.31 0 01-.642 2.231 1.952 1.952 0 00-1.013.127l-2.322-2.807.688-1.104-2.137-2.605-1.173.549-2.667-3.332c.071-.121.139-.238.185-.374l2.898-.028v-1.176z"
});

var _ref502 =
/*#__PURE__*/
React.createElement("path", {
  d: "M153.884 225.782c.025.316.068.626.12.931l1.077-.376c-.015-.239-.073-1.158-.1-1.555-.002-.002-.002-.006-.004-.01l-.006-.082-.004-.095c0-.019.004-.027.006-.031-.008-.399-.037-1.289-.046-1.522l-1.22-.328v-2.042l.052-.017c.534-.191.94-.648 1.125-1.207l.016-.05h3.2v-1.179h2.152v1.179h2.991l.019.054c.037.118.073.235.129.335l.027.045-2.875 3.47-1.173-.549-2.064 2.516.711 1.101-2.395 2.894-.05-.02a1.925 1.925 0 00-.996-.121l-.06.01-.021-.058a11.17 11.17 0 01-.611-2.156c-.005-.029-.011-.058-.015-.089a9.91 9.91 0 01-.133-.965h-1.195l-.006-.068c-.032-.37-.048-.74-.048-1.11v-.982l1.374.029v.953c0 .372-.006.736.023 1.095zm-.158-.071c-.023-.338-.019-.677-.019-1.024v-.801l-1.064-.023v.824c0 .342.012.683.039 1.024h1.044zm1.405-.989c.029.416.108 1.665.108 1.665l.004.056-1.209.424c.128.726.317 1.424.579 2.096.319-.038.659.004.963.116l2.251-2.719-.712-1.102 2.211-2.696 1.175.551 2.734-3.3a1.639 1.639 0 01-.102-.262H160.1v-1.178h-1.849v1.178h-3.24c-.2.56-.614 1.019-1.15 1.229v1.817l1.216.327.002.055s.048 1.406.052 1.718v.025zm14.486-6.264l.079-.085v-.154h2.009v1.179h3.197l.017.05c.185.559.607 1.016 1.147 1.207l.052.017v2.044l-1.243.326c-.004.218-.023 1.002-.027 1.432a.848.848 0 01.006.133c0 .028 0 .054-.002.083a.46.46 0 01-.013.103c-.033.399-.101 1.305-.12 1.544l1.249.428-.012.065a11.49 11.49 0 01-.649 2.245l-.022.058-.061-.01a1.837 1.837 0 00-.971.121l-.052.02-2.392-2.892.69-1.103-2.067-2.516-1.175.549-2.737-3.422.027-.044c.066-.116.135-.228.176-.362l.019-.051 2.875-.025v-.94zm5.073 6.253v-.014c0-.31.031-1.718.031-1.718l.002-.055 1.241-.327v-1.817a2.068 2.068 0 01-1.175-1.229h-3.24v-1.178h-1.778v1.178l-2.919.023a1.856 1.856 0 01-.145.293l2.596 3.244 1.173-.549 2.21 2.696-.688 1.102 2.249 2.719a2.02 2.02 0 01.94-.116c.264-.672.472-1.368.605-2.096l-1.235-.424.006-.06s.093-1.26.127-1.672zm-4.994-6.338s-.118-.063-.058-.129c.015-.017.058.129.058.129z"
});

var _ref503 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M177.237 223.795l-.003-3.063c.774-.247 1.335-1 1.335-1.881 0-.882-.567-1.642-1.345-1.896l.01-4.189h-1.187l-.006 4.214a1.919 1.919 0 00-1.216 1.276l-3.204.004v1.227h3.227c.191.58.626 1.035 1.187 1.233l.002 3.083 1.197-.008h.003zm.008-17.154l-.011 4.135h-1.187v-4.149a1.405 1.405 0 01-.266-.119l-4.39 5.391-.909-.784 4.474-5.497c-.035-.079-.075-.16-.102-.247h-3.245v-1.223h3.237c.247-.794.964-1.363 1.815-1.363 1.056 0 1.914.883 1.914 1.973 0 .885-.555 1.634-1.33 1.883zm-11.711-.014l-.01 2.546h-1.185l.002-2.524a1.956 1.956 0 01-1.252-1.278h-2.894v-1.223h2.894c.252-.794.965-1.363 1.815-1.363.851 0 1.57.569 1.819 1.363h2.954v1.223h-2.962c-.187.599-.628 1.064-1.181 1.256zm5.449 20.538l-1.17.542-2.142-2.592.703-1.102 2.609 3.152z"
});

var _ref504 =
/*#__PURE__*/
React.createElement("path", {
  d: "M177.234 223.871l-1.276.007-.002-3.106a2.012 2.012 0 01-1.164-1.208h-3.248v-1.378s3.227-.009 3.227-.007a1.994 1.994 0 011.195-1.253l.005-4.237h1.341l-.009 4.212a2.075 2.075 0 011.343 1.95c0 .896-.559 1.661-1.334 1.937l.001 3.083h-.079zm-.076-.151l-.003-3.044.055-.016c.744-.24 1.282-.961 1.282-1.809s-.547-1.578-1.289-1.824l-.054-.016.006-4.168h-1.033l-.004 4.191-.05.018a1.839 1.839 0 00-1.166 1.225l-.019.056-3.183.004v1.071h3.204l.017.054a1.85 1.85 0 001.137 1.183l.054.019v3.062l1.046-.006zm.162-17.023l-.011 4.158h-1.338v-4.172a1.527 1.527 0 01-.169-.077l-4.401 5.403-1.025-.885s4.493-5.518 4.493-5.516c-.025-.052-.05-.104-.069-.158h-3.268v-1.381h3.257c.275-.796 1.009-1.361 1.872-1.361 1.095 0 1.992.917 1.992 2.05 0 .9-.552 1.663-1.333 1.939zm-.1-.129c.748-.241 1.279-.96 1.279-1.81 0-1.048-.824-1.897-1.838-1.897-.815 0-1.503.547-1.742 1.308l-.017.057h-3.216v1.07h3.226l.019.054c.023.083.06.16.096.237l.021.042-4.46 5.476.792.686 4.38-5.381.059.031c.081.046.164.084.251.113l.052.016v4.131h1.033l.013-4.114.052-.019zm-11.609.113l-.01 2.571h-1.339l.002-2.549a2.024 2.024 0 01-1.229-1.253h-2.916v-1.381h2.916c.275-.796 1.004-1.361 1.869-1.361.867 0 1.601.565 1.876 1.361h2.973v1.381h-2.982a2.004 2.004 0 01-1.16 1.231zm-.102-.127c.53-.185.952-.632 1.133-1.204l.019-.054h2.94v-1.07h-2.934l-.016-.057c-.24-.761-.93-1.308-1.747-1.308-.817 0-1.501.547-1.74 1.308l-.017.057h-2.875v1.07h2.875l.017.054a1.869 1.869 0 001.2 1.224l.054.019-.004 2.503h1.033l.01-2.526.052-.016zm4.283 21.247l-2.216-2.678.792-1.241 2.738 3.312-1.314.607zm1.066-.663l-2.476-2.994-.615.967 2.069 2.501 1.022-.474z"
});

var _ref505 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M161.216 205.375l-.362 1.274h-3.295l-.357-1.274h4.014zm0-1.233l-.362-1.272h-3.295l-.357 1.272h4.014z"
});

var _ref506 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160.913 206.726h-3.414l-.399-1.428h4.218l-.405 1.428zm.201-1.274h-3.81l.311 1.118h3.183l.316-1.118zm-4.014-1.233l.399-1.424h3.414l.405 1.424H157.1zm4.014-.154l-.316-1.116h-3.183l-.311 1.116h3.81z"
});

var _ref507 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M158.827 227.165l1.171.542 2.139-2.592-.702-1.102-2.608 3.152zm-.91-.799l-.703-1.108 2.146-2.59 1.166.542-2.609 3.156z"
});

var _ref508 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.443 223.882l.79 1.241-2.217 2.678-1.313-.607 2.74-3.312zm-2.495 3.256l1.027.474 2.068-2.501-.615-.967-2.48 2.994zm-1.827-1.886l2.216-2.68 1.312.613-2.74 3.312-.788-1.245zm.806.983l2.476-2.995-1.023-.476-2.07 2.501.617.97z"
});

var _ref509 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M158.707 234.239l-.586 1.098a12.5 12.5 0 01-2.657-2.453 1.862 1.862 0 01-1.818-.381 2.015 2.015 0 01-.212-2.781l.1-.119a13.06 13.06 0 01-.925-3.817l1.198.007c.093 1.122.351 2.226.765 3.261.343-.051.694-.01 1.021.121l2.993-3.611.902.794-2.977 3.607a1.998 1.998 0 01-.072 2.179 11.41 11.41 0 002.268 2.095z"
});

var _ref510 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158.707 234.316s.077-.147.077-.077c0 .019-.077.077-.077.077zm0-.17v.17l.066-.041-.623 1.172-.071-.045a12.543 12.543 0 01-2.642-2.429 1.934 1.934 0 01-1.84-.411 2.098 2.098 0 01-.223-2.892l.071-.079a13.102 13.102 0 01-.91-3.798l-.009-.086 1.351.007.007.072a11.2 11.2 0 00.738 3.183 2.05 2.05 0 01.946.114l3.01-3.629 1.019.893-2.99 3.624a2.088 2.088 0 01-.071 2.169c.636.76 1.362 1.438 2.171 2.006zm-.1.118a11.553 11.553 0 01-2.226-2.068l-.038-.048.033-.046a1.93 1.93 0 00.071-2.098l-.029-.045 2.965-3.593-.786-.692-2.984 3.595-.05-.023a1.905 1.905 0 00-.981-.117l-.06.008-.021-.055a11.402 11.402 0 01-.765-3.215l-1.042-.004c.117 1.306.441 2.551.911 3.711l.017.046-.129.149a1.938 1.938 0 00.206 2.676 1.78 1.78 0 001.74.366l.05-.015.033.04a12.499 12.499 0 002.574 2.389l.511-.961z"
});

var _ref511 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M157.819 233.537a11.131 11.131 0 003.528 2.043l.272-1.291a9.727 9.727 0 01-2.919-1.598l-.881.846zm-.593 1.118a12.425 12.425 0 003.529 2.023l-.917.934a13.24 13.24 0 01-2.886-1.612l.274-1.345z"
});

var _ref512 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158.696 232.589l.05.041a9.566 9.566 0 002.901 1.584l.064.023-.306 1.443-.083-.025a11.27 11.27 0 01-3.553-2.058l-.064-.056.991-.952zm-.762.946a11.065 11.065 0 003.359 1.943l.239-1.139a9.733 9.733 0 01-2.827-1.547l-.771.743zm-.66 1.06a12.286 12.286 0 003.508 2.01l.112.042-1.037 1.056-.048-.019a13.285 13.285 0 01-2.9-1.621l-.04-.029.308-1.522.097.083zm.002.199l-.237 1.173c.87.634 1.801 1.156 2.78 1.555l.798-.813a12.466 12.466 0 01-3.341-1.915z"
});

var _ref513 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M152.574 223.795v-3.063c-.771-.247-1.335-1-1.335-1.881 0-.882.57-1.642 1.343-1.896l-.008-4.189h1.189l.002 4.214a1.904 1.904 0 011.216 1.276l3.204.004v1.227h-3.222a1.949 1.949 0 01-1.187 1.233l-.003 3.083-1.199-.008z"
});

var _ref514 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.574 223.795h-.077l.002-3.007c-.777-.276-1.335-1.041-1.335-1.937 0-.896.566-1.667 1.343-1.95l-.008-4.212h1.341l.002 4.237c.566.21 1.004.667 1.198 1.251l3.222.009v1.378s-3.245 0-3.245-.002a2.024 2.024 0 01-1.166 1.21l-.003 3.106-1.276-.007.002-.076zm.075-.075l1.048.006.002-3.062.05-.019a1.86 1.86 0 001.139-1.183l.019-.054h3.201v-1.071l-3.183-.004-.017-.056a1.837 1.837 0 00-1.168-1.225l-.054-.018-.002-4.191h-1.033l.01 4.168-.054.016c-.744.246-1.291.976-1.291 1.824 0 .848.539 1.569 1.283 1.809l.052.016-.002 3.044z"
});

var _ref515 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M152.755 226.88l-1.229-.302-.174-3.397 1.222-.438v1.95c0 .755.062 1.47.181 2.187zm1.023-4.212l1.226.314s.062 2.183.036 1.692c-.032-.572.135 1.707.135 1.707l-1.237.447a12.218 12.218 0 01-.165-2.135l.003-2.025h.002zm-1.189-12.948l-1.229.374v3.403l1.229.369v-4.146zm1.195 0l1.227.374v3.403l-1.227.369v-4.146zm3.447 8.54l.358-1.272h3.299l.357 1.272h-4.014z"
});

var _ref516 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.755 226.957h-.062l-.005-.015-1.237-.301-.178-3.512 1.376-.496.002 2.06c0 .75.06 1.461.183 2.174l-.079.09zm-.092-.179a12.783 12.783 0 01-.164-2.085l-.002-1.84-1.065.382.169 3.285 1.062.258zm1.036-4.033h.07l-.01-.004.017.002s-.003-.002-.003-.007c-.02-.033-.076-.145.005-.145l.02.002 1.281.328.002.058s.038 1.383.044 1.701l.124 1.697.005.058-1.377.495-.014-.09a12.14 12.14 0 01-.166-2.147l.002-1.948zm1.278 2.037a.085.085 0 01-.006-.019.556.556 0 01-.006-.085 1.158 1.158 0 01.002-.191c-.009-.42-.031-1.223-.038-1.445l-1.078-.276-.003 1.927c0 .694.038 1.37.15 2.031l1.096-.395c-.019-.237-.083-1.143-.117-1.547zm-2.312-10.813l-1.384-.413v-3.518l1.384-.422v4.353zm-.154-4.147l-1.076.331v3.288l1.076.323v-3.942zm2.576.216v3.518l-1.38.413v-4.353l1.38.422zm-1.226-.216v3.942l1.075-.323v-3.288l-1.075-.331zm3.671 7.089h3.414l.399 1.424h-4.216l.403-1.424zm-.199 1.273h3.811l-.312-1.119h-3.185l-.314 1.119z"
});

var _ref517 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DEAD00",
  fillRule: "nonzero",
  d: "M157.231 219.489l.358 1.272h3.299l.357-1.272z"
});

var _ref518 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.345 219.412l-.399 1.426h-3.414l-.403-1.426h4.216zm-4.012.154l.314 1.12h3.185l.312-1.12h-3.811z"
});

var _ref519 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M166.752 236.034c.94-.163 1.805-.443 2.662-.836l.588 1.091c-.983.46-2.046.79-3.15.973-.183.89-.948 1.557-1.867 1.557-.915 0-1.68-.659-1.869-1.544a11.905 11.905 0 01-3.312-.986l.593-1.091c.9.411 1.858.69 2.854.84a1.892 1.892 0 011.104-1.063l.013-5.345h1.181l.012 5.329c.524.17.969.559 1.189 1.075h.002z"
});

var _ref520 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.796 235.946a10.644 10.644 0 002.586-.819l.065-.031.661 1.229-.073.033c-.977.455-2.025.786-3.118.971-.21.9-.994 1.569-1.932 1.569-.933 0-1.717-.661-1.933-1.555a12.02 12.02 0 01-3.281-.985l-.072-.033.663-1.229.066.031a10.6 10.6 0 002.778.828c.216-.477.59-.847 1.073-1.032l.01-5.368h1.339l.01 5.347c.503.179.93.556 1.158 1.044zm-.095.164l-.021-.045a1.879 1.879 0 00-1.144-1.034l-.052-.018-.01-5.306h-1.031l-.009 5.324-.051.017a1.824 1.824 0 00-1.061 1.021l-.021.056-.06-.011a10.673 10.673 0 01-2.811-.817l-.519.955a11.88 11.88 0 003.218.948l.052.006.012.054c.181.848.913 1.484 1.792 1.484.884 0 1.616-.642 1.792-1.499l.009-.052.054-.01c1.07-.175 2.1-.491 3.056-.931l-.516-.955c-.84.379-1.692.651-2.615.811l-.008.002h-.056z"
});

var _ref521 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M171.989 233.537a11.22 11.22 0 01-3.528 2.043l-.274-1.291a9.737 9.737 0 002.921-1.598l.881.846zm.593 1.118a12.406 12.406 0 01-3.528 2.023l.917.934a13.196 13.196 0 002.883-1.612l-.272-1.345zm-7.027-3.969l1.231-.378v-3.401l-1.231-.368v4.147zm-1.194 0l-1.228-.378v-3.401l1.228-.368v4.147z"
});

var _ref522 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.039 233.597a11.326 11.326 0 01-3.553 2.058l-.081.027-.305-1.445.064-.023a9.507 9.507 0 002.894-1.584l.054-.041.992.952-.065.056zm-.164-.062l-.771-.743a9.761 9.761 0 01-2.825 1.547l.238 1.139a11.168 11.168 0 003.358-1.943zm1.066 2.499l-.039.029a13.345 13.345 0 01-2.902 1.621l-.048.019-1.036-1.056.113-.042a12.365 12.365 0 003.505-2.01l.1-.081.307 1.52zm-.407-1.24a12.493 12.493 0 01-3.343 1.915l.799.813a13.149 13.149 0 002.781-1.555l-.237-1.173zm-7.056-8.359l1.387.414v3.517l-1.387.424v-4.355zm.156 4.145l1.075-.33v-3.285l-1.075-.322v3.937zm-2.578-.214v-3.517l1.383-.414v4.355l-1.383-.424zm1.229.214v-3.937l-1.075.322v3.285l1.075.33z"
});

var _ref523 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M168.655 205.375l.364 1.274h3.295l.357-1.274h-4.016zm0-1.233l.364-1.272h3.295l.357 1.272h-4.016z"
});

var _ref524 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.773 205.298l-.401 1.428h-3.414l-.405-1.428h4.22zm-4.016.154l.32 1.118h3.178l.316-1.118h-3.814zm.201-2.657h3.414l.401 1.424h-4.22l.405-1.424zm-.201 1.27h3.814l-.316-1.116h-3.178l-.32 1.116z"
});

var _ref525 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M157.231 219.489l.358 1.272h3.299l.357-1.272z"
});

var _ref526 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.335 219.423l-.389 1.405h-3.403l-.412-1.405h4.204zm-3.998.152l.322 1.099h3.173l.301-1.099h-3.796z"
});

var _ref527 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DEAD00",
  fillRule: "nonzero",
  d: "M168.638 219.5l.343 1.253h3.289l.368-1.253z"
});

var _ref528 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.74 219.423l-.414 1.405h-3.403l-.387-1.405h4.204zm-4.002.152l.303 1.099h3.171l.324-1.099h-3.798z"
});

var _ref529 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M164.222 220.653c.046.019.09.038.139.048v5.84l-1.22.374v3.385l1.22.376v4.312a1.86 1.86 0 00-1.105 1.052c-.649-.1-1.293-.243-1.909-.451l.277-1.304a9.65 9.65 0 01-2.919-1.605l-.898.853a11.68 11.68 0 01-1.356-1.377c.46-.657.47-1.515.069-2.183l2.299-2.806 1.175.553 2.137-2.609-.69-1.102 2.781-3.356zm1.495.023l3.357 4.16.897-.775 1.241 1.503-.896.802-1.242-1.53-.69-.827-.713 1.104 2.14 2.607 1.17-.553 2.324 2.806a2.016 2.016 0 00.069 2.183 11.946 11.946 0 01-1.378 1.377l-.899-.853a9.6 9.6 0 01-2.921 1.605l.277 1.304c-.549.193-1.11.349-1.703.451a1.955 1.955 0 00-1.195-1.077v-4.287l1.243-.376v-3.385l-1.243-.374v-5.788c.067-.021.1-.054.162-.077zm11.52 3.106v.905c0 .378-.017.74-.048 1.103h-1.196c.027-.363.048-.729.048-1.103v-.878l1.196-.027z"
});

var _ref530 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158.649 234.092l.006.006-.088.125c-.001 0-.004-.002-.006-.007-.28-.199-.544-.401-.802-.623l-.065-.056c-.472-.41-.902-.853-1.301-1.333l-.04-.044.034-.05a1.924 1.924 0 00.066-2.097l-.027-.046 2.372-2.896 1.173.553 2.064-2.517-.69-1.104 2.859-3.447.052.025c.041.02.081.037.122.045l.061.015v5.956l-1.221.376v3.271l1.221.376v4.422l-.055.018a1.79 1.79 0 00-1.056 1.009l-.023.056-.06-.011a11.187 11.187 0 01-1.923-.453l-.062-.022s.274-1.304.276-1.304a9.75 9.75 0 01-2.827-1.553l-.788.748c.239.198.48.385.728.562zm-.844-.661l.895-.853.053.044a9.658 9.658 0 002.895 1.59l.065.023-.274 1.302c.569.191 1.168.324 1.771.418.218-.475.59-.834 1.073-1.021v-4.202l-1.216-.374v-3.497l1.216-.378v-5.724c-.013-.004-.027-.008-.038-.014l-2.709 3.27.691 1.104-2.215 2.694-1.172-.551-2.227 2.719c.381.668.366 1.51-.066 2.169.387.462.805.886 1.258 1.281zm11.259-8.485l-.05-.06-.623-.746-.624.967 2.065 2.517 1.172-.551 2.395 2.894-.027.046a1.933 1.933 0 00.066 2.097l.034.05-.038.044c-.401.484-.852.921-1.326 1.333h.002l-.067.056c-.262.222-.532.432-.808.63l-.09-.125c.252-.181.497-.368.734-.568l-.788-.748a9.78 9.78 0 01-2.823 1.553l.274 1.304-.064.022a10.17 10.17 0 01-1.713.453l-.06.013-.025-.058a1.88 1.88 0 00-1.148-1.034l-.054-.018v-4.397l1.241-.376v-3.271l-1.241-.374v-5.904l.056-.019c.064-.016.098-.05.156-.073l.052-.016.036.041 3.305 4.098.896-.777 1.339 1.623-1.011.904-1.243-1.53zm2.934 8.485a12.19 12.19 0 001.28-1.281 2.092 2.092 0 01-.066-2.169l-2.25-2.719-1.174.551-2.212-2.694.723-1.121-2.605-3.228-.06.033v5.68l1.241.378v3.497l-1.241.376v4.173c.503.181.935.557 1.164 1.048a10.63 10.63 0 001.566-.416l-.277-1.304.065-.023a9.71 9.71 0 002.898-1.59l.051-.044.897.853zm-2.817-8.587l1.143 1.412.782-.7-1.144-1.387-.781.675zm8.056-.983s-.079-.095-.079-.079l.079.079s.076-.148.076-.079v.905c0 .38-.014.744-.045 1.11l-.009.068h-1.347l.006-.083c.028-.359.046-.723.046-1.095v-.953l1.27-.027.003.154zm.002 0zm-.081.002c-.252.004-1.04.023-1.04.023v.801c0 .347-.017.686-.042 1.024h1.042c.027-.336.04-.673.04-1.024v-.824z"
});

var _ref531 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M159.832 224.061l.918.775-1.266 1.53-.895-.802 1.243-1.503zm4.529 3.582h1.194v1.981h-1.194v-1.981zm-5.656 6.592c.528.368 1.114.68 1.7.95l-.596 1.106a12.44 12.44 0 01-1.678-.954l.574-1.102z"
});

var _ref532 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160.857 224.828l-1.362 1.648-1.013-.904 1.339-1.619 1.036.875zm-1.017-.659l-1.144 1.387.782.7 1.164-1.409-.802-.678zm5.794 3.397v2.135h-1.351v-2.135h1.351zm-1.195.156v1.823h1.039v-1.823h-1.039zm-5.691 6.449c.524.365 1.106.675 1.691.946l.073.033-.67 1.241-.067-.031a13.15 13.15 0 01-1.69-.958l-.056-.038.647-1.241.072.048zm-.016.177l-.501.964c.497.331 1.01.624 1.544.877l.524-.967a11.634 11.634 0 01-1.567-.874z"
});

var _ref533 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M163.318 219.836a1.892 1.892 0 01-.143-.349h-2.996v-1.224h2.975c.033-.104.081-.206.131-.304l-3.672-4.453.902-.796 3.626 4.376c.063-.034.127-.063.194-.088l.004-5.831h1.18v5.796c.055.017.136.034.19.05l3.538-4.384.909.789-3.553 4.36c.093.148.154.312.206.485h2.881v1.224l-2.9.008c-.04.137-.114.267-.181.385l3.364 4.172-.903.796-3.349-4.176c-.06.025-.091.054-.16.071l-.008 6.895h-1.185l-.004-6.924c-.05-.017-.092-.044-.14-.069l-3.486 4.203-.902-.796 3.482-4.216z"
});

var _ref534 =
/*#__PURE__*/
React.createElement("path", {
  d: "M163.229 219.826a1.907 1.907 0 01-.111-.262h-3.014v-1.378h2.996c.027-.075.06-.148.095-.219l-3.688-4.47 1.015-.898 3.64 4.391c.029-.017.062-.031.095-.046l.005-5.852h1.336v5.813l.082.021 3.557-4.407 1.027.889-3.566 4.378c.071.123.123.256.167.4h2.902v1.376l-2.921.008a2.016 2.016 0 01-.145.304l3.378 4.187-1.017.9-3.361-4.193c-.024.01-.04.02-.063.031l-.008 6.917h-1.341l-.004-6.951a.573.573 0 01-.042-.022l-3.497 4.216-1.016-.898 3.499-4.235zm.089.01l.06.05-3.434 4.156.788.696 3.474-4.186.051.024c.047.023.084.05.13.065l.054.019.002 6.902h1.033l.008-6.876.056-.016c.065-.017.094-.044.154-.069l.052-.023 3.333 4.16.788-.696-3.352-4.152.025-.048a1.66 1.66 0 00.177-.37l.017-.054 2.879-.01v-1.071h-2.865l-.014-.056a1.723 1.723 0 00-.196-.459l-.029-.048 3.541-4.347-.794-.688-3.522 4.367-.052-.018c-.052-.019-.131-.033-.183-.052l-.054-.015v-5.777h-1.031l-.003 5.808-.05.019a1.521 1.521 0 00-.184.083l-.057.03-3.613-4.364-.788.696 3.657 4.431-.023.045a2.378 2.378 0 00-.124.293l-.019.052h-2.954v1.071h2.977l.014.054c.038.123.083.233.14.337l-.069.037z"
});

var _ref535 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M154.198 230.437a.796.796 0 011.153-.096c.345.304.387.84.094 1.193a.8.8 0 01-1.154.094.863.863 0 01-.093-1.191zm-1.863-11.586c0-.472.366-.85.817-.85.453 0 .817.378.817.85a.827.827 0 01-.817.842.828.828 0 01-.817-.842z"
});

var _ref536 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.05 230.514c.025-.044.054-.083.085-.123l-.1.123h-.001l.103-.125a.876.876 0 011.266-.106.943.943 0 01.102 1.299.879.879 0 01-1.266.102.94.94 0 01-.189-1.17zm.208-.027l-.006.004a.789.789 0 00.089 1.079.727.727 0 001.044-.083.79.79 0 00-.083-1.088.722.722 0 00-1.044.088zm-2-11.636c0-.514.401-.925.894-.925.494 0 .894.411.894.925 0 .511-.4.917-.894.917a.903.903 0 01-.894-.917zm.154 0c0 .424.33.763.74.763a.75.75 0 00.742-.763c0-.426-.33-.774-.742-.774-.41 0-.74.348-.74.774z"
});

var _ref537 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M171.101 234.239l.587 1.098a12.558 12.558 0 002.659-2.453 1.863 1.863 0 001.817-.381 2.02 2.02 0 00.21-2.781l-.1-.119c.484-1.193.813-2.474.919-3.817l-1.189.007a11.381 11.381 0 01-.767 3.261 1.965 1.965 0 00-1.021.121l-2.994-3.611-.902.794 2.973 3.607a2.014 2.014 0 00.075 2.179 11.296 11.296 0 01-2.267 2.095z"
});

var _ref538 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.101 234.403v-.087l-.043-.139.043-.031v-.071l.03.052a11.357 11.357 0 002.141-1.987 2.09 2.09 0 01-.071-2.169l-2.987-3.624 1.019-.893 3.006 3.629c.305-.112.634-.151.948-.114.391-1 .648-2.066.738-3.183l.008-.072 1.345-.007-.006.086a12.866 12.866 0 01-.909 3.796l.071.081a2.103 2.103 0 01-.22 2.892 1.94 1.94 0 01-1.84.411 12.696 12.696 0 01-2.643 2.429l-.072.045-.558-1.044zm.1-.139l.514.961c.964-.664 1.83-1.48 2.571-2.389l.034-.04.05.015c.58.187 1.243.077 1.742-.366a1.944 1.944 0 00.204-2.676l-.133-.149.018-.046c.474-1.16.796-2.405.909-3.711l-1.035.004a11.4 11.4 0 01-.768 3.215l-.022.055-.061-.008a1.913 1.913 0 00-.981.117l-.052.023-2.977-3.595-.788.692 2.961 3.593-.028.045a1.942 1.942 0 00.073 2.098l.034.046-.04.048a11.552 11.552 0 01-2.225 2.068z"
});

var _ref539 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M175.54 230.453a.794.794 0 00-1.152-.095.863.863 0 00-.091 1.191.8.8 0 001.154.094.862.862 0 00.089-1.19z"
});

var _ref540 =
/*#__PURE__*/
React.createElement("path", {
  d: "M175.601 230.404a.944.944 0 01-.098 1.297.88.88 0 01-1.266-.102.937.937 0 01.102-1.299.87.87 0 011.262.104zm-.121.097a.718.718 0 00-1.04-.087.784.784 0 00-.085 1.085.724.724 0 001.046.085.784.784 0 00.079-1.083z"
});

var _ref541 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M177.05 226.88l1.23-.302.175-3.397-1.218-.438-.003 1.95c0 .755-.06 1.47-.184 2.187zm-1.017-4.212l-1.227.314s-.066 2.183-.039 1.692c.033-.572-.133 1.707-.133 1.707l1.235.447c.122-.695.166-1.405.166-2.135l-.002-2.025zm.004-12.948l-1.229.374v3.403l1.229.369v-4.146zm1.196 0l1.228.374v3.403l-1.228.369v-4.146zm-5.344 16.646l.703-1.108-2.141-2.59-1.169.542 2.607 3.156z"
});

var _ref542 =
/*#__PURE__*/
React.createElement("path", {
  d: "M174.684 224.693v-.006c.002-.31.045-1.709.045-1.709l.002-.057 1.281-.328.021.075h.077l.002 2.025c0 .736-.042 1.449-.166 2.147l-.019.09-1.376-.495.004-.058s.095-1.285.129-1.684zm1.27-1.925l-1.073.274c-.006.221-.031 1.023-.039 1.445.002.027.004.066.004.11 0 .025 0 .052-.002.081-.002.054-.007.081-.007.085a.107.107 0 01-.006.017l-.118 1.549 1.095.395c.11-.661.148-1.337.148-2.031l-.002-1.925zm1.021 4.099c.122-.713.18-1.424.18-2.174l.005-2.06 1.376.496-.181 3.512-1.401.341.021-.115zm.17-.089l1.062-.258.169-3.285-1.063-.382-.001 1.84c0 .717-.057 1.401-.167 2.085zm-1.033-12.809l-1.381-.413v-3.518l1.381-.422v4.353zm-.154-4.147l-1.073.331v3.288l1.073.323v-3.942zm2.582.216v3.518l-1.386.413v-4.353l1.386.422zm-1.233-.216v3.942l1.077-.323v-3.288l-1.077-.331zm-8.145 13.363l1.312-.613 2.214 2.68-.788 1.245-2.738-3.312zm2.721 3.05l.616-.97-2.069-2.501-1.025.476 2.478 2.995zM152.318 204.837c-.002-.028-.004-.05-.004-.077 0-.508.403-.923.896-.923.495 0 .894.415.894.923a.907.907 0 01-.894.921.91.91 0 01-.892-.844zm.152-.077v.002c0 .422.333.765.74.765.41 0 .74-.343.74-.767a.754.754 0 00-.74-.767c-.409 0-.74.345-.74.767z"
});

var _ref543 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M175.835 218.851c0-.472.368-.85.817-.85.456 0 .818.378.818.85a.826.826 0 01-.818.842.83.83 0 01-.817-.842z"
});

var _ref544 =
/*#__PURE__*/
React.createElement("path", {
  d: "M175.756 218.851c0-.514.404-.925.896-.925.497 0 .894.411.894.925a.9.9 0 01-.894.917.906.906 0 01-.896-.917zm.156 0c0 .424.333.763.74.763.414 0 .74-.339.74-.763 0-.426-.326-.774-.74-.774-.407 0-.74.348-.74.774z"
});

var _ref545 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M172.642 218.26l-.362-1.272h-3.297l-.358 1.272h4.017zm0 1.229l-.362 1.272h-3.297l-.358-1.272h4.017z"
});

var _ref546 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.524 218.335l.399-1.424h3.415l.406 1.424h-4.22zm4.016-.151l-.318-1.119h-3.181l-.312 1.119h3.811zm-.202 2.654h-3.415l-.399-1.426h4.22l-.406 1.426zm.202-1.272h-3.811l.312 1.12h3.181l.318-1.12z"
});

var _ref547 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M164.168 236.846c0-.47.366-.848.817-.848.454 0 .817.378.817.848a.83.83 0 01-.817.845c-.451 0-.817-.379-.817-.845zm11.676-32.086a.83.83 0 01.817-.844.83.83 0 01.817.844.829.829 0 01-.817.842.829.829 0 01-.817-.842zm-11.759 0c0-.466.368-.844.819-.844.451 0 .817.378.817.844a.83.83 0 01-.817.842.832.832 0 01-.819-.842z"
});

var _ref548 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.089 236.846c0-.511.406-.923.896-.923.493 0 .894.412.894.923 0 .51-.401.919-.894.919a.907.907 0 01-.896-.919zm.154 0c0 .422.333.766.742.766a.751.751 0 00.739-.766c0-.424-.327-.771-.739-.771-.409 0-.742.347-.742.771zm11.524-32.086c0-.508.399-.923.894-.923.493 0 .894.415.894.923a.908.908 0 01-.894.921.907.907 0 01-.894-.921zm.151 0c0 .424.331.767.743.767a.754.754 0 00.742-.767.755.755 0 00-.742-.767.755.755 0 00-.743.767zm-11.91 0c0-.508.403-.923.896-.923.495 0 .894.415.894.923a.907.907 0 01-.894.921.91.91 0 01-.896-.921zm.156 0c0 .424.333.767.74.767.41 0 .74-.343.74-.767a.754.754 0 00-.74-.767c-.407 0-.74.345-.74.767z"
});

var _ref549 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M153.952 206.616l4.416 5.382.904-.795-4.438-5.362c.087-.144.149-.302.203-.47h3.229v-1.223h-3.231a1.917 1.917 0 00-1.825-1.363c-1.056 0-1.912.883-1.912 1.973 0 .864.536 1.6 1.286 1.866l-.006 4.152h1.187v-4.124c.05-.017.142-.017.187-.036z"
});

var _ref550 =
/*#__PURE__*/
React.createElement("path", {
  d: "M153.925 206.701c-.027.005-.056.007-.083.013v4.141h-1.341l.006-4.178c-.752-.29-1.287-1.042-1.287-1.919 0-1.133.895-2.05 1.99-2.05.869 0 1.607.565 1.881 1.361h3.252v1.381h-3.249a2.123 2.123 0 01-.167.383l4.452 5.378-1.019.898-4.435-5.408zm4.451 5.189l.79-.696-4.428-5.345.029-.05c.086-.137.146-.289.198-.449l.016-.054h3.208v-1.07h-3.21l-.016-.057a1.842 1.842 0 00-1.753-1.308c-1.012 0-1.836.849-1.836 1.897 0 .831.514 1.538 1.237 1.794l.052.016-.008 4.133h1.031v-4.106l.054-.018c.029-.009.071-.013.111-.019.026-.002.056-.004.076-.015l.05-.018 4.399 5.365z"
});

var _ref551 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M158.601 210.39l1.172-.541 2.142 2.591-.703 1.103-2.611-3.153zm-.907.802l-.7 1.108 2.141 2.588 1.168-.544-2.609-3.152z"
});

var _ref552 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159.796 209.753l2.214 2.68-.792 1.241-2.74-3.311 1.318-.61zm-1.071.666l2.479 2.993.615-.969-2.069-2.501-1.025.477zm1.701 3.952l-1.312.613-2.214-2.678.786-1.245 2.74 3.31zm-2.723-3.048l-.616.971 2.069 2.499 1.025-.477-2.478-2.993z"
});

var _ref553 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M164.347 208.117l-1.229.376v3.404l1.229.368v-4.148zm1.183 0l1.227.376v3.404l-1.227.368v-4.148z"
});

var _ref554 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.424 212.369l-1.38-.414v-3.518l1.38-.426v4.358zm-.152-4.148l-1.075.331v3.287l1.075.324v-3.942zm2.563.216v3.518l-1.382.414v-4.358l1.382.426zm-1.228-.216v3.942l1.073-.324v-3.287l-1.073-.331z"
});

var _ref555 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M163.048 218.899c0-1.096.858-1.981 1.917-1.981 1.054 0 1.912.885 1.912 1.981 0 1.089-.858 1.97-1.912 1.97-1.059 0-1.917-.881-1.917-1.97z"
});

var _ref556 =
/*#__PURE__*/
React.createElement("path", {
  d: "M162.971 218.899c0-1.138.894-2.059 1.994-2.059 1.097 0 1.989.921 1.989 2.059 0 1.133-.892 2.047-1.989 2.047-1.1 0-1.994-.914-1.994-2.047zm.156 0c0 1.046.821 1.896 1.838 1.896 1.012 0 1.835-.85 1.835-1.896 0-1.052-.823-1.905-1.835-1.905-1.017 0-1.838.853-1.838 1.905z"
});

var _ref557 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C8B100",
  fillRule: "nonzero",
  d: "M150.483 200.286h2.854v-.744h-2.854z"
});

var _ref558 =
/*#__PURE__*/
React.createElement("path", {
  d: "M150.41 199.469h2.998v.887h-2.998v-.887zm.143.744h2.711v-.597h-2.711v.597z"
});

var _ref559 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DEAD00",
  fillRule: "nonzero",
  d: "M150.483 200.286h2.854v-.744h-2.854z"
});

var _ref560 =
/*#__PURE__*/
React.createElement("path", {
  d: "M150.41 199.469h2.998v.887h-2.998v-.887zm.143.744h2.711v-.597h-2.711v.597z"
});

var _ref561 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6CB7E",
  fillRule: "nonzero",
  d: "M150.091 234.923c1.373.449 2.069 1.566 2.069 2.869 0 1.701-1.513 2.988-3.476 2.988-1.96 0-3.553-1.287-3.553-2.988 0-1.284.653-2.719 2.017-2.823 0 0-.04-.135-.156-.358a42.422 42.422 0 00-.422-.471s.522-.107.821.02c.304.123.501.333.501.333s.143-.306.343-.543c.202-.234.462-.38.462-.38s.303.276.401.462c.1.191.164.415.164.415s.277-.247.516-.349c.241-.104.553-.187.553-.187s-.09.328-.148.497c-.042.12-.079.241-.112.365l-.058.117.078.033z"
});

var _ref562 =
/*#__PURE__*/
React.createElement("path", {
  d: "M150.25 234.79l.104-.397-.106.395c0 .002.002.002.002.002l-.007.031.007-.031c1.386.499 2.087 1.653 2.087 3.002 0 1.792-1.58 3.169-3.653 3.169-2.068 0-3.733-1.379-3.733-3.169 0-1.295.646-2.721 1.945-2.969a9.546 9.546 0 00-.054-.11c-.143-.166-.405-.453-.405-.453l-.208-.231.306-.062s.584-.112.925.027c.154.064.283.146.38.218.065-.112.154-.251.26-.376v-.002c.22-.258.51-.42.51-.42l.114-.065.093.09s.329.306.437.509h.004c.033.067.062.139.087.202.106-.077.239-.162.364-.216.252-.108.576-.193.576-.193l.297-.078-.081.296s-.091.336-.151.507a6.434 6.434 0 00-.1.324zm-.159.31s-.02.002-.054-.006l-.001-.002c-.005 0-.009-.003-.015-.004l-.075-.032.067.013-.156-.262.047-.098c.032-.12.069-.241.111-.361l.056-.171a3.006 3.006 0 00-.223.085c-.218.09-.469.318-.469.318l-.212.192-.079-.275s-.057-.208-.148-.385a1.672 1.672 0 00-.264-.317c-.083.06-.204.151-.306.272a2.545 2.545 0 00-.318.501l-.11.235-.179-.189s-.177-.181-.439-.29a.966.966 0 00-.394-.049c.07.077.141.16.195.222l.012.015.009.018c.129.239.172.385.172.385l.067.214-.223.017c-1.27.095-1.854 1.451-1.854 2.646 0 1.607 1.52 2.811 3.376 2.811 1.857 0 3.298-1.204 3.298-2.811 0-1.226-.653-2.276-1.945-2.698l.165.052-.111-.046z"
});

var _ref563 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M148.395 242.626s-2.611-1.919-3.744-2.179c-1.445-.333-3.071-.062-3.775-.104.02.025.846.663 1.206 1.061.361.392 1.567 1.178 2.249 1.365 2.116.578 4.064-.143 4.064-.143zm.744.166s1.672-1.894 3.422-2.156c2.069-.312 3.422.187 4.225.414.019 0-.661.354-1.023.621-.364.271-1.295 1.121-2.719 1.138-1.429.025-3.002-.162-3.262-.119-.214.034-.431.067-.643.102z"
});

var _ref564 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.395 242.626l.063.166s-1.998.744-4.175.15c-.707-.193-1.956-1.011-2.333-1.418-.361-.397-1.187-1.04-1.208-1.062l-.28-.32.426.024c.709.042 2.347-.226 3.804.109 1.15.263 3.807 2.205 3.807 2.205l-.104.146zm-.395-.065c-.7-.499-2.503-1.735-3.388-1.941-1.156-.265-2.431-.139-3.246-.104.273.226.638.536.846.765.35.38 1.508 1.137 2.164 1.318 1.543.42 2.992.133 3.624-.038zm1.139.231l-.133-.118s1.728-1.944 3.53-2.212c2.092-.319 3.466.178 4.283.414a.156.156 0 01.116.076c.007.011.08.173-.072.26-.098.06-.676.364-.994.603-.376.281-1.347 1.154-2.823 1.175-1.414.021-2.977-.167-3.237-.123-.214.031-.428.065-.64.1l-.03-.175zm.502-.26l.112-.018c.262-.042 1.85.143 3.289.118 1.37-.019 2.264-.842 2.613-1.102.187-.139.46-.301.68-.428-.813-.237-2.027-.551-3.749-.291-1.205.183-2.374 1.166-2.945 1.721zm7.074-1.318c.013.004.023.011.036.013l-.013-.005c-.006-.004-.016-.006-.023-.008z"
});

var _ref565 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M148.316 240.06c-.657-.665-.744-1.222-.744-2.27s.412-1.992 1.069-2.653a3.775 3.775 0 011.06 2.653c0 1.048-.031 1.572-.686 2.237l-.364.274-.335-.241z"
});

var _ref566 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.192 240.185c-.697-.703-.797-1.287-.797-2.395 0-1.095.433-2.085 1.119-2.78l.127-.126.127.126c.708.718 1.112 1.726 1.11 2.78 0 1.108-.044 1.657-.736 2.36l-.009.01-.476.364-.457-.327-.008-.012zm.241-.26l.216.154s.249-.185.249-.187c.607-.622.626-1.119.626-2.102 0-.894-.318-1.752-.883-2.393a3.596 3.596 0 00-.892 2.393c0 .983.074 1.512.684 2.135z"
});

var _ref567 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006F46",
  fillRule: "nonzero",
  d: "M147.946 244.175s.43-.93.47-1.863a8.264 8.264 0 00-.102-1.553h.524s.26.832.26 1.553c0 .725-.121 1.692-.121 1.692s-.361.061-.48.123c-.121.06-.432.225-.432.225l-.189.054.07-.231z"
});

var _ref568 =
/*#__PURE__*/
React.createElement("path", {
  d: "M147.784 244.1s.418-.894.455-1.797c.033-.76-.1-1.513-.1-1.513l-.035-.21h.863l.039.125s.269.858.269 1.607c0 .736-.123 1.715-.123 1.715l-.014.131-.132.021s-.322.052-.428.104c-.118.064-.43.227-.43.227l-.017.008-.522.149.171-.557.004-.01zm.391-.004c.087-.048.183-.098.237-.127l.002-.002a2.18 2.18 0 01.401-.115c.031-.282.104-.983.104-1.54 0-.532-.145-1.123-.216-1.376h-.183c.042.289.098.833.075 1.382-.032.734-.295 1.466-.42 1.778z"
});

var _ref569 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "nonzero",
  d: "M148.368 200.381h33.014v-39.843h-33.014z"
});

var _ref570 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.192 160.359h33.367v40.199h-33.367v-40.199zm.353 39.844h32.66v-39.486h-32.66v39.486z"
});

var _ref571 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M168.975 195.169s-.408.46-.262.844c.152.383.409.784.409.784s-.014-.569.15-.725c.239-.231.684-.271.684-.271s-.351-.341-.466-.38c-.108-.04-.515-.252-.515-.252zm2.039.672s-.204.555.187.919c.387.366.722.403.722.403s-.297-.576-.204-.879c.098-.321.353-.518.353-.518s-.484-.174-.557-.154c-.073.017-.501.229-.501.229zm-5.738-24.873l.038-.44.056-.246s-1.058.096-1.616-.074a3.984 3.984 0 01-1.575-.901c-.518-.48-.724-.779-1.094-.842-.89-.154-1.578.287-1.578.287s.67.268 1.173.936c.499.673 1.041 1.012 1.28 1.095.387.129 1.74.038 2.113.052.37.021 1.203.138 1.203.138v-.005z"
});

var _ref572 =
/*#__PURE__*/
React.createElement("path", {
  d: "M165.281 171.043l-.005.002h-.008s-.004-.002-.015-.002h-.054v-.008c-.203-.027-.825-.11-1.13-.127-.261-.01-1.001.031-1.555.012-.246-.008-.458-.029-.579-.068-.241-.085-.802-.43-1.313-1.121a2.99 2.99 0 00-1.142-.912l-.129-.054.119-.075s.707-.455 1.628-.295c.199.033.353.128.526.28.162.144.345.339.605.578.509.47 1.004.713 1.548.882.547.17 1.587.077 1.587.077l.1-.011-.079.339-.042.503h-.062zm-.071-.152l.033-.374.035-.156c-.278.019-1.081.056-1.542-.085a4.012 4.012 0 01-1.605-.917c-.26-.239-.441-.434-.601-.576-.152-.131-.285-.218-.457-.245a2.33 2.33 0 00-1.406.21 3.16 3.16 0 011.071.898c.485.655 1.013.988 1.243 1.069.115.037.308.052.537.062.555.017 1.297-.025 1.557-.015.305.019.923.098 1.135.129zm3.798 24.214s.401.21.508.25a.644.644 0 01.17.11c.146.116.322.286.322.286l.11.109-.153.014s-.418.038-.643.25c-.056.056-.083.168-.102.28-.031.194-.025.391-.025.391l.006.258-.139-.216s-.262-.407-.416-.799c-.066-.17-.035-.353.029-.513a1.56 1.56 0 01.246-.403l.037-.04.05.023zm-.013.156c-.047.06-.13.177-.187.318-.049.125-.079.272-.026.408.08.206.191.415.276.565a1.89 1.89 0 01.04-.27.514.514 0 01.124-.262c.164-.158.418-.231.58-.264a2.924 2.924 0 00-.203-.177.535.535 0 00-.131-.089 8.58 8.58 0 01-.473-.229zm1.986.518s.439-.217.518-.237a.27.27 0 01.118.008c.164.035.48.147.48.147l.121.048-.102.079s-.237.183-.328.479c-.033.112-.007.261.033.401.062.224.166.426.166.426l.063.12-.133-.016s-.354-.035-.766-.42c-.421-.395-.205-.996-.205-.996l.01-.027.025-.012zm.551-.096c-.067.017-.366.166-.46.212-.031.106-.13.526.177.811.221.208.42.303.547.349a2.45 2.45 0 01-.114-.31c-.046-.17-.071-.351-.031-.484.064-.212.195-.374.284-.466a4.755 4.755 0 00-.284-.089 1.022 1.022 0 00-.119-.023z"
});

var _ref573 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M163.405 171.602l.223-.38.216.345-.439.035zm.537-.018l.26-.379.278.341-.538.038zm-.242-2.354l.539.212-.482.266-.057-.478zm.649.194l.483.133-.389.324-.094-.457z"
});

var _ref574 =
/*#__PURE__*/
React.createElement("path", {
  d: "M163.9 171.519l.297-.436.424.526-.675.047-.002-.024-.532.043-.007-.073-.062-.037.278-.482.279.436zm-.364 0l.183-.012-.089-.146-.094.158zm.406.067v-.002h-.002l.002.002zm.141-.085l.254-.017-.131-.16-.123.177zm-.383-2.271l.028-.066.538.212-.013-.054.73.201-.586.491-.108-.52-.591.329-.068-.582.07-.011zm.086.112l.029.25.255-.139-.284-.111zm.657.181l.045.225.192-.158-.237-.067z"
});

var _ref575 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#D85AAC",
  fillRule: "nonzero",
  d: "M170.218 169.351s.004.513.05 1.006c.044.472-.139.888-.069 1.15.069.262.104.472.198.661.087.191.137.675.137.675s-.253-.197-.489-.388a8.45 8.45 0 00-.395-.312c-.134-.098.048.516.069.738.025.218.144.636.335.882.189.241.567.638.686.956.123.318.098 1.027.098 1.027s-.308-.537-.572-.634c-.26-.098-.832-.445-.832-.445s.522.565.522 1.104c0 .54-.212 1.151-.212 1.151s-.237-.488-.543-.806c-.311-.318-.738-.638-.738-.638s.335.833.335 1.392c0 .566-.094 1.767-.094 1.767s-.261-.461-.523-.687c-.262-.221-.57-.416-.666-.56-.093-.147.31.462.356.83.044.368.206 1.679 1.26 3.357.613.979 1.565 2.693 3.605 2.129 2.041-.559 1.282-3.551.854-4.948-.426-1.395-.64-2.939-.615-3.48.023-.537.378-2.129.333-2.426-.05-.291-.161-1.43.095-2.345.26-.957.476-1.327.615-1.719.14-.393.26-.612.306-.957.048-.343.048-.981.048-.981s.378.761.474 1.031c.093.271.093 1.075.093 1.075s.071-.804.643-1.196c.569-.397 1.235-.81 1.401-1.031.166-.222.216-.367.216-.367s-.05 1.372-.405 1.914c-.237.349-1.164 1.493-1.164 1.493s.476-.2.808-.219c.333-.027.568 0 .568 0s-.403.344-.925 1.175c-.522.831-.31.904-.688 1.59-.383.686-.689.711-1.162 1.129-.716.624-.331 3.108-.24 3.476.096.366 1.329 3.408 1.354 4.142.023.735.143 2.376-1.044 3.43-.765.684-2.018.688-2.303.884-.287.193-.853.806-.853 2.081 0 1.276.424 1.469.757 1.79.335.317.761.147.854.393.098.243.144.39.287.538.142.145.24.316.192.584-.05.27-.595.884-.786 1.329-.191.436-.57 1.592-.57 1.762 0 .171-.044.709.119.982 0 0 .592.754.189.9-.262.098-.516-.177-.641-.146-.355.102-.538.339-.64.319-.237-.046-.237-.175-.262-.539-.023-.366-.008-.513-.114-.513-.144 0-.216.126-.241.318-.023.195-.023.638-.187.638-.167 0-.404-.32-.547-.391-.143-.073-.547-.148-.57-.341-.023-.196.237-.613.497-.688.262-.073.501-.218.333-.364-.166-.147-.333-.147-.497 0-.166.146-.52.023-.499-.2.025-.22.071-.488.048-.611-.023-.12-.31-.366.068-.59.381-.216.545.199.923.127.383-.071.574-.225.715-.466.142-.243.117-.759-.141-1.075-.262-.322-.521-.374-.619-.567a6.265 6.265 0 01-.235-.661s.068.854.023.981c-.048.12-.023.634-.023.634s-.262-.318-.474-.562c-.214-.245-.426-.978-.426-.978s-.025.685-.025.956c0 .266.284.513.191.611-.096.098-.545-.513-.663-.611-.123-.098-.501-.416-.668-.761-.166-.343-.284-.832-.332-1.006-.046-.171-.127-.934-.046-1.127.116-.293.307-.809.307-.809h-.927c-.496 0-.852-.168-1.041.198-.189.368-.096 1.104.139 2.058.239.952.379 1.42.31 1.592-.069.169-.379.564-.495.634-.122.075-.453.052-.596-.02-.142-.075-.377-.198-.83-.198-.451 0-.734.023-.898-.021-.169-.052-.572-.27-.765-.222-.189.049-.518.233-.429.515.146.441-.139.541-.33.516-.191-.027-.351-.1-.594-.17-.236-.078-.591 0-.545-.298.045-.295.141-.316.262-.536.118-.225.164-.366.031-.38-.169-.019-.335-.04-.466.078-.125.113-.328.36-.497.269-.168-.096-.297-.306-.297-.77 0-.459-.445-.86-.037-.839.407.018.929.345 1.022.097.09-.254.034-.363-.187-.559-.224-.192-.501-.306-.203-.555.297-.245.37-.245.482-.383.112-.133.27-.563.478-.457.407.21.019.518.426 1.015.41.494.667.671 1.356.592.686-.075.871-.173.871-.383 0-.209-.058-.592-.075-.748-.019-.152.093-.707.093-.707s-.316.214-.409.422c-.087.21-.274.57-.274.57s-.077-.428-.054-.778c.012-.207.079-.565.072-.634a7.295 7.295 0 00-.149-.673s-.113.519-.183.673c-.075.15-.113.767-.113.767s-.436-.416-.313-1.112c.091-.536-.076-1.243.072-1.474.146-.233.497-1.168 1.351-1.21.853-.033 1.52.042 1.818.023.297-.023 1.353-.229 1.353-.229s-1.948-1.091-2.391-1.42c-.445-.322-1.133-1.164-1.358-1.546-.22-.385-.424-1.129-.424-1.129s-.349.017-.665.208c-.316.189-.63.48-.817.705-.185.232-.48.752-.48.752s.052-.671.052-.884c0-.205-.035-.613-.035-.613s-.221.917-.668 1.262a19.02 19.02 0 00-.964.823s.058-.511.058-.629c0-.113.11-.707.11-.707s-.314.513-.796.615c-.483.092-1.189.073-1.245.401-.054.32.13.765.02.99-.114.233-.353.387-.353.387s-.277-.254-.518-.271a.866.866 0 00-.465.117s-.204-.289-.132-.481c.078-.191.445-.476.354-.594-.092-.112-.389.041-.574.135-.185.098-.576.191-.538-.135.035-.324.128-.514.035-.744-.091-.227-.035-.383.115-.439.147-.054.74.015.796-.131.054-.156-.148-.347-.539-.443-.389-.091-.576-.345-.372-.555.204-.212.262-.266.356-.459.089-.194.129-.537.48-.364.351.17.276.592.651.727.367.136 1.241-.058 1.424-.17.187-.118.779-.595.985-.713.204-.11 1.056-.803 1.056-.803s-.501-.378-.688-.573c-.185-.192-.518-.647-.68-.743-.168-.1-.985-.438-1.264-.461-.279-.021-1.131-.341-1.131-.341s.389-.137.518-.251c.131-.115.424-.406.578-.385.143.021.181.021.181.021s-.795-.042-.963-.094c-.166-.06-.648-.387-.834-.387-.184 0-.554.079-.554.079s.5-.345.908-.42c.407-.072.721-.06.721-.06s-.627-.191-.779-.42c-.146-.231-.296-.569-.408-.724-.112-.153-.185-.403-.388-.421-.204-.021-.558.268-.762.247-.201-.017-.351-.154-.371-.478-.013-.326 0-.212-.071-.38-.073-.177-.37-.578-.094-.674.283-.094.873.058.927-.056.058-.117-.313-.46-.555-.595-.241-.133-.632-.364-.426-.555.206-.189.407-.266.52-.439.112-.172.239-.648.482-.496.241.151.574.9.759.844.187-.059.204-.595.166-.824-.035-.231 0-.632.185-.594.188.037.333.303.632.326.296.019.74-.075.703.15-.037.228-.206.516-.407.765-.2.251-.294.748-.165 1.07.129.329.464.849.759 1.057.293.208.85.366 1.206.611.349.251 1.168.956 1.445 1.033.28.079.557.231.557.231s.314-.152.742-.152c.426 0 1.408.077 1.778-.095.374-.175.854-.462.706-.828-.147-.36-.962-.688-.889-.971.073-.289.372-.308.869-.329.501-.016 1.189.098 1.314-.669.13-.765.168-1.206-.532-1.376-.708-.173-1.225-.191-1.354-.748-.131-.554-.26-.687-.114-.842.151-.152.409-.229.929-.265.52-.039 1.112-.039 1.28-.176.167-.131.2-.497.406-.651.202-.15 1.002-.287 1.002-.287s.952.507 1.838 1.223c.792.646 1.507 1.598 1.507 1.598v-.012z"
});

var _ref576 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M170.304 169.351c0 .001.005.513.05.998.023.25-.014.482-.047.685-.029.181-.054.339-.024.45l.047.192c.042.172.079.321.144.453.094.205.147.713.147.714a.087.087 0 01-.148.062c-.26-.207-.518-.419-.78-.621l.057.284c.024.114.047.225.055.303.013.116.056.294.122.47.051.135.118.269.195.368l.157.191c.198.236.446.532.542.789l.001.004c.128.339.102 1.051.102 1.053a.087.087 0 01-.086.087.086.086 0 01-.079-.052c-.026-.045-.298-.505-.523-.588a4.262 4.262 0 01-.48-.24c.141.222.287.523.287.818 0 .554-.218 1.182-.219 1.183a.085.085 0 01-.112.048.079.079 0 01-.046-.045c-.022-.043-.245-.489-.527-.782a6.656 6.656 0 00-.492-.443c.101.302.237.776.237 1.139 0 .567-.094 1.773-.094 1.776a.086.086 0 01-.163.029c0-.001-.251-.443-.502-.661-.09-.076-.187-.149-.277-.218l-.031-.023c.065.146.123.304.139.436.022.181.073.597.248 1.172a8.94 8.94 0 001 2.149l.084.135c.603.971 1.539 2.478 3.425 1.957.972-.268 1.279-1.122 1.29-2.078.011-.98-.283-2.069-.496-2.762a16.465 16.465 0 01-.447-1.889c-.126-.714-.185-1.318-.171-1.62.011-.255.092-.725.172-1.19.092-.539.183-1.072.161-1.219a7.064 7.064 0 01-.062-1.272c.015-.362.061-.752.16-1.109.182-.671.345-1.058.473-1.365.054-.128.102-.243.143-.36l.115-.304c.087-.221.157-.4.188-.635.046-.335.046-.968.046-.97 0-.047.039-.086.087-.086.037 0 .068.023.08.055.039.077.384.776.476 1.034l.002.007c.038.116.061.314.075.51.099-.237.263-.5.528-.681l.441-.301c.427-.289.825-.558.94-.71.152-.205.199-.316.199-.316 0-.048.039-.087.086-.087.048 0 .087.039.087.087 0 .003-.052 1.4-.42 1.961-.145.214-.685.894-.977 1.26a2.32 2.32 0 01.545-.118l.571-.001a.087.087 0 01.062.148l-.007.006c-.052.046-.43.393-.906 1.153-.283.451-.346.673-.408.895a2.772 2.772 0 01-.278.691l-.003.005c-.271.486-.506.65-.784.845-.12.084-.251.176-.394.302-.239.209-.347.66-.382 1.167-.062.913.113 1.993.17 2.224.028.106.149.428.305.848.397 1.069 1.032 2.774 1.05 3.311l.004.111c.029.792.085 2.356-1.076 3.387-.526.469-1.261.626-1.781.738-.25.053-.449.096-.531.152l-.005.003c-.161.111-.415.362-.594.802a3.14 3.14 0 00-.215 1.205c0 1.078.309 1.352.599 1.608l.135.123c.152.142.334.174.483.2.18.031.326.056.388.221l.034.086c.073.183.122.306.235.423a.83.83 0 01.184.275.706.706 0 01.03.384c-.029.159-.195.401-.375.663-.158.231-.329.481-.417.684-.098.224-.243.631-.362 1-.112.346-.2.655-.2.73l-.002.097c-.007.215-.018.624.105.836.002.002.675.837.148 1.029-.194.073-.371-.016-.511-.086-.065-.033-.12-.061-.138-.056a1.422 1.422 0 00-.422.215l-.005.003c-.1.067-.173.116-.251.101-.294-.057-.303-.197-.329-.579l-.012-.208c-.009-.187-.013-.264-.019-.264a.11.11 0 00-.091.046l-.003.004a.416.416 0 00-.061.19l-.011.119c-.019.249-.048.598-.262.598-.135 0-.277-.133-.406-.253-.07-.064-.136-.126-.18-.147l-.143-.055c-.195-.068-.45-.157-.474-.354-.013-.126.06-.315.175-.473.103-.142.242-.268.384-.308l.004-.001a.959.959 0 00.255-.108.192.192 0 00.063-.06l.003-.019-.025-.028c-.067-.059-.132-.089-.192-.089-.061 0-.125.03-.19.089a.375.375 0 01-.285.082.48.48 0 01-.156-.042.412.412 0 01-.13-.095.285.285 0 01-.072-.217l.02-.162c.021-.171.044-.343.029-.425-.003-.016-.019-.044-.036-.075-.09-.161-.219-.391.146-.607.252-.143.417-.058.59.03l.004.003c.107.054.219.11.356.084l.005-.001a1.04 1.04 0 00.41-.154.804.804 0 00.241-.27c.066-.112.09-.296.065-.487a.985.985 0 00-.197-.489c-.127-.156-.257-.247-.364-.323-.115-.081-.21-.147-.266-.26l-.039-.087c.005.181.003.344-.016.397l-.001.006c-.033.092-.016.598-.016.599a.087.087 0 01-.086.087.088.088 0 01-.062-.026l-.01-.011c-.049-.06-.278-.338-.467-.555-.107-.122-.211-.35-.291-.557l-.009.478c0 .11.066.229.12.327l.002.004c.075.136.135.246.045.34l-.003.003c-.081.079-.202.009-.33-.117-.09-.087-.19-.204-.277-.304a2.368 2.368 0 00-.169-.186 3.667 3.667 0 01-.326-.295 2.005 2.005 0 01-.366-.496c-.147-.305-.257-.719-.316-.938l-.022-.083a4.327 4.327 0 01-.08-.699c-.008-.202 0-.392.038-.484l.264-.689h-.804c-.129 0-.253-.012-.365-.022-.279-.026-.486-.046-.6.173l-.002.004c-.084.169-.105.428-.078.759.029.344.11.763.227 1.235l.102.403c.179.702.273 1.07.204 1.242-.037.092-.136.24-.24.373-.107.136-.223.262-.29.303-.074.045-.2.062-.325.058a.944.944 0 01-.356-.075l-.008-.005a1.432 1.432 0 00-.275-.117 1.78 1.78 0 00-.507-.066l-.344.003c-.264.004-.448.007-.576-.027l-.01-.004c-.052-.016-.116-.043-.186-.072l-.004-.002c-.179-.075-.412-.171-.523-.145l-.025.008a.703.703 0 00-.263.15c-.065.062-.106.143-.082.235l.005.016c.04.121.049.223.038.305a.359.359 0 01-.086.198.365.365 0 01-.161.103l-.007.001a.486.486 0 01-.209.017 2.053 2.053 0 01-.378-.1l-.23-.072c-.06-.02-.134-.029-.204-.038l-.084-.011c-.199-.03-.356-.089-.318-.345l.002-.008c.034-.214.093-.295.167-.398l.003-.004c.03-.043.065-.09.099-.153a.923.923 0 00.101-.242l-.003-.013-.014-.002c-.144-.015-.285-.029-.384.059l-.062.06c-.143.139-.337.327-.534.22a.58.58 0 01-.249-.288 1.398 1.398 0 01-.093-.557c0-.171-.072-.341-.129-.477-.046-.11-.084-.202-.08-.28.006-.116.077-.178.262-.169.167.009.343.062.505.111.214.064.4.119.432.044.037-.106.045-.18.023-.243-.025-.067-.087-.134-.186-.223l-.109-.086c-.07-.053-.135-.102-.183-.16-.108-.128-.122-.262.09-.44.138-.113.229-.175.297-.222a.747.747 0 00.174-.148c.026-.031.057-.083.09-.14.119-.202.269-.455.494-.34.25.129.255.282.26.477.005.151.011.336.194.559.196.239.356.4.543.489.187.088.41.111.736.073h.004c.331-.036.54-.078.663-.133l.004-.002c.091-.042.123-.094.123-.162 0-.152-.031-.394-.053-.573l-.021-.164c-.011-.089.019-.302.048-.476a1.54 1.54 0 00-.198.213c-.088.21-.273.563-.273.564a.086.086 0 01-.163 0l-.004-.026a3.92 3.92 0 01-.055-.784c.007-.11.028-.258.046-.384a2.7 2.7 0 00.028-.235 3.237 3.237 0 00-.062-.317 2.53 2.53 0 01-.106.343l-.003.005c-.068.14-.102.725-.102.726a.087.087 0 01-.148.062c-.001-.001-.468-.447-.337-1.189.04-.239.027-.517.016-.767-.013-.314-.025-.591.068-.738l.073-.133c.188-.359.566-1.079 1.347-1.118.515-.019.96 0 1.298.014.224.009.401.017.517.01.207-.016.787-.122 1.112-.183-.514-.291-1.836-1.044-2.194-1.309-.207-.151-.465-.41-.705-.684a6.767 6.767 0 01-.676-.89c-.186-.324-.358-.888-.413-1.08a1.477 1.477 0 00-.557.189 3.362 3.362 0 00-.794.685c-.181.228-.471.737-.471.738a.087.087 0 01-.116.038.087.087 0 01-.047-.085c0-.007.051-.664.051-.876l-.004-.155c-.114.297-.299.672-.559.872l-.005.005c-.439.342-.95.811-.951.812a.088.088 0 01-.122 0 .083.083 0 01-.024-.078c.006-.055.056-.504.056-.614 0-.058.026-.23.054-.391-.15.155-.369.328-.635.385-.12.022-.253.039-.387.055-.376.045-.76.091-.792.276-.022.132.002.298.025.456.031.21.06.41-.011.556-.125.255-.392.427-.392.427a.086.086 0 01-.1-.017c-.001 0-.252-.23-.463-.244-.215-.019-.42.107-.421.107a.086.086 0 01-.099-.016l-.019-.028c-.054-.086-.205-.354-.132-.544l.003-.007c.037-.088.117-.184.196-.276.09-.107.179-.212.167-.228-.052-.051-.298.073-.457.154l-.008.004a.95.95 0 01-.298.097.466.466 0 01-.206-.015.233.233 0 01-.152-.16.364.364 0 01-.009-.143c.011-.104.027-.19.042-.266.031-.167.055-.298-.001-.436l-.008-.021a.508.508 0 01-.027-.322.309.309 0 01.188-.204l.012-.005c.067-.025.19-.028.324-.032.189-.005.407-.012.421-.049l.001-.004c.008-.035-.013-.079-.058-.124a.774.774 0 00-.287-.161l-.134-.039a.854.854 0 01-.401-.199.418.418 0 01-.101-.151.307.307 0 01-.012-.175.368.368 0 01.1-.173l.034-.035c.168-.176.223-.233.305-.402l.101-.25c.085-.172.214-.293.495-.155.196.095.274.25.349.401l.003.007c.066.13.133.259.291.316.142.052.375.05.61.022.322-.039.641-.125.739-.184.079-.05.24-.172.412-.301.219-.166.458-.346.576-.414l.006-.003c.166-.093.737-.549.954-.723a6.958 6.958 0 01-.611-.516c-.066-.068-.154-.174-.246-.284-.156-.187-.325-.39-.415-.443a5.899 5.899 0 00-.7-.299c-.213-.078-.419-.142-.528-.151h-.004c-.301-.025-1.145-.345-1.147-.345a.087.087 0 01-.055-.109.088.088 0 01.055-.055c.001 0 .37-.13.487-.234l.066-.059c.063-.057.142-.128.224-.191a3.12 3.12 0 01-.461-.06l-.004-.002c-.063-.022-.168-.081-.284-.145-.192-.107-.423-.236-.521-.236-.177 0-.527.074-.528.074a.085.085 0 01-.108-.054.086.086 0 01.037-.101c.062-.042.541-.359.938-.431.118-.022.226-.036.321-.045-.176-.08-.36-.187-.437-.302l-.005-.009a5.623 5.623 0 01-.202-.366c-.073-.139-.141-.27-.197-.346a1.29 1.29 0 01-.09-.145c-.065-.114-.133-.233-.238-.243-.077-.007-.206.054-.334.116-.149.072-.3.144-.425.132a.442.442 0 01-.326-.169.7.7 0 01-.126-.39c0-.268-.009-.241-.126-.477-.042-.079-.091-.17-.121-.258-.061-.174-.058-.337.141-.406.157-.051.38-.037.575-.025.161.01.3.019.302.014.005-.02-.047-.085-.119-.162a1.866 1.866 0 00-.401-.321 2.006 2.006 0 01-.397-.268c-.14-.134-.199-.282-.045-.425.089-.081.175-.142.253-.197.105-.073.197-.138.254-.226a1.71 1.71 0 00.079-.153c.032-.071.069-.148.112-.216l.005-.007c.1-.158.227-.257.404-.146.121.076.251.266.377.452.136.2.268.395.311.382.043-.017.074-.099.094-.201.035-.176.033-.401.012-.525a1.308 1.308 0 01.008-.418.538.538 0 01.062-.17l.004-.006a.21.21 0 01.144-.102.2.2 0 01.069.002c.098.019.177.081.264.149.099.077.21.165.357.176.076.004.161.002.243-.001.118-.003.235-.007.327.008l.003.001c.145.025.234.091.209.242-.02.118-.07.249-.14.381l-.003.005a2.674 2.674 0 01-.282.419l-.002.003c-.092.118-.16.295-.188.479-.027.178-.018.361.038.502a3 3 0 00.339.6c.123.172.262.328.39.418l.003.003c.134.094.333.181.54.271.231.1.473.206.662.337l.007.005c.103.075.245.186.4.309.373.295.833.657 1.012.707.228.064.453.175.538.219.103-.042.385-.143.738-.143l.328.007c.472.014 1.138.033 1.413-.095l.005-.002c.179-.085.383-.195.521-.324.124-.116.195-.249.138-.391-.061-.144-.26-.296-.45-.439-.256-.194-.497-.377-.444-.585.044-.179.158-.274.335-.326.155-.047.36-.057.614-.068l.206-.002c.433 0 .93 0 1.027-.594.062-.372.104-.665.047-.875l-.002-.007c-.054-.191-.203-.322-.513-.397l-.306-.07c-.578-.127-.99-.217-1.111-.743-.041-.174-.081-.302-.112-.402-.081-.263-.115-.375.018-.518l.005-.005a.804.804 0 01.361-.195c.154-.045.354-.074.62-.091l.343-.022c.4-.024.78-.047.89-.136l.004-.003c.059-.048.103-.151.149-.258l.003-.005c.061-.142.127-.293.252-.387.218-.161 1.038-.303 1.04-.303.02-.003.04.001.057.01.002.001.955.508 1.849 1.23l.003.003c.799.653 1.519 1.611 1.52 1.614l-.052.037h.068zm-.122 1.014c-.038-.415-.048-.84-.05-.972-.108-.141-.758-.975-1.474-1.56a13.088 13.088 0 00-1.8-1.2c-.144.025-.772.144-.936.265-.089.067-.145.195-.197.317l-.002.005c-.054.126-.107.247-.199.323l-.005.005c-.153.124-.56.148-.988.173l-.34.022a2.888 2.888 0 00-.585.085.63.63 0 00-.287.152c-.066.07-.041.153.02.349.033.107.075.244.115.414.097.419.464.5.979.613l.311.071c.382.092.566.264.638.518l.003.009c.066.243.022.554-.044.948-.121.739-.696.739-1.197.739l-.198.002c-.243.01-.437.02-.573.06-.116.034-.189.093-.216.203-.026.097.171.247.38.405.207.157.425.322.504.507l.002.006c.09.223-.006.418-.179.58a2.24 2.24 0 01-.567.356l-.005.002c-.31.145-1.001.125-1.49.11l-.324-.006c-.409 0-.703.142-.704.142a.084.084 0 01-.077 0s-.271-.148-.542-.224c-.211-.059-.685-.434-1.071-.738-.155-.122-.295-.233-.395-.305l-.004-.003a3.861 3.861 0 00-.633-.321c-.216-.094-.422-.184-.57-.289a2.012 2.012 0 01-.434-.46 3.123 3.123 0 01-.359-.637 1.175 1.175 0 01-.049-.591 1.25 1.25 0 01.222-.56l.005-.006a2.56 2.56 0 00.264-.391l.002-.004a1.13 1.13 0 00.123-.329c.004-.023-.025-.037-.068-.044a1.64 1.64 0 00-.295-.006c-.089.002-.179.005-.258 0-.203-.015-.337-.12-.454-.212a.532.532 0 00-.191-.115l-.01-.001c-.007.001-.016.01-.025.023l-.002.004a.373.373 0 00-.039.112 1.115 1.115 0 00-.007.359c.022.14.025.391-.014.586-.032.158-.096.29-.204.329l-.009.003c-.164.05-.332-.197-.504-.45-.116-.171-.235-.346-.326-.403-.061-.038-.117.015-.167.092l-.003.006a1.952 1.952 0 00-.103.199c-.032.065-.061.126-.091.173-.076.116-.18.19-.299.273-.074.053-.157.111-.235.183-.052.048-.018.111.047.173.094.09.245.178.361.241.141.079.32.222.444.355.117.125.188.255.153.345l-.004.008c-.051.111-.244.099-.469.085-.179-.011-.385-.024-.508.016-.069.025-.063.102-.034.186.026.077.071.161.11.234l.105.215c.012.027.021.042.027.071.012.051.012.195.015.259a.53.53 0 00.09.297c.05.064.121.096.202.103.08.008.209-.054.337-.116.15-.072.3-.144.426-.131.193.018.285.176.371.328l.079.128c.063.087.135.224.211.369.063.121.13.249.195.354l.004.005c.137.205.723.382.724.382.04.008.07.043.07.085a.087.087 0 01-.087.086s-.307-.012-.702.059c-.161.03-.335.101-.485.176l.112-.006c.141 0 .394.141.605.258.107.06.204.114.259.134.107.031.445.057.683.073a.246.246 0 01.08-.005l.169.02c.048 0 .087.039.087.087a.086.086 0 01-.087.086l-.239-.015c-.106.037-.28.194-.396.297l-.066.06a1.417 1.417 0 01-.332.183c.27.095.717.245.894.259.126.01.348.078.574.161.306.111.628.252.729.313.116.068.295.283.459.48.088.106.172.207.238.276.176.184.646.54.676.563l.016.015a.087.087 0 01-.011.121c-.002.002-.843.685-1.063.809l-.005.003c-.11.063-.343.239-.558.401-.174.131-.338.255-.424.309-.114.071-.466.169-.811.21-.258.031-.52.032-.689-.03-.222-.081-.305-.24-.386-.402l-.004-.007c-.062-.125-.127-.254-.269-.322-.153-.076-.222-.014-.265.074l-.099.248c-.095.195-.154.257-.338.449l-.034.035a.196.196 0 00-.055.092.128.128 0 00.006.077c.01.028.031.058.058.086a.708.708 0 00.321.155l.15.044a.96.96 0 01.353.201c.09.09.127.191.104.288l-.008.024c-.055.146-.335.154-.577.161a1.221 1.221 0 00-.27.022l-.005.001a.144.144 0 00-.089.094.349.349 0 00.024.212l.006.017c.075.185.047.338.011.533-.015.076-.03.161-.04.25l-.001.004a.195.195 0 00.004.075.066.066 0 00.045.045.277.277 0 00.124.007.753.753 0 00.24-.079l.011-.005c.206-.105.527-.267.664-.114l.008.008c.097.127-.036.284-.173.446-.069.082-.141.167-.168.23-.042.11.032.261.078.34a.903.903 0 01.444-.091c.2.015.416.168.516.248a.98.98 0 00.271-.316c.048-.098.022-.273-.005-.456-.025-.172-.05-.351-.024-.51.053-.312.502-.366.942-.419.128-.016.256-.031.372-.053.421-.089.703-.517.733-.565a.087.087 0 01.097-.051.087.087 0 01.068.102c0 .002-.109.585-.109.69 0 .067-.018.259-.035.416.19-.17.508-.447.797-.672l.005-.005c.421-.325.637-1.215.638-1.217a.086.086 0 01.169.017c0 .004.035.411.035.619 0 .107-.013.33-.026.526.096-.157.211-.336.3-.448a3.627 3.627 0 01.841-.725c.335-.203.708-.221.709-.221a.09.09 0 01.082.06c0 .002.203.737.418 1.113.119.204.376.544.656.863.232.265.48.514.677.657.428.318 2.277 1.356 2.376 1.411a.086.086 0 01-.015.162c-.003.001-1.068.208-1.368.231-.124.008-.307 0-.537-.01a15.606 15.606 0 00-1.281-.013c-.684.033-1.031.695-1.204 1.025l-.08.146c-.065.101-.054.352-.041.637.011.259.024.546-.019.802-.07.401.054.699.161.872.019-.199.053-.47.101-.572.062-.138.178-.66.178-.661a.086.086 0 01.167 0c0 .001.13.483.152.686.004.044-.011.151-.028.276a4.382 4.382 0 00-.044.37c-.011.166.001.346.015.489.052-.107.11-.228.147-.318.16-.356.428-.45.428-.45a.09.09 0 01.082-.023.087.087 0 01.063.105c0 .001-.109.535-.091.676l.02.164c.023.186.055.438.055.594 0 .14-.059.242-.224.319l-.005.002c-.139.063-.364.109-.715.148-.364.042-.616.015-.833-.089-.215-.103-.39-.278-.602-.535a.962.962 0 01-.233-.665c-.003-.137-.007-.245-.167-.327-.08-.041-.184.134-.266.273-.038.064-.073.123-.106.163-.069.084-.123.121-.209.18-.065.045-.153.105-.284.213-.107.09-.109.147-.069.196.033.04.093.086.155.134l.12.094c.12.107.197.194.233.293.038.105.029.214-.022.36-.088.23-.346.153-.644.063a2.016 2.016 0 00-.463-.103c-.06-.003-.082-.001-.083.004-.002.038.03.114.068.205.063.151.142.339.142.544 0 .22.029.377.078.488a.407.407 0 00.175.206c.085.045.225-.092.329-.193l.067-.064c.156-.14.337-.122.52-.102l.014.001c.127.015.171.087.155.206l-.001.005a1.05 1.05 0 01-.119.296 1.663 1.663 0 01-.111.173l-.004.005c-.061.085-.11.152-.137.325l-.001.006c-.016.105.068.133.172.148l.08.011c.078.009.159.019.234.044l.233.074c.124.04.231.076.347.093.041.005.09.003.134-.01l.005-.003a.192.192 0 00.085-.052.188.188 0 00.045-.104.526.526 0 00-.031-.23l-.007-.023c-.045-.168.022-.304.128-.407a.886.886 0 01.331-.191l.036-.01c.166-.041.429.068.631.152l.175.07c.109.029.282.026.531.022l.347-.004c.235 0 .416.033.556.075.136.041.234.092.307.13l.005.003a.774.774 0 00.284.057.49.49 0 00.229-.033c.05-.031.149-.141.244-.262.095-.123.185-.255.216-.332.047-.12-.042-.47-.212-1.135l-.102-.403a8.448 8.448 0 01-.231-1.263c-.03-.361-.004-.651.096-.851l.003-.006c.167-.321.424-.297.768-.264.105.009.221.02.35.02l.948.003a.086.086 0 01.063.105c0 .001-.191.517-.309.814l-.002.007c-.028.067-.033.23-.025.41.01.267.048.565.074.661l.022.083c.057.214.164.617.305.908.078.163.209.322.334.451.127.131.25.233.309.28.043.035.113.116.193.209.084.096.181.21.266.292.058.057.077.126.089.118l-.075-.141c-.063-.116-.141-.256-.141-.41 0-.268.025-.953.025-.961a.089.089 0 01.059-.077.086.086 0 01.109.054c.001.002.21.722.41.95l.314.369c-.001-.149.005-.326.035-.41.042-.118-.022-.899-.026-.94a.088.088 0 01.065-.101.086.086 0 01.104.064c0 .001.137.453.229.644.038.074.116.129.211.196.116.082.256.18.398.355.133.162.209.373.235.575.03.228-.003.454-.086.597a.953.953 0 01-.293.325 1.216 1.216 0 01-.475.182l-.005.001c-.195.037-.335-.033-.468-.101l-.005-.002c-.129-.067-.254-.13-.424-.034-.217.129-.138.272-.082.373.025.046.048.086.056.126.019.107-.005.295-.028.48l-.02.158a.124.124 0 00.031.085c.018.02.044.039.073.053a.317.317 0 00.099.027.209.209 0 00.155-.041.455.455 0 01.304-.132.462.462 0 01.37.212.183.183 0 01-.004.18.364.364 0 01-.12.121 1.104 1.104 0 01-.302.13l-.004.001c-.103.029-.21.129-.292.243-.092.126-.151.267-.143.35.011.091.208.16.359.213.064.021.123.042.164.063.066.034.141.103.22.176.104.098.22.206.288.206.056 0 .076-.256.09-.438l.011-.122a.596.596 0 01.094-.277l.004-.006a.276.276 0 01.229-.114c.169 0 .176.126.191.426l.012.207c.019.285.027.389.19.421a.57.57 0 00.121-.074l.005-.003c.11-.075.261-.179.47-.238l.006-.002c.08-.02.162.021.259.069.11.056.248.125.373.079.276-.099-.23-.77-.232-.771l-.002-.004c-.151-.254-.138-.699-.132-.932l.002-.093c0-.092.092-.421.209-.783.12-.372.268-.786.367-1.012.096-.224.271-.48.433-.716.169-.247.325-.474.348-.596a.54.54 0 00-.021-.292.666.666 0 00-.148-.217c-.137-.142-.191-.278-.27-.479l-.035-.089c-.028-.073-.13-.09-.256-.112-.173-.03-.382-.067-.572-.245l-.131-.118c-.318-.281-.658-.583-.658-1.738 0-.527.095-.946.228-1.27.196-.479.477-.756.657-.879l.005-.004c.11-.075.323-.121.592-.179.502-.107 1.212-.259 1.702-.696 1.101-.978 1.046-2.488 1.019-3.253l-.004-.112c-.017-.508-.646-2.197-1.04-3.255a18.02 18.02 0 01-.31-.863l-.001-.005c-.058-.237-.238-1.343-.174-2.277.038-.547.161-1.041.44-1.285.152-.133.285-.226.409-.313.261-.183.481-.337.733-.789l.002-.004c.163-.295.214-.475.263-.653.066-.234.132-.469.428-.941.334-.533.62-.868.785-1.042h-.355c-.307.019-.74.196-.768.208a.086.086 0 01-.109-.129c.003-.003.886-1.082 1.161-1.487.227-.348.325-1.059.365-1.496l-.035.048c-.133.177-.542.454-.981.75l-.441.301c-.494.338-.592 1.017-.604 1.124a.087.087 0 01-.173 0c0-.002-.001-.78-.087-1.041l-.001-.005a9.875 9.875 0 00-.313-.698 6.7 6.7 0 01-.042.631c-.034.257-.107.443-.198.675l-.112.298c-.042.118-.092.237-.147.37a9.32 9.32 0 00-.466 1.344c-.096.343-.14.72-.155 1.07a6.85 6.85 0 00.06 1.233l.001.006c.026.174-.067.721-.162 1.274-.079.461-.16.927-.17 1.168-.013.291.045.881.169 1.584.102.583.252 1.242.442 1.868.216.704.515 1.811.503 2.815-.012 1.025-.347 1.946-1.411 2.24l-.005.001c-2.011.556-2.988-1.017-3.618-2.031l-.084-.135a9.157 9.157 0 01-1.018-2.191 6.555 6.555 0 01-.254-1.202c-.027-.22-.2-.547-.295-.712l-.061-.103a.087.087 0 01.028-.119.087.087 0 01.119.028l.009.015c.056.084.203.196.367.321.093.07.192.146.284.223.149.129.297.329.402.485a26.99 26.99 0 00.073-1.497c0-.524-.301-1.293-.323-1.351a.09.09 0 01.003-.091.088.088 0 01.12-.024c.001.001.433.326.751.649.195.203.361.469.461.645.061-.218.147-.587.147-.928 0-.505-.496-1.042-.497-1.043a.087.087 0 01.113-.13c.001.001.557.337.811.433.16.06.333.261.454.429-.004-.227-.024-.533-.09-.707-.087-.232-.325-.516-.515-.742l-.161-.196a1.655 1.655 0 01-.22-.413 2.365 2.365 0 01-.132-.511c-.006-.065-.029-.175-.052-.288-.041-.193-.084-.399-.051-.489l.011-.024c.039-.053.088-.065.152-.023.229.151.511.404.729.579a1.983 1.983 0 00-.104-.442c-.073-.149-.111-.306-.155-.487l-.047-.188c-.039-.145-.011-.321.021-.522.031-.193.066-.413.045-.642z"
});

var _ref577 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M163.384 168.813s-.11-.348-.13-.441l-.032-.208s.535-.005.516.185c-.019.193-.187.193-.222.268-.038.077-.132.196-.132.196z"
});

var _ref578 =
/*#__PURE__*/
React.createElement("path", {
  d: "M163.222 168.235l-.016-.144h.016s.281 0 .441.068c.1.04.154.109.145.198a.285.285 0 01-.134.231c-.025.017-.05.029-.071.044a.067.067 0 00-.023.016c-.039.083-.139.208-.139.208l-.057-.043-.068.02s-.112-.351-.133-.449a4.886 4.886 0 01-.031-.208v-.002l.07.061zm.19.42a.395.395 0 00.037-.069l.002-.002a.203.203 0 01.09-.083c.045-.027.114-.057.126-.158 0-.013-.01-.021-.021-.027a.25.25 0 00-.099-.044 1.335 1.335 0 00-.239-.033c.004.037.01.078.016.118.013.056.054.191.088.298z"
});

var _ref579 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M166.019 167.814l-.038-.307s.501.006.742.189c.373.289.611.73.593.748-.065.069-.352-.191-.555-.266 0 0-.148.038-.297.038-.15 0-.223-.075-.244-.154-.014-.077.021-.21.021-.21l-.222-.035v-.003z"
});

var _ref580 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.176 167.896l-.157-.023v-.005s-.05-.004-.052-.047c.004.041.052.046.052.046s-.052-.067-.052-.053l.052.053-.052-.046v-.004l-.048-.364h.062s.524.008.774.202c.307.234.525.573.59.708a.225.225 0 01.027.075.055.055 0 01-.017.044.093.093 0 01-.072.027.254.254 0 01-.1-.029c-.115-.056-.287-.189-.426-.248a1.236 1.236 0 01-.293.036c-.183 0-.273-.096-.296-.192v-.002a.486.486 0 01.008-.178zm-.107-.127l.201.031.025.064-.004.004c-.004.021-.029.119-.017.184.015.058.075.11.19.11.141 0 .282-.038.282-.038l.019-.004.015.006c.143.055.33.198.45.256l.007.002a2.204 2.204 0 00-.547-.642c-.179-.142-.511-.171-.647-.179l.026.206zM169.698 172.101c.019.034.011.079-.023.1-.033.023-.076.013-.099-.021 0 0-.227-.351-.281-.47-.06-.114-.154-.347-.154-.347-.017-.037.002-.079.04-.095.037-.013.081.006.093.041 0 0 .094.227.148.339.054.114.276.453.276.453z"
});

var _ref581 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M156.06 168.694s.314.247.555.287c.24.039.501.039.539.039.035 0 .114-.386.075-.648-.131-.865-.855-1.057-.855-1.057s.214.524.111.765a2.15 2.15 0 01-.425.614z"
});

var _ref582 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.06 168.694l-.052-.05s.269-.26.41-.592c.037-.086.025-.21.002-.331a2.29 2.29 0 00-.112-.376l-.056-.135.141.037s.769.2.906 1.112c.034.223-.012.528-.051.641a.175.175 0 01-.044.076.093.093 0 01-.05.015c-.038 0-.304 0-.549-.04-.256-.041-.59-.299-.59-.299l.045-.058zm.109-.008c.099.07.297.197.459.222.189.033.395.039.484.039a.464.464 0 00.021-.074c.027-.129.046-.333.023-.491-.087-.58-.453-.838-.659-.94.021.071.048.158.067.252.029.152.035.308-.013.416-.11.255-.289.474-.382.576z"
});

var _ref583 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M156.06 168.694s.314.247.555.287c.24.039.501.039.539.039.035 0 .114-.386.075-.648-.131-.865-.855-1.057-.855-1.057s.214.524.111.765a2.15 2.15 0 01-.425.614z"
});

var _ref584 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.036 168.767h-.157l.129-.123s.269-.26.41-.592c.037-.086.025-.21.002-.331a2.29 2.29 0 00-.112-.376l-.056-.135.141.037s.769.2.906 1.112c.034.223-.012.528-.051.641a.175.175 0 01-.044.076.093.093 0 01-.05.015c-.038 0-.304 0-.549-.04-.218-.035-.493-.228-.569-.284zm.133-.081c.099.07.297.197.459.222.189.033.395.039.484.039a.464.464 0 00.021-.074c.027-.129.046-.333.023-.491-.087-.58-.453-.838-.659-.94.021.071.048.158.067.252.029.152.035.308-.013.416-.11.255-.289.474-.382.576z"
});

var _ref585 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M154.555 169.442s-.276-.557-.871-.482c-.59.079-.983.58-.983.58s.657-.025.817.092c.243.174.316.615.316.615s.353-.231.466-.384c.108-.155.255-.421.255-.421z"
});

var _ref586 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.555 169.442l.062.036s-.147.27-.259.428c-.117.158-.485.401-.485.401l-.093.06-.017-.11s-.027-.147-.095-.305a.648.648 0 00-.192-.262.566.566 0 00-.214-.058c-.245-.034-.557-.021-.557-.021l-.156.006.096-.123s.409-.526 1.031-.605c.642-.081.944.52.944.52l-.065.033zm-.081 0c-.066-.112-.32-.467-.777-.409-.387.05-.68.285-.83.43.117.002.276.008.412.025.122.019.226.044.282.085.107.077.183.2.24.321.037.087.064.17.078.234.109-.074.289-.207.36-.307.086-.119.191-.304.235-.379z"
});

var _ref587 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M154.555 169.442s-.276-.557-.871-.482c-.59.079-.983.58-.983.58s.657-.025.817.092c.243.174.316.615.316.615s.353-.231.466-.384c.108-.155.255-.421.255-.421z"
});

var _ref588 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.617 169.478s-.147.27-.259.428c-.117.158-.485.401-.485.401l-.093.06-.017-.11s-.027-.147-.095-.305a.648.648 0 00-.192-.262.566.566 0 00-.214-.058c-.245-.034-.557-.021-.557-.021l-.156.006.096-.123s.409-.526 1.031-.605c.642-.081.944.52.944.52l.018.035-.021.034zm-.143-.036c-.069-.112-.32-.467-.777-.409-.387.05-.68.285-.83.43.117.002.276.008.412.025.122.019.226.044.282.085.107.077.183.2.24.321.037.087.064.17.078.232.109-.072.289-.205.36-.305.086-.119.191-.304.235-.379z"
});

var _ref589 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M153.834 171.679s-.499.077-.78.422c-.278.347-.239.996-.239.996s.331-.38.63-.38c.297 0 .761.114.761.114s-.148-.405-.148-.576c0-.172-.224-.576-.224-.576z"
});

var _ref590 =
/*#__PURE__*/
React.createElement("path", {
  d: "M153.834 171.679l.062-.035s.113.204.181.385a.75.75 0 01.052.226c0 .164.143.553.143.553l.046.125-.131-.031s-.451-.113-.742-.113c-.106 0-.214.057-.31.123-.154.104-.266.235-.266.235l-.116.131-.011-.177s-.037-.682.258-1.043c.295-.366.821-.449.821-.449l.013.07zm-.037.081c-.129.03-.477.127-.685.389-.178.219-.218.57-.226.776.048-.042.106-.09.166-.133a.737.737 0 01.393-.146c.206 0 .489.052.651.085-.046-.137-.112-.362-.112-.476a.548.548 0 00-.042-.174 3.132 3.132 0 00-.145-.321z"
});

var _ref591 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M153.834 171.679s-.499.077-.78.422c-.278.347-.239.996-.239.996s.331-.38.63-.38c.297 0 .761.114.761.114s-.148-.405-.148-.576c0-.172-.224-.576-.224-.576z"
});

var _ref592 =
/*#__PURE__*/
React.createElement("path", {
  d: "M153.896 171.644s.113.204.181.385a.75.75 0 01.052.226c0 .164.143.553.143.553l.046.125-.131-.031s-.451-.113-.742-.113c-.106 0-.214.057-.31.123-.154.104-.266.235-.266.235l-.116.131-.011-.177s-.037-.682.258-1.043c.295-.366.821-.449.821-.449l.05-.011.025.046zm-.099.116c-.129.03-.477.127-.685.389-.178.219-.218.57-.226.776.048-.042.106-.09.166-.133a.737.737 0 01.393-.146c.206 0 .489.052.651.085-.046-.137-.112-.362-.112-.476a.548.548 0 00-.042-.174 3.132 3.132 0 00-.145-.321z"
});

var _ref593 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M160.751 173.99c-.001 0-.501.159-.68.446a1.428 1.428 0 00-.205.582c.184-.115.541-.277.961-.154l.382.121c.231.076.306.101.465.09.231-.019.811-.246.812-.246a.073.073 0 01.094.039.075.075 0 01-.013.075c-.036.046-.457.602-.41.979v.005c.021.152.046.28.066.389.034.179.057.306.048.445-.026.351-.192.751-.302.984a3.24 3.24 0 01.509-.161 2.73 2.73 0 00.578-.214 3.08 3.08 0 00.543-.345c.243-.202.58-.716.581-.717a.072.072 0 01.1-.015.072.072 0 01.027.072c.001.001-.105.687-.002.976.083.237.126.787.143 1.057.115-.102.298-.255.456-.346l.03-.019c.142-.085.428-.256.539-.452.086-.155.197-.74.197-.741a.072.072 0 01.141 0l.001.01c.011.082.088.654.248.926l.001.004c.135.22.31.744.404 1.041.075-.208.198-.511.33-.673.1-.125.211-.268.296-.399.082-.126.143-.246.15-.329l.001-.008c.016-.185-.048-.572-.048-.573a.072.072 0 01.045-.091.073.073 0 01.089.04l.256.61-.133.056-.064-.152-.002.13c-.009.108-.079.25-.173.395a5.1 5.1 0 01-.306.411c-.195.241-.374.83-.374.831a.073.073 0 01-.051.056.073.073 0 01-.089-.05c0-.002-.272-.925-.453-1.221l-.003-.005c-.098-.166-.164-.406-.206-.608a2.051 2.051 0 01-.13.408c-.132.231-.44.416-.592.507l-.032.02c-.237.136-.54.429-.541.43l-.021.014c-.095.145-.377.542-.748.777-.218.142-.928.541-.929.541l-.073-.123c.001-.001.709-.398.924-.539.387-.246.668-.672.722-.759-.008-.169-.048-.865-.141-1.128-.067-.19-.056-.522-.035-.762a3.072 3.072 0 01-.444.509c-.149.118-.344.25-.57.363a2.918 2.918 0 01-.608.225c-.414.099-.618.212-.662.238l-.008.005a.072.072 0 01-.095-.1c.001-.001.343-.614.381-1.116a1.626 1.626 0 00-.045-.405l-.018-.094c-.088.052-.491.288-.586.322-.05.017-.198.128-.366.255a8.531 8.531 0 01-.434.311c-.281.184-.585.755-.586.757l-.128-.065c0-.001.324-.608.636-.812.131-.085.286-.202.425-.306.178-.134.335-.251.406-.276.112-.039.584-.324.585-.324l.036.07-.039-.245c-.037-.296.167-.674.311-.897-.199.07-.486.164-.639.177-.19.013-.271-.014-.523-.097l-.377-.12c-.534-.157-.948.212-.949.213a.072.072 0 01-.123-.051c0-.001-.017-.402.236-.804.207-.331.765-.51.766-.51l.035.14z"
});

var _ref594 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M155.52 178.916s-.277-.322-.759-.229c-.482.096-.796.693-.796.693s.407-.119.648-.06c.24.06.408.326.408.326s.222-.212.295-.326c.073-.113.202-.404.202-.404h.002z"
});

var _ref595 =
/*#__PURE__*/
React.createElement("path", {
  d: "M155.518 178.916l.066.029s-.131.298-.208.414c-.074.119-.305.337-.305.337l-.065.062-.045-.075s-.15-.239-.364-.293c-.229-.056-.613.059-.613.059l-.165.045.081-.149s.117-.223.321-.424c.141-.138.317-.263.525-.304a.894.894 0 01.828.251l-.056.048zm-.085.015a.763.763 0 00-.659-.173.944.944 0 00-.454.266 2.118 2.118 0 00-.203.243c.149-.026.361-.054.513-.018.181.046.328.197.401.287.069-.069.177-.183.225-.256.054-.085.139-.264.177-.349z"
});

var _ref596 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M155.52 178.916s-.277-.322-.759-.229c-.482.096-.796.693-.796.693s.407-.119.648-.06c.24.06.408.326.408.326s.222-.212.295-.326c.073-.113.202-.404.202-.404h.002z"
});

var _ref597 =
/*#__PURE__*/
React.createElement("path", {
  d: "M155.52 178.987l.064-.042s-.131.298-.208.414c-.074.119-.305.337-.305.337l-.065.062-.045-.075s-.15-.239-.364-.293c-.229-.056-.613.059-.613.059l-.165.045.081-.149s.117-.223.321-.424c.141-.138.317-.263.525-.304a.894.894 0 01.828.251l-.054.119zm-.033.002l-.021-.027-.033-.031a.763.763 0 00-.659-.173.944.944 0 00-.454.266 2.118 2.118 0 00-.203.243c.149-.026.361-.054.513-.018.181.046.328.197.401.287.069-.069.177-.183.225-.256.054-.085.139-.264.177-.349l-.026.058h.08zm-.036-.1v-.002.002z"
});

var _ref598 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M154.965 181.039s-.41-.075-.759.233c-.354.307-.372.898-.372.898s.334-.306.596-.266c.256.035.572.191.572.191l.073-.46c.058-.268-.11-.596-.11-.596z"
});

var _ref599 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.965 181.039l.064-.029s.177.351.117.64c-.017.096-.073.455-.073.455l-.015.098-.087-.044s-.304-.147-.553-.182h-.002c-.087-.015-.187.022-.277.068-.143.075-.257.179-.257.179l-.127.118.006-.174s.023-.624.397-.95c.379-.331.819-.248.819-.248l-.012.069zm-.05.071a.886.886 0 00-.663.216c-.217.191-.3.496-.331.684.046-.031.096-.063.152-.092a.632.632 0 01.366-.085c.181.025.39.106.505.158l.06-.368v-.002c.042-.198-.05-.428-.089-.511z"
});

var _ref600 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M154.965 181.039s-.41-.075-.759.233c-.354.307-.372.898-.372.898s.334-.306.596-.266c.256.035.572.191.572.191l.073-.46c.058-.268-.11-.596-.11-.596z"
});

var _ref601 =
/*#__PURE__*/
React.createElement("path", {
  d: "M155.029 181.01s.177.351.117.64c-.017.096-.073.455-.073.455l-.015.098-.087-.044s-.304-.147-.553-.182h-.002c-.087-.015-.187.022-.277.068-.143.075-.257.179-.257.179l-.127.118.006-.174s.023-.624.397-.95c.379-.331.819-.248.819-.248l.035.007.017.033zm-.114.1a.886.886 0 00-.663.216c-.217.191-.3.496-.331.684.046-.031.096-.063.152-.092a.632.632 0 01.366-.085c.181.025.39.106.505.158l.06-.368v-.002c.042-.198-.05-.428-.089-.511z"
});

var _ref602 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M155.911 182.997s-.027.568.222.917c.262.366.742.42.742.42s-.162-.381-.187-.574c-.037-.285.223-.536.223-.536s-.239-.266-.479-.266c-.243 0-.521.039-.521.039z"
});

var _ref603 =
/*#__PURE__*/
React.createElement("path", {
  d: "M155.911 182.997l-.009-.072s.281-.038.53-.038c.108 0 .219.046.31.104.119.073.202.164.221.181.058.064-.052.124-.052.124l.052-.018s-.233.218-.202.474c.023.185.181.553.181.553l.05.116-.123-.012s-.516-.063-.794-.453c-.262-.366-.235-.963-.235-.963l.071.004zm.9.231a.773.773 0 00-.146-.114.435.435 0 00-.233-.084 4.6 4.6 0 00-.451.029c.002.152.023.549.213.811.159.229.415.327.567.366a2.405 2.405 0 01-.143-.468c-.032-.232.116-.444.193-.54z"
});

var _ref604 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M155.911 182.997s-.027.568.222.917c.262.366.742.42.742.42s-.162-.381-.187-.574c-.037-.285.223-.536.223-.536s-.239-.266-.479-.266c-.243 0-.521.039-.521.039z"
});

var _ref605 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.911 183.296l.052-.018s-.233.218-.202.474c.023.185.181.553.181.553l.05.116-.123-.012s-.516-.063-.794-.453c-.262-.366-.235-.963-.235-.963l.002-.06.06-.008s.281-.038.53-.038c.108 0 .219.046.31.104.119.073.202.164.221.181.058.064-.052.124-.052.124zm-.1-.068a.773.773 0 00-.146-.114.435.435 0 00-.233-.084 4.6 4.6 0 00-.451.029c.002.152.023.549.213.811.159.229.415.327.567.366a2.405 2.405 0 01-.143-.468c-.032-.232.116-.444.193-.54zM166.813 184.012l.083-.121s.486.331.871.759c.264.295.474.638.457.952-.039.763-.754 1.763-.754 1.763l-.119-.083s.691-.956.73-1.686c.015-.283-.185-.584-.424-.851-.37-.415-.844-.733-.844-.733z"
});

var _ref606 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M160.734 188.033s-.335-.462-.797-.443c-.465.022-.949.497-.949.497s.578-.054.723.151c.152.216.299.481.299.481s.258-.152.37-.248c.113-.093.354-.438.354-.438z"
});

var _ref607 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160.734 188.033l.056.039s-.247.357-.362.453c-.116.1-.382.256-.382.256l-.065.035-.035-.062s-.143-.262-.293-.472c-.05-.069-.158-.098-.27-.116-.187-.028-.387-.009-.387-.009l-.202.017.144-.141s.507-.495.995-.514c.497-.021.857.47.857.47l-.056.044zm-.092.001c-.089-.105-.357-.384-.702-.371-.289.014-.585.207-.753.346.098 0 .216.009.322.036a.45.45 0 01.262.154c.106.151.21.326.264.42.081-.05.225-.137.3-.202.083-.071.241-.289.307-.383z"
});

var _ref608 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M160.734 188.033s-.335-.462-.797-.443c-.465.022-.949.497-.949.497s.578-.054.723.151c.152.216.299.481.299.481s.258-.152.37-.248c.113-.093.354-.438.354-.438z"
});

var _ref609 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160.79 188.072s-.247.357-.362.453c-.116.1-.382.256-.382.256l-.065.035-.035-.062s-.143-.262-.293-.472c-.05-.069-.158-.098-.27-.116-.187-.028-.387-.009-.387-.009l-.202.017.144-.141s.507-.495.995-.514c.497-.021.857.47.857.47l.029.041-.029.042zm-.148-.038c-.089-.105-.357-.384-.702-.371-.289.014-.585.207-.753.346.098 0 .216.009.322.036a.45.45 0 01.262.154c.106.151.21.326.264.42.081-.05.225-.137.3-.202.083-.071.241-.289.307-.383z"
});

var _ref610 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M159.304 190.041s-.61-.096-.907.249c-.297.343-.279.975-.279.975s.37-.439.703-.403c.335.039.707.233.707.233s-.056-.383-.094-.557c-.037-.173-.13-.497-.13-.497z"
});

var _ref611 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159.304 190.041l.07-.019s.094.326.131.501c.038.174.096.562.096.562l.019.139-.125-.065s-.358-.189-.682-.224c-.114-.013-.237.046-.341.114-.171.112-.3.264-.3.264l-.12.142-.006-.188s-.017-.665.295-1.027a.85.85 0 01.491-.258c.251-.049.482-.014.482-.014l-.01.073zm-.057.064a1.52 1.52 0 00-.39.019.706.706 0 00-.406.212c-.185.214-.239.545-.254.746.053-.05.119-.104.196-.154.133-.089.289-.152.439-.137.222.027.463.117.605.179-.021-.125-.052-.31-.073-.416a7.308 7.308 0 00-.117-.449z"
});

var _ref612 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M159.304 190.041s-.61-.096-.907.249c-.297.343-.279.975-.279.975s.37-.439.703-.403c.335.039.707.233.707.233s-.056-.383-.094-.557c-.037-.173-.13-.497-.13-.497z"
});

var _ref613 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159.374 190.022s.094.326.131.501c.038.174.096.561.096.561l.019.14-.125-.065s-.358-.189-.682-.225c-.114-.012-.237.047-.341.115-.171.112-.3.264-.3.264l-.12.142-.006-.188s-.017-.665.295-1.027a.85.85 0 01.491-.258c.251-.049.482-.014.482-.014l.048.01.012.044zm-.127.083a1.52 1.52 0 00-.39.019.706.706 0 00-.406.212c-.185.214-.239.545-.254.746.053-.05.119-.104.196-.154.133-.089.289-.152.439-.137.222.027.463.117.605.179-.021-.125-.052-.31-.073-.416a7.308 7.308 0 00-.117-.449z"
});

var _ref614 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DB4446",
  fillRule: "nonzero",
  d: "M160.622 192.165s-.296.46-.073.824c.222.365.684.538.684.538s-.164-.266-.092-.576c.061-.245.445-.574.445-.574l-.964-.21v-.002z"
});

var _ref615 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160.622 192.165l.016-.068 1.106.239-.11.096s-.135.116-.256.257a.85.85 0 00-.166.277.754.754 0 00.083.524l.11.179-.197-.075s-.489-.181-.722-.568a.688.688 0 01-.078-.497c.039-.226.155-.401.155-.401l.059.037zm.035.085c-.029.061-.085.173-.108.306a.57.57 0 00.06.395c.127.208.337.349.485.431a.826.826 0 01-.021-.449.927.927 0 01.195-.337c.058-.067.119-.131.168-.177l-.779-.169z"
});

var _ref616 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M160.622 192.165s-.296.46-.073.824c.222.365.684.538.684.538s-.164-.266-.092-.576c.061-.245.445-.574.445-.574l-.964-.21v-.002zm8.141.865s-.534-.137-.834.057c-.295.191-.538.995-.538.995s.484-.441.838-.387c.349.061.611.212.611.212s.052-.326.014-.553c-.018-.137-.091-.324-.091-.324z"
});

var _ref617 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160.622 192.238v-.143l1.122.241-.11.096s-.135.116-.256.257a.85.85 0 00-.166.277.754.754 0 00.083.524l.11.179-.197-.075s-.489-.181-.722-.568a.688.688 0 01-.078-.497c.039-.226.155-.401.155-.401l.059.11zm.035.012c-.029.061-.085.173-.108.306a.57.57 0 00.06.395c.127.208.337.349.485.431a.826.826 0 01-.021-.449.927.927 0 01.195-.337c.058-.067.119-.131.168-.177l-.779-.169zm8.106.78l.068-.027s.073.196.094.341c.041.235-.015.576-.015.576l-.018.104-.09-.054s-.249-.146-.586-.204c-.129-.018-.272.036-.401.104a2.194 2.194 0 00-.374.264l-.192.177.073-.252s.123-.401.297-.709c.081-.143.173-.263.271-.326.128-.085.301-.112.459-.112.229-.004.43.048.43.048l-.016.07zm-.054.061a1.756 1.756 0 00-.358-.036.684.684 0 00-.382.092c-.111.07-.211.235-.291.403-.057.112-.102.229-.138.322.06-.041.131-.087.206-.127.158-.085.337-.145.493-.12.237.039.432.12.543.172.01-.11.026-.291.001-.432-.014-.096-.054-.214-.074-.274z"
});

var _ref618 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M168.763 193.03s-.534-.137-.834.057c-.295.191-.538.995-.538.995s.484-.441.838-.387c.349.061.611.212.611.212s.052-.326.014-.553c-.018-.137-.091-.324-.091-.324z"
});

var _ref619 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.763 192.955c.01.002.016.005.016.005l-.016-.005v-.129l.068.177s.073.196.094.341c.041.235-.015.576-.015.576l-.018.104-.09-.054s-.249-.146-.586-.204c-.129-.018-.272.036-.401.104a2.194 2.194 0 00-.374.264l-.192.177.073-.252s.123-.401.297-.709c.081-.143.173-.263.271-.326.128-.085.301-.112.459-.112.189-.005.36.033.414.043zm-.05.138l-.004-.002.054.141-.05-.139zm-.004-.002a1.756 1.756 0 00-.358-.036.684.684 0 00-.382.092c-.111.07-.211.235-.291.403-.057.112-.102.229-.138.322.06-.041.131-.087.206-.127.158-.085.337-.145.493-.12.237.039.432.12.543.172.01-.11.026-.291.001-.432-.014-.096-.054-.214-.074-.274zm-.013-.036z"
});

var _ref620 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M169.838 166.283l-.189.016a1.227 1.227 0 01-.175.256c-.169.174-.422.193-.564.045a.37.37 0 01-.091-.293.312.312 0 01-.335-.004c-.17-.106-.212-.359-.087-.572.019-.039.039-.093.069-.124l-.015-.231-.229.06-.066.135c-.142.177-.354.223-.458.119-.052-.05-.062-.09-.087-.189-.052.048-.056.062-.112.077-.354.093-.493-.749-.499-.969l-.119.181s.104.503.054.931a5.535 5.535 0 01-.191.853c.491.135 1.225.569 1.952 1.182.728.607 1.302 1.269 1.537 1.728 0 0 .376-.227.773-.364.393-.141.892-.143.892-.143l.141-.15c-.212.031-1.037.071-1.023-.31.002-.056-.008-.062.067-.147-.131 0-.15.012-.21-.027-.121-.086-.119-.308.015-.489l.116-.091.006-.244-.222.033c-.019.028-.071.063-.1.094-.175.167-.424.179-.564.023a.335.335 0 01-.072-.333.34.34 0 01-.298-.033c-.168-.11-.201-.372-.07-.574.062-.099.183-.218.203-.228l-.045-.214-.004-.004z"
});

var _ref621 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.838 166.289l.056-.015.054.254-.033.018a.928.928 0 00-.183.211v.001c-.115.175-.094.404.052.502a.302.302 0 00.251.026l.098-.031-.029.098a.28.28 0 00.062.281c.119.133.335.116.485-.025.026-.029.072-.061.093-.088l.012-.02.312-.046-.012.334s-.129.102-.131.102a.425.425 0 00-.083.287.17.17 0 00.062.121.113.113 0 00.067.021c.027 0 .062-.004.112-.004h.127l-.088.091a.326.326 0 00-.05.065c-.004.016 0 .026 0 .05-.006.124.109.187.25.224.25.067.586.046.709.025l.154-.025-.266.285h-.021s-.491.004-.876.139c-.388.135-.762.362-.762.362l-.048.031-.027-.054c-.235-.455-.803-1.11-1.526-1.711-.717-.605-1.445-1.037-1.927-1.173l-.056-.016.016-.052s.137-.422.187-.844c.054-.418-.048-.913-.048-.913l-.006-.023.221-.341.006.173c.004.127.056.472.168.707a.497.497 0 00.125.176c.039.034.087.046.139.034.048-.015.05-.025.09-.063l.068-.064.023.091c.019.084.025.119.071.163a.156.156 0 00.122.037.38.38 0 00.252-.148l.075-.151.318-.084.017.322-.017.017c-.025.027-.044.075-.058.11l-.002.002v.003c-.109.18-.077.405.068.498a.277.277 0 00.281.002l.091-.051-.01.104a.315.315 0 00.077.251c.123.125.339.102.484-.052h.002c.073-.073.152-.208.163-.233l.01-.033.224-.017.005.059zm-.038.051c-.05.005-.119.009-.119.009-.031.06-.101.175-.17.243-.191.198-.476.214-.64.046a.412.412 0 01-.106-.245.376.376 0 01-.31-.044c-.191-.119-.245-.405-.108-.642.019-.038.037-.084.062-.117l-.006-.145-.143.035-.056.12-.004.007a.496.496 0 01-.331.191.273.273 0 01-.21-.069.243.243 0 01-.077-.129.176.176 0 01-.071.029c-.129.036-.235-.026-.32-.147-.127-.181-.202-.503-.233-.713l-.019.031c.019.102.096.545.048.927-.041.341-.137.68-.174.809.495.156 1.208.584 1.919 1.179.706.59 1.27 1.231 1.521 1.694.117-.067.42-.233.734-.341.35-.125.782-.141.886-.143l.027-.032a2.004 2.004 0 01-.603-.043c-.2-.05-.341-.156-.333-.335 0-.035 0-.054.009-.079l.002-.01a.194.194 0 01-.133-.038.278.278 0 01-.108-.195.527.527 0 01.11-.372l.004-.007.102-.08.004-.154-.137.02c-.027.03-.065.059-.092.088-.199.185-.482.193-.64.018a.375.375 0 01-.102-.299.384.384 0 01-.258-.058c-.191-.125-.235-.42-.085-.651.048-.083.137-.172.187-.218l-.027-.14z"
});

var _ref622 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M168.983 167.347l-.214-.179c-.037-.033-.052-.087-.027-.119.025-.026.077-.026.116.005l.215.181.218.18c.035.032.052.086.027.119-.027.027-.079.025-.117-.006l-.218-.181zm-1.143-.853l-.169-.108c-.046-.029-.064-.083-.046-.118.017-.038.071-.042.111-.015l.17.11.173.109c.039.024.06.077.043.118-.018.031-.068.04-.112.01l-.17-.106z"
});

var _ref623 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.948 167.39l-.212-.183c-.065-.051-.077-.141-.033-.193.039-.045.122-.054.187-.004h.002l.214.185.218.179c.06.05.077.137.04.191l-.005.002-.004.004c-.041.044-.124.05-.189-.002l-.218-.179zm.071-.085l.216.181a.05.05 0 00.031.012h.01c0-.004 0-.008-.002-.01a.04.04 0 00-.018-.029l-.219-.183-.214-.181c-.008-.006-.019-.012-.027-.012-.006 0-.01 0-.013.004v.008c.003.011.013.021.021.032l.215.178zm-1.441-1.062c.031-.064.118-.081.189-.036l.168.109.171.11c.066.039.094.123.066.185l-.002.002v.002c-.033.056-.116.079-.189.031l-.17-.106.058-.093.17.11c.006.004.017.006.025.008.004 0 .009 0 .011-.002.004-.017-.009-.035-.026-.043l-.174-.113-.168-.108a.045.045 0 00-.025-.009h-.007l-.002.003v.002c-.002.004 0 .01.002.014a.063.063 0 00.025.031l.169.107-.058.091-.171-.108c-.066-.044-.094-.129-.062-.187z"
});

var _ref624 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M169.634 167.709c.06.045.081.122.047.168-.032.045-.108.045-.168.002-.06-.046-.081-.121-.047-.166.031-.046.107-.05.168-.004z"
});

var _ref625 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.665 167.667c.088.064.108.172.06.241-.05.069-.158.081-.245.014-.087-.064-.108-.174-.06-.241.048-.07.158-.081.245-.014zm-.064.087a.106.106 0 00-.063-.023.033.033 0 00-.029.015c-.006.008-.008.021-.004.035a.13.13 0 00.04.054c.02.015.041.023.062.023.01 0 .023-.004.031-.015.006-.01.004-.022.002-.037a.11.11 0 00-.039-.052z"
});

var _ref626 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M170.048 168.34l.141.148c.033.035.089.048.118.019.029-.025.028-.075-.006-.11l-.141-.152-.141-.15c-.034-.035-.088-.047-.117-.019-.033.023-.029.08.009.115l.137.149z"
});

var _ref627 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.048 168.34l-.04.036-.135-.148a.153.153 0 01-.048-.116.107.107 0 01.042-.077c.048-.041.137-.035.191.023l.144.151.139.15c.056.06.05.146.002.189-.05.046-.137.034-.194-.022l-.139-.15.038-.036zm.039-.037l.139.146c.011.01.021.018.034.02.004 0 .008.003.01 0l.002-.002c.004-.002.002-.008 0-.012-.002-.008-.004-.015-.012-.021l-.137-.152-.144-.149a.051.051 0 00-.029-.019c-.004 0-.008-.002-.01 0l-.005.006v.008a.035.035 0 00.013.021l.002.004.137.15z"
});

var _ref628 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M170.659 168.777c.043.065.039.144-.004.175-.046.033-.117.006-.161-.059-.043-.064-.041-.141.003-.172.045-.033.118-.008.162.056z"
});

var _ref629 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.702 168.746c.063.092.05.204-.016.251-.067.048-.175.021-.237-.072-.063-.092-.05-.202.016-.25.067-.048.175-.02.237.071zm-.089.062a.096.096 0 00-.054-.043c-.011-.005-.021-.009-.029-.002-.011.006-.015.02-.012.033a.096.096 0 00.02.066c.015.023.034.04.054.044.011.006.021.006.029.002.011-.008.013-.021.013-.031a.112.112 0 00-.021-.069z"
});

var _ref630 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M168.867 164.603l-.387.012-.077.622.042.1.101-.007.497-.366c-.056-.122-.116-.241-.176-.361z"
});

var _ref631 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.364 165.397s.012-.011.037-.029a.035.035 0 00-.008-.013l-.04-.096.05.034-.054-.063.083-.667.468-.016.015.031c.062.12.122.243.176.364l.019.039-.545.399-.201.017zm.093-.167l.023.048.046-.002c.183-.133.449-.33.449-.33-.044-.098-.092-.192-.139-.287l-.31.008-.069.563z"
});

var _ref632 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M167.815 164.948l-.011.389.603.079.096-.042-.011-.106-.349-.509c-.118.05-.224.114-.328.189z"
});

var _ref633 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.482 165.155l.01.167s.053-.106.057-.056l.006.102c.002.041-.033.056-.048.06l.017-.004-.09.041c-.014.006-.022.006-.027.006l-.659-.089.01-.38h-.11l.136-.098c.106-.077.218-.143.337-.198l.039-.016.322.465zm-.613-.178l-.011.314.543.07.044-.02-.004-.054-.319-.462a2.173 2.173 0 00-.253.152z"
});

var _ref634 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M169.06 165.723l-.32.193-.353-.511-.007-.104.094-.043.605.079c.008.13.006.257-.019.386z"
});

var _ref635 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.38 165.355l-.022-.102.093-.045.023.104.008-.109.651.086.002.043a1.71 1.71 0 01-.021.399l-.004.025-.387.235-.332-.486-.004-.046s-.05-.002-.053-.052l-.008-.102.054.05zm.102-.043l-.044.022.003.054.313.456.258-.154c.015-.102.021-.202.015-.308l-.545-.07z"
});

var _ref636 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M168.424 165.091c.114 0 .206.1.206.221 0 .122-.092.22-.206.22-.11 0-.202-.098-.202-.22 0-.121.092-.221.202-.221z"
});

var _ref637 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.424 165.037c.143 0 .258.123.258.275 0 .153-.115.276-.258.276-.139 0-.254-.123-.254-.276 0-.152.115-.275.254-.275zm0 .106c-.081 0-.148.079-.148.169 0 .091.067.166.148.166.085 0 .15-.075.15-.166 0-.09-.065-.169-.15-.169z"
});

var _ref638 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M166.871 164.601c-.008.002-.085-.329-.169-.51-.055-.133-.255-.306-.255-.306.021-.041.27-.141.57.067.243.218-.017.618-.017.618s-.065.097-.127.131h-.002z"
});

var _ref639 =
/*#__PURE__*/
React.createElement("path", {
  d: "M167.043 164.501l-.002.002a.474.474 0 01-.143.143l-.029-.052.012.061c-.006 0-.047.004-.066-.046-.019-.05-.085-.335-.162-.499-.052-.123-.242-.283-.242-.283l-.031-.027.019-.037a.093.093 0 01.025-.032.268.268 0 01.083-.039c.108-.033.312-.044.541.114l.004.002.002.002c.112.1.133.235.116.36a.933.933 0 01-.127.331zm-.145.01a.63.63 0 00.054-.069v-.002s.089-.133.112-.285c.011-.089 0-.189-.081-.261-.187-.129-.353-.127-.445-.1l-.002.002c.067.064.175.177.216.272.061.131.115.335.146.443z"
});

var _ref640 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M167.549 164.825l-.275.256-.449-.422.04-.061.014-.104.607-.049c.027.124.048.251.063.38z"
});

var _ref641 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.813 164.578l.012-.092.054.061-.002-.109.655-.05.008.046c.027.127.046.256.063.385v.006c0 .01-.054.052-.054.052l.035-.014-.31.295-.457-.433-.037-.096.033-.051zm.677.224a5.138 5.138 0 00-.045-.299l-.516.039-.01.061c-.002.01-.006.018-.009.025l-.014.02.378.36.216-.206z"
});

var _ref642 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M166.784 164.603c.002-.113.066-.202.139-.202.073.002.127.093.125.204-.002.114-.069.199-.14.201-.074-.002-.128-.093-.127-.203h.003zm3.569 1.012l-.384-.046-.165.607.032.104.099.003.541-.285c-.04-.129-.079-.256-.123-.383z"
});

var _ref643 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.73 164.601a.3.3 0 01.075-.198.165.165 0 01.116-.058h.004a.163.163 0 01.116.062.31.31 0 01.063.2.295.295 0 01-.075.197.164.164 0 01-.116.056h-.007a.159.159 0 01-.118-.06.293.293 0 01-.058-.199zm.108.004a.177.177 0 00.025.11c.01.021.025.037.047.037.013 0 .028-.01.038-.023a.204.204 0 00.048-.126.236.236 0 00-.027-.111c-.015-.021-.027-.035-.05-.037-.017.002-.034.016-.048.035a.196.196 0 00-.033.115zm2.948 1.696l-.004-.006-.029-.102.051.04-.051-.069.172-.653.468.054.012.033c.042.127.081.256.125.381l.012.045-.594.314-.112-.004-.109-.002s.023-.01.059-.031zm.075-.125l.014.053.048.001.488-.26-.099-.305-.304-.036-.147.547z"
});

var _ref644 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M169.264 165.802l-.061.387.585.166.098-.031.006-.102-.277-.563c-.118.041-.235.093-.351.143z"
});

var _ref645 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.904 166.12l.044.104-.006.102c-.005.04-.038.048-.052.05h.012l-.095.029-.019.002-.004.002-.643-.183.073-.459.027-.013c.117-.052.235-.106.358-.147l.043-.015.262.528zm-.116.177l.048-.014.004-.053-.252-.503a5.34 5.34 0 00-.276.113l-.048.307.524.15z"
});

var _ref646 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M170.397 166.748l-.349.15-.277-.56.006-.105.1-.03.586.169a6.554 6.554 0 01-.066.376z"
});

var _ref647 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.777 166.287l-.012-.106.096-.028.016.106.013-.106.629.179-.004.046a3.831 3.831 0 01-.066.383l-.006.026-.42.182-.256-.516-.05-.119.006-.105.054.058zm.1-.026l-.05.013-.002.054.25.501.274-.12c.021-.098.037-.198.054-.298l-.526-.15z"
});

var _ref648 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M169.821 166.058c.114 0 .206.099.206.22 0 .123-.092.22-.206.22-.11 0-.202-.097-.202-.22 0-.121.092-.22.202-.22z"
});

var _ref649 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.821 166.002c.144 0 .258.122.258.274 0 .154-.114.277-.258.277-.14 0-.254-.123-.254-.277 0-.152.114-.274.254-.274zm0 .106c-.081 0-.148.079-.148.168 0 .092.067.166.148.166.085 0 .15-.074.15-.166 0-.089-.065-.168-.15-.168z"
});

var _ref650 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M171.651 166.929l.07.399-.574.208-.1-.025-.012-.104.239-.576c.127.031.25.065.377.098z"
});

var _ref651 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.998 167.532c-.005-.004-.005-.009-.007-.017l-.01-.102.054.05-.05-.075.256-.619.044.01c.129.029.253.063.38.098l.033.01.083.476-.627.229-.007-.002s-.091-.021-.108-.023l-.004-.002.011.002c-.005 0-.009-.002-.015-.004l-.075-.017.042-.014zm.091-.117l.008.052.048.011.514-.185-.056-.32c-.098-.028-.198-.052-.298-.077l-.216.519z"
});

var _ref652 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M171.546 168.068l-.365.09-.204-.595.025-.102.099-.014.558.249-.113.372z"
});

var _ref653 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.002 167.515l-.011-.108.102-.013.008.107.021-.104.603.268-.014.045c-.035.125-.073.25-.113.373l-.01.031-.443.108-.185-.538-.035-.132.023-.103.054.066zm.091-.012a.976.976 0 01-.047.006l-.011.052c.054.164.181.532.181.532l.289-.068c.031-.1.06-.2.089-.298l-.501-.224z"
});

var _ref654 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M170.553 166.966l-.119.368.557.246.106-.013.019-.102-.199-.592-.364.093z"
});

var _ref655 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.143 167.376l.027.097-.021.1a.06.06 0 01-.052.048h.004l-.11.015h-.006l-.617-.271.143-.442.029-.011c.119-.031.241-.062.364-.091l.048-.013.191.568zm-.141.15l.048-.007.008-.052a32.69 32.69 0 00-.177-.53c-.096.025-.191.05-.285.073l-.095.295.501.221z"
});

var _ref656 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M171.043 167.264c.115 0 .206.099.206.22 0 .123-.091.22-.206.22-.11 0-.201-.097-.201-.22 0-.121.091-.22.201-.22z"
});

var _ref657 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.043 167.21c.144 0 .258.122.258.274 0 .154-.114.276-.258.276-.139 0-.253-.122-.253-.276 0-.152.114-.274.253-.274zm0 .105c-.081 0-.147.079-.147.169 0 .092.066.166.147.166.086 0 .15-.074.15-.166 0-.09-.064-.169-.15-.169z"
});

var _ref658 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M172.072 168.946c-.001.012.329.018.518.064.133.031.345.195.345.195.038-.029.073-.301-.185-.563-.26-.202-.58.154-.58.154s-.081.083-.098.15z"
});

var _ref659 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.072 168.946l-.051-.013a.505.505 0 01.104-.17c.001-.003.006-.004.006-.004a.836.836 0 01.282-.2c.115-.046.248-.054.37.042l.003.001.001.003c.198.197.233.403.227.519a.262.262 0 01-.022.092.073.073 0 01-.023.031l-.034.029-.033-.029s-.198-.154-.324-.183c-.169-.042-.453-.052-.506-.06-.054-.009-.054-.058-.054-.067l.054.009zm.136-.115v.002c-.007.009-.034.035-.054.069.105.006.322.027.449.056.095.021.224.106.303.162v-.004c.006-.096-.029-.268-.193-.435-.085-.064-.177-.054-.26-.02a.72.72 0 00-.243.17h-.002z"
});

var _ref660 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M171.719 168.307l-.191.333.497.366.062-.06.083-.03-.079-.623-.372.014z"
});

var _ref661 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.116 168.995l-.05.048c-.02.019-.041.017-.041.017l-.007.006-.559-.411.227-.4.031-.002c.125-.006.25-.01.372-.014l.052-.002.085.71-.039.021-.071.027zm-.095-.06l.029-.027.037.094-.019-.104.042-.017c-.023-.183-.064-.534-.064-.534-.098.006-.198.01-.296.014l-.149.264.42.31z"
});

var _ref662 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M172.087 169.037c.104-.021.177-.1.16-.173-.017-.076-.114-.122-.22-.099-.102.023-.173.097-.154.176.015.073.112.119.214.096z"
});

var _ref663 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.1 169.091a.296.296 0 01-.206-.031.17.17 0 01-.075-.106c-.021-.106.062-.212.197-.243h.002c.133-.027.258.039.281.143a.16.16 0 01-.027.127.273.273 0 01-.172.11zm-.023-.104a.191.191 0 00.095-.052c.015-.019.027-.037.021-.06-.006-.021-.023-.037-.046-.048a.17.17 0 00-.108-.01.196.196 0 00-.093.051c-.019.019-.027.04-.021.063a.074.074 0 00.046.044.185.185 0 00.106.012z"
});

var _ref664 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M166.401 167.941s.038.065.029.094c-.008.029-.06.058-.06.058.116.046.179.013.227-.019-.011-.08-.067-.106-.119-.128-.025-.013-.077-.005-.077-.005z"
});

var _ref665 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M167.299 165.977c.06.046.081.122.048.168-.033.046-.108.046-.168.002-.061-.045-.082-.12-.048-.166.031-.046.108-.05.168-.004z"
});

var _ref666 =
/*#__PURE__*/
React.createElement("path", {
  d: "M167.33 165.931c.088.064.108.172.061.241-.05.069-.158.081-.246.015-.087-.065-.108-.175-.06-.242.048-.07.158-.08.245-.014zm-.064.087a.105.105 0 00-.062-.023.032.032 0 00-.029.015c-.007.008-.009.021-.005.035.009.019.021.04.04.054.02.015.041.023.062.023a.04.04 0 00.031-.014c.006-.011.005-.023.002-.038a.104.104 0 00-.039-.052z"
});

var _ref667 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M168.509 166.767c.061.045.081.123.048.168-.033.046-.108.046-.169.002-.06-.046-.08-.12-.047-.166.031-.046.108-.05.168-.004z"
});

var _ref668 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.542 166.721c.088.065.108.173.061.241-.05.069-.158.081-.245.015-.088-.065-.109-.175-.061-.241.048-.071.158-.082.245-.015zm-.064.087a.104.104 0 00-.062-.022c-.011 0-.021.001-.029.014-.007.008-.009.021-.005.035a.15.15 0 00.04.055.112.112 0 00.062.022.04.04 0 00.031-.014c.007-.011.005-.023.002-.038a.104.104 0 00-.039-.052z"
});

var _ref669 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B50027",
  fillRule: "nonzero",
  d: "M137.801 200.207c0-7.223 4.775-13.079 10.665-13.079 5.892 0 10.667 5.856 10.667 13.079 0 7.224-4.775 13.083-10.667 13.083-5.89 0-10.665-5.859-10.665-13.083z"
});

var _ref670 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.595 200.207c0-7.35 4.879-13.287 10.871-13.287 5.993 0 10.873 5.937 10.873 13.287 0 7.351-4.88 13.289-10.873 13.289-5.992 0-10.871-5.938-10.871-13.289zm.414 0c0 7.1 4.669 12.873 10.457 12.873 5.788 0 10.457-5.773 10.457-12.873s-4.669-12.873-10.457-12.873c-5.788 0-10.457 5.773-10.457 12.873z"
});

var _ref671 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#prefix__a)"
}, React.createElement("image", {
  x: 140.978,
  y: 190.593,
  width: 15.035,
  height: 19.226,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOIAAAEhCAYAAAEVHEzvAAAACXBIWXMA AA7DAAAOwwHHb6hkAAAHcUlEQVR4nO3diXIT1xqF0Z5sMjwcNy9K8nIhcSJ1R6ftdsSQqlQA6T/7 rlVlRIBUc/hqI1k21vLw9t32+Pg43MK2bcP7eRiWW12wGcdxGE7nYbnZFV/8OM23v2jjoi7qoi7q oi7qoi7qoi7qoi7qoi76gWlY2rvk+3vIN/K0nobl/bgN313eO57X9RtfbhpO0zCswzYsb376ZVuW 2/wpn8/nYbnVxZp5vsNzDS7ogi7ogi7ogi7ogi7ogi7ogi7ogvsF2xML7QmGW2jXWn5dz8MPYzvo t31iYRun4X17JqM9qTBN09DekrQ/zXVdh/eXY930iYxbOp77+v5en6hxS9P5Dp8Ccw8OmcIhUzhk CodM4ZApHDKFQ6ZwyBQOmcIhUzhkCodM4ZApHDKFQ6aIP2T7kPrSPm++fSj9lv8i4Vbah9N/H9dh efzfz/vnDLTP2U/SDtjelsRPiGiOMy1p5a61Q8b/ZeOAvXPA3jlg7xywdw7YOwfsnQP2zgF754C9 c8DeOWDvHLB3Dtg7B+ydA/bOAXvngL1zwN45YO8csHcO2DsH7J0D9s4Be+eAvXPA3jlg7xywdw7Y OwfsnQP2zgF754C92w/Y/q3r+s1fg+729q+Fn3iww+l0GpbfpmF/BcE38zKM+4sM9H7gadjGYfhj PQ+neXz+QgHth1vO9pb8z84THC910ZbXvv/0MD9/MYQjYOKXtUjTRna8MMR+O4R/wYdE1/d9LeTD JWP8Q5p08/Z/8Lg03dReivnevwm+nIgBRAwgYgARA4gYQMQAIgYQMYCIAUQMIGIAEQOIGEDEACIG EDGAiAFEDCBiABEDiBhAxAAiBhAxgIgBRAwgYgARA4gYQMQAIgYQMYCIAUQMIGIAEQOIGEDEACIG EDGAiAFEDCBiABEDiBhAxAAiBhAxgIgBRAwgYgARA4gYQMQAIgYQMYCIAUQMIGIAEQOIGEDEACJ2 bxKxd+1VvvfXZ79+Yejj1aPpw9P59ByxuX6Vb+pqfVqz9nY+n4fz4zIsD2/fbddL9GrftbV47W/L 4+2PN5eI1wGtsL5PGrVX9xaxL9eNju+L2Jn22KX9NXo8lmnFFveBfXmN9zK47fLgxvuJnXucFxF7 N0+esenfeRWxd5eHOSImEDGAiAFEDCBiABEDiBhAxAAiBhAxgIgBRAwgYgARA4gYQMQAIgYQMYCI AUQMIGIAEQOIGEDEACIGEDGAiAFEDCBiABEDiBhAxAAiBhAxgIgBRAwgYgARA4gYQMQAIgYQMYCI AUQMIGIAEQOIGEDEACIGEDGAiAFEDCBiABEDiBhAxAAiBhAxgIgBRAwgYgARA4gYQMQAIgYQMYCI AUQMIGIAEQOIGEDEACIGEDGAiAFEDCBiABEDiBhAxAAiBhAxgIgBRAwgYgARA4gYQMQAIgYQMYCI AUQMIGIAEQOIGEDEACIGEDGAiAFEDCBiABEDiBhAxAAiBhAxgIgBRAwgYgARA4gYQMQAIgYQMYCI AUQMIGIAEQOIGEDEACIGEDGAiAFEDCBiABEDiBhAxO5NIiYQsXPbKGKEZdu2YRzH17d1Xe/9e+Jf aK2ap/PpOeLxg8f3qe9o1b59jdgWeNSlttas9dpv5+nviAch67uOuC2XiE+Xb8ZLx2nbf3Z4M837 Lxxf27qPvK9p/7Y9Cl3b26XRn5fb7WHeB9e6LQ9v3+25jgUeD3AO8zzf4TcOGV4fu1zdXt/7PT0+ 72u5HuBx624Rvo7PbemDdwRfbpZpmj75nz6+Bf6b6y197lmYY2HLx7/4+hb4MseWjue2P/n54x7R +4Dw7fzTB5OOUU4v95I+lAh3tLzcERoiFGCIcEfj6qEp3N00GCKUYYhQgCFCAYYIBRgiFGCIUIAh QgGGCAUYIhRgiFCAIUIBhggFGCIUYIhQgCFCAYYIBRgiFGCIUIAhQgGGCAUYIhRgiFCAIUIBhggF GCIUYIhQgCFCAYYIBRgiFGCIUIAhQgGGCAUYIhRgiFCAIUIBhggFGCIUYIhQgCFCAYYIBRgiFGCI UIAhQgGGCAUYIhRgiFCAIUIBhggFGCIUYIhQgCFCAYYIBRgiFGCIUIAhQgGGCAUYIhRgiFCAIUIB hggFGCIUYIhQgCFCAYYIBRgiFGCIUIAhQgGGCAUYIhRgiFCAIUIBhggFGCIUYIhQgCFCAYYIBRgi FGCIUIAhQgGGCAUYIhRgiFCAIUIBhggFGCIUYIhQgCFCAYYIBRgiFGCIUIAhQgGGCAUYIhRgiFCA IUIBhggFGCIUYIhQgCFCAYYIBRgiFGCIUIAhQgGGCAUYIhRgiFCAIUIBhggFGCIUYIhQgCFCAYYI BRgiFGCIUIAhQgGGCAUYIhRgiFCAIUIBhggFGCIUYIhQgCFCAYYIBRgiFGCIUIAhQgGGCHc17d8a IhRgiHBH2/h8a4hwR+sxxG3bXn9wHMf97fj+/gvX9ea/OUh37OvP02m//WCITfvv9ouOW+DrOLZ2 vbnXe8TjHu9z4zNG+DLHrj731mwP8367fHwP+PFDVeDr+XSMz0P8CwY/WEPW4AOrAAAAAElFTkSu QmCC"
}));

var _ref672 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#0044AD",
  fillRule: "nonzero",
  d: "M140.965 200.184c0-5.3 3.36-9.592 7.505-9.592s7.503 4.292 7.503 9.592c0 5.299-3.358 9.594-7.503 9.594s-7.505-4.295-7.505-9.594z"
});

var _ref673 =
/*#__PURE__*/
React.createElement("path", {
  d: "M140.759 200.184c0-5.426 3.466-9.8 7.711-9.8 4.243 0 7.711 4.374 7.711 9.8 0 5.424-3.468 9.802-7.711 9.802-4.193 0-7.624-4.266-7.711-9.596v-.206zm.414 0c0 5.172 3.251 9.387 7.297 9.387 4.046 0 7.297-4.215 7.297-9.387 0-5.17-3.251-9.384-7.297-9.384-4.046 0-7.297 4.214-7.297 9.384z"
});

var _ref674 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M144.925 193.581s-.889 1.065-.889 2.048c0 .992.374 1.813.374 1.813a.986.986 0 00-.927-.674c-.541 0-.98.453-.98 1.015 0 .164.092.416.161.555l.318.702c.108-.257.355-.403.646-.403.387 0 .703.324.703.726 0 .06-.006.122-.023.176l-.8.003v.744h.715l-.53 1.145.702-.299.53.653.551-.653.701.299-.528-1.145h.713v-.744l-.8-.003a.598.598 0 01-.019-.176.71.71 0 01.699-.726c.291 0 .538.146.648.403l.316-.702c.069-.139.16-.391.16-.555 0-.562-.436-1.015-.983-1.015a.985.985 0 00-.923.674s.374-.821.374-1.813c0-.983-.909-2.048-.909-2.048z"
});

var _ref675 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.16 196.949a4.854 4.854 0 01-.197-1.32c0-1.006.908-2.096.908-2.096l.054.046.052-.046s.928 1.09.928 2.096c0 .513-.098.985-.196 1.32.183-.158.418-.252.674-.252.584 0 1.056.485 1.056 1.086 0 .172-.096.438-.169.586l-.386.854-.06-.154c-.098-.232-.323-.357-.582-.357a.636.636 0 00-.626.651c0 .035 0 .07.004.104l.815.004v.885h-.672l.56 1.214-.826-.351-.572.678-.553-.676-.825.349.561-1.214h-.671v-.885l.813-.004a.64.64 0 00-.622-.755c-.26 0-.484.125-.58.357l-.064.154-.387-.854c-.071-.148-.166-.414-.166-.586 0-.601.474-1.086 1.052-1.086.257 0 .492.094.677.252zm1.41.416c-.023.054-.035.087-.042.1l-.002.006-.135-.052a4.849 4.849 0 00.37-1.79c0-.815-.638-1.684-.836-1.934-.193.25-.819 1.119-.819 1.934 0 .757.225 1.414.325 1.669.016.038.035.077.048.121l-.134.052s-.018-.04-.048-.114a.91.91 0 00-.814-.516c-.501 0-.909.422-.909.942 0 .153.09.39.154.524l.258.574a.765.765 0 01.642-.315.788.788 0 01.751.992l-.015.054-.784.002v.599h.755l-.499 1.079.58-.245.512.623.53-.623.575.245-.496-1.079h.755v-.599l-.787-.002-.014-.054a.742.742 0 01-.019-.195.78.78 0 01.77-.797c.265 0 .5.113.64.315l.258-.574h.002c.064-.134.153-.371.153-.524 0-.52-.405-.942-.912-.942a.904.904 0 00-.813.524z"
});

var _ref676 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M143.508 200.286h2.856v-.744h-2.856v.744zm8.392-6.705s-.892 1.065-.892 2.048c0 .992.375 1.813.375 1.813a.983.983 0 00-.923-.674c-.545 0-.984.453-.984 1.015 0 .164.092.416.16.555l.316.702c.111-.257.358-.403.649-.403.387 0 .701.324.701.726 0 .06-.004.122-.019.176l-.8.003v.744h.712l-.529 1.145.7-.299.534.653.547-.653.705.299-.532-1.145h.715v-.744l-.8-.003a.598.598 0 01-.021-.176c0-.402.313-.726.702-.726.289 0 .537.146.645.403l.318-.702c.071-.139.16-.391.16-.555 0-.562-.439-1.015-.979-1.015a.985.985 0 00-.927.674s.374-.821.374-1.813c0-.983-.909-2.048-.909-2.048h.002zm-3.488 6.538s-.892 1.065-.892 2.05c0 .99.378 1.813.378 1.813a.984.984 0 00-.927-.676c-.54 0-.981.454-.981 1.015 0 .166.089.416.158.555l.32.705c.108-.26.356-.408.644-.408.389 0 .703.327.703.728a.713.713 0 01-.021.181l-.798.002v.742h.715l-.532 1.146.701-.302.532.653.551-.653.704.302-.534-1.146h.713v-.742l-.798-.002a.843.843 0 01-.019-.181c0-.401.312-.728.701-.728.289 0 .536.148.645.408l.32-.705c.068-.139.16-.389.16-.555 0-.561-.441-1.015-.982-1.015a.993.993 0 00-.929.676s.376-.823.376-1.813c0-.985-.912-2.05-.912-2.05h.004z"
});

var _ref677 =
/*#__PURE__*/
React.createElement("path", {
  d: "M151.133 196.949a4.861 4.861 0 01-.195-1.32c0-1.006.906-2.096.906-2.096l.054.046.055-.046s.927 1.09.927 2.096c0 .513-.1.983-.198 1.32.185-.158.42-.252.678-.252.58 0 1.052.485 1.052 1.086 0 .172-.094.438-.166.586l-.391.854-.061-.154c-.095-.232-.318-.357-.578-.357a.639.639 0 00-.63.651c0 .035 0 .07.009.104l.81.004v.885h-.671l.563 1.214-.827-.351-.572.678-.555-.676-.823.349.563-1.214h-.673v-.885l.815-.004a.894.894 0 00.006-.104.639.639 0 00-.63-.651c-.26 0-.484.125-.582.357l-.065.154-.382-.854c-.073-.146-.168-.414-.168-.586 0-.601.472-1.086 1.056-1.086.255 0 .49.094.673.252zm1.412.408c-.029.074-.048.114-.048.114l-.133-.052c.013-.044.031-.083.048-.123.099-.255.324-.91.324-1.667 0-.815-.64-1.684-.836-1.934-.193.25-.819 1.119-.819 1.934 0 .755.221 1.409.32 1.667.019.04.036.079.05.123l-.135.052-.046-.117a.91.91 0 00-.81-.513c-.508 0-.911.422-.911.942 0 .153.087.39.154.524l.258.575a.757.757 0 01.64-.316c.428 0 .773.354.773.797a.788.788 0 01-.022.195l-.013.054-.786.002v.599h.755l-.499 1.079.578-.245.513.623.528-.623.581.245-.502-1.079h.755v-.599l-.784-.002-.012-.054a.668.668 0 01-.023-.195c0-.443.343-.797.773-.797.266 0 .499.113.639.315l.259-.574c.067-.134.154-.371.154-.524 0-.52-.407-.942-.908-.942a.913.913 0 00-.815.516zm-4.9 6.13a4.79 4.79 0 01-.196-1.318c0-1.008.909-2.097.909-2.097l.052.046.054-.046s.931 1.089.931 2.097c0 .516-.099.984-.197 1.32.181-.157.415-.253.675-.253.578 0 1.055.484 1.055 1.085 0 .175-.096.439-.167.586l-.389.853-.064-.152c-.098-.233-.32-.36-.578-.36a.64.64 0 00-.63.653c0 .037.002.073.008.108l.811.002v.886h-.673l.565 1.218-.83-.355-.571.675-.551-.675-.826.355.566-1.218h-.676v-.886l.813-.002a.946.946 0 00.008-.108.641.641 0 00-.632-.653c-.259 0-.48.127-.577.36l-.065.154-.387-.855c-.072-.147-.168-.411-.168-.586 0-.601.476-1.085 1.056-1.085.258 0 .493.093.674.251zm1.409.418c-.02.054-.035.088-.041.1l-.002.004-.134-.052c0-.002 0-.004.003-.006a.916.916 0 01.043-.102 4.85 4.85 0 00.327-1.68c0-.815-.643-1.686-.84-1.935-.194.249-.815 1.12-.815 1.935 0 .757.22 1.414.32 1.668.021.039.035.081.052.12l-.135.052s-.019-.039-.048-.112a.904.904 0 00-.813-.515c-.503 0-.91.419-.91.939 0 .156.087.393.151.526l.262.574a.751.751 0 01.638-.318c.429 0 .778.355.778.798a.87.87 0 01-.025.2l-.017.054h-.781v.598h.759l-.502 1.079.578-.247.51.624.53-.624.578.247-.501-1.079h.757v-.598l-.784-.002-.015-.054a.945.945 0 01-.021-.198c.003-.443.348-.798.774-.798.266 0 .499.114.638.318l.262-.574c.065-.133.152-.37.152-.526 0-.52-.407-.939-.909-.939a.91.91 0 00-.819.523zm-5.617-4.436h3v.887h-3v-.887zm.143.744h2.713v-.597h-2.713v.597z"
});

var _ref678 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  fillRule: "nonzero",
  d: "M146.996 206.826h2.854v-.742h-2.854v.742zm3.484-6.54h2.857v-.744h-2.857v.744z"
});

var _ref679 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146.923 206.011h2.998v.886h-2.998v-.886zm.144.742h2.711v-.596h-2.711v.596zm3.341-7.284h3v.887h-3v-.887zm.143.744h2.713v-.597h-2.713v.597z"
});

var _ref680 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.495 245.784s-.281-.387-.287-.316c-.027.274.287.316.287.316-8.63 0-17.185-2.306-24.378-6.141-5.362-2.897-8.918-8.73-8.918-15.408v-23.814l-.044-40.172h66.506l.002 40.172v23.814c0 6.678-3.555 12.511-8.919 15.408-7.193 3.835-15.615 6.141-24.249 6.141zm0-.58c8.536 0 16.862-2.279 23.972-6.073 5.185-2.798 8.618-8.441 8.618-14.896v-23.814l-.005-39.594h-65.343l.041 39.594v23.814c0 6.455 3.433 12.098 8.614 14.896 7.112 3.794 15.569 6.073 24.103 6.073z"
});

var _ref681 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M204.808 230.973v4.173h-15.025v-4.173z"
});

var _ref682 =
/*#__PURE__*/
React.createElement("path", {
  d: "M204.903 235.241h-15.215v-4.363h15.215v4.363zm-.189-4.172h-14.837v3.981h14.837v-3.981z"
});

var _ref683 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9F7E00",
  d: "M106.945 230.973v4.173H91.916v-4.173z"
});

var _ref684 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.04 235.241H91.823v-4.363h15.217v4.363zm-.191-4.172H92.012v3.981h14.837v-3.981z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 356.18",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371, _ref372, _ref373, _ref374, _ref375, _ref376, _ref377, _ref378, _ref379, _ref380, _ref381, _ref382, _ref383, _ref384, _ref385, _ref386, _ref387, _ref388, _ref389, _ref390, _ref391, _ref392, _ref393, _ref394, _ref395, _ref396, _ref397, _ref398, _ref399, _ref400, _ref401, _ref402, _ref403, _ref404, _ref405, _ref406, _ref407, _ref408, _ref409, _ref410, _ref411, _ref412, _ref413, _ref414, _ref415, _ref416, _ref417, _ref418, _ref419, _ref420, _ref421, _ref422, _ref423, _ref424, _ref425, _ref426, _ref427, _ref428, _ref429, _ref430, _ref431, _ref432, _ref433, _ref434, _ref435, _ref436, _ref437, _ref438, _ref439, _ref440, _ref441, _ref442, _ref443, _ref444, _ref445, _ref446, _ref447, _ref448, _ref449, _ref450, _ref451, _ref452, _ref453, _ref454, _ref455, _ref456, _ref457, _ref458, _ref459, _ref460, _ref461, _ref462, _ref463, _ref464, _ref465, _ref466, _ref467, _ref468, _ref469, _ref470, _ref471, _ref472, _ref473, _ref474, _ref475, _ref476, _ref477, _ref478, _ref479, _ref480, _ref481, _ref482, _ref483, _ref484, _ref485, _ref486, _ref487, _ref488, _ref489, _ref490, _ref491, _ref492, _ref493, _ref494, _ref495, _ref496, _ref497, _ref498, _ref499, _ref500, _ref501, _ref502, _ref503, _ref504, _ref505, _ref506, _ref507, _ref508, _ref509, _ref510, _ref511, _ref512, _ref513, _ref514, _ref515, _ref516, _ref517, _ref518, _ref519, _ref520, _ref521, _ref522, _ref523, _ref524, _ref525, _ref526, _ref527, _ref528, _ref529, _ref530, _ref531, _ref532, _ref533, _ref534, _ref535, _ref536, _ref537, _ref538, _ref539, _ref540, _ref541, _ref542, _ref543, _ref544, _ref545, _ref546, _ref547, _ref548, _ref549, _ref550, _ref551, _ref552, _ref553, _ref554, _ref555, _ref556, _ref557, _ref558, _ref559, _ref560, _ref561, _ref562, _ref563, _ref564, _ref565, _ref566, _ref567, _ref568, _ref569, _ref570, _ref571, _ref572, _ref573, _ref574, _ref575, _ref576, _ref577, _ref578, _ref579, _ref580, _ref581, _ref582, _ref583, _ref584, _ref585, _ref586, _ref587, _ref588, _ref589, _ref590, _ref591, _ref592, _ref593, _ref594, _ref595, _ref596, _ref597, _ref598, _ref599, _ref600, _ref601, _ref602, _ref603, _ref604, _ref605, _ref606, _ref607, _ref608, _ref609, _ref610, _ref611, _ref612, _ref613, _ref614, _ref615, _ref616, _ref617, _ref618, _ref619, _ref620, _ref621, _ref622, _ref623, _ref624, _ref625, _ref626, _ref627, _ref628, _ref629, _ref630, _ref631, _ref632, _ref633, _ref634, _ref635, _ref636, _ref637, _ref638, _ref639, _ref640, _ref641, _ref642, _ref643, _ref644, _ref645, _ref646, _ref647, _ref648, _ref649, _ref650, _ref651, _ref652, _ref653, _ref654, _ref655, _ref656, _ref657, _ref658, _ref659, _ref660, _ref661, _ref662, _ref663, _ref664, _ref665, _ref666, _ref667, _ref668, _ref669, _ref670, _ref671, _ref672, _ref673, _ref674, _ref675, _ref676, _ref677, _ref678, _ref679, _ref680, _ref681, _ref682, _ref683, _ref684);
};

export default __webpack_public_path__ + "static/media/spain.dd88995b.svg";
export { SvgComponent as ReactComponent };